angular.module('c', [
    'ui.router',
    'ui.mask',

    'elif',

    // 'angular-loading-bar',
    //'ui.select',
    'ngSanitize',
    'ngTable',
    'ngLocale',
    'toaster',
    'dialogs.main',
    'pascalprecht.translate',
    'dialogs.default-translations',

    'sticky',

    //'ui.tree',
    // 'ui.slimscroll',
    'ui.checkbox',
    'ngAnimate',
    'rzModule',
    'angular-clipboard',
    'angularPromiseButtons',

    //'monospaced.qrcode',
    'angular-click-outside',
    'monospaced.elastic',
    'mgo-angular-wizard',

    'ui.bootstrap',
    // 'ui.bootstrap.datetimepicker',
    'mwl.calendar',
    'toggle-switch',
    'FBAngular',
    'ngFileUpload',
    'btford.socket-io',
    'angularMoment',

    //'angular-img-cropper',
    'ipCookie',
    'colorpicker.module',

    'dndLists',
    'oc.lazyLoad',

    'ng.deviceDetector',
    'ckeditor',
    'uiCropper',

    'ngResource',
    'ngStorage',
    'fileSaver'
]);

angular.module("ngLocale", [], ["$provide", function ($provide) {
    var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
    $provide.value("$locale", {
        "DATETIME_FORMATS": {
            "AMPMS": [
                "\u4e0a\u5348",
                "\u4e0b\u5348"
            ],
            "DAY": [
                "\u661f\u671f\u65e5",
                "\u661f\u671f\u4e00",
                "\u661f\u671f\u4e8c",
                "\u661f\u671f\u4e09",
                "\u661f\u671f\u56db",
                "\u661f\u671f\u4e94",
                "\u661f\u671f\u516d"
            ],
            "ERANAMES": [
                "\u516c\u5143\u524d",
                "\u516c\u5143"
            ],
            "ERAS": [
                "\u516c\u5143\u524d",
                "\u516c\u5143"
            ],
            "FIRSTDAYOFWEEK": 6,
            "MONTH": [
                "\u4e00\u6708",
                "\u4e8c\u6708",
                "\u4e09\u6708",
                "\u56db\u6708",
                "\u4e94\u6708",
                "\u516d\u6708",
                "\u4e03\u6708",
                "\u516b\u6708",
                "\u4e5d\u6708",
                "\u5341\u6708",
                "\u5341\u4e00\u6708",
                "\u5341\u4e8c\u6708"
            ],
            "SHORTDAY": [
                "\u5468\u65e5",
                "\u5468\u4e00",
                "\u5468\u4e8c",
                "\u5468\u4e09",
                "\u5468\u56db",
                "\u5468\u4e94",
                "\u5468\u516d"
            ],
            "SHORTMONTH": [
                "1\u6708",
                "2\u6708",
                "3\u6708",
                "4\u6708",
                "5\u6708",
                "6\u6708",
                "7\u6708",
                "8\u6708",
                "9\u6708",
                "10\u6708",
                "11\u6708",
                "12\u6708"
            ],
            "WEEKENDRANGE": [
                5,
                6
            ],
            "fullDate": "y\u5e74M\u6708d\u65e5EEEE",
            "longDate": "y\u5e74M\u6708d\u65e5",
            "medium": "y\u5e74M\u6708d\u65e5 ah:mm:ss",
            "mediumDate": "y\u5e74M\u6708d\u65e5",
            "mediumTime": "ah:mm:ss",
            "short": "yy/M/d ah:mm",
            "shortDate": "yy/M/d",
            "shortTime": "ah:mm"
        },
        "NUMBER_FORMATS": {
            "CURRENCY_SYM": "\u00a5",
            "DECIMAL_SEP": ".",
            "GROUP_SEP": ",",
            "PATTERNS": [
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 3,
                    "minFrac": 0,
                    "minInt": 1,
                    "negPre": "-",
                    "negSuf": "",
                    "posPre": "",
                    "posSuf": ""
                },
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 2,
                    "minFrac": 2,
                    "minInt": 1,
                    "negPre": "\u00a4\u00a0-",
                    "negSuf": "",
                    "posPre": "\u00a4\u00a0",
                    "posSuf": ""
                }
            ]
        },
        "id": "zh-cn",
        "pluralCat": function (n, opt_precision) {
            return PLURAL_CATEGORY.OTHER;
        }
    });
}]);
// moment.js locale configuration
// locale : chinese (zh-cn)
// author : suupic : https://github.com/suupic
// author : Zeno Zeng : https://github.com/zenozeng

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(['moment'], factory); // AMD
    } else if (typeof exports === 'object') {
        module.exports = factory(require('../moment')); // Node
    } else {
        factory((typeof global !== 'undefined' ? global : this).moment); // node or other global
    }
}(function (moment) {
    return moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'Ah点mm',
            LTS : 'Ah点m分s秒',
            L : 'YYYY-MM-DD',
            LL : 'YYYY年MMMD日',
            LLL : 'YYYY年MMMD日LT',
            LLLL : 'YYYY年MMMD日ddddLT',
            l : 'YYYY-MM-DD',
            ll : 'YYYY年MMMD日',
            lll : 'YYYY年MMMD日LT',
            llll : 'YYYY年MMMD日ddddLT'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : function () {
                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
            },
            nextDay : function () {
                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
            },
            lastDay : function () {
                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
            },
            nextWeek : function () {
                var startOfWeek, prefix;
                startOfWeek = moment().startOf('week');
                prefix = this.unix() - startOfWeek.unix() >= 7 * 24 * 3600 ? '[下]' : '[本]';
                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
            },
            lastWeek : function () {
                var startOfWeek, prefix;
                startOfWeek = moment().startOf('week');
                prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
            },
            sameElse : 'LL'
        },
        ordinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            m : '1分钟',
            mm : '%d分钟',
            h : '1小时',
            hh : '%d小时',
            d : '1天',
            dd : '%d天',
            M : '1个月',
            MM : '%d个月',
            y : '1年',
            yy : '%d年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));

(function () {
    'use strict';


    angular.module('c')
        .factory('Province', Province)
        .factory('City', City)
        .factory('County', County)
        .factory('Street', Street)
    ;

    /** @ngInject */
    function Province($resource, serviceConfObj) {
        return $resource('/api/v1/area/provinces/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function City($resource, serviceConfObj) {
        return $resource('/api/v1/area/cities/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function County($resource, serviceConfObj) {
        return $resource('/api/v1/area/counties/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function Street($resource, serviceConfObj) {
        return $resource('/api/v1/area/streets/:id', {}, serviceConfObj);
    }

})();
angular.module('c')
    .factory('BloodStorage', function ($resource) {
        return $resource('/api/v1/blood_storage/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            exchange: {
                method: 'POST',
                params: {
                    action: 'exchange'
                }
            },
            query: {
                method: 'GET'
            }
        });
    });



(function () {
    'use strict';

    angular.module('c')
        .factory('CommonPhone', CommonPhone);

    /** @ngInject */
    function CommonPhone($resource, serviceConfObj) {
        return $resource('/api/v1/common_phones/:id', {}, serviceConfObj);
    }

})();

angular.module('c')
    .factory('ContactGroup', ['$resource', function ($resource) {
        return $resource('/api/v1/contact_groups/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            attach_members: {
                method: 'POST',
                params: {
                    action: 'attach_members'
                }
            },
            detach_members: {
                method: 'POST',
                params: {
                    action: 'detach_members'
                }
            },
            index_members: {
                method: 'GET',
                params: {
                    action: 'index_members'
                }
            },
            set_member_stop: {
                method: 'POST',
                params: {
                    action: 'set_member_stop'
                }
            }
        });
    }]);


(function () {
    'use strict';

    angular.module('c')
        .factory('Conversation', Conversation)
        .factory('ConversationDetail', ConversationDetail)
    ;

    /** @ngInject */
    function Conversation($resource, serviceConfObj) {
        var API_URL = "/api/v1/conversation/conversation";
        var service = {
            API_URL: API_URL,
            STATE: {
                STATE_UNCLAIM: 0,
                STATE_HANDLING: 1,
                STATE_UNCOMMON: 2,
                STATE_COMMONED: 3
            },
            getStates: getStates,
            getTypes: getTypes,
        };

        return angular.extend(service, $resource(service.API_URL + '/:id', {}, serviceConfObj));

        function getStates() {
            return [
                {id: 0, name: '待认领'},
                {id: 1, name: '处理中'},
                {id: 2, name: '未评价'},
                {id: 3, name: '已评价'}
            ];
        }

        function getTypes() {
            return [
                {id: 0, name: '信息咨询'}
            ];
        }
    }

    /** @ngInject */
    function ConversationDetail($resource, serviceConfObj) {
        var API_URL = "/api/v1/conversation/detail";
        var service = {
            API_URL: API_URL,
        };

        return angular.extend(service, $resource(service.API_URL + '/:id', {}, serviceConfObj));
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .factory('Dept', Dept)
        .factory('DeptPhone', DeptPhone)
        .factory('AdminGroup', AdminGroup)
        .factory('DeptAgent', DeptAgent)
        .factory('DeptGroup', DeptGroup)
    ;

    /** @ngInject */
    function DeptGroup($resource, $http, serviceConfObj) {
        var API = '/api/v1/dept/dept_groups';
        var service = {};
        return angular.extend(service, $resource(API + '/:id',
            {}, serviceConfObj));
    }

    /** @ngInject */
    function DeptAgent($resource, serviceConfObj) {
        var service = {};
        return angular.extend(service, $resource('/api/v1/dept/dept_agents/:id',
            {}, serviceConfObj));
    }


    /** @ngInject */
    function DeptPhone($resource, serviceConfObj) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/dept/dept_phones/:id',
            {}, serviceConfObj));
    }

    /** @ngInject */
    function AdminGroup($resource, serviceConfObj) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/dept/admin_groups/:id',
            {}, serviceConfObj));
    }

    /** @ngInject */
    function Dept($resource, $http, serviceConfObj) {
        var API = '/api/v1/dept/depts';
        var service = {
            urls: {
                API: API
            },

            getTypes: getTypes,
            getMembers: getMembers,
        };

        return angular.extend(service, $resource(API + '/:id', {}, serviceConfObj));

        function getTypes() {
            return [
                {id: 0, name: '联络站'},
                {id: 1, name: '党支部'}
            ];
        }

        function getMembers(deptId) {
            var api = API + '/' + deptId + '/members';
            return $http.get(api);
        }
    }

})();

angular.module('c')
    .factory('Email', function ($resource) {
        return $resource('/api/v1/emails/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            withdraw: {
                method: 'POST',
                params: {
                    action: 'withdraw'
                }
            },
            rm_from_inbox: {
                method: 'POST',
                params: {
                    action: 'rm_from_inbox'
                }
            },
            rm_from_outbox: {
                method: 'POST',
                params: {
                    action: 'rm_from_outbox'
                }
            }
        });
    }
);


angular.module('c')
    .factory('HelpPage', ['$resource', function ($resource) {
        return $resource('/api/v1/help_pages/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);

angular.module('c')
    .factory('HelpContent', ['$resource', function ($resource) {
        return $resource('/api/v1/help_contents/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);


(function () {
    'use strict';

    angular.module('c')
        .factory('LetterRegister', LetterRegister)
    ;

    /** @ngInject */
    function LetterRegister($resource,serviceConfObj) {
        var API_URL = "/api/v1/letter/letter_registers";
        var service = {
            API_URL: API_URL,
            getHandleStates: getHandleStates,
            getLetterTypeOneStates: getLetterTypeOneStates,
            getLetterTypeTwoStates: getLetterTypeTwoStates,
            getLetterContentStates: getLetterContentStates,
            STA_URL: API_URL + '/sta',
        };
        //处理结果
        function getHandleStates() {
            return [
                {id: 1, name: '已办妥'},
                {id: 2, name: '已转安置科'},
                {id: 3, name: '已转党建联络站'},
                {id: 4, name: '已转国企社会化工作站'},
                {id: 5, name: '已转综合科'},
                {id: 6, name: '已转财务科'},
                {id: 7, name: '已转社保局'}
            ];
        }
        //信函类别一
        function getLetterTypeOneStates() {
            return [
                {id: 1, name: '挂号'},
                {id: 2, name: '机要'},
                {id: 3, name: '普信'},
                {id: 4, name: '特快'},
            ];
        }
        //信函类别二
        function getLetterTypeTwoStates() {
            return [
                {id: 1, name: '安置材料'},
                {id: 2, name: '文件'},
                {id: 3, name: '信函'},
                {id: 4, name: '药费'},
            ];
        }
        //信函内容
        function getLetterContentStates() {
            return [
                {id: 1, name: '查询养老待遇'},
                {id: 2, name: '查询医保待遇'},
                {id: 3, name: '查询养老政策'},
                {id: 4, name: '查询医保政策'},
                {id: 5, name: '修改地址'},
                {id: 6, name: '修改电话'},
                {id: 7, name: '申请调整联络站'},
                {id: 8, name: '申请调整国企社会化工作站'},
                {id: 9, name: '反映问题'},
                {id: 10, name: '其他'}
            ];
        }
        return angular.extend(service, $resource(service.API_URL + '/:id', {},serviceConfObj));
    }

})();
angular.module('c')
    .factory('MedicalInfo', function ($resource) {
        return $resource('/api/v1/medical_info/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            exchange: {
                method: 'POST',
                params: {
                    action: 'exchange'
                }
            },
            query: {
                method: 'GET'
            }
        });
    });



(function () {
    'use strict';

    angular.module('c')
        .factory('OfficeDeptPhone', OfficeDeptPhone)
    ;

    /** @ngInject */
    function OfficeDeptPhone($resource, serviceConfObj) {
        var service = {
        };
        return angular.extend(service, $resource('/api/v1/dept_phone/:id', {
            id: '@id',
            action: '@action'
        }, serviceConfObj,{
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .factory('OperationPermit', OperationPermit)      // 手术单申请
        .factory('ORRecipient', ORRecipient)
        .factory('IRSchedule', IRSchedule)      // 介入手术室手术单
        .factory('ORSchedule', ORSchedule)      // 住院部手术单
        .factory('OutPSchedule', OutPSchedule)  // 门诊部手术单
    ;

    /** @ngInject */
    function OperationPermit($resource, serviceConfObj) {
        var service = {
            urls: {
                UPLOAD: '/api/v1/operation_permits/upload',
                DN: '/api/v1/operation_permits/download'
            }
        };
        return angular.extend(service, $resource('/api/v1/operation_permits/:id', {}, serviceConfObj));
    }

    /** @ngInject */
    function ORRecipient($resource, serviceConfObj) {
        return $resource('/api/v1/or_recipients/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function IRSchedule($resource) {
        return opSchedule($resource, 'ir_schedules');
    }

    /** @ngInject */
    function ORSchedule($resource) {
        return opSchedule($resource, 'or_schedules');
    }

    /** @ngInject */
    function OutPSchedule($resource) {
        return opSchedule($resource, 'out_p_schedules');
    }

    function opSchedule($resource, type) {
        var service = {
            urls: {
                UPLOAD: '/api/v1/' + type + '/upload',
                DN: '/api/v1/' + type + '/download',
            }
        };

        return angular.extend(service, $resource('/api/v1/' + type + '/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            exchange: {
                method: 'POST',
                params: {
                    action: 'exchange'
                }
            }
        }));
    }
})();

angular.module('c')
    .factory('QualificationChangeRemind', ['$resource', function ($resource) {
        return $resource('/api/v1/qualification/qualification_change_reminds/:action/:id', {
            id: '@id',
            action: '@action'
        },{
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c')
    .factory('RedHeadApprover', ['$resource', function ($resource) {
        return $resource('/api/v1/red_head_approvers/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


(function () {
    'use strict';

    angular.module('c')
        .factory('Role', Role)
        .factory('Permission', Permission)
    ;

    /** @ngInject */
    function Permission($resource) {
        return $resource('/api/v1/permissions/:id');
    }

    /** @ngInject */
    function Role($resource, serviceConfObj) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/roles/:id',
            {}, serviceConfObj));
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .factory('ServiceRecord', ServiceRecord)
        .factory('ServiceActivity', ServiceActivity)
        .factory('CallCenterType', CallCenterType)
        .factory('CallCenterTemplate', CallCenterTemplate)
        .factory('CallCenterRecord', CallCenterRecord)
    ;

    /** @ngInject */
    function CallCenterRecord($resource) {
        var API_URL = "/api/v1/service/call_center_records";
        var service = {
            API_URL: API_URL,
            getStates: getStates,
        };

        function getStates() {
            return [
                {id: 1, name: '待回复'},
                {id: 2, name: '已回复'}
            ];
        }


        return angular.extend(service, $resource(service.API_URL + '/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            sta: {
                method: 'POST',
                params: {
                    action: 'sta'
                }
            },
        }));
    }

    /** @ngInject */
    function CallCenterTemplate($resource, serviceConfObj) {
        var API_URL = "/api/v1/service/call_center_templates";
        var service = {
            API_URL: API_URL,
        };

        return angular.extend(service, $resource(service.API_URL + '/:id', {}, serviceConfObj));
    }

    /** @ngInject */
    function CallCenterType($resource, serviceConfObj) {
        var API_URL = "/api/v1/service/call_center_types";
        var service = {
            API_URL: API_URL,
        };

        return angular.extend(service, $resource(service.API_URL + '/:id', {}, serviceConfObj));
    }

    /** @ngInject */
    function ServiceActivity($resource, serviceConfObj) {
        var API_URL = "/api/v1/service/service_activities";
        var service = {
            API_URL: API_URL,
        };

        return angular.extend(service, $resource(service.API_URL + '/:id', {}, serviceConfObj));
    }


    /** @ngInject */
    function ServiceRecord($resource, serviceConfObj) {
        var API_URL = "/api/v1/service/service_records";
        var service = {
            API_URL: API_URL,

            STATE: {
                PENDING_ASSIGN: 1,
                PENDING: 2,
                HANDLED: 3
            },
            getStates: getStates,
            getTypes: getTypes,
            getStatesForInfoConfirm: getStatesForInfoConfirm,
            STA_URL: API_URL + '/sta',
            STA_DETAIL_URL: API_URL + '/detail_sta',
            STA_EC_URL: API_URL + '/ec_sta',
            ERROR_EXPORT: API_URL + '/error_export',
            DUPLICATE_EXPORT: API_URL + '/duplicate_export'
        };

        return angular.extend(service, $resource(service.API_URL + '/:id', {}, serviceConfObj));

        function getStatesForInfoConfirm() {
            return [
                {id: 1, name: '待回复'},
                {id: 2, name: '待确认'},
                {id: 3, name: '已确认'},
            ];
        }

        function getStates() {
            var states = getStatesForInfoConfirm();
            states.push({id: 4, name: '已评价'});
            return states;
        }

        function getTypes() {
            return [
                {id: 1, name: '信息确认'},
                {id: 2, name: '投诉'},
                {id: 3, name: '工资查询'},
                {id: 4, name: '医保查询'},
                {id: 5, name: '医疗咨询'},
                {id: 6, name: '其他咨询'},
                {id: 7, name: '电话随访'},
                {id: 8, name: '上门随访'},
                {id: 9, name: '活动随访'}
            ];
        }
    }


})();

(function () {
    'use strict';


    angular.module('c')
        .factory('Setting', SettingService);

    /** @ngInject */
    function SettingService($resource) {
        return $resource('/api/v1/settings/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .factory('Sms', Sms)
    ;

    /** @ngInject */
    function Sms($resource, serviceConfObj) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/sms/:action/:id',
            {}, angular.extend(serviceConfObj, {
                send: {
                    method: 'POST',
                    params: {
                        action: 'send'
                    }
                },
                batchRemove: {
                    method: 'POST',
                    params: {
                        action: 'batchRemove'
                    }
                }
            })));
    }

})();

// angular.module('c')
//     .factory('Sms', function($http, C) {
//         return {
//             send: function (data, success, error) {
//                 $http.post(C.URL.SMS_SEND, data).success(success).error(error);
//             },
//             remove: function (data, success, error) {
//                 $http.post(C.URL.SMS_RM, data).success(success).error(error);
//             },
//             history: function (data, success, error) {
//                 $http.get(C.URL.SMS_HISTORY, {params: data}).success(success).error(error);
//             }
//         };
//     });


(function () {
    'use strict';


    angular.module('c')
        .factory('UserType', UserType)
        .factory('UserStatus', UserStatus)
        .factory('UserInfo', UserInfo)
        .factory('User', User)
        .factory('UserDept', UserDept)
        .factory('EntryType', EntryType)
        .factory('LeaveReason', LeaveReason)
        .factory('Role', Role)
        .factory('Permission', Permission)
        .factory('MedicalInsuranceType', MedicalInsuranceType)
        .factory('RetirementType', RetirementType)
        .factory('Company', Company)
        .factory('DisableLevel', DisableLevel)
        .factory('ManageType', ManageType)
        .factory('Disease', Disease)
        .factory('CompanyUser', CompanyUser)
    ;

    /** @ngInject */
    function UserDept($resource, serviceConfObj) {
        return $resource('/api/v1/user/user_depts/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function UserInfo($resource, $http, Dlg, UserStatus, serviceConfObj, DateHelper, City, County, Street, ArrayHelper,
                      $timeout, ExtHelper) {
        var bindVm;
        var API = '/api/v1/user/user_info';
        var service = {
            urls: {
                API: API,
                DN_WORK_PHOTO: API + '/dnWorkPhoto',
                EXPORT_USER_INFO: API + '/exportUsers',
                DN_WAGE_EXAMPLE: API + '/dnWageExample'
            },

            getYesNos: getYesNos,
            getSexes: getSexes,
            getHasOrNot: getHasOrNot,

            // helper
            formHelper: {
                init: init,
                bindAsyncOptions: bindAsyncOptions,
                loadParams: loadParams,
                loadItem: loadItem
            },

            transferDept: transferDept,
        };

        return angular.extend(service, $resource(service.urls.API + '/:action/:id',
            {}, angular.extend(serviceConfObj, {
                batchBadge: {
                    method: 'POST',
                    params: {
                        action: 'batchBadge'
                    }
                }
            })));

        /////////////////////////////////////////////////////////////
        // form helper
        function init(vm) {
            vm.addUserPhoto = addUserPhoto;
            vm.idCardChange = idCardChange;
            vm.startChange = startChange;
            vm.tibetChange = tibetChange;
            vm.leaveChange = leaveChange;
            vm.liveTypeSelected = liveTypeSelected;
            vm.tagTransform1 = tagTransform1;
            vm.tagTransform2 = tagTransform2;
            vm.add = add;
            vm.remove = remove;
            vm.addInfo = addInfo;
            vm.readCard = readCard;
            vm.chkExt = ExtHelper.chkCardReadExt(vm);

            vm.workStates = getWorkStates();
            vm.houseTypes = getHouseTypes();
            vm.soldierTypes = getSoldierTypes();
            vm.liveTypes = getLiveTypes();
            vm.identities = getIdentities();
            vm.marryTypes = getMarryTypes();
            vm.selfCares = getSelfCares();
            vm.elderlyServiceTypes = getElderlyServiceTypes();
            vm.elderlyServiceGrades = getElderlyServiceGrades();
            vm.index = 0;
            vm.relativeTypes = getRelativeTypes();
            bindVm = vm;
        }

        function getYesNos() {
            return [
                {id: 0, name: '否'},
                {id: 1, name: '是'}
            ];
        }

        function liveTypeSelected(m) {
            var vm = bindVm;
            if (m.id === 3) {
                vm.m.has_children = true;
                vm.m.same_city = true;
            }
        }

        function startChange(m) {
            if (m.started_work && m.leave_time) {
                var startYear = m.started_work.getFullYear(), startMonth = m.started_work.getMonth(),
                    startDay = m.started_work.getDate();
                var endYear = m.leave_time.getFullYear(), endMonth = m.leave_time.getMonth(),
                    endDay = m.leave_time.getDate();
                m.work_time = endYear - startYear;
                if (startMonth < endMonth || (startMonth == endMonth && startDay < endDay)) {
                    m.work_time += 1;
                }
            }
        }

        function tibetChange(m) {
            if (m.tibet_work && m.leave_time) {
                var startYear = m.tibet_work.getFullYear(), startMonth = m.tibet_work.getMonth(),
                    startDay = m.tibet_work.getDate();
                var endYear = m.leave_time.getFullYear(), endMonth = m.leave_time.getMonth(),
                    endDay = m.leave_time.getDate();
                m.tibet_time = endYear - startYear;
                if (startMonth < endMonth || (startMonth == endMonth && startDay < endDay)) {
                    m.tibet_time += 1;
                }
            }
        }

        function leaveChange(m) {
            startChange(m);
            tibetChange(m);
        }

        function idCardChange(m, queryInfo) {
            var vm = bindVm;
            if (m.id_card && (m.id_card.length == 18 || m.id_card.length == 15)) {
                if (queryInfo) {
                    service.get({id: '-', op: 'byIdCard', id_card: m.id_card}).$promise.then(function (resp) {
                        var item = resp.item;
                        loadItem(item);
                        $timeout(function () {
                            for (var i in item) {
                                if (item.hasOwnProperty(i)) {
                                    m[i] = item[i];
                                }
                            }
                        }, 500);
                    });
                }
                $timeout(function () {
                    var idCard = m.id_card.length == 18 ? m.id_card.substring(0, 17) : m.id_card.slice(0, 6) + "19" + m.id_card.slice(6, 16);
                    m.birthday = DateHelper.str2Date(idCard.substring(6, 10) + "-" + idCard.substring(10, 12) + "-" + idCard.substring(12, 14));
                    m.male = parseInt(idCard.substr(16, 1)) % 2 == 1 ? 1 : 0;
                }, 1000);
            }
        }

        function tagTransform1(newTag) {
            var vm = bindVm;
            var item = ArrayHelper.getItem(newTag, vm.workCompanies, 'name');
            if (item) {
                return none;
            }
            return {name: newTag};
        }

        function tagTransform2(newTag) {
            var vm = bindVm;
            var item = ArrayHelper.getItem(newTag, vm.manageCompanies, 'name');
            if (item) {
                return none;
            }
            return {name: newTag};
        }

        function add(m) {
            var vm = bindVm;
            m.relatives.push({index: vm.index++});
        }

        function remove(m, index) {
            m.relatives.splice(index, 1);
        }

        function addInfo(r, m, phoneConfirm, phoneConfirm1) {
            var num = 0;
            if (m.relatives.length > 0) {
                for (var i = 0; i < m.relatives.length; i++) {
                    if (m.relatives[i].type.id == 1) {
                        num++;
                    }
                }
            }
            if (num > 1) {
                Dlg.w('已经存在配偶关系，无法再次添加');
                return
            }
            Dlg.show({
                template: 'pages/personnel/temp/secondUserDlg.html',
                ctrl: 'SecondUserDlgCtrl',
                data: {r: r, phoneConfirm: phoneConfirm, phoneConfirm1: phoneConfirm1},
                size: 'lg'
            }).then(function (params) {
                r = params;
            });
        }

        function readCard(m, vm) {
            return ExtHelper.readCard(vm).then(function (cardInfo) {
                m.id_card = cardInfo.idcard;
                idCardChange(m, true);
                if (!cardInfo && cardInfo.address) m.address = cardInfo.address;
                if (!cardInfo && cardInfo.name) m.name = cardInfo.address;
            }, function (msg) {
                if (msg) Dlg.error(msg);
            });
        }

        function getWorkStates() {
            return [
                {id: 1, name: '退休'},
                {id: 2, name: '离休'},
                {id: 3, name: '其他'}
            ]
        }

        function getHouseTypes() {
            return [
                {id: 1, name: '已解'},
                {id: 2, name: '已由组织解决'},
                {id: 3, name: '自己'},
                {id: 4, name: '自解'},
                {id: 5, name: '租住'},
                {id: 6, name: '其他'}
            ]
        }

        function getIdentities() {
            return [
                {id: 1, name: '干部'},
                {id: 2, name: '工人'}
            ]
        }

        function getLiveTypes() {
            return [
                {id: 1, name: '独居'},
                {id: 2, name: '配偶同居'},
                {id: 3, name: '子女同居'}
            ]
        }

        function getMarryTypes() {
            return [
                {id: 1, name: '已婚'},
                {id: 2, name: '未婚'},
                {id: 3, name: '离婚'},
                {id: 4, name: '再婚'},
                {id: 5, name: '丧偶'}
            ]
        }

        function getSelfCares() {
            return [
                {id: 1, name: '完全自理'},
                {id: 2, name: '部分自理'},
                {id: 3, name: '完全不能自理'}
            ]
        }

        function getElderlyServiceTypes() {
            return [
                {id: 1, name: '居家养老'},
                {id: 2, name: '机构性养老'},
            ]
        }

        function getElderlyServiceGrades() {
            return [
                {id: 1, name: '2000-4000元'},
                {id: 2, name: '4000-6000元'},
                {id: 3, name: '6000-8000元'},
                {id: 4, name: '8000-10000元'},
            ]
        }

        function getSoldierTypes() {
            return [
                {id: 1, name: '十八军'},
                {id: 2, name: '抗美援朝'},
                {id: 3, name: '西北先遣支队'}
            ]
        }

        function getRelativeTypes() {
            return [
                {id: 1, name: '配偶'},
                {id: 2, name: '父亲'},
                {id: 3, name: '母亲'},
                {id: 4, name: '儿子'},
                {id: 5, name: '女儿'}
            ]
        }

        function getSexes() {
            return [
                {id: 0, name: '女'},
                {id: 1, name: '男'}
            ];
        }

        function getHasOrNot() {
            return [
                {id: 1, name: '有'},
                {id: 0, name: '无'}
            ];
        }

        function bindAsyncOptions(vm, resp) {
            vm.nations = resp.items.nations;
            vm.medicalInsuranceTypes = resp.items.medical_insurance_types;
            vm.workCompanies = resp.items.work_companies;
            vm.manageCompanies = resp.items.manage_companies;
            vm.retirementTypes = resp.items.retirement_types;
            vm.politicalStatuses = resp.items.political_statuses;
            vm.provinces = resp.items.provinces;
            vm.disableLevels = resp.items.disable_levels;
            vm.manageTypes = resp.items.manage_types;
            vm.partyBranches = resp.items.party_branches;
            vm.depts = resp.items.depts;
            vm.diseases = resp.items.diseases;

            bindVm = vm;
        }

        function loadParams(m) {
            var pa = {
                // 账户信息
                phone: m.phone == '' ? null : m.phone,
                name: m.name,
                // 基本信息
                photo: m.photo,
                id_card: m.id_card,
                male: m.male,
                nation_id: m.nation ? m.nation.id : null,
                native_place: m.native_place,
                domicile: m.domicile,
                political_status_id: m.political_status ? m.political_status.id : null,
                telephone: m.telephone,
                ss_number: m.ss_number,
                ss_card: m.ss_card,
                birthday: m.birthday ? DateHelper.date2Str(m.birthday) : null,
                speciality: m.speciality,
                interest: m.interest,
                special_difficulty: m.special_difficulty,
                individual_need: m.individual_need,
                // 居住信息
                house_type: m.house_type ? m.house_type.id : null,
                province_id: m.province ? m.province.id : null,
                city_id: m.city ? m.city.id : null,
                county_id: m.county ? m.county.id : null,
                street_id: m.street ? m.street.id : null,
                address: m.address,
                live_type: m.live_type ? m.live_type.id : null,
                marry_type: m.marry_type ? m.marry_type.id : null,
                has_children: m.has_children ? 1 : 0,
                same_city: m.same_city ? 1 : 0,
                // 工作信息
                work_state: m.work_state ? m.work_state.id : null,
                work_company: m.workCompany,
                post: m.post,
                title: m.title,
                identity: m.identity,
                tibet_work: m.tibet_work ? DateHelper.date2Str(m.tibet_work) : null,
                started_work: m.started_work ? DateHelper.date2Str(m.started_work) : null,
                leave_time: m.leave_time ? DateHelper.date2Str(m.leave_time) : null,
                work_time: m.work_time,
                tibet_time: m.tibet_time,
                retirement_type_id: m.retirement_type ? m.retirement_type.id : null,
                manage_company: m.manageCompany,
                manage_type_id: m.manage_type ? m.manage_type.id : null,
                // 医疗信息
                mi_id: m.mi ? m.mi.id : null,
                mi_place: m.mi_place,
                mi_servant: m.mi_servant ? 1 : 0,
                disability: m.disability ? m.disability : 0,
                disable_level_id: m.disable_level ? m.disable_level.id : null,
                self_care: m.self_care ? m.self_care.id : null,
                fixed_hospital: m.fixed_hospital,
                dept_name: m.dept_name,
                dept_id: m.dept ? m.dept.id : null,
                fd: m.fd ? 1 : 0,
                //安置信息
                resettlement_time: m.resettlement_time ? DateHelper.date2Str(m.resettlement_time) : null,
                supply_time: m.supply_time ? DateHelper.date2Str(m.supply_time) : null,
                soldier_type: m.soldier_type ? m.soldier_type.id : null,
                elderly_service: m.elderly_service ? 1 : 0,
                elderly_service_type: m.elderly_service_type ? m.elderly_service_type.id : null,
                elderly_service_grade: m.elderly_service_grade ? m.elderly_service_grade.id : null,
                ex_serviceman: m.ex_serviceman ? 1 : 0,
                bank: m.bank,
                bank_account: m.bank_account,
                wage: m.wage,
                manage_fee: m.manage_fee,
                activity_fee: m.activity_fee,
                add_fee: m.add_fee,
                health_fee: m.health_fee,
                welfare_fee: m.welfare_fee,
                nurse_fee: m.nurse_fee,
                phone_fee: m.phone_fee,
                examine_fee: m.examine_fee,
                retire_fee: m.retire_fee,
                clinc_fee: m.clinc_fee,
                age_fee: m.age_fee,
                month_fee: m.month_fee,
                festival_fee: m.festival_fee,
                other_fee: m.other_fee,
                maintenance_fee: m.maintenance_fee,
                traffic_fee: m.traffic_fee,
                heating_fee: m.heating_fee,
                welfare_fund: m.welfare_fund,
                servant: m.servant ? 1 : 0,
                line_number: m.line_number,
                incapable: m.incapable ? 1 : 0,
                incapable_note: m.incapable_note,
                difficulty: m.difficulty ? 1 : 0,
                difficulty_note: m.difficulty_note,
                illness: m.illness ? 1 : 0,
                illness_note: m.illness_note,
                recuperation: m.recuperation ? 1 : 0,
                recuperation_note: m.recuperation_note,
                //党组织信息
                old_branch_name: m.old_branch_name,
                branch_name: m.branch_name,
                p_branch_id: m.p_branch ? m.p_branch.id : null,
                party_place: m.party_place,
                party_join_time: m.party_join_time ? DateHelper.date2Str(m.party_join_time) : null,
                party_member_time: m.party_member_time ? DateHelper.date2Str(m.party_member_time) : null,
                diseaseIds: [],
                dead_time: m.dead_time ? DateHelper.date2Str(m.dead_time) : null,
                dead: m.dead_time ? 1 : 0,
                placement_type: m.placement_type ? m.placement_type.id : null,
                rr: m.rr ? m.rr : null,
                is_into: m.is_into ? m.is_into : null,
                is_dc: m.is_dc ? m.is_dc : null,
                is_cd_home: m.is_cd_home ? m.is_cd_home : null,
                cd_home_address: m.cd_home_address ? m.cd_home_address : null,
                is_placement: m.is_placement ? m.is_placement : null,


            };

            if (m.diseases.length > 0) {
                pa.diseaseIds = ArrayHelper.map(m.diseases, function (i) {
                    return i.id;
                });
            }

            return pa;
        }

        function loadItem(item) {
            var vm = bindVm;
            if (item) {
                item.work_state = ArrayHelper.getItem(item.work_state, vm.workStates);
                item.house_type = ArrayHelper.getItem(item.house_type, vm.houseTypes);
                item.soldier_type = ArrayHelper.getItem(item.soldier_type, vm.soldierTypes);
                item.live_type = ArrayHelper.getItem(item.live_type, vm.liveTypes);
                item.marry_type = ArrayHelper.getItem(item.marry_type, vm.marryTypes);
                item.self_care = ArrayHelper.getItem(item.self_care, vm.selfCares);
                item.elderly_service_type = ArrayHelper.getItem(item.elderly_service_type, vm.elderlyServiceTypes);
                item.elderly_service_grade = ArrayHelper.getItem(item.elderly_service_grade, vm.elderlyServiceGrades);
                item.relative_type = ArrayHelper.getItem(item.relative_type, vm.relativeTypes);
                if (item.work_company) {
                    item.workCompany = [item.work_company];
                } else {
                    item.workCompany = [];
                }
                if (item.manage_company) {
                    item.manageCompany = [item.manage_company];
                } else {
                    item.manageCompany = [];
                }
                item.birthday = item.birthday ? DateHelper.str2Date(item.birthday) : null;
                item.tibet_work = item.tibet_work ? DateHelper.str2Date(item.tibet_work) : null;
                item.started_work = item.started_work ? DateHelper.str2Date(item.started_work) : null;
                item.leave_time = item.leave_time ? DateHelper.str2Date(item.leave_time) : null;
                item.resettlement_time = item.resettlement_time ? DateHelper.str2Date(item.resettlement_time) : null;
                item.supply_time = item.supply_time ? DateHelper.str2Date(item.supply_time) : null;
                item.party_join_time = item.party_join_time ? DateHelper.str2Date(item.party_join_time) : null;
                item.party_member_time = item.party_member_time ? DateHelper.str2Date(item.party_member_time) : null;
                item.dead_time = item.dead_time ? DateHelper.str2Date(item.dead_time) : null;
                if (item.province) vm.provinceSelected(item.province, item);
                var backup = item.diseases;
                item.diseases = [];
                $timeout(function () {
                    var diseases = [];
                    angular.forEach(backup, function (d) {
                        var disease = ArrayHelper.getItem(d.id, vm.diseases);
                        if (disease) {
                            diseases.push(disease);
                        }
                    });
                    item.diseases = diseases;
                });

                var relatives = [];
                if (item.s_users && item.s_users.length > 0) {
                    angular.forEach(item.s_users, function (item) {
                        loadItem(item);
                        item.type = ArrayHelper.getItem(item.pivot.type, vm.relativeTypes);
                        relatives.push(item);
                    });
                }
                if (item.relatives && item.relatives.length > 0) {
                    angular.forEach(item.relatives, function (item) {
                        item.type = ArrayHelper.getItem(item.pivot.type, vm.relativeTypes);
                        relatives.push(item);
                    });

                }
                item.relatives = relatives;
            }
        }

        function addUserPhoto(m) {
            Dlg.show({
                template: 'pages/user/profile/userPhotoDlg.html',
                ctrl: 'UserPhotoDlgCtrl',
                data: {id: m.id}
            }).then(function (resp) {
                m.photo = resp[0];
            });
        }

        ///////////////////////////////////////////////////////////////
        function transferDept(userId, deptId, params) {
            var api = service.urls.API + '/' + userId + '/transfer/' + deptId;
            params.op = 'transfer';
            return $http.post(api, params);
        }
    }

    /** @ngInject */
    function User($resource, $http, Dlg, UserStatus, serviceConfObj, DateHelper) {
        var bindVm;
        var API = '/api/v1/user/users';
        var service = {
            urls: {
                API: API,
                DN_WORK_PHOTO: API + '/dnWorkPhoto',
                EXPORT_USER_INFO: API + '/exportUsers',
                EXPORT_DEPT_NOT_SIGN: API + '/exportSignSeal'
            },
            CONFIRM: {
                PENDING: 0,
                USER: 1,
                DEPT: 2,
                PERSONNEL: 3
            },
            BADGE: {
                PENDING: 1,
                MAKING: 2,
                RECEIVE: 3,
                FINISH: 4
            },
            getDegree: getDegree,

            getYesNos: getYesNos,
            getSexes: getSexes,

            getDegreeTypes: getDegreeTypes,
            getEduBgList: getEduBgList,
            getEnLvList: getEnLvList,

            getBadges: getBadges,

            // helper
            formHelper: {
                init: init,
                bindAsyncOptions: bindAsyncOptions,
                loadParams: loadParams
            },

            transferDept: transferDept,

            // means old version , 应该逐渐抛弃
            ov: $resource('/api/v1/user/ov/users/:action/:id', {
                id: '@id',
                action: '@action'
            }, {
                update: {
                    method: 'PUT'
                },
                query: {
                    method: 'GET'
                }
            })
        };

        return angular.extend(service, $resource(service.urls.API + '/:action/:id',
            {}, angular.extend(serviceConfObj, {
                batchBadge: {
                    method: 'POST',
                    params: {
                        action: 'batchBadge'
                    }
                }
            })));

        /////////////////////////////////////////////////////////////
        // form helper
        function init(vm, $scope) {

            vm.addUserPhoto = addUserPhoto;
            vm.calcAnnualTotal = calcAnnualTotal;

            vm.edu_bgs = getEduBgList();
            vm.degree_types = getDegreeTypes();
            vm.en_lvs = getEnLvList();

            $scope.$watch('vm.m.edu_bg', function (newValue) {
                if (typeof newValue !== 'undefined') {
                    if (vm.m) {
                        if (newValue.id == 5) {
                            vm.m.degree = vm.degree_types[0];
                        } else if (newValue.id == 6) {
                            vm.m.degree = vm.degree_types[1];
                        } else if (newValue.id == 7) {
                            vm.m.degree = vm.degree_types[2];
                        } else {
                            vm.m.degree = vm.degree_types[3];
                        }
                    }
                }
            });

            $scope.$watch('vm.m.pt_edu_bg', function (newValue) {
                if (typeof newValue !== 'undefined' && newValue != null) {
                    if (vm.m) {
                        if (newValue.id == 5) {
                            vm.m.pt_degree = vm.degree_types[0];
                        } else if (newValue.id == 6) {
                            vm.m.pt_degree = vm.degree_types[1];
                        } else if (newValue.id == 7) {
                            vm.m.pt_degree = vm.degree_types[2];
                        } else {
                            vm.m.pt_degree = vm.degree_types[3];
                        }
                    }
                }
            });

            bindVm = vm;
        }

        function getYesNos() {
            return [
                {id: 0, name: '否'},
                {id: 1, name: '是'}
            ];
        }

        function getSexes() {
            return [
                {id: 0, name: '女'},
                {id: 1, name: '男'}
            ];
        }

        function bindAsyncOptions(vm, options) {
            //
            vm.types = options.items.types;
            vm.statuses = options.items.statuses;

            vm.political_statuses = options.items.political_statuses;
            vm.companies = options.items.companies;

            bindVm = vm;
        }

        function loadParams(m, op) {
            var pa = {
                op: op,
                // 账户信息
                // username: m.username, // 自动根据id生成 4位数，不足在前面用0补齐
                phone: m.phone,
                name: m.name,
                // 基本信息
                sex: m.sex,
                id_card: m.id_card,
                political_status_id: m.political_status ? m.political_status.id : null,
                salary_card: m.salary_card ? m.salary_card : null,
                card_bank: m.card_bank ? m.card_bank : null,
                // 工作相关 ! 头像/工作照 修改后直接更新
                status_id: m.status ? m.status.id : null,
                type_id: m.type ? m.type.id : null,
                is_cadre: m.is_cadre,
                entry_time: m.entry_time ? DateHelper.date2Str(m.entry_time) : null,
                started_work: m.started_work ? DateHelper.date2Str(m.started_work) : null,
                post: m.post,
                // 教育背景
                graduate_school: m.graduate_school,
                major: m.major,
                edu_bg: m.edu_bg ? m.edu_bg.id : null,
                degree: m.degree ? m.degree.name : null,
                en_lv: m.en_lv ? m.en_lv.id : null,
                // 联系方式
                phone2: m.phone2,
                office_phone: m.office_phone,
                email: m.email,
                qq: m.qq,
                address: m.address,
                //
                update_annual_num: m.update_annual_num,
                //籍贯
                native_place: m.native_place,
                domicile: m.domicile,
                //入党时间
                party_time: m.party_time ? DateHelper.date2Str(m.party_time) : null,
                //非全日制
                pt_graduate_school: m.pt_graduate_school,
                pt_major: m.pt_major,
                pt_edu_bg: m.pt_edu_bg ? m.pt_edu_bg.id : null,
                pt_degree: m.pt_degree ? m.pt_degree.name : null,
                pt_en_lv: m.pt_en_lv ? m.pt_en_lv.id : null
            };
            // 3 表示护士
            if (m.update_annual_num) pa.annual_days = m.annual_days;

            return pa;
        }

        function addUserPhoto(m) {
            Dlg.show({
                template: 'pages/user/profile/userPhotoDlg.html',
                ctrl: 'UserPhotoDlgCtrl',
                data: {id: m.id}
            }).then(function (resp) {
                m.photo = resp[0];
                m.work_photo = resp[1];
            });
        }

        function calcAnnualTotal(m) {
            var vm = bindVm;
            if (m.status && m.entry_time && m.started_work) {
                var params = {
                    op: 'annual_total',
                    status_id: m.status.id, entry_time: m.entry_time,
                    started_work: m.started_work
                };
                var api = service.urls.API + '/-';
                $http.get(api, {params: params}).success(function (resp) {
                    vm.annualTotal = resp;
                });
            } else {
                delete vm.annualTotal;
            }
            // addition
            var required = m.status && m.status.id !== UserStatus.ID.PRACTICE;
            bindVm.cfg.required.annualDays = required;
        }

        ///////////////////////////////////////////////////////////////
        function transferDept(userId, deptId, params) {
            var api = service.urls.API + '/' + userId + '/transfer/' + deptId;
            params.op = 'transfer';
            return $http.post(api, params);
        }

        function getDegree(degree) {
            var degreeTypes = getDegreeTypes();
            if (degree) {
                for (var i = 0; i < degreeTypes.length; i++) {
                    var type = degreeTypes[i];
                    if (degree.indexOf(type.name) >= 0) {
                        return type;
                    }
                }
            }
            return degreeTypes[0];
        }

        function getDegreeTypes() {
            return [
                {id: 4, name: "学士"},
                {id: 3, name: "硕士"},
                {id: 2, name: "博士"},
                {id: 0, name: "无"}
            ];
        }

        function getEduBgList() {
            return [
                {id: 5, name: "本科"},
                {id: 6, name: "硕士研究生"},
                {id: 7, name: "博士研究生"},
                {id: 1, name: "高中"},
                {id: 2, name: "中专"},
                {id: 3, name: "大专"},
                {id: 4, name: "初中"},
                {id: 8, name: "职高"},
                {id: 9, name: "其他"}
            ];
        }

        function getEnLvList() {
            return [
                {id: 3, name: "大学公共英语4级"},
                {id: 4, name: "大学公共英语6级"},
                {id: 2, name: "大学公共英语2级"},
                {id: 5, name: "其他英语等级"},
                {id: 6, name: "其他外语种"},
                {id: 1, name: "无"}
            ];
        }

        function getBadges() {
            return [
                {id: 1, name: '胸牌待制作'},
                {id: 2, name: '胸牌制作中'},
                {id: 3, name: '胸牌待领取'},
                {id: 4, name: '胸牌已领取'}
            ]
        }
    }

    /** @ngInject */
    function UserType($resource) {
        return $resource('/api/v1/user/user_types/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }

    /** @ngInject */
    function UserStatus($resource) {
        var service = {
            ID: {
                OTHER: 1,
                DIRECT: 5
            }
        };

        return angular.extend(service, $resource('/api/v1/user/user_statuses/:id', {}, {
            update: {
                method: 'PUT'
            }
        }));
    }

    /** @ngInject */
    function EntryType($resource) {
        return $resource('/api/v1/user/entry_types/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }

    /** @ngInject */
    function LeaveReason($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/user/leave_reasons/:id', {}, {
            update: {
                method: 'PUT'
            }
        }));
    }

    /** @ngInject */
    function Permission($resource) {
        return $resource('/api/v1/user/permissions/:id');
    }

    /** @ngInject */
    function Role($resource, serviceConfObj) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/user/roles/:id',
            {}, serviceConfObj));
    }

    /** @ngInject */
    function MedicalInsuranceType($resource, serviceConfObj) {
        return $resource('/api/v1/user/medical_insurance_types/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function RetirementType($resource, serviceConfObj) {
        return $resource('/api/v1/user/retirement_types/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function Company($resource, serviceConfObj) {
        var service = {
            getLevels: getLevels,
            getTypes: getTypes,
            getClasses: getClasses
        };

        function getLevels() {
            return [
                {id: 0, name: '二类'},
                {id: 1, name: '三类'},
                {id: 2, name: '四类'},
                {id: 3, name: '其他'},
            ];
        }

        function getTypes() {
            return [
                {id: 1, name: '机关'},
                {id: 2, name: '机合'},
                {id: 3, name: '企业'},
                {id: 4, name: '事合'},
                {id: 5, name: '事业'},
                {id: 6, name: '其他'}
            ];
        }

        function getClasses() {
            return [
                {id: 1, name: '工作单位'},
                {id: 2, name: '主管单位'},
            ];
        }

        return angular.extend(service, $resource('/api/v1/user/companies/:id', {}, serviceConfObj));
    }

    /** @ngInject */
    function DisableLevel($resource, serviceConfObj) {
        return $resource('/api/v1/user/disable_levels/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function ManageType($resource, serviceConfObj) {
        return $resource('/api/v1/user/manage_types/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function Disease($resource, serviceConfObj) {
        return $resource('/api/v1/user/diseases/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function CompanyUser($resource, serviceConfObj) {
        return $resource('/api/v1/user/company_users/:id', {}, serviceConfObj);
    }
})();

(function () {
    'use strict';

    angular.module('c').config(config);

    /** @ngInject */
    function config(calendarConfig) {
        calendarConfig.dateFormatter = 'moment'; //use either moment or angular to format dates on the calendar. Default angular. Setting this will override any date formats you have already set.

        calendarConfig.allDateFormats.moment.date.hour = 'HH:mm'; //this will configure times on the day view to display in 24 hour format rather than the default of 12 hour
        calendarConfig.allDateFormats.moment.date.datetime = 'MMM D日, h:mm a'; //this will configure times on the day view to display in 24 hour format rather than the default of 12 hour

        calendarConfig.allDateFormats.moment.title.week = '{year}年 {week}周'; //this will configure the day view title to be shorter
        calendarConfig.allDateFormats.moment.title.day = 'dddd MMMM D号'; //this will configure the day view title to be shorter
        calendarConfig.allDateFormats.moment.title.month = 'YYYY年 MMMM'; //this will configure the day view title to be shorter
        calendarConfig.allDateFormats.moment.title.year = 'YYYY年'; //this will configure the day view title to be shorter

        calendarConfig.showTimesOnWeekView = false;

        calendarConfig.i18nStrings.weekNumber = '{week}周'; //This will set the week number hover label on the month view

    }

})();

(function () {
    'use strict';

    angular.module('c').config(dialogConfig);

    /** @ngInject */
    function dialogConfig(dialogsProvider, $translateProvider) {
        dialogsProvider.useBackdrop('static');
        dialogsProvider.useEscClose(true);
        dialogsProvider.useCopy(false);
        dialogsProvider.setSize('sm');
        dialogsProvider.useAnimation();

        $translateProvider.preferredLanguage('zh-CN');
    }

})();

(function () {
    'use strict';

    angular.module('c').config(lazyLoadConfig);

    /** @ngInject */
    function lazyLoadConfig($ocLazyLoadProvider) {
        var l = '/ocLazyLoad/';
        var m = [
            //0               1       2        3          4         5
            'ngHandsontable', 'pdf', 'video', 'uiSelect', 'qrCode', 'chart'
        ];
        $ocLazyLoadProvider.config({
            modules: [
                {
                    name: m[0],
                    files: [
                        l + m[0] + '/handsontable.full.min.js',
                        l + m[0] + '/handsontable.full.min.css',
                        l + m[0] + '/ngHandsontable.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[1],
                    files: [
                        l + m[1] + '/compatibility.js',
                        l + m[1] + '/pdf.js',
                        l + m[1] + '/angular-pdf.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[2],
                    files: [
                        l + m[2] + '/vg-overlay-play.min.js',
                        l + m[2] + '/vg-controls.min.js',
                        l + m[2] + '/vg-buffering.min.js',
                        l + m[2] + '/videogular.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[3],
                    files: [
                        l + m[3] + '/select.min.css',
                        l + m[3] + '/select.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[4],
                    files: [
                        l + m[4] + '/qrCode.min.js',
                        l + m[4] + '/angular-qrcode.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[5],
                    files: [
                        l + m[5] + '/chart.min.js',
                        l + m[5] + '/chartjs-plugin-piechart-outlabels.min.js',
                        l + m[5] + '/angular-chart.min.js'
                    ],
                    serie: true
                }
            ]
        });
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .config(otherCfg)
        .run(otherRunner);
    /** @ngInject */
    function otherCfg($provide, $httpProvider, $compileProvider, $localStorageProvider) {
        // Improving Angular performance with 1 line of code
        // https://blog.upstate.agency/improving-angular-performance-with-1-line-of-code-a1fb814a6476
        $compileProvider.debugInfoEnabled(false);

        $provide.constant('$compileProvider', $compileProvider);

        $httpProvider.useApplyAsync(true);

        $localStorageProvider.setKeyPrefix('ygjgoa');
    }

    /** @ngInject */
    function otherRunner($anchorScroll, amMoment) {
        $anchorScroll.yOffset = 128;
        amMoment.changeLocale('zh-cn');
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .config(['$urlRouterProvider', modWhenRouter])
        .config(['$stateProvider', '$urlRouterProvider', '$httpProvider', MainRouter])
        .run(stateChangeCfg);


    /**
     * ui-router bug
     * http://stackoverflow.com/questions/23658846/angular-ui-router-urlrouterprovider-when-not-working-anymore
     */
    function modWhenRouter($urlRouterProvider) {
        // $urlRouterProvider.when('/app/pc/stock', '/app/pc/stock/rooms');
        // $urlRouterProvider.when('/app/pc/remind', '/app/pc/remind/rooms');
    }

    function MainRouter($stateProvider, $urlRouterProvider, $httpProvider) {
        $urlRouterProvider.deferIntercept();

        $urlRouterProvider.otherwise('/app/home');

        $stateProvider
            // 主页
            .state('app', {
                url: '/app',
                templateUrl: 'templates/cache/main.html',
                resolve: {
                    window: ['$window', function ($window) {
                        return $window;
                    }],
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['uiSelect']);
                    }]
                },
                controller: 'MainCtrl',
                //目前能实现注销后路由状态重载的办法，但会引起页面刷新（bad!）
                //2016-7-15,以上方法在手机浏览器和苹果浏览器上会引起注销异常，现在弃用
                //关注：https://github.com/angular-ui/ui-router/issues/1095
                onExit: function () {
                    //window.location.reload();
                },
                data: {
                    requireLogin: true
                }
            })
            .state('app.home', {
                url: '/home?pendingDlgOpen',
                templateUrl: 'templates/cache/home.html',
                controller: 'HomeCtrl',
                controllerAs: 'home'
            })
            //登录
            .state('login', {
                templateUrl: 'pages/login.html',
                url: '/login',
                params: {data: {}},
                controller: 'LoginCtrl',
                data: {
                    requireLogin: false
                }
            })
            .state('temp', {
                templateUrl: 'pages/blank.html',
                url: '/blank',
                data: {requireLogin: false}
            })
            .state('get_wechat_token', {
                url: "/get_wechat_token?code",
                controller: "WechatAuthCtrl",
                data: {requireLogin: false}
            })

            .state('user_confirm', {
                templateUrl: 'pages/userConfirm.html',
                url: "/user_confirm",
                data: {requireLogin: true},
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['uiSelect']);
                    }]
                }
            });

        angular.forEach(previewRoutes, function (b) {
            var pa = {
                templateUrl: "/pages/preview/" + b[1],
                url: "/" + b[2],
                data: {
                    requireLogin: true
                }
            };
            $stateProvider.state(b[0], pa);
        });

        angular.forEach(routes, function (r) {
            var pa = {
                url: "/" + r[1] + '?tab&wxnpId&wxnpType',
                reloadOnSearch: false,
                params: {data: {}},
                perm: r[3],
                onExit: function () {
                    for (var i in CKEDITOR.instances) {
                        var editor = CKEDITOR.instances[i];
                        if (editor) editor.destroy();
                    }
                }
            };
            if (r[2].charAt(0) === '<') {
                pa.template = '<ui-view></ui-view>';
            } else {
                pa.templateUrl = "pages/" + r[2];
            }
            if (r[4]) {
                pa.resolve = {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(r[4]);
                    }]
                };
            }
            if (r[5]) {
                angular.forEach(r[5], function (c) {
                    $stateProvider.state("app." + r[0] + "." + c[0], {
                        url: "/" + c[1],
                        templateUrl: "pages/" + c[2]
                    });
                });
            }
            $stateProvider.state("app." + r[0], pa);
        });

        $httpProvider.interceptors.push(apiInterceptorFn);
    }

    var pendingRequests = [];
    var previousToState, previousToParams;

    /** @ngInject */
    function apiInterceptorFn($timeout, $q, $injector, $window, Auth, WxHelper) {
        var $state;
        var dialogs;
        var $http;
        var CODE = Auth.CODE;
        $timeout(function () {
            $state = $injector.get('$state');
            dialogs = $injector.get('dialogs');
            $http = $injector.get('$http');
        });

        return {
            'request': function (config) {
                config.headers = config.headers || {};
                if (Auth.hasToken()) {
                    config.headers.Authorization = 'Bearer ' + Auth.getToken();
                }
                return config;
            },
            'responseError': function (response) {
                if (response.status === 401) {
                    var code = getCode(response.data);
                    if (code === CODE.TOKEN_DEAD || code === CODE.INVALID) {
                        logout(code === CODE.TOKEN_DEAD);
                    }
                    if (code !== CODE.TOKEN_EXPIRED) return $q.reject(response);

                    if (pendingRequests.length === 0) {
                        $timeout(function () {
                            Auth.refreshToken().then(function (resp) {
                                var token = resp.data;
                                Auth.setToken(token);
                                var newAuth = 'Bearer ' + Auth.getToken();
                                angular.forEach(pendingRequests, function (req) {
                                    req.config.headers.Authorization = newAuth;
                                    req.resolve($http(req.config));
                                });
                            }, function (err) {
                                angular.forEach(pendingRequests, function (req) {
                                    req.reject();
                                });
                                logout(err.data.code === CODE.TOKEN_DEAD);
                            }).finally(function () {
                                pendingRequests = [];
                            });
                        }, 1000);
                    }

                    return $q(function (resolve, reject) {
                        pendingRequests.push({config: response.config, resolve: resolve, reject: reject})
                    });

                }
                return $q.reject(response);
            }
        };

        function logout(tokenDead) {
            if (Auth.hasToken()) {
                Auth.deleteToken();
                if (tokenDead) {
                    var isWx = WxHelper.isWechatBrowser();
                    dialogs.notify('信标已过期', '安全信标已过期，' +
                        (isWx ? '系统将通过微信绑定账号重新登录.' : '您需要重新登录！'))
                        .result.then(function () {
                        if (isWx) {
                            var toUrl;
                            if (previousToState) { // 好像没起作用，之后再看
                                toUrl = WxHelper.getWechatAuthorizeUrl(previousToState, previousToParams);
                            } else {
                                toUrl = WxHelper.getWechatAuthorizeUrl();
                            }
                            $window.location.href = toUrl;  // 获取微信认证地址
                        } else {
                            $state.go('login');
                        }
                    });
                } else {
                    $state.go('login');
                }
            }
        }

        function getCode(body) {
            // 针对文件上传时，响应数据类型为ArrayBuffer的情况
            if (body instanceof ArrayBuffer) {
                var str = String.fromCharCode.apply(null, new Uint8Array(body));
                body = JSON.parse(str)
            }
            return parseInt(body.code)
        }
    }

    /** @ngInject */
    function stateChangeCfg($rootScope, $state, $window, $uibModalStack, WxHelper,
                            $urlRouter, Auth, Dlg, Sidebar) {
        // $urlRouter sync() 貌似只能用在 $locationChangeSuccess 事件
        $rootScope.$on('$stateChangeStart', changeStart);
        $rootScope.$on('$stateChangeSuccess', changeSuccess);

        $urlRouter.listen();

        function changeStart(event, toState, toParams) {
            var requireLogin = toState.data.requireLogin;
            var isLoggedIn = Auth.hasToken();

            previousToState = toState;
            previousToParams = toParams;

            if (!requireLogin) { // 无需登录，则直接访问该路由
                // alert('无需登录，则直接访问该路由');
                return;
            }

            if (!isLoggedIn) {  // 未登录，则尝试利用微信登录或跳到登录页面
                event.preventDefault();
                if (WxHelper.isWechatBrowser()) {  // 尝试通过微信认证方式登录
                    // alert('未登录，尝试通过微信');
                    $window.location.href = WxHelper.getWechatAuthorizeUrl(toState, toParams);
                } else {
                    // alert('未登录，跳到login');
                    $state.go('login');
                }
                return;
            }

            // 还未获取用户菜单项表示的权限列表，则尝试获取
            if (!Sidebar.hasMenuItems()) {
                event.preventDefault();
                // alert('还未获取用户菜单项表示的权限列表，则尝试获取, toState: ' + toState.name);
                Sidebar.getMenuItems(function () {
                    $state.go(toState, toParams)
                });
                return;
            }

            // alert('检查是否拥有对应权限, toState: ' + toState.name);
            if (toState.can === false) {
                event.preventDefault();
                Dlg.notify("您没有访问该页面的权限，请求被中止了").then(function () {
                    $state.go('login');
                });
            }
        }

        function changeSuccess(event, state) {
            if (state.name) {
                $uibModalStack.dismissAll();
                if (window.innerWidth < 768) Sidebar.updateState(Sidebar.STATE.HIDDEN);
                window.scrollTo(0, 0);

                var index = $state.current.index;
                if (angular.isDefined(index)) $rootScope.collapseVar = index;
            }
        }
    }

    var previewRoutes = [
        ["email", "email.html", "emails/:id"],
        ["article", "article.html", "articles/:type/:id"],
        ["meeting", "meeting.html", "meetings/:id"],
        ["topic", "topic.html", "topics/:id"],
        ["mission", "mission.html", "missions/:id"],
        ["attendancePublicity", "attendancePublicity.html", "attendancePublicity"],
        ["meeting_comment", "meetingComment.html", "meeting_attendances/:id"],
        ["attendance_abnormal_appeals", "attendanceAbnormal.html", "attendance_abnormal_appeals/:day"]
    ];

    var routes = [
        ["user_profile", "user/profile", "user/profile.html", 1000],
        ["user_file_cabinet", "user/file_cabinet", "user/file_cabinet.html", 1001],
        ["user_dept_record", "user/dept_record", "user/dept_record.html", 1002],
        ["user_help", "user/help", "user/help.html", 1003],

        ["coop_meeting", "coop/meeting", "coop/meeting.html", 10001],

        ["message_email", "message/email", "message/email.html", 8001],
        ["message_bulletin", "message/bulletin", "message/bulletin.html", 8002],
        ["message_news", "message/news", "message/news.html", 8003],
        ["message_contact_group", "message/contact_group", "message/contact_group.html", 8004],
        ["message_contacts", "message/contacts", "message/contacts.html", 8005],
        ["message_sms", "message/sms", "message/sms.html", 8006],
        ["message_common_phone", "message/common_phone", "message/commonPhone.html", 8007],

        ["dept_member", "dept_leader/members", "dept_leader/members.html", 3001],
        ["dept_notice_approval", "dept_leader/notice_approval", "dept_leader/notice_approval.html", 3002],
        ["dept_meeting_approval", "dept_leader/meeting_approval", "dept_leader/meeting_approval.html", 3003],
        ["dept_file", "dept_leader/dept_file", "dept_leader/dept_file.html", 3004],
        ["dept_news", "dept_leader/news", "dept_leader/news.html", 3005],

        ["personnel_user_info", "personnel/user_info", "personnel/userInfoAll.html", 2000],
        ["personnel_dept_member", "personnel/dept_member", "personnel/deptMember.html", 2001],
        ["personnel_user_reg", "personnel/user_reg", "personnel/userReg.html", 2002],
        ["personnel_contact_group", "personnel/contact_group", "personnel/contact_group.html", 2003],
        ["personnel_common_phone", "personnel/common_phone", "personnel/common_phone.html", 2004],

        ["info_census_scene", "info_census/scene", "info_census/scene.html", 4001],
        ["info_census_phone", "info_census/phone", "info_census/phone.html", 4002],
        ["info_census_activity", "info_census/activity", "info_census/activity.html", 4003],

        ["company_manage", "company/manage", "company/manage.html", 4101],

        ["call_center_phone", "call_center/phone", "call_center/phone.html", 4201],
        // ["call_center_network", "call_center/network", "call_center/network.html", 4202],
        ["call_center_conversation", "call_center/conversastion", "call_center/conversation/conversation.html", 4203],

        ["letter_register", "letter/register", "letter/register.html", 4301],
        ["letter_receive", "letter/receive", "letter/receive.html", 4302],

        ["sys_basic", "sys/basic", "sys/basic.html", 9000],
        ["sys_dept", "sys/dept", "sys/dept.html", 9001],
        ["sys_meeting", "sys/meeting", "sys/meeting.html", 9002],
        ["sys_authority", "sys/authority", "sys/authority.html", 9003],
        ["sys_help", "sys/help", "sys/help.html", 9004],
        ["sys_app_cfg", "sys/app_cfg", "sys/app_cfg.html", 9005],
    ];

})();

(function () {
    'use strict';

    angular.module('c')
        .factory('mySocket', socketFactory)
        .run(runSocket)
    ;

    /** @ngInject */
    function runSocket(mySocket) {
    }

    /** @ngInject */
    function socketFactory(socketFactory) {
        // var protocol = window.location.protocol;
        var myIoSocket = io.connect("//" + window.location.hostname + ':3286');

        var mySocket = socketFactory({
            ioSocket: myIoSocket
        });

        mySocket.forward([
            // 餐补
            "ygjgoa:meal.purchased",

            // 邮件
            "ygjgoa:mail.read",
            "ygjgoa:mail.send",
            "ygjgoa:mail.withdraw",

            // 公文
            "ygjgoa:bulletin.send",
            "ygjgoa:file.release",
            "ygjgoa:meeting.send",
            "ygjgoa:meeting.read",
            "ygjgoa:mission.send",
            "ygjgoa:news.send",
            "ygjgoa:rule.send",
            "ygjgoa:selfAssessment.automatic",

            "ygjgoa:task",

            'ygjgoa:round.progress',

            //"ygjgoa:question.send",
            "ygjgoa:wechat.orderPay",
            "ygjgoa:takeOut.send",
            "ygjgoa:workingMeal.handle",
            "ygjgoa:workingMeal.send",
            "ygjgoa:appointment.notify",
        ]);

        return mySocket;
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .config(['uiMask.ConfigProvider', uiMaskConfig])
        .config(uibConfig)
    ;

    /** @ngInject */
    function uiMaskConfig(uiMaskConfigProvider) {
        uiMaskConfigProvider.clearOnBlur(false);
    }

    /** @ngInject */
    function uibConfig(uibDatepickerConfig, uibDatepickerPopupConfig, $uibTooltipProvider) {
        uibDatepickerConfig.startingDay = 1;

        uibDatepickerPopupConfig.currentText = "今天";
        uibDatepickerPopupConfig.clearText = "清除";
        uibDatepickerPopupConfig.closeText = "关闭";

        $uibTooltipProvider.options({
            appendToBody: true
        });
    }

})();

angular.module('c')
    .constant('C', {
        P: "socket:ygjgoa:",

        V: "pages/dlg/",
        T: "templates/",


        STAGE1: {
            /**
             * 科审：0
             */
            DEPT_APPROVAL: 0,
            /**
             * 分管审：1
             */
            HOSPITAL_APPROVAL: 1,
            /**
             * 科退：2
             */
            DEPT_BACK: 2,
            /**
             * 院退：3
             */
            HOSPITAL_BACK: 3,
            /**
             * 发布：4
             */
            PUBLIC: 4,
            OVER: 5
        },
        STAGE2: {
            /**
             * 审核中：0
             */
            APPROVAL: 0,
            /**
             * 退回：1
             */
            BACK: 1,
            /**
             * 发布：2
             */
            PUBLIC: 2
        },
        STAGE3: {
            /**
             * 审核中：0
             */
            APPROVAL: 0,
            /**
             * 发布：1
             */
            PUBLIC: 1,
            /**
             * 退回：2
             */
            BACK: 2
        },

        STAGE5: {
            /**
             * 科审：0
             */
            DEPT_APPROVAL: 0,
            /**
             * 分管审：1
             */
            HOSPITAL_APPROVAL: 1,
            //个人整改意见
            USER_APPROVAL: 5,
            /**
             * 办公室审核：6
             */
            PARTY_APPROVAL: 6,
            /**
             * 接受：7
             */
            ACCEPT: 7,
            /**
             * 拒绝：8
             */
            REJECT: 8,
            /**
             * 退回意见人：9
             */
            BACK: 9
        },

        EDU: {
            Q: {
                TYPE: {
                    SINGLE: '1',
                    MULTI: '2'
                }
            },
            FOR: {
                DOCTOR: 1,
                NURSE: 2,
                ALL: 3
            },
            P: {
                TYPE: {
                    NORMAL: '1',
                    PACKAGE: '2',
                    PART: '3'
                },
                R_BY: {
                    /**
                     *
                     */
                    DEPT: '1',
                    EDU: '2',
                    NURSE: '3'
                }
            },
            T: {
                SHOW: {
                    FOR: {
                        PAPER: '1',
                        FILL: '2',
                        ANSWER_SHEET: '3',
                        STATISTIC: '4'
                    }
                }
            }
        },
        Q: {
            QUESTION: {
                TYPE: {
                    SINGLE: '1',
                    MULTI: '2'
                }
            },
            TYPE: {
                NORMAL: '1',
                DEPT: '6',
                USER: '7',
                LEADER: '8'
            }
        },
        Q_SURVEY: {
            TYPE: {
                DEPT: '1',
                HOSPITAL: '2'
            },
            CLOSE: {
                WHEN_EXPIRED: '1',
                WHEN_FINISH: '2',
                WHEN_MANUAL: '3'
            },
            RR: {
                REAL_TIME: '1',
                WHEN_FINISH: '2',
                MANUAL: '3'
            },
            SHOW: {
                FOR: {
                    QUESTIONNAIRE: '1',
                    FILL: '2',
                    ANSWER_SHEET: '3',
                    STATISTIC: '4',
                    APPROVAL: '5'
                }
            }
        },
        Q_OPINION: {
            PRIVACY: {
                NONE: '1',
                RESPONDENT: '2',
                ALL: '3'
            }
        },
        OPT: {
            EDU: {
                TEST: {
                    INDEX: {
                        DEPT: 1,
                        NURSE: 2,
                        EDU: 3
                    },
                    SHOW: {
                        SIMPLE: 1,
                        STATISTICS: 2,
                        PKG_STATISTICS: 3,
                        MAKEUP: 4,
                        REMAINING: 5
                    }
                },
                P: {
                    INDEX: {
                        DEPT_P: 1,
                        DEPT_P_OPTIONS: 2,
                        PARTS: 3,
                        NURSE: 7,
                        EDU: 8
                    },
                    EDIT: {
                        SAVE: 3,
                        STOP: 4
                    }
                },
                Q: {
                    INDEX: {
                        USER_Q: 1,
                        NURSING_Q: 2,
                        EDU_Q: 3,
                        ITEM_BANK: 4
                    },
                    EDIT: {
                        APPROVAL: 1,
                        SAVE: 3,
                        STOP: 4
                    }
                },
                C: {
                    INDEX: {
                        USER: 1,
                        DEPT: 2,
                        NURSE: 3,
                        EDU: 4
                    }
                }
            },
            Q: {
                INDEX: {
                    USER_Q: 1,
                    USER_Q_OPTIONS: 2,
                    PARTY_Q: 3,
                    PARTY_Q_OPTIONS: 4
                },
                EDIT: {
                    SAVE: 3,
                    STOP: 4
                },
                EDIT1: 1,
                EDIT2: 2,
                RELEASE: 3,
                SUBMIT: 5
            },
            Q_SURVEY: {
                INDEX: {
                    USER_Q_SURVEY: 1,
                    DEPT_APPROVAL: 2,
                    HOSPITAL_APPROVAL: 3,
                    PARTY_Q_SURVEY: 4,
                    DEPT_RESULT: 5,
                    DEPT_RESULT4HOSPITAL: 6,
                    RESULT_OPTIONS: 7,
                    OPTION_NOTES: 8,
                    USER_RESULT: 9,
                    APPROVAL_LIST: 10,
                    USER_SS: 11
                },
                SHOW: {
                    SIMPLE: 1,
                    STATISTICS: 2,
                    APPROVAL: 3
                },
                EDIT: {
                    APPROVAL: 1,
                    MANUAL_CLOSE: 2,
                    MANUAL_RR: 3
                },
                APPROVAL: '1'
            },
            Q_ANSWER_SHEET: {
                INDEX: {
                    USER_Q_SHEET: 1,
                    APPROVAL_LIST: 10
                },
                EDIT: {
                    FILL: 1
                }
            },
            Q_OPINION: {
                INDEX: {
                    DEPT_APPROVAL: 2,
                    HOSPITAL_APPROVAL: 3,
                    PARTY_APPROVAL: 4,
                    USER_APPROVAL: 5,
                    USER_OPINION: 6,
                    APPROVAL_LIST: 10
                },
                EDIT: {
                    APPROVAL: 1,
                    CHANGE_DEPT: 2,
                    ADD: 3    //补充意见
                }
            },
            FILE: {
                INDEX: {
                    HOSPITAL_OFFICE_FILING: 1,
                    USER_UNREAD: 2,
                    USER_READ: 3,
                    HOSPITAL_OFFICE_SEAL_UP: 4,
                    IS_READING_PRINT: 5,
                    ALREADY_READ_PRINT: 6,
                    SEAL_UP_PRINT: 7,
                    USER_FILING: 8,
                    FILING_PRINT: 9,
                    USER_APPLIED: 10
                },
                EDIT: {
                    SEAL_UP: 1,
                    READ: 2,
                    CIRCULATE: 3,
                    FILING: 4
                }
            },
            /**
             * @deprecated 移到对应服务中
             */
            RULE_TYPE: {
                INDEX: {
                    DEPT_MANAGE: 1,
                    HOSPITAL_MANAGE: 2,
                    OPTIONS: 3,
                    NAME_EXCHANGE: 4,
                    CLASS_EXCHANGE: 5
                }
            }
        },

        URL: {
            CHROME: {
                windows: 'download/android/chrome.exe',
                android: 'download/android/chrome.apk'
                //mac: 'http://sw.bos.baidu.com/sw-search-sp/software/441142fc7c4/googlechrome_mac_50.0.2661.102.dmg',
                //ios: 'http://itunes.apple.com/cn/app/id535886823?mt=8'
            },

            IMG_UPLOAD: '/api/v1/file/images/upload',

            MEDICAL_INFO_UPLOAD: '/api/v1/medical_info/upload',
            MEDICAL_INFO_DOWNLOAD: '/api/v1/medical_info/download',

            BLOOD_STORAGE_UPLOAD: '/api/v1/blood_storage/upload',
            BLOOD_STORAGE_DOWNLOAD: '/api/v1/blood_storage/download',

            MAIL_UPLOAD: '/api/v1/emails/upload',
            MAIL_DOWNLOAD: '/api/v1/emails/download',
            BULLETIN_UPLOAD: '/api/v1/bulletin/bulletin/upload',
            BULLETIN_DOWNLOAD: '/api/v1/bulletin/bulletin/download',

            Q_OPINION_EXPORT: '/api/v1/q/q_opinions/export',

            FILE_CABINET_UPLOAD: '/api/v1/file_cabinet/upload',
            FILE_CABINET_DOWNLOAD: '/api/v1/file_cabinet/download',

            NEWS_DOWNLOAD: '/api/v1/bulletin/download',

            MEETING_EXPORT: '/api/v1/meeting/meetings/export',
            MEETING_UPLOAD: '/api/v1/meeting/meetings/upload',
            MEETING_DOWNLOAD: '/api/v1/meeting/meetings/download',

            MISSION_UPLOAD: '/api/v1/mission/missions/upload',
            MISSION_DOWNLOAD: '/api/v1/mission/missions/download',
            MISSION_EXPORT: '/api/v1/mission/missions/export',

            REGULAR_MISSION_UPLOAD: '/api/v1/mission/regular_missions/upload',
            REGULAR_MISSION_DOWNLOAD: '/api/v1/mission/regular_missions/download',

            MISSION_REPORT_UPLOAD: '/api/v1/mission/mission_reports/upload',
            MISSION_REPORT_DOWNLOAD: '/api/v1/mission/mission_reports/download',

            QUALIFICATION_REPORT_UPLOAD: '/api/v1/q/qualifications/upload',
            QUALIFICATION_REPORT_DOWNLOAD: '/api/v1/q/qualifications/download',

            E_QUESTION_DOWNLOAD: '/api/v1/edu/edu_questions/download',

            E_COURSE_UPLOAD: '/api/v1/edu/edu_courses/upload',
            E_COURSE_DOWNLOAD: '/api/v1/edu/edu_courses/download',
            E_UC_DOWNLOAD: '/api/v1/edu/edu_user_courses/export',
            E_SC_DOWNLOAD: '/api/v1/edu/edu_user_courses/signExport',

            Q_SURVEY_DOWNLOAD: '/api/v1/q/questionnaire_surveys/export',
            E_TEST_DOWNLOAD: '/api/v1/edu/edu_tests/export',

            FILES_EXPORT: '/api/v1/files/export',

            ROUND_DOWNLOAD: '/api/v1/rounds/export',

            CONTRACT_UPLOAD: '/api/v1/contract/contracts/upload',
            CONTRACT_UPLOAD1: '/api/v1/contract/contracts/upload1',
            CONTRACT_DOWNLOAD: '/api/v1/contract/contracts/download',

            CONTRACT_EXPORT: 'api/v1/contract/contracts/export',

            /**
             * 证书订单导出
             */
            QUALIFICATION_EXPORT: '/api/v1/qualification/qualifications/export',
            QUALIFICATION_STATISTIC: '/api/v1/qualification/qualifications/statistic',

            /**
             * 会话发送附件
             */
            CONVERSATION_UPLOAD: '/api/v1/conversation/upload_attachments'
        }
    });

(function () {
    'use strict';

    angular.module('c')
        .constant('serviceConfObj', {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        });
})();

angular.module('c')
    .filter('bytes', function() {
    return function(bytes) {
        if (isNaN(parseFloat(bytes)) || !isFinite(bytes) || bytes == 0) return '0';
        var units = {1: 'KB', 2: 'MB', 3: 'GB', 4: 'TB'},
            measure, floor, precision;
        if (bytes > 1099511627775) {
            measure = 4;
        } else if (bytes > 1048575999 && bytes <= 1099511627775) {
            measure = 3;
        } else if (bytes > 1024000 && bytes <= 1048575999) {
            measure = 2;
        } else if (bytes <= 1024000) {
            measure = 1;
        }
        floor = Math.floor(bytes / Math.pow(1024, measure)).toString().length;
        if (floor > 3) {
            precision = 0
        } else {
            precision = 3 - floor;
        }
        return (bytes / Math.pow(1024, measure)).toFixed(precision) + units[measure];
    }
});

/**
 * 将从laravel服务器传过来的时间格式转换成javascript的格式，在送入内建过滤器date处理
 */
angular.module('c')
    .filter('date2', function ($filter) {
        return function (text, format) {
            if (text != null && text != '') {
                var tempdate = new Date(text.replace(/-/g, "/"));
                return $filter('date')(tempdate, format);
            }
            return text;
        }
    });
angular.module('c')
    .filter('dateInRange', function (uibDateParser) {
        return function (data, params) {
            var result = [];
            angular.forEach(data, function (item) {
                var needPush = true;
                for (key in params) {
                    var date = item[key];
                    date = uibDateParser.parse(date, 'yyyy-MM-dd');
                    var dateRange = params[key];
                    if ((dateRange.startDate != null && date < dateRange.startDate)
                        || (dateRange.endDate != null && date > dateRange.endDate)) {
                        needPush = false;
                        break;
                    }
                }
                if (needPush) {
                    result.push(item);
                }
            });
            return result;
        }
    });

(function () {
    'use strict';

    angular.module('c')
        .filter('defValIfNone', defValIfNone);

    /** @ngInject */
    function defValIfNone() {
        return function (input, val) {
            if (!input) {
                if (angular.isUndefined(val)) {
                    if (input === 0) {
                        val = '无';
                    } else {
                        val = '其他';
                    }
                }
                return val;
            }
            return input;
        }
    }

})();

angular.module('c')
    .filter('exceptItem', function (F) {
        return function (items, exclude) {
            if (exclude && exclude.length > 0) {
                var ret = [];
                angular.forEach(items, function (item) {
                    var i = F.indexOfKey(item, exclude);
                    if (F.indexOfKey(item.id, exclude) == -1) {
                        ret.push(item);
                    }
                });
            } else {
                ret = items;
            }
            return ret;
        }
    });
angular.module('c')
    .filter('numInRange', function () {
        return function (data, params) {
            var result = [];
            angular.forEach(data, function (item) {
                var needPush = true;
                for (var key in params) {
                    var num = item[key];
                    var numRange = params[key];
                    var start = -Number.MAX_VALUE, end = Number.MAX_VALUE;
                    if (numRange.start != null && numRange.start != '') {
                        start = parseInt(numRange.start);
                    }
                    if (numRange.end != null && numRange.end != '') {
                        end = parseInt(numRange.end);
                    }
                    if (num < start || num > end) {
                        needPush = false;
                        break;
                    }
                }
                if (needPush) {
                    result.push(item);
                }
            });
            return result;
        }
    });
(function () {
    'use strict';

    angular.module('c')
        .filter('strLimit', strLimit);

    /** @ngInject */
    function strLimit($filter) {
        return function (input, limit) {
            if (!input) return;
            if (angular.isUndefined(limit)) limit = 20;
            if (input.length <= limit) {
                return input;
            }

            return $filter('limitTo')(input, limit) + '...';
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('UserConfirmCtrl', UserConfirmCtrl);

    /** @ngInject */
    function UserConfirmCtrl ($scope, $state, Auth, User, $q, Dlg, FormHelper, DateHelper, ArrayHelper) {
        var account = Auth.getAccount();
        var vm = this;
        var helper = User.formHelper;
        var required = {
            status: true, entryTime: false, startedWork: true, annualDays: true, password: true
        };

        vm.ok = ok;
        vm.logout = logout;

        init();


        function init () {

            if (account.confirm_state !== User.CONFIRM.PENDING) $state.go('app.home');

            helper.init(vm, $scope);

            // form config
            vm.cfg = {
                disable: {
                    dept: true,
                    company: true,
                    username: true,
                    cardre: true
                },
                enableTransferDept: false,
                hideUpdateAnnualChecker: true,
                required: required,
                contactBodyStyle: {height: '360px'}// 下面再设置
            };

            $q.all([
                User.get({id: '-', op: 'default'}).$promise,
                User.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                var m = respArray[0].item;

                if (m.username && m.name && m.dept && m.type && m.status && m.entry_time && m.started_work) {
                    // vm.cfg.disable = {
                    //     username: true, name: true, dept: true, type: true, status: true,
                    //     entryTime: false, startedWork: true
                    // }
                }

                helper.bindAsyncOptions(vm, respArray[1]);

                m.edu_bg = ArrayHelper.getItem(m.edu_bg, vm.edu_bgs);
                m.degree = User.getDegree(m.degree);
                m.en_lv = ArrayHelper.getItem(m.en_lv, vm.en_lvs);
                m.entry_time = DateHelper.str2Date(m.entry_time);
                m.started_work = DateHelper.str2Date(m.started_work);

                vm.calcAnnualTotal(m);

                m.update_annual_num = true;
                vm.m = m;
            });
        }

        function logout () {
            Auth.logout(function () {
                $state.go('login');
            });
        }

        function ok (m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = helper.loadParams(m, 'user_confirm');
                pa.password = m.password;
                if (m.change_note) pa.change_note = m.change_note;
                else pa.change_note = null;

                User.update({id: m.id}, pa).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    account.confirm_state = User.CONFIRM.USER;
                    account.name = m.name;
                    account.photo = m.photo;
                    account.phone = m.phone;
                    Auth.setAccount(account);
                    // $state.go('app.user_profile', {data: {requireChangePasswd: true}});
                    $state.go('app.home');
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }

    }

})();

(function () {
    'use strict';

    angular.module('c').controller('HomeCtrl', HomeCtrl)
        .controller('BulletinListCtrl', BulletinListCtrl)
        .controller('NewsListCtrl', NewsListCtrl)
        .controller('FileListCtrl', FileListCtrl)
        .controller('MeetingListCtrl', MeetingListCtrl)
        .controller('CPhoneDlgCtrl', CPhoneDlgCtrl)
    ;

    /** @ngInject */
    function HomeCtrl($scope, $http, C, ArrayHelper, Auth, Dlg, FileHelper, DateHelper) {
        var vm = this;
        vm.hrm = hrm;
        vm.openPhoneDlg = openPhoneDlg;
        vm.download = download;
        vm.today = DateHelper.date2Str(new Date()); //bulletin-list news-list use
        vm.bulletins = [];
        vm.meetings = [];
        vm.ns = [];
        vm.files = [];
        vm.rules = [];

        init();


        function init() {
            vm.cards = [
                {
                    statTitle: '已录入人数',
                    statNum: 0,
                    icon: 'fa-users',
                    iconTitle: '人员管理',
                    bg: 'bg-red-active',
                    linkTo: 'app.personnel.user_reg'
                },
                {
                    statTitle: '总单位数',
                    statNum: 0,
                    icon: 'fa-university',
                    bg: 'bg-orange-active',
                    iconTitle: '单位管理',
                    linkTo: 'app.coop_doc'
                },
                {
                    statTitle: '联系站数',
                    icon: 'fa-building',
                    bg: 'bg-blue',
                    iconTitle: '站点管理',
                    linkTo: 'app.user_duty_fee'
                }
            ];

            $http.get('api/v1/home').then(function (resp) {
                var data = resp.data;
                // vm.hasMission = data.hasMission;
                vm.bulletins = data.bulletins;
                vm.meetings = data.meetings;
                loadMeeting($scope, data.meetings, DateHelper, Auth);
                vm.ns = data.ns;
                vm.files = data.files;
                //
                angular.forEach(data.stats, function (num, i) {
                    vm.cards[i].statNum = num;
                });
            });
        }

        function download(m, _url) {
            FileHelper.download1(C.URL[_url], {name: m.name, filename: m.filename, mime: m.mime});
        }

        function hrm() {
            Dlg.show({
                template: C.T + 'leave/hrm_dlg.html',
                ctrl: 'SimpleDlgCtrl',
                data: {},
                size: 'lg'
            });
        }

        function openPhoneDlg() {
            Dlg.show({
                template: C.T + 'misc/common_phone.html',
                ctrl: 'CPhoneDlgCtrl',
                data: {},
                size: 'lg'
            });
        }
    }

    /** @ngInject */
    function BulletinListCtrl($scope, Dlg, C, Api, $http, ArrayHelper) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();


        function init() {
            $scope.$on('bulletin.send', function (event, data) {
                reload();
            });

            $scope.$on('ReadBulletin', function (event, data) {
                var id = data.id;
                var bulletin = ArrayHelper.getItem(id, home.bulletins);
                if (bulletin && bulletin.recipient == null) {
                    bulletin.recipient = true;
                }
            });
        }

        function reload() {
            var pa = Api.param2Url({opt: 1, page: 1, count: 6, sorting: {updated_at: 'desc'}});
            $http.get('api/v1/bulletin/bulletins', {
                params: pa
            }).then(function (resp) {
                home.bulletins = resp.items;
            });
        }

        function read(bulletin) {
            Dlg.show({
                template: C.T + 'article/show_dlg.html',
                ctrl: 'BulletinShowDlgCtrl',
                data: {
                    id: bulletin.id
                },
                size: 'lg'
            });
        }
    }

    /** @ngInject */
    function NewsListCtrl($scope, Dlg, C, $http, Api) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();


        function init() {
            $scope.$on('news.send', function () {
                reload();
            });
        }

        function reload() {
            var pa = Api.param2Url({opt: 1, page: 1, count: 6, sorting: {updated_at: 'desc'}});
            $http.get('api/v1/news/news', {
                params: pa
            }).then(function (resp) {
                home.ns = resp.items;
            });
        }

        function read(n) {
            Dlg.show({
                template: C.T + 'article/show_dlg.html',
                ctrl: 'NewsShowDlgCtrl',
                data: {
                    id: n.id
                },
                size: 'lg'
            });
        }
    }

    /** @ngInject */
    function FileListCtrl($scope, $http, Api) {
        var vm = $scope;
        var home = $scope.home;

        init();


        function init() {
            $scope.$on('file.release', function () {
                reload();
            });
        }

        function reload() {
            var pa = Api.param2Url({opt: 1, page: 1, count: 6, sorting: {updated_at: 'desc'}});
            $http.get('api/v1/file_cabinet', {
                params: pa
            }).success(function (data) {
                home.files = data.files;
            });
        }
    }

    function loadMeeting(vm, meetings, DateHelper, Auth) {
        var account = Auth.getAccount();
        angular.forEach(meetings, function (meeting) {
            meeting.forLeave = false;
            meeting.forRemind = false;
            meeting.forRCancel = false;
            meeting.isApplicant = false;
            meeting.isModerator = false;
            var start = new Date(),
                end = DateHelper.str2Datetime(meeting.start_time, 'yyyy-MM-dd HH:mm:ss');

            var yesterday = new Date(end - 24 * 60 * 60 * 1000),
                time = DateHelper.date2Str(yesterday) + ' ' + '08:30:00',
                y_start = DateHelper.str2Datetime(time, 'yyyy-MM-dd HH:mm:ss');
            if (meeting.applicant_id == account.id) {
                meeting.isApplicant = true;
            }
            if (DateHelper.diffInHours(start, y_start) >= 1) {
                if (meeting.attendees.length > 0) {
                    if (meeting.attendees[0].reminder_time) {
                        meeting.forRCancel = true;
                    } else {
                        meeting.forDayRemind = true;
                    }
                }
            }

            if (DateHelper.diffInHours(start, end) >= 1) {
                if (meeting.attendees.length > 0) {
                    if (meeting.attendees[0].reminder_time) {
                        meeting.forRCancel = true;
                    } else {
                        meeting.forRemind = true;
                    }
                }
            }

            if (DateHelper.diffInMinutes(start, end) >= 30) {
                if (meeting.attendees.length > 0) {
                    meeting.forLeave = true;
                }
            }

            if (meeting.leavers.length > 0) {
                meeting.forLeave = false;
            }

            if (meeting.moderator_id && meeting.moderator_id == account.id) {
                meeting.isModerator = true;
            }
            meeting.start_time = meeting.start_time.substr(0, 16);
        });
    }

    /** @ngInject */
    function MeetingListCtrl($scope, C, ArrayHelper, DateHelper, Auth, Api, Dlg, $http) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();


        function init() {
            $scope.$on('meeting.send', function () {
                reload();
            });

            $scope.$on('MeetingRead', function (event, data) {
                var id = data;
                var meeting = ArrayHelper.getItem(id, home.meetings);
                if (meeting && meeting.recipient == null) {
                    meeting.recipient = true;
                }
            });
        }

        function reload() {
            var pa = Api.param2Url({op: 'home', page: 1, count: 5, sorting: {start_time: 'asc'}});
            $http.get('/api/v1/meeting/meetings', {params: pa}).then(function (data) {
                loadMeeting(vm, data.meetings, DateHelper, Auth);
                home.meetings = data.meetings;
            });
        }

        function read(meeting) {
            Api.loadMod('meeting', function () {
                Dlg.show({
                    template: 'pages/dlg/meeting/show_dlg.html',
                    ctrl: 'MeetingShowDlgCtrl',
                    data: {
                        id: meeting.id,
                        ForLeave: meeting.forLeave,
                        ForRemind: meeting.forRemind,
                        ForDayRemind: meeting.forDayRemind,
                        ForRCancel: meeting.forRCancel,
                        isApplicant: meeting.isApplicant,
                        isModerator: meeting.isModerator
                    },
                    size: 'lg'
                }).then(function (params) {
                    switch (params.opt) {
                        case 4:
                            leave(meeting);
                            break;
                        case 5:
                            remind(meeting, params.op);
                            break;
                        case 6:
                            remove(meeting);
                            break;
                    }
                });
            });
        }


        function leave(meeting) {
            Api.comment({
                title: '会议请假',
                icon: 'sign-out',
                label: '原因'
            }, function (pa) {
                var params = {};
                params['reason'] = pa;
                params['start_time'] = meeting.start_time;
                $http.post('/api/v1/meeting/meetings/leave/' + meeting.id, params).then(function (resp) {
                        // Meeting.leave({id: meeting.id}, params).$promise.then(
                        //     function (resp) {
                        switch (resp.result) {
                            case 0:
                                Dlg.s('请假成功');
                                reload();
                                break;
                            case 1:
                                Dlg.w('请在开会前半小时请假!');
                                break;
                        }
                    }, function () {
                        Dlg.e('请假失败了!');
                    }
                )
            });
        }

        function remind(meeting, op) {
            Dlg.confirm('确定要会前' + (op == 1 ? '半小时' : '一天08:30') + '短信提醒吗?', function () {
                $http.post('/api/v1/meeting/meetings/get_attendance/' + meeting.id, {
                    opt: op
                }).then(function (resp) {
                        // Meeting.setReminderTime({id: meeting.id}, {opt: op}).$promise.then(
                        //     function (resp) {
                        switch (resp.result) {
                            case 0:
                                Dlg.s('设置成功!');
                                reload();
                                break;
                            case 1:
                                Dlg.w('请在开会前一小时设置!');
                                break;
                            case 2:
                                Dlg.w('已统一设置会前半小时提醒!');
                                break;
                            case 3:
                                Dlg.w('请在开会前一天08:30之前设置!');
                                break;
                        }
                    }, function () {
                        Dlg.e('设置失败了!');
                    }
                )
            }, '会前提醒');
        }

        function remove(meeting) {
            Dlg.confirm('确定要取消会前短信提醒吗?', function () {
                $http.post('/api/v1/meeting/meetings/set_reminder_time/' + meeting.id, {opt: 3}).then(function (resp) {
                        // Meeting.setReminderTime({id: meeting.id}, {opt: 3}).$promise.then(
                        //     function (resp) {
                        switch (resp.result) {
                            case 0:
                                Dlg.s('取消成功!');
                                reload();
                                break;
                            case 1:
                                Dlg.w('请在开会前一小时取消!');
                                break;
                        }
                    }, function () {
                        Dlg.e('取消失败了!');
                    }
                )
            }, '取消会前提醒');
        }
    }

    /** @ngInject */
    function CPhoneDlgCtrl($scope, $uibModalInstance, CommonPhone, Table) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            var options = {
                service: CommonPhone,
                params: {opt: 2/*INDEX_ALL*/},
                hideOpt: true,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "phone", title: "电话", filter: {'phone': "text"}},
                    {field: "cornet", title: "小号", filter: {'cornet': "text"}}
                ]
            };
            Table.load(vm, options);
        }

    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('LoginCtrl', LoginCtrl)
    ;

    /** @ngInject */
    function LoginCtrl($scope, $stateParams, $state, Dlg, deviceDetector,
                       Auth, $http, $interval, $urlRouter, Sidebar, OS_VERSIONS) {
        var vm = $scope;
        vm.loginForm = loginForm;
        vm.openid = $stateParams.data.openid;
        vm.user = {autoLogin: vm.openid ? true : Auth.getAutoLogin()};
        vm.smsLogin = false;
        vm.getSmsPassword = getSmsPassword;
        vm.getSmsBtnText = getSmsBtnText;
        vm.remain = -1;
        vm.regex = {
            false: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/,
            true: /^[0-9]{6}$/
        };

        init();


        function init() {
            var chromeUrls = {
                windows: '/download/chrome/chrome.exe',
                android: '/download/chrome/chrome.apk'
                //mac: 'http://sw.bos.baidu.com/sw-search-sp/software/441142fc7c4/googlechrome_mac_50.0.2661.102.dmg',
                //ios: 'http://itunes.apple.com/cn/app/id535886823?mt=8'
            };
            vm.chromeUrl = chromeUrls[deviceDetector.os];
            if (deviceDetector.browser !== 'chrome') {
                if (deviceDetector.os_version === OS_VERSIONS.WINDOWS_XP) {
                    vm.chromeUrl = '/download/chrome/chromeXp.exe'
                }
                if (vm.chromeUrl) {
                    Dlg.notify("您正在" + deviceDetector.os + "系统下访问本站,强烈建议您改用<span class='text-red'>" +
                        "chrome浏览器</span>访问,以保证正常使用所有功能" + " 点击<a class='text-red' href=" +
                        vm.chromeUrl + ">" + "这里</a>下载");
                }
            }
        }

        function loginForm(user, Form) {
            if (Form.$valid) {
                user.sms_login = vm.smsLogin;
                if (vm.openid) user.openid = vm.openid;
                Auth.login(user, function (resp) {
                    Sidebar.setupMenuItems(resp.menuItems);
                    if (vm.smsLogin) {
                        $state.go('app.user_profile', {data: {requireChangePasswd: true}});
                    } else {
                        $state.go('app.home');
                    }
                }, function (error) {
                    Dlg.e(error.msg);
                });
            } else {
                Form.submitted = true;
            }
        }

        function getSmsPassword() {
            if (!vm.user.username
                || !vm.user.username.match(/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[189])\d{8}$/)) {
                Dlg.e('手机号格式不正确');
                return
            }

            $http.post("/auth/sms/password", {
                username: vm.user.username
            }).then(
                function () {
                    vm.remain = 60;
                    var intervalId = $interval(function () {
                        vm.remain--;
                        if (vm.remain === 0) {
                            $interval.cancel(intervalId)
                        }
                    }, 1000)
                }
            ).catch(function (error) {
                    Dlg.e(error.data.message);
                }
            )
        }

        function getSmsBtnText() {
            return vm.remain > 0 ? '重新获取(' + vm.remain + ')'
                : vm.remain === 0 ? '重新获取' : '获取短信动态密码'
        }
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .controller('MainCtrl', MainCtrl);

    /** @ngInject */
    function MainCtrl($rootScope, $scope, $http, $state, $timeout, $q, dialogs, Dlg, toaster, Api, C,
                      ArrayHelper, Auth, User, FileHelper, Email, SaveAs, UIHelper, Sidebar) {
        var account = Auth.getAccount();
        var vm = $rootScope.main = $scope;

        init();


        function init() {
            $timeout(function () {
                if (!vm.$finishedLoading) vm.$finishedLoading = true;
            }, 500);

            Sidebar.bindState($scope);

            $scope.$on('state.go', function (event, state) {
                $state.go(state.name, {data: {tab: state.tab}});
            });

            // 等待header初始化完成
            $scope.$on('headerLoaded', function () {
                defer.resolve();
            });

            var pusherFnList = {
                'task': taskFn,

                'mail.send': mailSendFn,
                'bulletin.send': bulletinSendFn,
                'file.release': fileReleaseFn,
                'meeting.send': meetingSendFn,
                'mission.send': missionSendFn,
                'news.send': newsSendFn

            };

            angular.forEach(pusherFnList, function (fn, evtName) {
                $scope.$on(C.P + evtName, fn);
            });


            var defer = $q.defer();

            UIHelper.initCKEditor();

            $q.all([
                $http.get('api/v1/main'),
                defer.promise
            ]).then(function (respArray) {
                var resp = respArray[0];
                var data = resp.data;
                var header = $scope.header;
                header.mails = data.mails;
                header.hasTask = data.hasTask;

                account = data.account;

                // 用户已离职
                if (account.leave_time) {
                    Auth.logout(function () {
                        Dlg.notify('检查到登录账户已离职，请使用其他账户登录系统').then(function () {
                            $state.go('login');
                        });
                    });
                }

                // 临时，如果有任务，弹出待处理列表
                if (header.hasTask) {
                    $timeout(function () {
                        header.openTaskD = true;
                    }, 500);
                }

                Auth.setAccount(account);
                header.account = vm.account = account;
                checkIfUnConfirmUpdate(account);
            });
        }

        function checkIfUnConfirmUpdate(account) {
            if (account.confirm_state === User.CONFIRM.PENDING) {
                $state.go('user_confirm');
            }
        }

        function mailSendFn(event, data) {
            var mail = data.data.mail;
            if (ArrayHelper.inArray(account.id, mail.recipients) >= 0) {
                Dlg.msg('新邮件', "你有一封新邮件《" + mail.subject + "》,点击查阅", function () {
                    dialogs.create(C.V + 'email/show_dlg.html', 'MailShowDlgCtrl', {mail: mail},
                        {size: 'lg'}).result.then(function (params) {
                        switch (params.opt) {
                            case 1:
                                $state.go('app.message_email', {
                                    data: {
                                        tab: 'write',
                                        event: 'mailReply',
                                        mail: params.mail
                                    }
                                });
                                break;
                            case 2:
                                $state.go('app.message_email', {
                                    data: {
                                        tab: 'write',
                                        event: 'mailForward',
                                        mail: params.mail
                                    }
                                });
                                break;
                            case 3:
                                Email.rm_from_inbox({mails: [mail.id]}).$promise.then(
                                    function () {
                                        $rootScope.$broadcast('mailDel', mail.id);
                                    },
                                    function () {
                                        toaster.error('邮件删除失败!');
                                    }
                                );
                                break;
                        }
                    });
                });
                $rootScope.$broadcast("mail.send", mail);
            }
        }

        function taskFn(event, data) {
            var task = data.data.task;
            if (ArrayHelper.inArray(account.id, task.approvers) >= 0) {
                $rootScope.$broadcast("newTask", {task: task.task});
            }
        }

        function bulletinSendFn(event, data) {
            var bulletin = data.data.task;
            switch (bulletin.is_pass) {
                case C.STAGE1.DEPT_APPROVAL:
                case C.STAGE1.HOSPITAL_APPROVAL:
                    if (ArrayHelper.inArray(account.id, bulletin.approvers) >= 0) {
                        $rootScope.$broadcast("newTask", {task: bulletin.task});
                    }
                    break;
                case C.STAGE1.PUBLIC:
                    $rootScope.$broadcast("bulletin.send", bulletin);
                    Dlg.msg('新公告', bulletin.dept.name + "发布了新公告《" + bulletin.title + "》,点击查阅", function () {
                        dialogs.create('templates/article/show_dlg.html', 'BulletinShowDlgCtrl', {
                            id: bulletin.id
                        }, {
                            size: 'lg'
                        });
                    });
                    break;
            }
        }

        function newsSendFn(event, data) {
            var news = data.data.task;
            if (news.is_pass === 0 || news.is_pass === 2) {
                if (ArrayHelper.inArray(account.id, news.approvers) >= 0) {
                    $rootScope.$broadcast("newTask", {task: news.task});
                }
            } else if (news.is_pass === 6) {
                $rootScope.$broadcast("news.send", news);
                Dlg.msg('新闻', news.dept + "发布了新闻《" + news.title + "》,点击查阅", function () {
                    dialogs.create('templates/article/show_dlg.html', 'NewsShowDlgCtrl', {
                        id: news.id
                    }, {
                        size: 'lg'
                    });
                });
            }
        }

        function meetingSendFn(event, data) {
            var meeting = data.data.task;
            switch (meeting.stage) {
                case C.STAGE1.DEPT_APPROVAL:
                case C.STAGE1.HOSPITAL_APPROVAL:
                    if (ArrayHelper.inArray(account.id, meeting.approvers) >= 0) {
                        $rootScope.$broadcast("newTask", {task: meeting.task});
                    }
                    break;
                case C.STAGE1.PUBLIC:
                    if (ArrayHelper.inArray(account.id, meeting.attendees) >= 0) {
                        $rootScope.$broadcast("meeting.send", meeting);
                        Api.loadMod('meeting', function () {
                            Dlg.msg('新会议', meeting.dept.name + "发布了新会议《" + meeting.name + "》,点击查阅", function () {
                                dialogs.create('pages/dlg/meeting/show_dlg.html', 'MeetingShowDlgCtrl', {
                                    id: meeting.id
                                }, {
                                    size: 'lg'
                                });
                            });
                        });
                    }
                    break;
            }
        }

        function missionSendFn(event, data) {
            var mission = data.data.task;
            if (ArrayHelper.inArray(account.id, mission.attendees) >= 0) {
                $rootScope.$broadcast("mission.send", mission);
                Dlg.msg('任务通知', '您加入了任务《' + mission.name + "》,点击查阅", function () {
                    dialogs.create('templates/mission/show_dlg.html', 'MissionShowDlgCtrl', {
                        id: mission.id
                    }, {
                        size: 'lg'
                    });
                });
            }
        }

        function fileReleaseFn(event, data) {
            var file = data.data.task;
            if (ArrayHelper.inArray(account.id, file.approvers) >= 0) {
                $rootScope.$broadcast("newTask", {task: file.task});
            } else if (file.state == C.STAGE3.PUBLIC &&
                ((file.release_type == 2 && ArrayHelper.inArray(account.id, file.receivers) >= 0) || file.release_type == 3)) {
                $rootScope.$broadcast("file.release", file);
                Dlg.msg('文件发布', file.dept + "发布了文件《" + file.name + "》,点击下载", function () {
                    var params = {filename: file.filename, mime: file.mime};
                    file.downloading = true;
                    FileHelper.download(C.URL.FILE_CABINET_DOWNLOAD, params, function (resp) {
                        file.downloading = false;
                        var data = [resp];
                        var options = {type: file.mime};
                        SaveAs.download(data, file.name, options);
                    }, function (error) {
                        file.downloading = false;
                        //toaster.error('服务端文件丢失,请联系管理员!');
                    });
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('TabCtrl', TabCtrl);

    /** @ngInject */
    function TabCtrl($scope, $stateParams, UIHelper) {
        UIHelper.loadTabs($scope, $stateParams);
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('WechatAuthCtrl', WechatAuthCtrl);

    /** @ngInject */
    function WechatAuthCtrl($state, $location, Api, Auth, WxHelper) {
        // 获取返回参数 code 和 state
        var qs = $location.search();
        var code = qs.code;
        var state = qs.state;

        // alert('到达WechatAuthCtrl');

        WxHelper.getWechatToken(code, state).then(function (data) {
            // alert('data.result:' + data.result);
            switch (data.result) {
                case 0:
                    Auth.setAutoLogin(true);
                    Auth.setToken(data.token);
                    Auth.setAccount(data.account);
                    if (qs.toState) {
                        if (qs.toParams) {
                            $state.go(qs.toState, JSON.parse(qs.toParams));
                        } else {
                            $state.go(qs.toState);
                        }
                    } else {
                        $state.go('app.home');
                        // alert('WechatAuthCtrl:go:app.home');
                    }
                    break;
                case 1:
                    Api.e(data.msg);
                    break;
                case 2:  //用户未绑定微信
                case 3:
                    $state.go('login', {data: {openid: data.openid}});
                    break;
            }
        });
    }

})();
/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('Api', apiService);

    /** @ngInject */
    function apiService($ocLazyLoad, $compileProvider, $http, toaster, ArrayHelper, Dlg) {
        var service = {

            setStop: setStop,
            /**
             * @deprecated 请用Dlg.delTableItem 替代
             */
            delTableItem: Dlg.delTableItem,
            /**
             * @deprecated 请用Dlg.addEdit 替代
             */
            addEdit: Dlg.addEdit,

            setDisable: setDisable,

            respMsg: respMsg,

            /**
             * @deprecated use Dlg.w instead
             */
            w: Dlg.w,
            /**
             * @deprecated use Dlg.e instead
             */
            e: Dlg.e,
            /**
             * @deprecated use Dlg.s instead
             */
            s: Dlg.s,
            /**
             * @deprecated use Dlg.i instead
             */
            i: Dlg.i,

            /**
             * @deprecated 请用Dlg.exportDR替代
             */
            exportDR: Dlg.exportDR,
            /**
             * @deprecated 请用Dlg.comment替代
             */
            comment: Dlg.comment,

            EDIT: {
                SAVE: 1,
                STOP: 2
            },

            param2Url: param2Url,

            //身份证检查和手机号码检查
            checkId: checkId,
            checkPhone: checkPhone,

            loadQuestionOpt: loadQuestionOpt,

            //数值转化
            numConversion: numConversion,

            loadMod: loadMod,

            fixText: fixText,

            idCardLoadFn: idCardLoadFn
        };

        return service;

        function idCardLoadFn(searchStr) {
            return $http.post('/api/v1/user/user_info/idcards?start=' + searchStr);
        }

        function fixText(text) {
            text = text || '';

            var RexStr = /\<|\>|\&/g
            text = text.replace(RexStr, function (MatchStr) {
                switch (MatchStr) {
                    case "<":
                        return "&lt";
                    case ">":
                        return "&gt";
                    default:
                        break;
                }
            });

            var replaceRegex = /(\n\r|\r\n|\r|\n)/g;
            return text.replace(replaceRegex, "<br/>");
        }

        function loadMod(mod, fn) {
            var debugEnabled = $compileProvider.debugInfoEnabled();
            if (debugEnabled) {
                fn();
            } else {
                $ocLazyLoad.load(['/ocLazyLoad/mod/' + mod + '.js',
                    '/ocLazyLoad/mod/' + mod + '.css']).then(fn);
            }
        }

        function respMsg(resp) {
            if (resp.result === 0) {
                Dlg.s(resp.msg);
                return true;
            } else {
                Dlg.error(resp.msg);
                return false;
            }
        }

        /**
         * 停用/启用某数据项，
         * @param s 服务
         * @param m 数据项
         */
        function setStop(s, m) {
            s.update({id: m.id}, {opt: service.EDIT.STOP, is_stop: !(m.is_stop == '1')})
                .$promise.then(function (resp) {
                m.is_stop = resp.is_stop;
            });
        }

        /**
         * 利用ApiController新写法时推荐用此方法替代setStop
         * @param s service
         * @param m model
         */
        function setDisable(s, m) {
            s.update({id: m.id}, {op: 'disable', is_stop: !m.is_stop}).$promise.then(function (resp) {
                m.is_stop = !m.is_stop;
            });
        }

        ///////////////////////////////////////

        function param2Url(params) {
            var pairs = {};
            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    var item = params[key],
                        name = encodeURIComponent(key);
                    if (typeof item === "object") {
                        for (var subkey in item) {
                            if (!angular.isUndefined(item[subkey]) && item[subkey] !== "") {
                                var pname = name + "[" + encodeURIComponent(subkey) + "]";
                                pairs[pname] = item[subkey];
                            }
                        }
                    } else if (!angular.isFunction(item) && !angular.isUndefined(item) && item !== "") {
                        pairs[name] = encodeURIComponent(item);
                    }
                }
            }
            return pairs;
        }

        /////////////////////////////////////

        function checkPhone(phone) {
            var phoneCheck = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
            return phoneCheck.test(phone);
        }

        function checkId(pId) {
            //检查身份证号码
            pId = pId.toUpperCase();
            var arrVerifyCode = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
            var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            if (pId.length != 15 && pId.length != 18) return false;
            var Ai = pId.length == 18 ? pId.substring(0, 17) : pId.slice(0, 6) + "19" + pId.slice(6, 16);
            if (!/^\d+$/.test(Ai)) return false;
            var yyyy = Ai.slice(6, 10), mm = Ai.slice(10, 12) - 1, dd = Ai.slice(12, 14);
            var d = new Date(yyyy, mm, dd), now = new Date();
            var nowdate = now.getFullYear();
            var year = d.getFullYear(), mon = d.getMonth(), day = d.getDate();
            if (year != yyyy || mon != mm || day != dd || d > now || year < 1800) return false;
            if (nowdate - year < 14) return false;
            for (var i = 0, ret = 0; i < 17; i++) ret += Ai.charAt(i) * Wi[i];
            Ai += arrVerifyCode[ret %= 11];
            return pId.length == 18 && pId == Ai;
        }

        function numConversion(m, array) {
            angular.forEach(array, function (str) {
                m[str] = !m[str] || m[str] === '0' ? '未填' : m[str]
            });
        }


        ///////////////////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////////////////
        function loadQuestionOpt(vm) {
            vm.upOption = upOption;
            vm.downOption = downOption;
            vm.rmOption = rmOption;
            vm.addOption = addOption;
            vm.optionOnFocus = optionOnFocus;
            vm.correctOptionDesc = correctOptionDesc;
            vm.isMultiSelect = isMultiSelect;
            vm.checkMaxOptions = checkMaxOptions;
        }

        function upOption(question, index) {
            ArrayHelper.swap(question.options, index, index - 1);
        }

        function downOption(question, index) {
            ArrayHelper.swap(question.options, index, index + 1);
        }

        function rmOption(question, index) {
            if (question.options.length === 1) {
                toaster.warning('每个问题至少一个选项!');
            } else {
                question.options.splice(index, 1);
            }
        }

        function addOption(question) {
            question.options.push({
                desc: '选项' + (question.options.length + 1),
            });
        }

        function optionOnFocus(option, $index, $event) {
            if (option.desc === '选项' + $index) {
                $event.target.select();
            }
        }

        function correctOptionDesc(option, index) {
            if (!option.desc.length) {
                option.desc = '选项' + index;
            }
        }

        function isMultiSelect(question) {
            return question.type === 2;
        }

        function checkMaxOptions(question) {
            if (question.type === 2 && question.max_options) {
                if (question.max_options < 1) {
                    toaster.warning('最多可选不能小于2!');
                    question.max_options = '';
                } else if (question.max_options > question.options.length) {
                    toaster.warning('最多可选不能大于选项数!');
                    question.max_options = '';
                }
            }
            return true;
        }

    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('ArrayHelper', ArrayHelper);

    /** @ngInject */
    function ArrayHelper($timeout, $injector) {
        var service = {
            inArray: inArray,
            indexOf: inArray,
            except: except,
            getItem: getItem,
            indexOfKey: indexOfKey,
            findItem: findItem,
            getItems: getItems,
            listKey: listKey,
            get: get,
            swap: swap,
            mergeObj: mergeObj,
            bitwise2array: bitwise2array,
            array2bitwise: array2bitwise,
            shuffle: shuffle,
            map: map,
            memset: memset,
            filter: filter,
        };

        var l = null;
        $timeout(function () {
            var $http = $injector.get('$http');
            $http.get('json/options.json').success(function (resp) {
                l = resp;
            });
        });

        return service;


        function get(key) {
            return l[key];
        }

        function map(arr, mapFn) {
            var mapArr = [];
            angular.forEach(arr, function (item) {
                mapArr.push(mapFn(item));
            });
            return mapArr;
        }

        function filter(arr, filterFn) {
            var filterArr = [];
            angular.forEach(arr, function (item) {
                if (filterFn(item)) filterArr.push(item);
            });
            return filterArr;
        }

        function memset(arr, val, start, len) {
            if (angular.isUndefined(start)) start = 0;
            if (angular.isUndefined(len)) len = arr.length;

            for (var i = 0; i < len; i++) {
                arr[start + i] = val;
            }
        }

        /**
         * 打乱数组顺序
         * @param a
         */
        function shuffle(a) {
            var j, x, i;
            for (i = a.length; i; i--) {
                j = Math.floor(Math.random() * i);
                x = a[i - 1];
                a[i - 1] = a[j];
                a[j] = x;
            }
        }

        /**
         * 合并对象
         * @param o1
         * @param o2
         * @returns {*}
         */
        function mergeObj(o1, o2) {
            for (var key in o2) {
                o1[key] = o2[key]
            }
            return o1;
        }

        function array2bitwise(a) {
            var b = 0;
            for (var i = 0; i < a.length; i++) {
                if (a[i]) {
                    b |= (1 << i);
                }
            }
            return b;
        }

        /**
         * 位图转数组
         * @param b
         * @param n
         * @returns {Array}
         */
        function bitwise2array(b, n) {
            var a = [];
            for (var i = 0; i < n; i++) {
                a[i] = (b & 1) === 1;
                b >>= 1;
            }
            return a;
        }

        function swap(arr, indexA, indexB) {
            var temp = arr[indexA];
            arr[indexA] = arr[indexB];
            arr[indexB] = temp;
        }

        function inArray(val, arr) {
            var i = arr.length;
            while (i--) {
                if (angular.equals(val, arr[i])) return i;
            }
            return -1
        }

        function listKey(items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            var result = [];
            while (++i < items.length) {
                result.push(items[i][key]);
            }
            return result;
        }

        function getItems(value, items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            var result = [];
            while (++i < items.length) {
                if (items[i][key] == value) {
                    result.push(items[i]);
                }
            }
            return result;
        }

        function findItem(value, items) {
            var i = -1;
            while (++i < items.length) {
                if (items[i] == value)
                    return i;
            }
            return -1;
        }

        function except(exceptId, items) {
            var itemsExp = [];
            angular.forEach(items, function (item) {
                if (exceptId != item.id) {
                    itemsExp.push(item);
                }
            });
            return itemsExp;
        }

        function getItem(value, items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            while (++i < items.length) {
                if (items[i][key] == value)
                    return items[i];
            }
            return null;
        }

        function indexOfKey(value, items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            while (++i < items.length) {
                if (items[i][key] == value)
                    return i;
            }
            return -1;
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('Auth', Auth);

    /** @ngInject */
    function Auth($injector, $localStorage, $sessionStorage) {
        var storage;
        var service = {
            CODE: {
                TOKEN_INVALID: 1,
                TOKEN_EXPIRED: 2,
                TOKEN_DEAD: 3,
                LOGIN: 4
            },

            setAccount: setAccount,
            getAccount: getAccount,
            getAutoLogin: getAutoLogin,
            setAutoLogin: setAutoLogin,
            setToken: setToken,
            getToken: getToken,
            hasToken: hasToken,
            deleteToken: deleteToken,
            register: register,
            login: login,
            logout: logout,
            refreshToken: refreshToken
            // getWechatAuthorizeUrl: getWechatAuthorizeUrl,
            // getWechatToken: getWechatToken,
            /**
             * 判断是否为微信浏览器
             * @returns {boolean}
             */
        };

        var $http;

        init();

        return service;

        
        function init() {
            storage = getAutoLogin() ? $localStorage : $sessionStorage;
        }

        function getHttp() {
            return $http ? $http : $injector.get('$http');
        }

        function logout(success) {
            getHttp().post('/auth/token/revoke').finally(function () {
                deleteToken();
                success();
            });
        }

        function refreshToken() {
            return getHttp().post('/auth/token/refresh')
        }

        function login(data, successFn, errorFn) {
            getHttp().post('/auth/token/issue', data).success(function (resp) {
                setAutoLogin(data.autoLogin);
                setToken(resp.token);
                setAccount(resp.account);
                if (successFn) {
                    successFn(resp);
                }
            }).error(function (resp) {
                if (errorFn) {
                    errorFn(resp);
                }
            });
        }

        function getAutoLogin() {
            return !!$localStorage.autoLogin;
        }

        function setAutoLogin(autoLogin) {
            delete $localStorage.token;
            delete $localStorage.account;
            $localStorage.autoLogin = !!autoLogin;
            storage = autoLogin ? $localStorage : $sessionStorage;
        }

        function register(data, success, error) {
            getHttp().post('/auth/register', data).success(success).error(error);
        }

        function deleteToken(excludeAccount) {
            delete storage.token;
            if (!excludeAccount) delete storage.account;
        }

        function hasToken() {
            return storage.token;
        }

        function getToken() {
            return storage.token;
        }

        function setToken(token) {
            storage.token = token;
        }

        function getAccount() {
            return storage.account || {};
        }

        function setAccount(account) {
            storage.account = account;
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('Checker', Checker);

    /** @ngInject */
    function Checker() {
        var service = {
            checkIp: checkIp
        };

        return service;


        function checkIp(ip) {
            var exp = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
            return ip.match(exp);
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('DateHelper', DateHelper);

    /** @ngInject */
    function DateHelper ($filter, uibDateParser, $ocLazyLoad) {
        var service = {
            date2Str: date2Str,
            datetime2Str: datetime2Str,
            str2Date: str2Date,
            str2Datetime: str2Datetime,
            getDaysInMonth: getDaysInMonth,
            diffInDays: diffInDays,
            diffInHours: diffInHours,
            diffInMinutes: diffInMinutes,
            sec2MinSec: sec2MinSec,
            isSameDay: isSameDay,
            toLocalTime: toLocalTime,
            linarCalendar: linarCalendar,
            time2Str: time2Str,
            str2Time: str2Time
        };

        return service;


        function sec2MinSec (sec) {
            var r = '';
            var m = Math.floor(sec / 60);
            if (m > 0) {
                r += m + '分';
            }
            var s = sec % 60;
            if (s > 0) {
                r += s + '秒';
            }
            return r;
        }

        function linarCalendar (vm, lunarWeekdays, curr) {
            $ocLazyLoad.load({
                files: ["ocLazyLoad/lunarCalendar/lunarCalendar.min.js"]
            }).then(function () {
                vm.lunarCalendars = [];
                for (var i = 0; i < 7; i++) {
                    if (i == 0) {
                        var first = curr.getDate() - curr.getDay() + 1;
                        lunarWeekdays[i] = new Date(curr.setDate(first));
                    } else {
                        var prev = lunarWeekdays[i - 1];
                        var now = new Date(prev);
                        now.setDate(now.getDate() + 1);
                        lunarWeekdays[i] = now;
                    }
                    var d = lunarWeekdays[i];
                    var c = lunarCalendar.solar2lunar(d.getFullYear(), (d.getMonth() + 1), d.getDate());
                    var cStr = c.IMonthCn + ' ' + c.IDayCn;
                    vm.lunarCalendars.push(cStr);
                }
            });
        }

        function toLocalTime (utcTime) {
            var u = new Date(utcTime);
            var l = u.getTime() - (u.getTimezoneOffset() * 60000);
            l = new Date(l);
            return l;

        }

        function isSameDay (d1, d2) {
            return d1.getFullYear() === d2.getFullYear()
                && d1.getMonth() === d2.getMonth()
                && d1.getDate() === d2.getDate();
        }

        function diffInMinutes (start, end) {
            return Math.floor((end - start) / (1000 * 60));
        }

        function diffInHours (start, end) {
            return ((end - start) / (1000 * 60 * 60)).toFixed(1);
        }

        function diffInDays (start, end) {
            return Math.round((end - start) / (1000 * 60 * 60 * 24));
        }

        function getDaysInMonth (m, y) {
            return /8|3|5|10/.test(--m) ? 30 : m == 1 ? (!(y % 4) && y % 100) || !(y % 400) ? 29 : 28 : 31;
        }

        function date2Str (date, format) {
            if (angular.isUndefined(format)) format = 'yyyy-MM-dd';
            return $filter('date')(date, format);
        }

        function datetime2Str (datetime, format) {
            if (angular.isUndefined(format)) format = 'yyyy-MM-dd HH:mm';
            return $filter('date')(datetime, format);
        }

        function time2Str (time, format) {
            if (angular.isUndefined(format)) format = 'HH:mm';
            return $filter('date')(time, format);
        }

        function str2Time (str, format) {
            if (angular.isUndefined(format)) format = 'HH:mm:ss';
            return uibDateParser.parse(str, format);
        }

        function str2Date (str, format) {
            if (angular.isUndefined(format)) format = 'yyyy-MM-dd';
            return uibDateParser.parse(str, format);
        }

        function str2Datetime (str, format) {
            if (angular.isUndefined(format)) format = 'yyyy-MM-dd HH:mm';
            return uibDateParser.parse(str, format);
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('Dlg', Dlg);

    /** @ngInject */
    function Dlg($q, FormHelper, dialogs, toaster) {
        var service = {
            TP: {  // toast position
                BR: 1,  // bottom right
                TR: 2   // top right
            },
            show: ds,
            notify: dn,
            error: de,
            confirm: dc,

            w: w,
            e: e,
            s: s,
            i: i,

            //
            msg: msg,
            formError: formError,
            delTableItem: delTableItem,
            addEdit: addEdit,
            addEditOk: addEditOk,

            /**
             * @param pa 可填以下参数
             * title: 标题,
             * label: 文本标签, 默认: '理由说明',
             * icon:  font awesome图标, 默认: 'edit',
             * withRate: 是否打星, 默认: 否,
             * notRequired: 文本是否必填, 默认: 否
             * @param fn 回调函数, 参数option:
             * rate: 星级 1-5
             * opinion: 文本内容
             * @returns {*}
             */
            comment: comment,
            exportDR: exportDR,
            setReminder: setReminder,

            loadScrollbar: loadScrollbar,
        };

        return service;


        function addEditOk(vm, service, paFn, args) {
            var m, form, formIdSelector, op;
            if (angular.isDefined(args)) {
                op = args.op;
                /** @namespace args.formId */
                formIdSelector = '#' + (args.formId ? args.formId : 'Form');
                if (args.m) m = args.m;
                if (args.form) form = args.form;
            } else {
                op = 'default';
                formIdSelector = '#Form';
            }
            var closeFn = vm.close;
            if (!m) m = vm.m;
            if (!form) form = vm.Form;

            var defer = $q.defer();
            if (form.$valid) {
                var promise;
                var pa = paFn();
                if (m.id) { //修改
                    promise = service.update({id: m.id, op: op}, pa).$promise;
                } else { //添加
                    if (!pa.op) pa.op = op;
                    promise = service.save(pa).$promise;
                }
                promise.then(function (resp) {
                    if (resp.msg) {
                        s(resp.msg);
                    } else {
                        s('保存成功');
                    }
                    if (args && args.closePa) {
                        var closePa = args.closePa;
                        closeFn(closePa instanceof Function ? closePa(resp) : closePa);
                    } else {
                        closeFn(resp);
                    }
                }, function (error) {
                    console.log(error.data);
                    var data = error.data;
                    if (data.msg) de(data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                FormHelper.handleError(formIdSelector, form);
                defer.reject();
            }
            return defer.promise;
        }

        /**
         * @deprecated 请使用 dlgri 模板
         * 删除表格中的数据项
         * @param s 服务
         * @param id 数据项id
         * @param vm 关联vm
         * @param itemType 数据项类型名称
         * @param itemName 数据项名称
         */
        function delTableItem(s, id, vm, itemType, itemName) {
            dialogs.confirm('删除' + itemType, '确定要删除<strong>' + itemName + '</strong>'
                + itemType + '吗？')
                .result.then(function () {
                s.delete({id: id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            vm.tableReload();
                            toaster.success(resp.msg);
                            break;
                        default:
                            toaster.warning(resp.msg);
                    }
                });
            });
        }

        function addEdit(vm, dlg, dlgCtrl, m, data, dlgSiz, cb) {
            var pa = data ? data : {};
            if (m) pa.id = m.id;
            if (!dlgSiz) dlgSiz = 'md';
            return dialogs.create(dlg, dlgCtrl, pa,
                {size: dlgSiz}, 'vm').result.then(function (resp) {
                vm.tableReload();
                if (cb) cb(resp);
            });
        }

        /**
         * @param pa 可填以下参数
         * title: 标题,
         * label: 文本标签, 默认: '理由说明',
         * icon:  font awesome图标, 默认: 'edit',
         * withRate: 是否打星, 默认: 否,
         * notRequired: 文本是否必填, 默认: 否
         * @param fn 回调函数, 参数option:
         * rate: 星级 1-5
         * opinion: 文本内容
         * @returns {*}
         */
        function comment(pa, fn) {
            return dialogs.create('pages/dialogs/comment/commentDlg.html', 'CommentDlgCtrl', pa, {
                size: 'md'
            }, 'vm').result.then(fn);
        }

        function exportDR(urlOrParams, title, start, end, icon) {
            var params = urlOrParams !== null && typeof urlOrParams === 'object' ?
                urlOrParams : {title: title, url: urlOrParams, icon: icon, start: start, end: end};

            return dialogs.create('pages/dialogs/export/dateRangeDlg.html', 'EDRCtrl',
                params, {size: 'md'}, 'vm');
        }

        function setReminder(service, event, users, title, label) {
            return dialogs.create('pages/dialogs/eventReminderDlg.html', 'eventReminderDlgCtrl',
                {service: service, event: event, title: title, users: users, label: label},
                {size: 'md'}, 'vm');
        }

        function loadScrollbar(vm) {
            if (window.innerWidth < 568) {
                vm.bodyStyle = {
                    'min-height': window.innerHeight - 200,
                    width: window.innerWidth - 40
                };
            } else {
                vm.bodyStyle = {
                    height: 480
                };
            }
        }


        function msg(title, body, hideFn, noSound) {
            toaster.pop({
                title: title, body: body, bodyOutputType: 'trustedHtml', toasterId: 1,
                clickHandler: function (toast, isCloseButton) {
                    if (!isCloseButton && !angular.isUndefined(hideFn)) {
                        hideFn();
                    }
                    return true;
                },
                onShowCallback: function () {
                    if (!noSound) {
                        document.getElementById('msgTone1').play();
                    }
                }
            });
        }

        function formError() {
            toaster.error("有项目填错了亲,请检查表单上的提示哟^-^!");
        }

        function w(msg, id) {
            toaster.warning({title: msg, toasterId: id});
        }

        function e(msg, id) {
            toaster.error({title: msg, toasterId: id});
        }

        function s(msg, id) {
            toaster.success({title: msg, toasterId: id});
        }

        function i(msg, id) {
            toaster.info({title: msg, toasterId: id});
        }

        /**
         * 显示对话框
         * @param pa： backdrop: true(非模态) false(无背景) 'static'(默认，模态)
         * @returns {*}
         */
        function ds(pa) {
            var options = {};
            if (pa.name) {
                pa.ctrl = pa.name + 'Ctrl';
                if (!pa.template) pa.template = pa.name;
            }
            if (!pa.data) pa.data = {};
            if (!pa.size) options.size = 'md';
            else options.size = pa.size;
            if (pa.backdrop) options.backdrop = pa.backdrop;
            switch (pa.pos) {
                case 'right':  // 目前仅支持right
                    options.windowClass = 'modal-right';
                    options.backdropClass = 'modal-backdrop-light';
            }
            if (pa.size === 'full') options.windowClass += ' modal-full';
            return dialogs.create(pa.template, pa.ctrl, pa.data, options, 'vm').result;
        }

        function dn(msg, title) {
            if (angular.isUndefined(title)) {
                title = "提示";
            }
            return dialogs.notify(title, msg).result;
        }

        function de(msg, title) {
            if (angular.isUndefined(title)) {
                title = "出错了";
            }
            return dialogs.error(title, msg).result;
        }

        function dc(msg, cb, title, error) {
            if (angular.isUndefined(title)) {
                title = "提示";
            }
            return dialogs.confirm(title, msg).result.then(cb, error);
        }


    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('ExtHelper', ExtHelper);

    /** @ngInject */
    function ExtHelper($q, $timeout, deviceDetector) {
        var service = {
            chkCardReadExt: chkCardReadExt,
            readCard: readCard,
            parseIdcardStr: parseIdcardStr,
            EXT_ID: {
                CARD_READER: "oiigbdbjedaiiogmnfpncpmoaapnfjgl"
            }

        };

        return service;

        function chkCardReadExt(vm) {
            vm.extMissing = false;
            var extensionId = service.EXT_ID.CARD_READER;
            vm.envInvalid = !deviceDetector.isDesktop() || deviceDetector.browser !== "chrome";
            if (vm.envInvalid) return;

            if (!!chrome.runtime) {
                chrome.runtime.sendMessage(extensionId, {do: "chk.ext"}, function (resp) {
                    $timeout(function () {
                        vm.extMissing = !resp;
                    });
                });
            } else {
                vm.extMissing = true;
            }
        }

        function readCard(vm, success, error) {
            var defer = $q.defer();
            var extensionId = service.EXT_ID.CARD_READER;
            chrome.runtime.sendMessage(extensionId, {do: "read.card"}, function (resp) {
                $timeout(function () {
                    vm.extMissing = !resp;
                    if (resp && resp.result === 0) {
                        defer.resolve(parseIdcardStr(resp.msg));
                    } else {
                        defer.reject(resp.msg);
                    }
                });
            });
            return defer.promise;
        }

        function parseIdcardStr(idcardStr) {
            var idcardArr = idcardStr.split(",");
            var cardInfo = {
                idcard: idcardArr[0],
                name: idcardArr[1],
                nation: idcardArr[2],
                birthday: idcardArr[3],
                gender: idcardArr[4]
            };
            if (idcardArr.length > 5) cardInfo.address = idcardArr[5];
            return cardInfo;
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('FileHelper', fileService);

    /** @ngInject */
    function fileService($q, $http, ArrayHelper, Upload, SaveAs, dialogs, toaster) {
        var service = {
            urls: {
                UPLOAD: '/api/v1/file/attachments/upload_single'
            },

            UPLOAD_STATE: {
                UPLOADING: 1,
                UPLOADED: 2,
                FAILED: 3
            },

            uploadSingle: uploadSingle,
            uploadAttachment: uploadAttachment,
            uploadCroppedImage: uploadCroppedImage,

            isAttachmentsUploaded: isAttachmentsUploaded,
            loadAttachmentParams: loadAttachmentParams,
            upload: upload,
            upload1: upload1,

            dnExcel: dnExcel,
            download: download,
            download1: download1,

            getPublicLink: getPublicLink,

            humanReadableSizeToValue: humanReadableSizeToValue
        };

        return service;

        function humanReadableSizeToValue(humanReadableSize) {
            var measure = 0;
            var unit = humanReadableSize.substr(-2, 2).toUpperCase();
            switch (unit) {
                case 'TB':
                    measure = 4;
                    break;
                case 'GB':
                    measure = 3;
                    break;
                case 'MB':
                    measure = 2;
                    break;
                case 'KB':
                    measure = 1;
                    break;
            }
            if (measure === 0) return +humanReadableSize;
            return +humanReadableSize.slice(0, -2) * Math.pow(1024, measure);
        }


        function getPublicLink(filename) {
            return $http.post('api/v1/file/preview/mk_pub_link', {filename: filename});
        }

        function download(url, data, success, error) {
            $http({
                url: url,
                method: "POST",
                data: data,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(success).error(error);
        }

        function dnExcel(url, params, filename, cb) {
            return $http({
                url: url,
                method: "POST",
                data: params,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function (resp) {
                var data = [resp];
                var options = {type: 'vnd.ms-excel'};
                SaveAs.download(data, filename, options);
                if (cb) cb();
            });
        }

        /**
         * 上传裁剪后的图片
         * @param image image->json, 其中需要填写的属性包括toUrl:上传地址，croppedDataUrl：裁剪后生成的url
         * @returns {*}
         */
        function uploadCroppedImage(image) {
            var defer = $q.defer();

            var file = Upload.dataUrltoBlob(image.croppedDataUrl);

            if (image.inProgress) {
                defer.reject("正在上传，请稍后再试");
            } else {
                if (!file.$error) {
                    image.inProgress = true;
                    Upload.upload({
                        url: image.toUrl, data: {file: file}
                    }).progress(function (evt) {
                        image.progress = parseInt(100.0 * evt.loaded / evt.total);
                    }).success(function (resp) {
                        defer.resolve(resp);
                    }).error(function () {
                        defer.reject("服务器错误");
                    }).finally(function () {
                        image.inProgress = false;
                    });
                } else {
                    defer.reject("图片不能大于20M");
                }
            }
            return defer.promise;
        }

        function uploadAttachment(file, data, e, extra) {
            service.upload(service.urls.UPLOAD, file, data, e, extra);
        }

        function uploadSingle(file, data, e, rename, extra) {
            return service.upload1(service.urls.UPLOAD, file, data, e, rename, extra);
        }

        function mergeObj(o1, o2) {
            for (var key in o2) {
                o1[key] = o2[key]
            }
            return o1;
        }


        /**
         * 对多附件上传的封装
         * @param url
         * @param file
         * @param data
         * @param e
         * @param extra
         */
        function upload(url, file, data, e, extra) {
            if (e && e[0] && e[0].$error === 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }

            if (file === null) return;

            var attachment = {name: file.name, progress: 0};
            data.attachments.push(attachment);
            var pa = {
                url: url, file: file
            };

            if (extra) pa.data = {extra: extra};

            var defer = $q.defer();
            Upload.upload(pa).progress(function (evt) {
                attachment.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        attachment.name = resp.name;
                        attachment.mime = resp.mime;
                        attachment.filename = resp.filename;
                        attachment.size = resp.size;
                        defer.resolve(attachment);
                        break;
                    case 1:
                        attachment.progress = 101;
                        attachment.errorInfo = '服务器空间不足!';
                        defer.reject();
                        break;
                }
            }).error(function () {
                defer.reject();
                attachment.progress = 102;
                attachment.errorInfo = '服务器错误!';
            });

            return defer.promise;
        }

        /**
         * @deprecated
         * 用于单个附件上传
         * @param url
         * @param file
         * @param data 附件依附对象，其各字段标准为attach_name（附件名称），mime，filename（服务器路径），size
         * @param e
         * @param rename
         * @param extra 额外参数
         */
        function upload1(url, file, data, e, rename, extra) {
            if (e && e[0] && e[0].$error === 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }

            if (!file) return;

            if (angular.isUndefined(rename) || !rename) {
                rename = {};
            }
            if (!rename.name) rename.name = 'attach_name';
            if (!rename.mime) rename.mime = 'mime';
            if (!rename.filename) rename.filename = 'filename';
            if (!rename.size) rename.size = 'size';

            data.progress = 0;
            var pa = {file: file, id: data.id, remap: rename};
            if (angular.isDefined(extra) && extra) {
                mergeObj(pa, extra);
            }
            delete data[rename.filename];

            var defer = $q.defer();
            Upload.upload({
                url: url, data: pa
            }).progress(function (evt) {
                data.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        data[rename.name] = resp[rename.name];
                        data[rename.mime] = resp[rename.mime];
                        data[rename.filename] = resp[rename.filename];
                        data[rename.size] = resp[rename.size];
                        defer.resolve(data);
                        break;
                    case 1:
                        data.progress = 101;
                        data.errorInfo = '服务器空间不足!';
                        defer.reject();
                        break;
                }
            }).error(function () {
                defer.reject();
                data.progress = 102;
                data.errorInfo = '服务器错误!';
            });

            return defer.promise;
        }

        /**
         * 检查多附件上传中，所有附件是否都已上传并返回服务器文件路径
         * @param data
         * @param attachmentField
         * @returns {boolean}
         */
        function isAttachmentsUploaded(data, attachmentField) {
            if (angular.isUndefined(attachmentField)) attachmentField = 'attachments';
            for (var i = 0; i < data[attachmentField].length; i++) {
                if (!data[attachmentField][i].filename) {
                    return false;
                }
            }
            return true;
        }

        function loadAttachmentParams(pa, m) {
            pa.attachments = ArrayHelper.map(m.attachments, function (attachment) {
                return attachment.id ? {id: attachment.id} : {
                    name: attachment.name, mime: attachment.mime,
                    filename: attachment.filename, size: attachment.size
                };
            });
        }

        /**
         * 下载文件
         * @param url 文件资源地址
         * @param data 文件信息数据
         * @param rename 重命名文件信息数据中的字段
         */
        function download1(url, data, rename) {


            if (angular.isUndefined(rename)) {
                rename = {};
            }
            if (!rename.name) rename.name = 'name';
            if (!rename.mime) rename.mime = 'mime';
            if (!rename.filename) rename.filename = 'filename';
            if (!rename.size) rename.size = 'size';
            var params = {name: data[rename.name], filename: data[rename.filename], mime: data[rename.mime]};
            data.downloading = true;
            $http({
                url: url,
                method: "POST",
                data: params,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function (resp) {
                SaveAs.download([resp], data[rename.name], {type: data[rename.mime]});
            }).error(function (error) {
                toaster.error('文件丢失');
            }).finally(function () {
                data.downloading = false;
            });
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('Float', Float);

    /** @ngInject */
    function Float() {
        var service = {
            toFixed: toFixed
        };

        return service;


        function toFixed(floatNum, decimal) {
            if (angular.isUndefined(decimal)) decimal = 2;
            return parseFloat(floatNum.toFixed(decimal));
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('FormHelper', FormHelper);

    /** @ngInject */
    function FormHelper($q, $timeout, $location, $anchorScroll, toaster) {
        var service = {
            handleError: handleError,
            handleSubmit: handleSubmit,
            deleteAttachment: deleteAttachment
        };

        return service;


        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function handleSubmit(vm, cb, args) {
            var form, formIdSelector, skipTip = false;
            if (angular.isDefined(args)) {
                /** @namespace args.formId */
                formIdSelector = '#' + (args.formId ? args.formId : 'Form');
                if (args.form) form = args.form;
                skipTip = args.skipTip;
            } else {
                formIdSelector = '#Form';
            }
            if (!form) form = vm.Form;

            var defer = $q.defer();
            if (form.$valid) {
                if (cb) cb(defer);
            } else {
                if (skipTip) {
                    form.$submitted = true;
                } else {
                    service.handleError(formIdSelector, form);
                }
                defer.reject();
            }
            return defer.promise;
        }


        function handleError(formIdSelector, form) {
            $timeout(function () {
                var firstInvalid = angular.element(formIdSelector)[0].querySelector('.ng-invalid');

                if (firstInvalid) {
                    if ($location.hash() !== firstInvalid.id) {
                        $location.hash(firstInvalid.id);
                    }
                    $anchorScroll();
                    firstInvalid.focus();
                }
            });
            toaster.error("有项目填错了亲,请检查表单上的提示哟^-^!");
            form.$submitted = true;
        }
    }
})();

/**
 * @deprecated 1.模块相关的服务应当放在模块的服务中，而不是这里；
 * 2.不同功能的公共方法应该按功能分类，而不是统一放在这里，
 * 所以F服务从此废弃，不要在往里面放东西了，也尽量不要再用它了。
 */
angular.module('c')
    .factory('F', function (ArrayHelper, Table, UIHelper, uibDateParser) {
        return {
            /**
             * @deprecated ArrayHelper.inArray 替代
             */
            inArray: ArrayHelper.inArray,
            /**
             * @deprecated ArrayHelper.indexOf 替代
             */
            indexOf: ArrayHelper.inArray,
            /**
             * @deprecated UIHelper.getIconFromMime 替代
             */
            getIconFromMime: UIHelper.getIconFromMime,
            /**
             * @deprecated Table.getNgTableOpts 替代
             */
            getNgTableOpts: Table.getNgTableOpts,
            /**
             * @deprecated ArrayHelper.except 替代
             */
            except: ArrayHelper.except,
            /**
             * @deprecated 使用Array.getItem替代
             */
            getItem: ArrayHelper.getItem,
            /**
             * @deprecated 使用Array.indexOfKey 替代
             */
            indexOfKey: ArrayHelper.indexOfKey,
            /**
             * @deprecated 使用Array.findItem 替代
             */
            findItem: ArrayHelper.findItem,
            /**
             * @deprecated 使用Array.getItems 替代
             */
            getItems: ArrayHelper.getItems,
            /**
             * @deprecated 使用Array.listKey 替代
             */
            listKey: ArrayHelper.listKey,
            /**
             * @deprecated 使用Array.get 替代
             */
            get: ArrayHelper.get,
            /**
             * @deprecated
             * 公告审批阶段列表
             * @returns {*[]}
             */
            getApprovalStages1: function (appendOverStage) {
                var states = ArrayHelper.get('approval_stages1');
                if (appendOverStage) {
                    var arr = angular.copy(states);
                    arr.push({id: '5', name: '已结束'});
                    return arr;
                }
                return states;
            },
            /**
             * @deprecated 使用 UIHelper.getProgressType 替代
             */
            getProgressType: UIHelper.getProgressType,
            /**
             * @deprecated 使用 UIHelper.loadTabs 替代
             */
            loadTabs: UIHelper.loadTabs,
            /**
             * @deprecated 使用  UIHelper.loadTab 替代
             */
            loadTab: UIHelper.loadTab,
            bitwise2array: ArrayHelper.bitwise2array,
            array2bitwise: ArrayHelper.array2bitwise,
            checkTime: function (dateTime, beginTime, endTime) {
                var bd = uibDateParser.parse(beginTime, 'HH:mm');
                var ed = uibDateParser.parse(endTime, 'HH:mm');
                var nd = uibDateParser.parse(dateTime, 'HH:mm');
                if (bd > ed && nd > bd) {
                    var edNew = ed.getTime() + 24 * 60 * 60 * 1000;
                    ed = new Date(edNew);
                }
                if (bd > ed && nd < ed) {
                    var bdNew = bd.getTime() - 24 * 60 * 60 * 1000;
                    bd = new Date(bdNew);
                }
                return nd > bd && nd < ed;
            },
            toFixed: function (floatNum, decimal) {
                if (angular.isUndefined(decimal)) decimal = 2;
                return parseFloat(floatNum.toFixed(decimal));
            },
            getParent: function getParent(type) {
                if (type.parent) {
                    return getParent(type.parent);
                }
                return type;
            }
        };
    });


/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('PrintHelper', Print);

    /** @ngInject */
    function Print($timeout, $templateRequest, $sce, SaveAs, $ocLazyLoad) {
        var service = {
            print: print,
            printAsWord: printAsWord,
            STYLE: {
                TEMP2: 'templates/print/table2.html'
            }
        };

        return service;


        function printAsWord(name, styleFile, createBody) {
            if (!!styleFile) {
                var templateUrl = $sce.getTrustedResourceUrl(styleFile, '');
                $templateRequest(templateUrl).then(function (resp) {
                    var printStyle = resp;
                    var html = '<!DOCTYPE html><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"></head><body>';
                    html += createBody();
                    html += '</body></html>';
                    $ocLazyLoad.load('/ocLazyLoad/html2Doc/html-docs.min.js').then(function () {
                        var converted = htmlDocx.asBlob(html + printStyle);
                        SaveAs.download(converted, name + '.docx');
                    });
                });
            } else {
                var html = '<!DOCTYPE html><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"></head><body>';
                html += createBody();
                html += '</body></html>';
                $ocLazyLoad.load('/ocLazyLoad/html2Doc/html-docs.min.js').then(function () {
                    var converted = htmlDocx.asBlob(html);
                    SaveAs.download(converted, name + '.docx');
                });
            }
        }

        /**
         * @param w, 已打开窗口
         * @param styleFileOrCB
         * @param createBody:function, 创建<body>元素内的html并返回
         */
        function print(w, styleFileOrCB, createBody) {
            if (typeof styleFileOrCB === "function") {
                createBody = styleFileOrCB;
                styleFileOrCB = service.STYLE.TEMP2;
            }

            if (styleFileOrCB) {
                var templateUrl = $sce.getTrustedResourceUrl(styleFileOrCB, '');
                $templateRequest(templateUrl).then(function (resp) {
                    var printStyle = resp;
                    var html = '<html><body>';
                    html += createBody();
                    html += '</body></html>';
                    w.document.write(html + printStyle);
                    w.document.close();
                    w.focus();
                    $timeout(function () {
                        w.print();
                        w.close();
                    }, 24);
                });
            } else {
                var html = '<html><body>';
                html += createBody();
                html += '</body></html>';
                w.document.write(html);
                w.document.close();
                w.focus();
                $timeout(function () {
                    w.print();
                    w.close();
                }, 24);
            }
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').constant('Regex', {
        IP: /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/,
        PHONE: /^(13[0-9]|14[579]|15[0-3,5-9]|16[5-7]|17[0-3,5-8]|18[0-9]|19[12389])\d{8}$/,
        PASSWORD: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,16}$/,
        CAPTCHA: /^[a-zA-Z0-9_\.]{6,}$/
    });

})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('Table', TableHelper);

    /** @ngInject */
    function TableHelper (NgTableParams, $filter, Dlg) {
        return {
            _1_BTN: 48,
            _2_BTN: 78,
            _3_BTN: 108,
            _4_BTN: 140,
            _5_BTN: 172,
            _6_BTN: 208,

            _1_CHAR: 48,
            _2_CHAR: 72,
            _3_CHAR: 96,
            _4_CHAR: 128,
            _5_CHAR: 170,
            _6_CHAR: 300,

            loadMultiSelectedFn: loadMultiSelectedFn,
            getTableData: getTableData,
            /**
             * 方便ngTable获取数据
             * @param service 服务名称
             * @param url 参数
             * @param $defer ngTable的参数
             * @param params ngTable的参数
             * @param items 获取的主要数据项，字符串
             * @param cb 回调函数，可选
             */
            query: queryItems,

            /**
             * @deprecated
             * 加载ngTable
             * @param scope
             * @param options 配置选项
             *  *cols: 数据项
             *  *service： 查询的服务名称，params：查询的额外参数，如opt等，*items：返回的主要数据项名称，注意是string类型
             *  optColWidth：操作列宽度，hideOpt：是否隐藏操作列，hideFilter：是否隐藏过滤行，justDataCol：是否只显示数据列
             *  count： 分页显示时初始每页显示数据条数（默认10），sorting：排序方式（默认 {created_at: 'desc'}）， filter: 初始过滤,
             *  counts: 分页页数选择（默认[10, 30, 50]）, dateFilters：日期范围过滤器数组,
             *  primaryParam: 如果指定了该参数并且params参数列表中该参数为空，则返回暂无数据
             * @param cb 回调函数
             */
            loadNgTable: loadNgTable
            ,
            /**
             * 加载ngtable，后台分页
             * @param scope
             * @param options 配置选项
             *  *cols: 数据项
             *  *service： 查询的服务名称，params：查询的额外参数，如opt等，*items：返回的主要数据项名称，注意是string类型
             *  optColWidth：操作列宽度，hideOpt：是否隐藏操作列，hideFilter：是否隐藏过滤行，showSn：是否显示序号列
             *  cbWidth: 多选列表中checkbox列宽度
             *  count： 分页显示时初始每页显示数据条数（默认10），sorting：排序方式（默认 {created_at: 'desc'}）， filter: 初始过滤,
             *  counts: 分页页数选择（默认[10, 30, 50]）
             *  primaryParam: 如果指定了该参数并且params参数列表中该参数为空，则返回暂无数据
             *  primaryFilter: 如果filter中该过滤项为空，则返回暂无数据
             * @param cb 回调函数
             */
            load: loadTable,
            loadItem: loadItem,
            loadTableCols: loadTableCols,
            getNgTableOpts: getNgTableOpts
        };

        function loadItem(resp, startSn, cb) {
            angular.forEach(resp.items, function (item, i) {
                item.sn = startSn + i + 1;
                if (cb) cb(item, i);
            });
        }

        function loadTableCols(service, params) {
            var cols = [];
            var serviceCols = service.getCols();
            angular.forEach(params, function (param) {
                cols.push(serviceCols[param]);
            });
            return cols;
        }

        function getNgTableOpts(items, firstRow) {
            var data = [angular.isDefined(firstRow) ? {id: firstRow[0], title: firstRow[1]} : {id: '', title: '-'}];
            angular.forEach(items, function (item) {
                data.push({id: item.id, title: item.name});
            });
            return data;
        }

        function loadMultiSelectedFn(scope) {
            scope.header = {checkAll: false};
            scope.checkOneFn = function (item, items) {
                if (item.is_checked) {
                    scope.header.checkAll = true;
                } else {
                    var allUnchecked = true;
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].is_checked) {
                            allUnchecked = false;
                            break;
                        }
                    }
                    if (allUnchecked) {
                        scope.header.checkAll = false;
                    }
                }
            };
            scope.checkAllFn = function (checkAll, items) {
                if (checkAll) {
                    angular.forEach(items, function (item) {
                        item.is_checked = true;
                    })
                } else {
                    angular.forEach(items, function (item) {
                        item.is_checked = false;
                    })
                }
            };
            return {
                hasChecked: function () {
                    return scope.header.checkAll;
                },
                clearChecked: function (items) {
                    scope.header.checkAll = false;
                    if (!items) items = scope.tableParams.data;
                    angular.forEach(items, function (item) {
                        item.is_checked = false;
                    });
                },
                getCheckedIds: function (items) {
                    var ids = [];
                    if (!items) items = scope.tableParams.data;
                    angular.forEach(items, function (item) {
                        if (item.is_checked) {
                            ids.push(item.id);
                        }
                    });
                    return ids;
                },
                getChecked: function (items, fields) {
                    var checked = [];
                    if (!items) items = scope.tableParams.data;
                    angular.forEach(items, function (item) {
                        if (item.is_checked) {
                            checked.push(item);
                        }
                    });
                    return checked;
                }
            }
        }

        function getTableData(data, $defer, params, $filter) {
            if ($filter) {
                data = params.filter() ?
                    $filter('filter')(data, params.filter()) :
                    data;
                data = params.sorting() ?
                    $filter('orderBy')(data, params.orderBy()) : data;
            }
            params.total(data.length);
            if (params.page() > Math.ceil(data.length / params.count())) {
                params.$params.page = params.page() - 1;
            }
            if (params.page() === 0) {
                params.$params.page = 1;
            }
            $defer.resolve(data.slice((params.page() - 1) * params.count(),
                params.page() * params.count()));
        }

        function loadTable(scope, options, cb) {
            var filters = options.filter ? options.filter : {};
            options.filterDelay = options.filter ? 0 : 750;
            scope.cols = options.cols;
            angular.forEach(scope.cols, function (col) {
                if (typeof col.show === 'undefined') {
                    col.show = true;
                }
                if (typeof col.width === 'number') {
                    col.widthStyle = {'min-width': col.width + 'px'};
                }
            });
            scope.optColWidth = options.optColWidth;
            if (options.optColWidth) scope.optColStyle = {'min-width': options.optColWidth + 'px'};
            scope.hideOpt = options.hideOpt;
            scope.hideFilter = options.hideFilter;
            scope.showSn = options.showSn;
            scope.optInFront = options.optInFront;
            scope.cbWidth = options.cbWidth ? options.cbWidth : 62;
            scope.tableParams = new NgTableParams({
                count: options.count ? options.count : 10, sorting: options.sorting ? options.sorting : {id: 'desc'},
                filter: filters
            }, {
                filterDelay: options.filterDelay,
                counts: options.counts ? options.counts : [10, 30, 50],
                getData: function ($defer, params) {
                    if ((options.primaryParam && !options.params[options.primaryParam]) || (
                            options.primaryFilter && !params.filter()[options.primaryFilter]
                        )) {
                        //return $defer.resolve([]);
                    } else {
                        if (options.filterDelay === 0) {
                            options.filterDelay = 750;
                            scope.tableParams.settings({filterDelay: options.filterDelay});
                        }
                        var url = params.url();
                        for (var index in options.params) {
                            url[index] = options.params[index];
                        }
                        return queryItems(options.service, url, $defer, params, options.items, cb);
                    }
                }
            });

            scope.clearFilters = function () {
                scope.tableParams.filter({});
            };

            scope.tableReload = function () {
                scope.tableParams.reload();
            };

            return {
                options: function () {
                    return options;
                }
            }
        }

        function loadNgTable (scope, options, cb) {
            scope.cols = options.cols;
            angular.forEach(scope.cols, function (col) {
                if (typeof col.show === 'undefined') {
                    col.show = true;
                }
            });
            if (options.dateFilters) {
                scope.dateRangeFilter = {};
                scope.$watch('dateRangeFilter',
                    function () {
                        scope.tableParams.reload();
                    }, true
                );
            }
            scope.optColWidth = options.optColWidth;
            scope.hideOpt = options.hideOpt;
            scope.hideFilter = options.hideFilter;
            scope.justDataCol = options.justDataCol;
            scope.tableParams = new NgTableParams({
                page: 1, count: options.count ? options.count : 10, sorting: options.sorting ? options.sorting : {
                        created_at: 'desc'
                    }, filter: options.filter ? options.filter : {}
            }, {
                counts: options.counts ? options.counts : [10, 30, 50], total: 0,
                getData: function ($defer, params) {
                    if (options.primaryParam && !options.params[options.primaryParam]) {
                        $defer.resolve([]);
                    } else {
                        var url = params.url();
                        for (var index in options.params) {
                            url[index] = options.params[index];
                        }
                        if (options.dateFilters != null && options.dateFilters.length > 0) {
                            angular.forEach(options.dateFilters, function (d) {
                                if (scope.dateRangeFilter[d.name] != null) {
                                    var start = d.start;
                                    var end = d.end;
                                    if (!start) start = 'startDate';
                                    if (!end) end = 'endDate';
                                    url[start] = $filter('date')(scope.dateRangeFilter[d.name][start], 'yyyy-MM-dd');
                                    url[end] = $filter('date')(scope.dateRangeFilter[d.name][end], 'yyyy-MM-dd');
                                }
                            });
                        }
                        queryItems(options.service, url, $defer, params, options.items, cb);
                    }
                }
            });

            scope.clearFilters = function () {
                scope.tableParams.filter({});
                if (options.dateFilters) {
                    scope.dateRangeFilter = {};
                }
            };

            scope.clearReload = function () {
                if (angular.equals(scope.tableParams.filter(), {}) &&
                    (!scope.dateRangeFilter || angular.equals(scope.dateRangeFilter, {}))) {
                    scope.tableReload();
                } else {
                    scope.clearFilters();
                }
            };

            scope.tableReload = function () {
                scope.tableParams.reload();
            };

            return {
                options: function () {
                    return options;
                }
            }
        }

        function queryItems(service, url, $defer, params, items, cb) {
            if (items === null || items === undefined) {
                items = 'items';
            }
            service.query(url).$promise.then(function (data) {
                if (data.total > 0 && data[items].length === 0) {
                    params.$params.page = params.page() - 1;
                    params.reload();
                } else {
                    params.total(data.total);
                    if (angular.isDefined(cb)) {
                        cb(data, (params.page() - 1) * params.count());
                    }
                    $defer.resolve(data[items]);
                }
            }, function (err) {
                if (err.data.msg) Dlg.error(err.data.msg);
                $defer.resolve();
            });
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c')
        .factory('UIHelper', UIHelper)
        .controller('UploadWordImagesDlg', UploadWordImagesDlg)

    ;

    /** @ngInject */
    function UIHelper(ArrayHelper, $window, $document, $state, $rootScope, $location, deviceDetector, OS, Upload, dialogs) {
        var curExtraParam = null;
        var service = {
            getIconFromMime: getIconFromMime,
            getProgressType: getProgressType,
            isTooDark: isTooDark,
            scrollTo: scrollTo,

            tabTo: tabTo,
            loadTabs: loadTabs,
            loadTab: loadTab,
            hasTabExtra: hasTabExtra,
            getTabExtra: getTabExtra,

            onCKReady: onCKReady,
            initCKEditor: initCKEditor,

            offset: offset
        };

        return service;

        function offset(element) {
            var boundingClientRect = element[0].getBoundingClientRect();
            return {
                width: boundingClientRect.width || element.prop('offsetWidth'),
                height: boundingClientRect.height || element.prop('offsetHeight'),
                top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
                left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
            };
        }

        function setResponsive(el) {
            if (el.children && el.children.length > 0) {
                angular.forEach(el.children, function (child) {
                    setResponsive(child);
                });
            } else {
                if (el.name !== 'img') return;
                el.addClass('img-responsive');
            }
        }

        function initCKEditor() {
            // 响应式
            CKEDITOR.on('instanceReady', function (ev) {
                ev.editor.dataProcessor.htmlFilter.addRules({
                    elements: {
                        $: setResponsive
                    }
                });
            });
        }

        function onCKReady(editor) {
            editor = CKEDITOR.instances[editor];
            if (!editor) return;

            //目前只支持桌面
            if (deviceDetector.isDesktop()) {
                editor.on('afterInsertHtml', function (evt) {
                    // 解决从word拷贝图片的问题...
                    var editable = editor.editable();
                    var imgList = editable.find('img').$;
                    var localImgList = {};
                    angular.forEach(imgList, function (img) {
                        if (img.src.match(/^file:\/\//)) {
                            if (ArrayHelper.indexOfKey(img.src, localImgList, 'src') === -1) {
                                var filename = img.src.replace(/^.*(\\|\/|\:)/, '');
                                localImgList[filename] = img;
                            }
                        }
                    });
                    if (Object.keys(localImgList).length > 0) {
                        if (editor.commands.maximize.state === 1) {
                            editor.execCommand('maximize');
                        }

                        var files = [], startIndex = 7, changeSeparator = false;
                        if (deviceDetector.os === OS.WINDOWS) {
                            startIndex = 8;
                            changeSeparator = true;
                        }
                        var names = Object.keys(localImgList);
                        angular.forEach(names, function (name) {
                            var img = localImgList[name];
                            var path = img.src.substr(startIndex);
                            if (changeSeparator) {
                                path = path.replace(/\//g, "\\");
                            }
                            files.push({name: name, path: path});
                        });
                        dialogs.create('templates/upload/word_images_dlg.html', 'UploadWordImagesDlg', {
                            files: files
                        }, {
                            size: 'md'
                        }).result.then(function (result) {
                            var widgets = editor.widgets.instances,
                                curWidget,
                                i;
                            for (i in widgets) {
                                curWidget = widgets[i];
                                if (curWidget.definition.name === 'image') {
                                    var name = curWidget.parts.image.getAttribute('src').replace(/^.*(\\|\/|\:)/, '');
                                    var url = result[name];
                                    if (url) {
                                        curWidget.setData('src', url);
                                    }
                                }
                            }
                            editor.fire('change');
                        });
                    }
                });
            }

            editor.on('fileUploadRequest', function (evt) {
                var loader = evt.data.fileLoader;
                var file = Upload.dataUrltoBlob(loader.data);
                file.name = loader.file.name;
                Upload.upload({
                    url: loader.uploadUrl, data: {file: file}
                }).progress(function (evt) {
                    if (!loader.uploadTotal) loader.uploadTotal = evt.total;
                    loader.uploaded = evt.loaded;
                    loader.update();
                }).success(function (resp) {
                    loader.responseData = resp;
                    if (resp.error && resp.error.message) {
                        loader.message = resp.error.message;
                    }
                    if (resp.result === 1) { // 错误
                        evt.cancel();
                        loader.changeStatus('error');
                    } else {
                        loader.url = resp.url;
                        loader.fileName = resp.fileName;
                        loader.changeStatus('uploaded');
                        editor.fire('change');
                    }
                }).error(function () {
                    loader.changeStatus('error');
                });
                evt.stop();
            });
        }

        // for ui bootstrap 1.3.3
        function loadTabs($scope, $stateParams) {
            var vm = $scope;
            vm.curTab = $stateParams.tab;
            curExtraParam = $stateParams.data.extra;
            vm.tabSelected = tabSelected;

            $scope.$on('tabChange', function (event, pa) {
                var tab = pa.tab;
                curExtraParam = pa.extra;

                // 如果当前标签页正好是审批提醒跳转标签页,则直接发广播,触发刷新;否则改变标签页,通过tabSelected触发刷新
                if (vm.curTab === tab) {
                    $rootScope.$broadcast("reload", {tab: tab, extra: curExtraParam});
                } else {
                    vm.curTab = tab;
                }
            });

            /**
             * 记录选择的标签页，并触发该页面的重新加载事件
             * <strong>注意：这个函数必须应用的标签页上</strong>
             * @param tab
             * @param skipReloadContent 不触发标签内容更新
             */
            function tabSelected(tab, skipReloadContent) {
                $location.search('tab', tab);
                if (!skipReloadContent) {
                    $rootScope.$broadcast("reload", {tab: tab, extra: curExtraParam});
                }
            }
        }

        function loadTab($scope, tab, reloadFn) {
            var vm = $scope;
            $scope.$on("reload", function (event, data) {
                var tabTo = data.tab;
                if (tabTo === tab) {
                    if (reloadFn) {
                        if (reloadFn(data.extra)) curExtraParam = null;
                    } else {
                        vm.tableReload();
                    }
                }
            });
        }

        function hasTabExtra() {
            return curExtraParam !== null && typeof curExtraParam !== 'undefined'
                && !angular.equals(curExtraParam, {});
        }

        function getTabExtra() {
            return curExtraParam;
        }

        function tabTo(tab, extra, state) {
            if (state) {
                $state.go(state, {tab: tab, data: {extra: extra}});
            } else {
                $rootScope.$broadcast('tabChange', {tab: tab, extra: extra});
            }
        }

        function scrollTo(toElemId, scrollableBodyId, offset, duration) {
            if (angular.isUndefined(scrollableBodyId)) scrollableBodyId = '.modal-body';
            else scrollableBodyId = '#' + scrollableBodyId;
            if (angular.isUndefined(offset)) offset = 0;
            if (angular.isUndefined(duration)) duration = 200;
            var scrollableBody = angular.element(scrollableBodyId)[0];
            var toElemOffset = angular.isUndefined(toElemId) ? 0 :
                angular.element('#' + toElemId)[0].offsetTop;

            var currentTime = 0;
            var increment = 2;
            var from = scrollableBody.scrollTop;
            var to = toElemOffset - offset;
            var change = to - from;

            function __scrollTo() {
                currentTime += increment;
                scrollableBody.scrollTop = __easeInOutQuad(currentTime, from, change, duration);
                if (currentTime < duration) {
                    setTimeout(__scrollTo, increment)
                }
            }

            __scrollTo();
        }

        // t = current time
        // b = start value
        // c = change in value
        // d = duration
        function __easeInOutQuad(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        }

        function isTooDark(color, limit) {
            if (angular.isUndefined(limit)) {
                limit = 128;
            }
            var c = color.substring(1);      // strip #
            var rgb = parseInt(c, 16);   // convert rrggbb to decimal
            var r = (rgb >> 16) & 0xff;  // extract red
            var g = (rgb >> 8) & 0xff;  // extract green
            var b = (rgb >> 0) & 0xff;  // extract blue

            var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

            if (luma < limit) {
                return true;
            }
            return false;
        }

        function getIconFromMime(mime) {
            var mime2Ico = ArrayHelper.get('mime2Ico');
            var app2Ico = ArrayHelper.get('app2Ico');

            var len = mime.indexOf('/');
            var type = mime.substr(0, len);

            var ico = mime2Ico[type];
            if (ico == null) {
                var app = mime.substr(len + 1, mime.length);
                ico = app2Ico[app];
                if (ico == null) {
                    ico = 'file-o'
                }
            }
            return ico;
        }

        function getProgressType(index) {
            var progressTypes = ArrayHelper.get('progressTypes');
            return progressTypes[index % progressTypes.length];
        }
    }

    /** @ngInject */
    function UploadWordImagesDlg($scope, $uibModalInstance, clipboard, Upload,
                                 deviceDetector, OS, OS_VERSIONS, C, dialogs, data) {

        var canOpenMultiFile = false;
        //多个文件同时上传受到windows文件打开窗口文件路径输入框可接受字符串长度限制，现在暂时都按照逐一打开文件处理
        //if (deviceDetector.os == OS.WINDOWS) {
        //    canOpenMultiFile = [
        //        OS_VERSIONS.WINDOWS_VISTA,
        //        OS_VERSIONS.WINDOWS_7,
        //        OS_VERSIONS.WINDOWS_8_1,
        //        OS_VERSIONS.WINDOWS_8,
        //        OS_VERSIONS.WINDOWS_10
        //    ].some(function (item) {
        //            return deviceDetector.os_version == item;
        //        });
        //}
        $scope.canOpenMultiFile = canOpenMultiFile;
        var paths = '';
        if (canOpenMultiFile) {
            angular.forEach(data.files, function (file) {
                paths += '"' + file.path + '" ';
            });
        } else {
            $scope.files2Upload = data.files;
        }

        $scope.getDataFromClipboard = function (path) {
            if (path) {
                clipboard.copyText(path);
            } else {
                clipboard.copyText(paths);
            }
        };

        var result = [];
        $scope.uploadFile = function ($file, file, e) {
            if (e && e[0] && e[0].$error === 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }

            if (!$file) return;

            Upload.upload({
                url: C.URL.IMG_UPLOAD, file: $file
            }).progress(function (evt) {
                file.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        file.progress = 0;
                        file.fileName = resp.fileName;
                        result[file.name] = resp.url;
                        break;
                    case 1:
                        file.progress = 101;
                        file.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                file.progress = 102;
                file.errorInfo = '服务器错误!';
            });
        };

        //$scope.uploadFiles = function (files, e) {
        //    $scope.filesUploaded = files;
        //    if (e && e[0] && e[0].$error == 'maxSize') {
        //        dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
        //        return;
        //    }
        //
        //    if (files == null) {
        //        return;
        //    }
        //
        //    var count = 0;
        //    angular.forEach(files, function (file) {
        //        Upload.upload({
        //            url: C.URL.IMG_UPLOAD, file: file
        //        }).progress(function (evt) {
        //            file.progress = parseInt(100.0 * evt.loaded / evt.total);
        //        }).success(function (resp) {
        //            switch (resp.result) {
        //                case 0:
        //                    file.progress = 0;
        //                    result[file.name] = resp.url;
        //                    break;
        //                case 1:
        //                    file.progress = 101;
        //                    file.errorInfo = '服务器空间不足!';
        //                    break;
        //            }
        //            count++;
        //            if (count == files.length) {
        //                $uibModalInstance.close(result);
        //            }
        //        }).error(function () {
        //            file.progress = 102;
        //            file.errorInfo = '服务器错误!';
        //            count++;
        //            if (count == files.length) {
        //                $uibModalInstance.close(result);
        //            }
        //        });
        //    });
        //};

        $scope.ok = function () {
            $uibModalInstance.close(result);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('WxHelper', WxHelper);

    /** @ngInject */
    function WxHelper($q, $injector, $location) {
        var service = {
            getWechatAuthorizeUrl: getWechatAuthorizeUrl,
            getWechatToken: getWechatToken,
            isWechatBrowser: isWechatBrowser,
            API_AUTH_LOGIN: '/api/wx/get_wechat_token',
            WX_API_ID: 'wx8e2d3281394ab136',    // 西藏在蓉离退休人员服务中心
            // WX_API_ID: 'wxd5f73f77dc8d5850', // 测试号
            WX_AUTH_REDIRECT_URL: 'https://ygjg.cbxz.gov.cn/get_wechat_token',
            // WX_AUTH_REDIRECT_URL: 'http://cbfy.tunnel.qydev.com/get_wechat_token',
            loadWxnp: loadWxnp
        };

        var $http;


        return service;


        function getHttp() {
            return $http ? $http : $injector.get('$http');
        }

        // load wx notice page
        function loadWxnp(cb) {
            var urlParams = $location.search();
            if (urlParams.wxnpId) {
                var id = urlParams.wxnpId;
                var type = urlParams.wxnpType;
                cb(id, type);
                $location.search('wxnpId', null);
                $location.search('wxnpType', null);
            }
        }

        /**
         * 判断是否为微信浏览器
         * @returns {boolean}
         */
        function isWechatBrowser() {
            var ua = navigator.userAgent.toLowerCase();
            // 注意： 请保留双等号
            return ua.match(/MicroMessenger/i) == "micromessenger";
        }

        function getWechatToken(code, state) {
            var deferred = $q.defer();
            // 构造 url
            var url = service.API_AUTH_LOGIN + "?code=" + code + "&state=" + state;
            // 发送 get
            getHttp().get(url).then(function (data) {
                deferred.resolve(data.data);
            }, function (data) {
                deferred.reject(data);
            });
            return deferred.promise;
        }

        function getWechatAuthorizeUrl(toState, toParams) {
            var appId = service.WX_API_ID,
                rUrl = service.WX_AUTH_REDIRECT_URL;

            if (toState) {
                rUrl += "?toState=" + toState.name;
                if (toParams) rUrl += "&toParams=" + JSON.stringify(toParams);
            }

            rUrl = window.encodeURIComponent(rUrl);

            var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId + '&redirect_uri='
                + rUrl + '&response_type=code&scope=snsapi_base&state=123#wechat_redirect';
            return url;
        }

    }
})();

(function () {
    'use strict';


    angular.module('c')
        .factory('EventReminder', EventReminder);

    /** @ngInject */
    function EventReminder($http) {
        var API = '/api/v1/shared/event_reminders';
        return {
            getInstance: function (mod, events) {
                return angular.extend(events, {
                    get: function (event) {
                        return $http.get(API + '/' + mod, {params: {event: event}});
                    },
                    set: function (event, reminder) {
                        return $http.put(API + '/' + mod, {event: event, user_id: reminder});
                    },
                    mod: mod
                })
            }
        };
    }

})();

(function () {
    'use strict';


    angular.module('c')
        .factory('PdfDoc', PdfDoc);

    /** @ngInject */
    function PdfDoc($resource, serviceConfObj) {
        var API = 'api/v1/shared/pdf_docs';
        return {
            getInstance: function (mod, extend) {
                var r = $resource(API + '/' + mod + '/:id', {}, serviceConfObj);
                if (extend) r = angular.extend(extend, r);
                return r;
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CompanyManageCtrl', CompanyManageCtrl)
    ;

    /** @ngInject */
    function CompanyManageCtrl($scope, Table, ArrayHelper, Dlg, Api, Company) {
        var vm = $scope;
        vm.addEdit = addEdit;
        vm.addUser = addUser;

        init();


        function init() {
            var levels = Company.getLevels();
            var classes = Company.getClasses();
            var types = Company.getTypes();

            var options = {
                service: Company,
                params: {op: 'sys'},
                optInFront: true,
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "sorting", title: "序号", width: '72'},
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "address", title: '地址', filter: {address: 'text'}},
                    {field: "class", title: '类别', filter: {class: 'select'}, data: Table.getNgTableOpts(classes)},
                    {field: "level", title: '性质', filter: {level: 'select'}, data: Table.getNgTableOpts(levels)},
                    {field: "type", title: '分类', filter: {type: 'select'}, data: Table.getNgTableOpts(types)},
                    {field: "note", title: '备注', filter: {note: 'text'}}
                ]
            };

            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.level = ArrayHelper.getItem(item.level, levels);
                    item.class = ArrayHelper.getItem(item.class, classes);
                    item.type = ArrayHelper.getItem(item.type, types);
                });
            });
        }

        function addEdit(m) {
            Dlg.addEdit(vm, 'pages/sys/basic/companyDlg.html', 'CompanyDlgCtrl', m);
        }

        function addUser(m) {
            Dlg.addEdit(vm, 'pages/sys/basic/companyUserDlg.html', 'CompanyUserDlgCtrl', m, {}, 'lg');
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('BulletinShowDlgCtrl', BulletinShowDlgCtrl);

    /** @ngInject */
    function BulletinShowDlgCtrl($rootScope, $scope, $sce, dialogs, $uibModalInstance, C, Auth, FileHelper, PrintHelper,
                                 SaveAs, toaster, $http, data) {
        function initData() {
            $scope.approval = data.approval;
            $http.get('/api/v1/bulletin/bulletins/' + data.id ).success(function (resp) {
                var bulletin = resp;
                $scope.article = {
                    id: bulletin.id,
                    sender: bulletin.sender,
                    release_time: bulletin.release_time,
                    title: bulletin.title,
                    dept: bulletin.dept,
                    body: bulletin.body,
                    attachment: bulletin.attachments,
                    recipient: bulletin.recipient,
                    created_at: bulletin.created_at
                };
                $scope.article.body_sce = $sce.trustAsHtml(bulletin.body);

                if (!bulletin.recipient) {
                    var params = {};
                    params['opt'] = 1;
                    params['bulletin_id'] = bulletin.id;
                    $http.post('/api/v1/bulletin/bulletins/collect', params).success(function () {
                        $rootScope.$broadcast('ReadBulletin', {id: bulletin.id});
                    });
                }
            });
        }

        if (data.id === 0) {
            var preview = data.preview;
            $scope.article = {
                title: preview.title,
                body_sce: $sce.trustAsHtml(preview.body),
                dept: preview.dept.name,
                sender: Auth.getAccount()
            }
        } else {
            initData();
        }

        $scope.collect = function (article) {
            var params = {};
            params['opt'] = 2;
            params['bulletin_id'] = article.id;
            $http.post('/api/v1/bulletin/bulletins/collect', params).success(function () {
                article.recipient = {};
                article.recipient['is_collect'] = 1;
                $rootScope.$broadcast('Collect');
                toaster.success('已收藏!');
            });
        };

        $scope.cancel_collect = function (article) {
            var params = {};
            params['opt'] = 3;
            params['bulletin_id'] = article.id;
            $http.post('/api/v1/bulletin/bulletins/collect', params).success(function () {
                article.recipient.is_collect = 0;
                $rootScope.$broadcast('CancelCollect');
                toaster.success('已取消收藏!');
            });
        };


        $scope.back = function (article) {
            dialogs.create('templates/article/back.html', 'BulletinBackDlgCtrl', {
                stage: 4
            }, {
                size: 'xs'
            }).result.then(function (params) {
                Bulletin.update({id: article.id, opt: 5}, params).$promise.then(function () {
                    toaster.success('退回成功!');
                    $rootScope.$broadcast('bulletinBack');
                    $uibModalInstance.dismiss('cancel');
                }, function () {
                    toaster.error('退回失败!');
                })
            })
        };

        $scope.download = function (attachment) {
            var params = {filename: attachment.filename, mime: attachment.mime};
            attachment.downloading = true;
            FileHelper.download(C.URL.BULLETIN_DOWNLOAD, params, function (resp) {
                attachment.downloading = false;
                var data = [resp];
                var options = {type: attachment.mime};
                SaveAs.download(data, attachment.name, options);
            }, function (error) {
                attachment.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        $scope.print = function (article) {

            PrintHelper.print(window.open('', '打印预览'), 'templates/print/ap_order.html', function () {
                var html = '<header class="clearfix"><h1>' + article.title + '</h1>' +
                    '<small style="margin-left: 120px">发布部门:' + article.dept.name + '&nbsp;&nbsp;&nbsp;' + '发布人：' + article.sender.name +
                    '&nbsp;&nbsp;&nbsp;发布时间：' + article.release_time + '</small></header><hr/>';

                html += article.body_sce;

                return html;
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();

angular.module('c').controller('ContactGroupMembersCtrl',
    function ($scope, $uibModalInstance, $filter, NgTableParams, dialogs, Table,
              toaster, F, ContactGroup, data) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);

        $scope.group = data.group;

        $scope.cols = [
            {title: '姓名', filter: {'users.name': 'text'}, field: 'name', show: true}, //0
            {title: '用户名', filter: {'users.username': 'text'}, field: 'username', width: '30%', show: true}, //0
            {title: '是否停用', filter: {is_stop: 'select'}, data: yesNoOpts, field: 'is_stop', width: '10%', show: true}, //6
        ];
        $scope.optColWidth = 70;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['id'] = data.group.id;
                ContactGroup.index_members(url, function (resp) {
                    params.total(resp.total);
                    var members = [];
                    angular.forEach(resp.members, function (m) {
                        members.push({id: m.member_id});
                    });
                    $scope.members_ids = members;
                    $defer.resolve(resp.members);
                    $scope.members = resp.members;
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        Table.loadMultiSelectedFn($scope);

        $scope.add = function () {
            dialogs.create('directives/form/user-selector/user_selector_dlg.html', 'UserSelectCtrl',
                {
                    title: '添加' + data.group.name + '成员', multiSelect: true, existMembers: $scope.members_ids
                }, {

                    size: 'md'
                }).result.then(function (params) {
                if (params.length > 0) {
                    var members_ids = [];
                    angular.forEach(params, function (m) {
                        members_ids.push(m.id)
                    });
                    ContactGroup.attach_members({id: data.group.id}, {members: members_ids}).$promise.then(function (resp) {
                        toaster.success('添加成功!');
                        $scope.tableParams.reload();
                    }, function () {
                        toaster.error('添加失败!');
                    });
                }
            });
        };

        $scope.delete = function (m) {
            dialogs.confirm('移除成员', '确定要移除成员吗?')
                .result.then(function () {
                var members = [];
                if (angular.isArray(m)) {
                    angular.forEach(m, function (member) {
                        if (member.is_checked) {
                            members.push(member.member_id);
                        }
                    });
                } else {
                    members.push(m.member_id);
                }
                ContactGroup.detach_members({id: data.group.id}, {members: members}).$promise.then(
                    function () {
                        toaster.success('移除成功!');
                        $scope.tableParams.reload();
                    },
                    function () {
                        toaster.error('移除失败!');
                    }
                );
            });
        };

        $scope.setStop = function (m, stop) {
            ContactGroup.set_member_stop({id: m.id, is_stop: stop}).$promise.then(function () {
                m.is_stop = stop ? '1' : '0';
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

(function () {
    'use strict';

    angular.module('c')
        .controller('eventReminderDlgCtrl', eventReminderDlgCtrl);

    /** @ngInject */
    function eventReminderDlgCtrl($uibModalInstance, $q, FormHelper, Dlg, data) {
        var noneVal = {name: '空缺'};
        var vm = this;
        var reminder = data.service;
        var event = data.event;

        vm.title = data.title;
        vm.users = angular.copy(data.users);

        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init();


        function init() {
            vm.m = {};
            reminder.get(event).then(function (resp) {
                var reminder = resp.data;
                if (!reminder) reminder = noneVal;
                vm.m = {reminder: reminder};
            });
            vm.users.splice(0, 0, noneVal);
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var userId = !m.reminder || !m.reminder.id ? null : m.reminder.id;
                reminder.set(event, userId).then(function (resp) {
                    Dlg.s(resp.data.msg);
                    vm.close();
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('NewsShowDlgCtrl', NewsShowDlgCtrl)
    ;

    /** @ngInject */
    function NewsShowDlgCtrl($scope, $sce, $uibModalInstance, $http, C, FileHelper, Auth, SaveAs, data, PrintHelper) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.download = download;
        vm.print = print;
        vm.isNews = true;


        init(data.id);

        function init(id) {
            if (id === 0) {
                var preview = data.preview;
                vm.article = {
                    title: preview.title,
                    body_sce: $sce.trustAsHtml(preview.body),
                    dept: preview.dept,
                    sender: Auth.getAccount()
                }
            } else {
                $http.get('/api/v1/news/news/' + id ).success(function (resp) {
                    vm.article = resp;
                    vm.article.body_sce = $sce.trustAsHtml(resp.body);
                });
            }
        }

        function download(attachment) {
            var params = {filename: attachment.filename, mime: attachment.mime};
            attachment.downloading = true;
            FileHelper.download(C.URL.NEWS_DOWNLOAD, params, function (resp) {
                attachment.downloading = false;
                var data = [resp];
                var options = {type: attachment.mime};
                SaveAs.download(data, attachment.name, options);
            }, function () {
                attachment.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        }

        function print(article) {
            print(window.open('', '打印预览'), 'templates/print/ap_order.html', function () {
                var html = '<header class="clearfix"><h1>' + article.title + '</h1>' +
                    '<small style="margin-left: 120px">新闻类型：' + article.type + '&nbsp;&nbsp;&nbsp;发布部门:'
                    + article.dept.name + '&nbsp;&nbsp;&nbsp;' + '发布人：' + article.sender.name +
                    '&nbsp;&nbsp;&nbsp;发布时间：' + article.release_time + '</small></header><hr/>';

                html += article.body_sce;

                return html;
            });
        }
    }
})();

angular.module('c').controller('RichEditDlgCtrl', function ($scope, $uibModalInstance, data) {
    $scope.body = data.body;
    $scope.ok = function (body) {
        $uibModalInstance.close(body);
    };
    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});
angular.module('c').controller('SimpleDlgCtrl', function ($scope, $uibModalInstance) {
    $scope.cancel = $uibModalInstance.dismiss;
});
angular.module('c').controller('SmsShowDlgCtrl',
    function ($scope, $uibModalInstance, data) {
        $scope.sms = data.sms;

        $scope.edit = function (sms) {
            var params = {opt: 5, sms: sms};
            $uibModalInstance.close(params);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
(function () {
    'use strict';

    angular.module('c')
        .controller('TransMemberCtrl', TransMemberCtrl)

    ;

    /** @ngInject */
    function TransMemberCtrl($scope, $uibModalInstance, Dlg, ArrayHelper, Dept, data, DateHelper) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;
        vm.m = {
            leave_time: new Date(),
            entry_time: new Date(),
            post: data.user.post
        };
        vm.user = data.user;
        vm.dept = data.dept;

        vm.dateOptions = {
            minDate: new Date(1920, 0, 1),
            initDate: new Date()
        };

        Dept.ov.query({opt: 4}, function (resp) {
            vm.depts = ArrayHelper.except(data.dept.id, resp.depts);
            vm.m['dept'] = vm.depts[0];
        });


        function ok(m) {
            if (vm.u_form.$valid) {
                var p = {};
                p['leave_time'] = DateHelper.date2Str(m.leave_time, 'yyyy-MM-dd');
                p['user_id'] = data.user.user_id;
                p['dept_id'] = m.dept.id;
                p['post'] = m.post;
                p['entry_time'] = DateHelper.date2Str(m.entry_time, 'yyyy-MM-dd');
                p['is_main'] = data.user.is_main;
                $uibModalInstance.close(p);
            } else {
                Dlg.w('表单中有错误!');
                vm.u_form.submitted = true;
            }
        }
    }
})();

(function () {
    'use strict';
    
    angular.module('c')
        .controller('PhotoImgDlgCtrl', PhotoImgDlgCtrl)
    
    /** @ngInject */
    function PhotoImgDlgCtrl($uibModalInstance, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.m = {
            photo: data.photo
        }
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('HospitalUserInTabCtrl', HospitalUserInTabCtrl)

    ;
    /** @ngInject */
    function HospitalUserInTabCtrl($scope, UIHelper, $stateParams, $rootScope) {
        UIHelper.loadTabs($scope, $stateParams, $rootScope);
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('OfficeDeptPhoneDlgCtrl',OfficeDeptPhoneDlgCtrl)
        .controller('OfficeDeptPhoneCtrl', OfficeDeptPhoneCtrl);

    /** @ngInject */
    function OfficeDeptPhoneCtrl(DeptPhone, $scope, Dlg, dialogs, Dept, toaster, OfficeDeptPhone) {
        var vm = $scope;
        vm.remove = remove;
        vm.add = add;
        vm.edit = edit;
        vm.typeSelectedFn = typeSelectedFn;
        vm.selectDeptPhone = selectDeptPhone;
        vm.deptTypeVisible = deptTypeVisible;
        vm.deptVisible = deptVisible;
        vm.cancel = cancel;

        init();


        function init() {
            vm.selectTypes = [
                {id: 1, name: '部门', exAll: false, fresh: true},
            ];
            vm.curType = $scope.selectTypes[0];
            vm.pager = {total: 0, page: 1, count: 10};
            vm.showDetail = $(window).width() > 768;
            vm.search = {};

            vm.typeSelectedFn(0);
        }
        function cancel() {
            vm.selectedDept = false;

        }

        function typeSelectedFn($index) {
            var toType = $scope.selectTypes[$index];
            $(window).resize(function () {
                var width = $(window).width();
                if (width > 768) {
                    $scope.hideList = false;
                    $scope.showDetail = true;
                } else {
                    $scope.hideList = false;
                    $scope.showDetail = false;
                }
            });
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            $scope.curType = toType;
        }

        function selectDeptPhone(dept) {
            showDetailAccordingToScreenSize();

            vm.selected = dept;
            vm.selectedDept = true;
            DeptPhone.query({opt: 2, dept_id: dept.id}, function (resp) {
                vm.deptPhones = resp.items;
            });
        }

        function initDeptSelector() {
            vm.loading = true;
            Dept.ov.query({opt: 9}, function (resp) {
                vm.loading = false;
                vm.types = resp.dept_types;
            }, function () {
                vm.loading = false;
            });
        }


        function showDetailAccordingToScreenSize() {
            if (!vm.showDetail) {
                vm.hideList = true;
                vm.showDetail = true;
            }
        }


        function deptTypeVisible(type) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            if (!visible) {
                for (var i = 0; i < type.depts.length; i++) {
                    var dept = type.depts[i];
                    if (dept.name.indexOf(vm.search.dept) !== -1) {
                        visible = true;
                        break;
                    }
                }
            }
            return visible;
        }

        function deptVisible(dept) {
            return !(vm.search.dept && vm.search.dept.length > 0
                && dept.name.indexOf(vm.search.dept) === -1);
        }
        function remove(m) {
            Dlg.confirm('确定删除该记录吗？').then(function () {
                OfficeDeptPhone.delete({
                    id: m,
                }).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            });
        }

        function add(depts) {

            dialogs.create('OfficeDeptPhoneDlg.html', 'OfficeDeptPhoneDlgCtrl', {dept: depts}, { size: 'md'});

        }
        function edit(m) {
            dialogs.create('UpDeptPhoneDlg.html', 'OfficeDeptPhoneDlgCtrl', {id: m.id}, { size: 'md'})
                .result.then(function (pa) {
                OfficeDeptPhone.update({id: m.id}, pa).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            });
        }
    }
    function OfficeDeptPhoneDlgCtrl($scope, $uibModalInstance, toaster, Dlg, FormHelper,  OfficeDeptPhone, data) {
        var vm = $scope;
        vm.submit = submit;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        function submit(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    name: m.name,
                    dept_id: data.dept.id,
                    phone : m.phone,
                    cornet : m.cornet,
                    // sorting: m.sorting,
                };

                OfficeDeptPhone.save(pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }).finally(function () {
                    defer.resolve();
                });
            });


        }

        if (data.id) {
            loadModel(data.id);
        }
        function loadModel(id) {
                OfficeDeptPhone.get({id: id}, function (resp) {
                    var m = resp;
                    vm.m = m;
                });
        }

        function ok(m) {
            if (vm.Form.$valid) {
                var pa = {
                    name: m.name,
                    phone: m.phone,
                    cornet: m.cornet,
                };
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
            }
        }
    }


})();



(function () {
    'use strict';

    angular.module('c')
        .controller('ConversationAddDlgCtrl', ConversationAddDlgCtrl);

    /** @ngInject */
    function ConversationAddDlgCtrl($uibModalInstance, ArrayHelper, Dlg, Conversation) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init();


        function init() {
            vm.loading = true;
            vm.types = Conversation.getTypes();
            vm.states = Conversation.getStates();
            vm.m = {attachments: []};
            vm.loading = false;
            vm.m.apply_content = '通话记录保存'
        }

        function ok(m) {
            return Dlg.addEditOk(vm, Conversation, function () {
                var pa = {
                    applicant_id: m.user.id,
                    type: m.type.id,
                    description: m.apply_content,
                    state: Conversation.STATE['STATE_UNCOMMON']
                }
                return pa;
            }, {op: 'notes'});
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('ConversationDlgCtrl', ConversationDlgCtrl);

    /** @ngInject */
    function ConversationDlgCtrl($uibModalInstance, ArrayHelper, Dlg, Conversation, ConversationDetail,
                                           FileHelper, data, C, Auth) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.send = send;
        vm.upload = upload;

        init(data.id);


        function init(id) {
            if (id) {
                vm.attachments = [];
                vm.loading = true;
                vm.types = Conversation.getTypes();
                vm.states = Conversation.getStates();
                vm.m = {id: id};
                Conversation.get({id: id, op: 'detail'}).$promise.then(function (resp) {
                    vm.m = resp.item;
                    vm.m.type = ArrayHelper.getItem(vm.m.type, vm.types);
                    vm.m.state = ArrayHelper.getItem(vm.m.state, vm.states);
                }, function (err) {
                    Dlg.error(err.data.msg);
                    vm.cancel();
                });

                ConversationDetail.get({id: id, op: 'detail'}).$promise.then(function (resp) {
                    // angular.forEach(resp.chats, function (item, i) {
                    //     if (item.attachment_url) {
                    //         resp.chats[i].attachment_url = item.attachment_url.slice(1, item.length);
                    //     }
                    // });
                    vm.chats = resp.chats;

                }, function (e) {
                    Dlg.e(e.data.msg);
                    vm.cancel();
                }).finally(function () {
                    vm.loading = false;
                });
            }
        }

        function send(m) {
            if (!m.content) Dlg.e('必须输入内容哦');
            else {
                var date = new Date().toLocaleString();
                var chat = {
                    is_user: 'false',
                    message: m.content,
                    kind: 0, // 消息 忘了在哪定义了
                    created_at: date
                };
                ConversationDetail.save({conversation_id: m.id, message: m.content, is_user: 'false'})
                    .$promise.then(function(){
                        vm.chats.push(chat);
                    },
                    function (e) {
                        var data = e.data;
                        if (data.msg) Dlg.e(data.msg);
                    }).finally(function () {
                    vm.m.content = '';
                })
            }
        }

        function upload() {
            var token = 'Bearer ' + Auth.getToken();
            var file = vm.attachments;
            var type = file.type.substring(0, 5) === 'image' ? 'image' : file.type.substring(0, 11) === 'application' ? 'file' : 'error';
            if (file) {
                var fd = new FormData();
                fd.set('file', file);
                fd.set('id', vm.m.id);
                fd.set('type', type);
                fd.set('name', file.name);
                fd.set('is_user', 'false');
                var xhr = new XMLHttpRequest();
                xhr.open('POST', C.URL.CONVERSATION_UPLOAD, false);
                xhr.setRequestHeader('Authorization', token);
                if (type === 'error') Dlg.e('文件格式有误');
                else {
                    xhr.send(fd);
                    var chat = {
                        is_user: 'false',
                        kind: type === 'image' ? 2 : type === 'file' ? 3 : 0,
                        message: file.name,
                        created_at: new Date().toLocaleString(),
                        attachment_url: window.URL.createObjectURL(file)
                    };
                    vm.chats.push(chat)
                }
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('ConversationFinishDlgCtrl', ConversationFinishDlgCtrl);

    /** @ngInject */
    function ConversationFinishDlgCtrl($uibModalInstance, ArrayHelper, Dlg, Conversation, ConversationDetail,
                                           FileHelper, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data.id);


        function init(id) {
            if (id) {
                vm.loading = true;
                vm.types = Conversation.getTypes();
                vm.states = Conversation.getStates();
                vm.m = {id: id};
                Conversation.get({id: id, op: 'finish_detail'}).$promise.then(function (resp) {
                    vm.m = resp.item;
                    vm.m.type = ArrayHelper.getItem(vm.m.type, vm.types);
                    vm.m.state = ArrayHelper.getItem(vm.m.state, vm.states);
                }, function (err) {
                    Dlg.error(err.data.msg);
                    vm.cancel();
                });

                ConversationDetail.get({id: id, op: 'detail'}).$promise.then(function (resp) {
                    vm.chats = resp.chats;
                }, function (e) {
                    Dlg.e(e.data.msg);
                    vm.cancel();
                }).finally(function () {
                    vm.loading = false;
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CallCenterRecordDetailCtrl', CallCenterRecordDetailCtrl);

    /** @ngInject */
    function CallCenterRecordDetailCtrl($uibModalInstance, ArrayHelper, Dlg, ServiceRecord, FileHelper, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data.id);


        function init(id) {
            if (id) {
                vm.loading = true;
                vm.types = ServiceRecord.getTypes();
                vm.states = ServiceRecord.getStates();
                vm.m = {id: id};
                ServiceRecord.get({id: id, op: 'confirm'}).$promise.then(function (resp) {
                    vm.m = resp.item;
                    vm.m.type = ArrayHelper.getItem(vm.m.type, vm.types);
                    vm.m.state = ArrayHelper.getItem(vm.m.state, vm.states);
                    var userAttachments = [], attachments = []
                    if (vm.m.attachments.length > 0) {
                        angular.forEach(vm.m.attachments, function (attachment) {
                            if (attachment.type == 1) {
                                userAttachments.push(attachment);
                            } else {
                                attachments.push(attachment);
                            }
                        });
                    }
                    vm.m.userAttachments = userAttachments;
                    vm.m.attachments = attachments;
                }, function (err) {
                    Dlg.error(err.data.msg);
                    vm.cancel();
                }).finally(function () {
                    vm.loading = false;
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CallCenterRecordEditCtrl', CallCenterRecordEditCtrl);

    /** @ngInject */
    function CallCenterRecordEditCtrl($uibModalInstance, ArrayHelper, Dlg, ServiceRecord, FileHelper, data) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.upload = upload;
        vm.deleteAttachment = deleteAttachment;

        init(data.id);


        function init(id) {
            if (id) {
                vm.loading = true;
                vm.types = ServiceRecord.getTypes();
                vm.states = ServiceRecord.getStates();
                vm.m = {id: id};
                ServiceRecord.get({id: id, op: 'confirm'}).$promise.then(function (resp) {
                    vm.m = resp.item;
                    vm.m.type = ArrayHelper.getItem(vm.m.type, vm.types);
                    vm.m.state = ArrayHelper.getItem(vm.m.state, vm.states);
                    var userAttachments = [], attachments = []
                    if (vm.m.attachments.length > 0) {
                        angular.forEach(vm.m.attachments, function (attachment) {
                            if (attachment.type == 1) {
                                userAttachments.push(attachment);
                            } else {
                                attachments.push(attachment);
                            }
                        });
                    }
                    vm.m.userAttachments = userAttachments;
                    vm.m.attachments = attachments;
                }, function (err) {
                    Dlg.error(err.data.msg);
                    vm.cancel();
                }).finally(function () {
                    vm.loading = false;
                });
            }
        }

        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function upload(file, m, e) {
            FileHelper.uploadAttachment(file, m, e);
        }


        function ok(m) {
            return Dlg.addEditOk(vm, ServiceRecord, function () {
                var pa = {
                    handle_content: m.handle_content
                }
                if (m.attachments.length > 0) {
                    pa.attachments = ArrayHelper.map(m.attachments, function (attachment) {
                        return attachment.id ? {id: attachment.id} : {
                            name: attachment.name, mime: attachment.mime,
                            filename: attachment.filename, size: attachment.size, type: 2
                        };
                    });
                }
                return pa;
            }, {op: 'confirm'});
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CallCenterPhoneEditCtrl', CallCenterPhoneEditCtrl);

    /** @ngInject */
    function CallCenterPhoneEditCtrl($uibModalInstance, ArrayHelper, Dlg, ServiceRecord, FileHelper, data) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.upload = upload;
        vm.deleteAttachment = deleteAttachment;

        init();


        function init() {
            vm.loading = true;
            vm.types = ServiceRecord.getTypes();
            vm.states = ServiceRecord.getStates();
            vm.m = {attachments: []};
            vm.loading = false;
        }

        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function upload(file, m, e) {
            FileHelper.uploadAttachment(file, m, e);
        }


        function ok(m) {
            return Dlg.addEditOk(vm, ServiceRecord, function () {
                var pa = {
                    user_id: m.user.id,
                    type: m.type.id,
                    apply_content: m.apply_content,
                    handle_content: m.handle_content
                }
                if (m.attachments.length > 0) {
                    pa.attachments = ArrayHelper.map(m.attachments, function (attachment) {
                        return attachment.id ? {id: attachment.id} : {
                            name: attachment.name, mime: attachment.mime,
                            filename: attachment.filename, size: attachment.size, type: 2
                        };
                    });
                }
                return pa;
            }, {op: 'confirm'});
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('InfoCensusActivityCtrl', InfoCensusActivityCtrl);

    /** @ngInject */
    function InfoCensusActivityCtrl($scope, Api, Table, ServiceActivity, Dlg, ServiceRecord, FileHelper, $q) {
        var vm = $scope;
        vm.addEdit = addEdit;
        vm.setStop = setStop;
        vm.remove = remove;
        vm.finish = finish;
        vm.sendSms = sendSms;
        vm.download = download;

        init();


        function init() {
            var options = {
                service: ServiceActivity,
                params: {op: 'info_confirm'},
                optInFront: true,
                optColWidth: Table._4_BTN,
                cols: [
                    {field: "sorting", title: "序号", width: Table._2_CHAR},
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "created_at", title: '创建时间'}
                ]
            };

            Table.load(vm, options);
        }

        function addEdit(m) {
            Dlg.addEdit(vm, 'pages/info_census/activityDlg.html', 'InfoCensusActivityDlgCtrl', m);
        }

        function setStop(m) {
            Api.setDisable(ServiceActivity, m)
        }

        function finish(m) {
            ServiceActivity.update({id: m.id}, {
                op: 'complete',
                is_completed: !m.is_completed
            }).$promise.then(function (resp) {
                m.is_completed = !m.is_completed;
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的活动吗？', function () {
                ServiceActivity.delete({id: m.id}).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除活动');
        }

        function sendSms(m) {
            Dlg.addEdit(vm, 'pages/info_census/activityMsgDlg.html', 'InfoCensusActivityMsgDlgCtrl', m);
        }

        function download(m) {
            var defer = $q.defer();
            FileHelper.dnExcel(ServiceRecord.DUPLICATE_EXPORT, {
                activityId: m.id
            }, '同名信息名单.xls')
                .finally(function () {
                    defer.resolve();
                });
            return defer.promise;
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('InfoCensusActivityDlgCtrl', InfoCensusActivityDlgCtrl);

    /** @ngInject */
    function InfoCensusActivityDlgCtrl($uibModalInstance, Dlg, ServiceActivity, data, ArrayHelper) {
        var vm = this;

        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.types = [{id: 1, name: '电话信息确认'}, {id: 2, name: '问卷信息确认'}];

        init(data.id);


        function init(id) {
            if (id) {
                ServiceActivity.get({id: id}, function (resp) {
                    vm.m = resp;
                    vm.m.type = ArrayHelper.getItem(vm.m.type, vm.types);
                });
            } else {
                var year = (new Date()).getFullYear();
                var month = (new Date()).getMonth() + 1;
                vm.m = {
                    name: year + '年' + month + '月信息确认活动',
                    type: 1
                };
                vm.m.type = ArrayHelper.getItem(vm.m.type, vm.types);
            }
        }

        function ok(m) {
            return Dlg.addEditOk(vm, ServiceActivity, function () {
                return {
                    name: m.name,
                    type: m.type.id
                };
            }, {op: 'info_confirm'});
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('InfoCensusActivityMsgDlgCtrl', InfoCensusActivityMsgDlgCtrl);

    /** @ngInject */
    function InfoCensusActivityMsgDlgCtrl($q, $uibModalInstance, Dlg, ServiceActivity, data) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data.id);


        function init(id) {
            vm.m = {id: id};
        }

        function ok(m) {
            return Dlg.addEditOk(vm, ServiceActivity, function () {
                var pa = {
                    note: m.note
                };
                return pa;
            }, {op: 'send_msg'});
        }
    }

})();


(function () {
    'use strict';

    angular.module('c')
        .controller('LetterRegisterCtrl', LetterRegisterCtrl);

    /** @ngInject */
    function LetterRegisterCtrl($scope, $q, Dlg, LetterRegister, UserInfo, Table, ArrayHelper, Api, Regex, FormHelper) {
        var vm = this;
        vm.ok = ok;
        vm.chooseUserName = chooseUserName;
        vm.reset = reset;
        vm.handleStates = LetterRegister.getHandleStates();
        vm.typeOneStates = LetterRegister.getLetterTypeOneStates();
        vm.typeTwoStates = LetterRegister.getLetterTypeTwoStates();
        vm.contentStates = LetterRegister.getLetterContentStates();
        vm.changeTitle = changeTitle;
        vm.changeAddress = changeAddress;
        vm.contentShow = false;
        vm.contentShow2 = false;
        var oldTitle;
        var oldAddress;

        init();


        function init() {
            vm.userNameAcdOption = {trigLen: 1, data: Api.idCardLoadFn, onSelect: chooseUserName};
            vm.handleState = vm.handleStates[0];
        }

        function reset() {
            vm.Form.$setUntouched();
            vm.Form.$setPristine();
            vm.handleState = vm.handleStates[0];
            vm.user = null;
            vm.idCard = null;
            vm.letterNumber = null;
            vm.typeOneState = null;
            vm.typeTwoState = null;
            vm.contentState = null;
            vm.letter_content = null;
        }

        function chooseUserName(idCard) {
            if (idCard) {
                UserInfo.get({id: '-', id_card: idCard, op: 'by_id_card'}).$promise.then(function (resp) {
                    vm.user = resp.item;
                    oldTitle = vm.user.title;
                    oldAddress = vm.user.address;
                }, function (err) {
                    if (err.data.msg) Dlg.e(err.data.msg);
                });
            } else Dlg.e('请先输入名字或者身份证号！');
        }

        function changeTitle(title) {
            return title !== oldTitle;
        }

        function changeAddress(address) {
            return address !== oldAddress;
        }

        function ok(letterNumber, typeOneState, typeTwoState, contentState, handleState, letter_content, user, recipients, handler) {
            if (handleState.id !== 1 && (recipients == null || recipients.length === 0)) {
                return Dlg.w('请填写收件人!');
            }
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    letter_no: letterNumber,
                    type1: typeOneState.id,
                    type2: typeTwoState.id,
                    user_id: user.id,
                    content_type: contentState.id,
                    letter_content: letter_content,
                    state: handleState.id,
                    handle_id: handler
                }
                if (user.title !== oldTitle || user.address !== oldAddress) {
                    var id = user.id;
                    user.op = 'info';
                    UserInfo.update({id: id}, user).$promise.then(function (resp) {
                        Dlg.s(resp.msg);
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Dlg.e(data.msg);
                        updateLetter(pa, defer);
                    }).finally(function () {
                        defer.resolve();
                    });
                } else {
                    updateLetter(pa, defer);
                }

            });
        }

        function updateLetter(pa, defer) {
            LetterRegister.save(pa).$promise.then(function (resp) {
                Dlg.s(resp.msg);
                reset();
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            }).finally(function () {
                defer.resolve();
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CommonPhoneViewCtrl', CommonPhoneViewCtrl);

    /** @ngInject */
    function CommonPhoneViewCtrl($scope, dialogs, toaster, Table, CommonPhone, F) {
        var vm = $scope;

        init();

        function init() {
            var options = {
                service: CommonPhone,
                params: {opt: 1/*INDEX_ALL*/},
                hideOpt: true,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "phone", title: "电话", filter: {'phone': "text"}},
                    {field: "cornet", title: "小号", filter: {'cornet': "text"}},
                    {field: "sort", title: "排序"},
                    {
                        field: "is_stop",
                        title: "是否停用",
                        filter: {is_stop: "select"},
                        data: F.getNgTableOpts(F.get('yesNo'))
                    }
                ]
            };
            Table.load(vm, options);
        }
    }
})();




angular.module('c')
    .controller('ContactGroupCtrl',function ($scope, $filter, dialogs, toaster, NgTableParams, ContactGroup, F) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);

        $scope.cols = [
            {title: '群名称', field: 'name', show: true}, //0
            {title: '成员数', field: 'members_count', width: '10%', show: true}, //1
            {title: '是否公开', filter: {is_public: 'select'}, data: yesNoOpts, field: 'is_public', width: '10%', show: true}, //6
            {title: '是否停用', filter: {is_stop: 'select'}, data: yesNoOpts, field: 'is_stop', width: '10%', show: true} //6
        ];
        $scope.hideFilter = true;
        $scope.optColWidth = 108;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                ContactGroup.query({opt: 3}, function (resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.groups);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.add = function () {
            dialogs.create('ContactGroupDlg.html', 'ContactGroupDlgCtrl', {}, {
                 size: 'md'
            }).result.then(function (group) {
                    ContactGroup.save(group).$promise.then(function (data) {
                        toaster.success('群添加成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('群添加失败!');
                    });
                });
        };

        $scope.edit = function (group) {
            group.$edit = true;
            group.$nameChanged = group.name;
            group.$is_stopChanged = F.getItem(group.is_stop, $scope.yesNo);
            group.$is_publicChanged = F.getItem(group.is_public, $scope.yesNo);
        };

        $scope.save = function (group) {
            group.$edit = false;
            if (group.$nameChanged == "") {
                toaster.warning('名称不能为空!');
            } else {
                var data = {};
                data['name'] = group.$nameChanged;
                data['is_stop'] = group.$is_stopChanged.id;
                data['is_public'] = group.$is_publicChanged.id;
                ContactGroup.update({id: group.id}, data).$promise.then(function (resp) {
                    toaster.success('群信息修改成功!');
                    group.name = group.$nameChanged;
                    group.is_stop = group.$is_stopChanged.id;
                    group.is_public = group.$is_publicChanged.id;
                }, function (error) {
                    toaster.error('群信息修改失败!');
                });
            }
        };

        $scope.delete = function (group) {
            dialogs.confirm('删除群记录', '确定要删除<strong>' + group.name + '</strong>的群吗?')
                .result.then(function () {
                    ContactGroup.delete({id: group.id}).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('群记录删除成功!');
                                break;
                            case 1:
                                toaster.warning('存在属于该群的成员,因此无法删除该群!');
                                break;
                        }
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('群记录删除失败!');
                    });
                });

        };

        $scope.member = function (group) {
            dialogs.create('templates/contact_group_members_dlg.html', 'ContactGroupMembersCtrl',
                {group: group}, { size: 'md'}).result.then(function () {
                }, function () {
                    $scope.tableParams.reload();
                });
        };

    });

angular.module('c').controller('ContactGroupDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, data) {
        $scope.yesNo = F.get('yesNo');

        $scope.group = {is_public: false, is_stop: false};

        $scope.ok = function (group) {
            if ($scope.g_form.$valid) {
                var params = {};
                params['name'] = group.name;
                params['is_public'] = group.is_public;
                params['is_stop'] = group.is_stop;
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.g_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

(function () {
    'use strict';

    angular.module('c')
        .controller('ContactsCtrl', ContactsCtrl);

    /** @ngInject */
    function ContactsCtrl($scope, ContactGroup, ArrayHelper, Api, Dept, DeptPhone, $q, DeptGroup,
                          WxHelper, deviceDetector, OS, AdminGroup, User, CommonPhone, FileHelper) {
        var isWx = WxHelper.isWechatBrowser();
        var cacheGroup;
        var vm = $scope;
        vm.query = {};

        vm.typeSelectedFn = typeSelectedFn;
        vm.clearQuery = clearQuery;
        vm.clearQueryPhone = clearQueryPhone;

        vm.toggleDeptTypeNode = toggleDeptTypeNode;
        vm.toggleDeptNode = toggleDeptNode;
        vm.toggleDeptGroupNode = toggleDeptGroupNode;
        vm.toggleContactGroupNode = toggleContactGroupNode;

        vm.selectDeptPhone = selectDeptPhone;
        vm.pageChanged = pageChanged;
        vm.selectUser = selectUser;
        vm.queryUser = queryUser;

        vm.deptGroupVisible = deptGroupVisible;
        vm.contactGroupVisible = contactGroupVisible;
        vm.deptTypeVisible = deptTypeVisible;
        vm.deptVisible = deptVisible;
        vm.groupVisible = groupVisible;

        //常用电话
        vm.phoneGroupVisible = phoneGroupVisible;
        vm.togglePhoneGroupNode = togglePhoneGroupNode;


        vm.getCallUrl = getCallUrl;
        vm.hasCallUrl = hasCallUrl;

        vm.initCommonPhoneSelector = initCommonPhoneSelector;

        vm.download = download;

        init();


        function init() {
            vm.selectTypes = [
                // {id: 1, name: '部门', exAll: false, fresh: true},
                {id: 3, name: '姓名/手机号/主管单位', fresh: true},
                // {id: 4, name: '科管组', fresh: true},
                {id: 5, name: '群', fresh: true},
                {id: 7, name: '常用电话', fresh: true}
            ];
            vm.curType = $scope.selectTypes[0];
            vm.selected = null; //所有选中的人
            vm.pager = {total: 0, page: 1, count: 10};
            vm.showDetail = $(window).width() > 768;
            vm.search = {};

            vm.typeSelectedFn(0);
        }

        function download(type) {
            var defer = $q.defer();
            var url, title;
            if (type == 1) {
                url = '/api/v1/dept_phones/download';
                title = '部门电话明细.xls'
            } else {
                url = '/api/v1/common_phones/download';
                title = '常用电话明细.xls'
            }
            FileHelper.dnExcel(url, {}, title)
                .finally(function () {
                    defer.resolve();
                });
            return defer.promise;
        }

        function phoneGroupVisible(group) {
            var visible = !vm.search.phoneGroup;
            if (!visible) {
                if (group.group) {
                    if (group.group.indexOf(vm.search.phoneGroup) !== -1) {
                        visible = true;
                    }
                } else {
                    visible = true;
                }
            }
            return visible;
        }

        function togglePhoneGroupNode(group, toggle, node) {
            CommonPhone.query({
                opt: 4,
                queryStr: vm.query.phone ? vm.query.phone : undefined,
                group_name: group.group
            }, function (resp) {
                group.members = resp.items;
                toggle(node);
            });
        }

        function getCallUrl(phone) {
            var index = phone.indexOf('转');
            if (index !== -1) phone = phone.slice(0, index);
            var url = 'tel:' + phone;
            if (isWx && deviceDetector.os !== OS.IOS) return url + '#weixin.qq.com';
            return url;
        }

        function hasCallUrl(phone) {
            return !deviceDetector.isDesktop() && phone
        }

        function typeSelectedFn($index) {
            var toType = $scope.selectTypes[$index];
            $(window).resize(function () {
                var width = $(window).width();
                if (width > 768) {
                    $scope.hideList = false;
                    $scope.showDetail = true;
                } else {
                    $scope.hideList = false;
                    $scope.showDetail = false;
                }
            });
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
                // case 2:
                //     if (toType.fresh) {
                //         initRoleSelector();
                //         toType.fresh = false;
                //     }
                //     break;
                case 3:
                    if (toType.fresh) {
                        initNameSelector();
                        toType.fresh = false;
                    }
                    break;
                case 4:
                    if (toType.fresh) {
                        initDeptAdminGroupSelector();
                        toType.fresh = false;
                    }
                    break;
                case 5:
                    if (toType.fresh) {
                        initContactGroupMembersSelector();
                        toType.fresh = false;
                    }
                    break;
                case 7:
                    initCommonPhoneSelector();
            }
            $scope.curType = toType;
        }

        function clearQuery() {
            vm.users = [];
            vm.query.str = '';
            vm.pager.total = 0;
        }

        function clearQueryPhone() {
            vm.query.phone = undefined;
            initCommonPhoneSelector(vm.query.phone);
        }

        function initCommonPhoneSelector(qStr) {
            vm.loading = true;
            CommonPhone.query({
                opt: 3,
                queryStr: qStr
            }, function (resp) {
                vm.loading = false;
                vm.commonPhoneGroups = resp.items;
            }, function () {
                vm.loading = false;
            })
        }

        function queryUser(qStr) {
            if (qStr) {
                vm.query.str = qStr;
                var urlParams = Api.param2Url({
                    op: 'search',
                    page: vm.pager.page,
                    count: vm.pager.count
                });
                urlParams.queryStr = qStr;
                vm.loading = true;
                User.query(urlParams).$promise.then(function (resp) {
                    vm.users = resp.items;
                    vm.pager.total = resp.total;
                }).finally(function () {
                    vm.loading = false;
                });
            } else {
                clearQuery();
            }
        }

        function pageChanged() {
            queryUser(vm.query.str);
        }

        function selectDeptPhone(dept) {
            showDetailAccordingToScreenSize();

            vm.selected = dept;
            vm.selectedDept = true;
            DeptPhone.query({opt: 2, dept_id: dept.id}, function (resp) {
                vm.deptPhones = resp.items;
            });
        }

        function selectUser(user) {
            showDetailAccordingToScreenSize();

            vm.selected = user;
            vm.selectedDept = false;
            User.get({id: user.id, op: 'contact'}, function (resp) {
                vm.contact = resp.item;
            });
        }


        function initDeptSelector() {
            vm.loading = true;
            Dept.query({op: 'contact'}, function (resp) {
                vm.depts = resp.items;
            }).$promise.finally(function () {
                vm.loading = false;
            });
        }

        function showDetailAccordingToScreenSize() {
            if (!vm.showDetail) {
                vm.hideList = true;
                vm.showDetail = true;
            }
        }

        function initNameSelector() {

        }

        function initContactGroupMembersSelector() {
            vm.loading = true;
            ContactGroup.query({opt: 2}, function (resp) {
                vm.loading = false;
                cacheGroup = resp.groups;

                vm.groups = ArrayHelper.map(cacheGroup, function (g) {
                    return {id: g.id, name: g.name, memberCount: g.members.length};
                });
            }, function () {
                vm.loading = false;
            });
        }

        function initDeptAdminGroupSelector() {
            vm.loading = true;
            vm.adminGroups = [];
            AdminGroup.query({op: 'with_members'}, function (resp) {
                vm.loading = false;
                angular.forEach(resp.items, function (item) {
                    if (item.group !== null && item.group.members.length > 0) {
                        vm.adminGroups.push(item);
                    }
                });
            }, function () {
                vm.loading = false;
            });
        }

        function tagDeptLeaderAndHide(dept) {
            var index, item;
            if (dept.mail_recipient_id) {
                index = ArrayHelper.indexOfKey(dept.mail_recipient_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.mail_recipient_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }

            if (dept.leader_id) {
                index = ArrayHelper.indexOfKey(dept.leader_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.leader_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }
        }

        function toggleDeptTypeNode(type, toggle, node) {
            if (type.depts) {
                toggle(node);
            }
        }

        function toggleDeptNode(dept, toggle, node) {
            if (dept.members) {
                toggle(node);
            } else {
                $q.all([
                    DeptGroup.query({op: 'option', dept_id: dept.id}).$promise,
                    Dept.getMembers(dept.id)
                ]).then(function (respArray) {
                    var items = respArray[1].data.items;
                    if (items.length > 0) {
                        var groups = []; // 部门小组
                        var no = [];     // 没有部门小组的人员
                        if (respArray[0].items.length > 0) {
                            angular.forEach(respArray[0].items, function (group) {
                                var array1 = [];  // 有部门小组的人
                                var array2 = [];  // 没有...
                                angular.forEach(items, function (item) {
                                    if (item.group_id) {
                                        if (item.group_id === group.id) {
                                            if (item.id == group.user_id) {
                                                array1.unshift(item)
                                            } else {
                                                array1.push(item);
                                            }
                                        }
                                    } else {
                                        array2.push(item);
                                    }
                                });
                                groups.push({
                                    group: group,
                                    members: array1
                                });
                                no = array2;
                            });
                            dept.members = no.concat(groups);
                        } else {
                            dept.members = items;
                        }

                        dept.mail_recipient_id = respArray[1].data.mail_recipient_id;
                        tagDeptLeaderAndHide(dept);
                        toggle(node);
                    }
                });
                // Dept.getMembers(dept.id).then(function (resp) {
                //     var items = resp.data.items;
                //     if (items.length > 0) {
                //         dept.mail_recipient_id = resp.data.mail_recipient_id;
                //         dept.members = items;
                //         tagDeptLeaderAndHide(dept);
                //         toggle(node);
                //     }
                // });
            }
        }

        function toggleDeptGroupNode(toggle, node) {
            toggle(node);
        }

        function toggleContactGroupNode(group, toggle, node) {
            if (!group.members) {
                group.members = ArrayHelper.getItem(group.id, cacheGroup).members;
            }
            toggle(node);
        }

        function deptGroupVisible(group) {
            return !(vm.search.deptGroup && vm.search.deptGroup.length > 0
                && group.name.indexOf(vm.search.deptGroup) === -1);
        }

        function contactGroupVisible(group) {
            return !(vm.search.contactGroup && vm.search.contactGroup.length > 0
                && group.name.indexOf(vm.search.contactGroup) === -1);
        }

        function deptTypeVisible(type) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            if (!visible) {
                for (var i = 0; i < type.depts.length; i++) {
                    var dept = type.depts[i];
                    if (dept.name.indexOf(vm.search.dept) !== -1) {
                        visible = true;
                        break;
                    }
                }
            }
            return visible;
        }

        function deptVisible(dept) {
            return !(vm.search.dept && vm.search.dept.length > 0
                && dept.name.indexOf(vm.search.dept) === -1);
        }

        function groupVisible(group) {
            return !(vm.search.group && vm.search.group.length > 0
                && group.name.indexOf(vm.search.group) === -1);
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('SmsCtrl', SmsCtrl);

    /** @ngInject */
    function SmsCtrl($scope, $stateParams, UIHelper) {
        UIHelper.loadTabs($scope, $stateParams);
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('SignedTabCtrl', SignedTabCtrl)


    ;
    /** @ngInject */
    function SignedTabCtrl($scope, UIHelper, $stateParams, $rootScope) {
        var vm = $scope;
        UIHelper.loadTabs(vm, $stateParams, $rootScope);
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('TOZRTabCtrl', TOZRTabCtrl)


    ;
    /** @ngInject */
    function TOZRTabCtrl($scope, UIHelper, $stateParams, $rootScope) {
        var vm = $scope;
        UIHelper.loadTabs(vm, $stateParams, $rootScope);
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('CommonPhoneCtrl', CommonPhoneCtrl)
        .controller('CommonPhoneDlgCtrl', CommonPhoneDlgCtrl);

    /** @ngInject */
    function CommonPhoneCtrl ($scope, dialogs, toaster, Table, CommonPhone, F) {
        var vm = $scope;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;

        init();

        function init () {
            var options = {
                service: CommonPhone,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "phone", title: "电话", filter: {phone: "text"}},
                    {field: "cornet", title: "小号", filter: {cornet: "text"}},
                    {field: "group", title: "所属组", filter: {group: "text"}},
                    {field: "sort", title: "排序"},
                    {
                        field: "is_stop",
                        title: "是否停用",
                        filter: {is_stop: "select"},
                        data: F.getNgTableOpts(F.get('yesNo'))
                    }
                ]
            };
            Table.load(vm, options);
        }


        function add () {
            dialogs.create('CommonPhoneDlg.html', 'CommonPhoneDlgCtrl', {}, {size: 'md'})
                .result.then(function (m) {
                CommonPhone.save(m).$promise.then(function () {
                    toaster.success('保存成功');
                    vm.tableReload();
                });
            });
        }

        function edit (m) {
            dialogs.create('CommonPhoneDlg.html', 'CommonPhoneDlgCtrl', {id: m.id}, {size: 'md'})
                .result.then(function (pa) {
                pa.opt = 1; //EDIT_SAVE
                CommonPhone.update({id: m.id}, pa).$promise.then(function () {
                    toaster.success('修改成功');
                    vm.tableReload();
                });
            });
        }

        function remove (m) {
            dialogs.confirm('删除条目', '确定要删除<strong>' + m.name + '</strong>条目吗?')
                .result.then(function () {
                CommonPhone.delete({id: m.id}).$promise.then(function (resp) {
                    toaster.success('删除成功');
                    vm.tableReload();
                });
            });
        }

    }

    /** @ngInject */
    function CommonPhoneDlgCtrl ($scope, $uibModalInstance, toaster, F, CommonPhone, data) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);

        function loadModel (id) {
            if (id) {
                CommonPhone.get({id: id}, function (resp) {
                    var m = resp;
                    m.is_stop = m.is_stop == '1';
                    vm.m = m;
                });
            } else {
                vm.m = {is_stop: false};
            }
        }

        function ok (m) {
            if (vm.Form.$valid) {
                var pa = {
                    name: m.name,
                    phone: m.phone,
                    cornet: m.cornet,
                    sort: m.sort,
                    is_stop: m.is_stop ? '1' : '0',
                    group: m.group ? m.group : null
                };
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
            }
        }
    }
})();


angular.module('c')
    .controller('PersonnelContactGroupCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, ContactGroup, F) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);

        $scope.cols = [
            {title: '群名称', field: 'name', show: true}, //0
            {title: '成员数', field: 'members_count', width: '10%', show: true}, //1
            {
                title: '是否公开',
                filter: {is_public: 'select'},
                data: yesNoOpts,
                field: 'is_public',
                width: '10%',
                show: true
            }, //6
            {title: '是否停用', data: yesNoOpts, field: 'is_stop', width: '10%', show: true}, //6
            {title: '创建人', field: 'creator_id', width: '10%', show: true} //6
        ];
        $scope.hideFilter = true;
        $scope.optColWidth = 108;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 5;
                ContactGroup.query(url, function (resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.groups);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.add = function () {
            dialogs.create('ContactGroupDlg.html', 'ContactGroupDlgCtrl', {}, {
                 size: 'md'
            }).result.then(function (group) {
                    ContactGroup.save(group).$promise.then(function (data) {
                        toaster.success('群添加成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('群添加失败!');
                    });
                });
        };

        $scope.edit = function (group) {
            group.$edit = true;
            group.$nameChanged = group.name;
            group.$is_stopChanged = F.getItem(group.is_stop, $scope.yesNo);
            group.$is_publicChanged = F.getItem(group.is_public, $scope.yesNo);
            group.$creatorChanged = {id: group.creator_id, name: group.creator.name};
        };

        $scope.save = function (group) {
            group.$edit = false;
            if (group.$nameChanged == "") {
                toaster.warning('名称不能为空!');
            } else {
                var data = {};
                data['name'] = group.$nameChanged;
                data['is_stop'] = group.$is_stopChanged.id;
                data['is_public'] = group.$is_publicChanged.id;
                data['creator_id'] = group.$creatorChanged.id;
                ContactGroup.update({id: group.id}, data).$promise.then(function (resp) {
                    toaster.success('群信息修改成功!');
                    group.name = group.$nameChanged;
                    group.is_stop = group.$is_stopChanged.id;
                    group.is_public = group.$is_publicChanged.id;
                    group.creator = group.$creatorChanged;
                    group.creator_id = group.$creatorChanged.id;
                }, function (error) {
                    toaster.error('群信息修改失败!');
                });
            }
        };

        $scope.delete = function (group) {
            dialogs.confirm('删除群记录', '确定要删除<strong>' + group.name + '</strong>的群吗?')
                .result.then(function () {
                    ContactGroup.delete({id: group.id}).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('群记录删除成功!');
                                break;
                            case 1:
                                toaster.warning('存在属于该群的成员,因此无法删除该群!');
                                break;
                        }
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('群记录删除失败!');
                    });
                });

        };

        $scope.member = function (group) {
            dialogs.create('templates/contact_group_members_dlg.html', 'ContactGroupMembersCtrl',
                {group: group}, { size: 'md'}).result.then(function () {
                }, function () {
                    $scope.tableParams.reload();
                });
        };

    });

(function () {
    'use strict';

    angular.module('c')
        .controller('DeptRecordDlgCtrl', DeptRecordDlgCtrl);

    /** @ngInject */
    function DeptRecordDlgCtrl($scope, $uibModalInstance, dialogs, toaster, NgTableParams,
                               UserDept, data) {

        $scope.user = data.user;
        $scope.cols = [
            {title: '名称', field: 'name', show: true}, //0
            {title: '类型', field: 'type', show: true}, //6
            {title: '进入时间', field: 'entry_time', sortable: 'entry_time', show: true}, //6
            {title: '离开时间', field: 'leave_time', sortable: 'leave_time', show: true}, //6
        ];
        $scope.hideFilter = true;
        if (data.hideOpt) {
            $scope.hideOpt = true;
        } else {
            $scope.optColWidth = 56;
        }

        $scope.tableParams = new NgTableParams({page: 1, count: 10, sorting: {entry_time: 'desc'}}, {
            counts: [10, 30, 50],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 3;  //INDEX_DEPTS_IN_MEMBER
                url['user_id'] = $scope.user.id;
                UserDept.query(url, function (resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.depts);
                });
            }
        });

        $scope.delete = function (dept) {
            dialogs.confirm('删除记录', '确定要删除<strong>' + dept.name + '</strong>的记录吗?')
                .result.then(function () {
                UserDept.delete({id: dept.id}).$promise.then(function (data) {
                    switch (data.result) {
                        case 0:
                            toaster.success('记录删除成功!');
                            break;
                        case 1:
                            toaster.warning('这是当前所在的主记录,无法直接删除');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('记录删除失败!');
                });
            });
        };

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('UserInfoCtrl', UserInfoCtrl);

    /** @ngInject */
    function UserInfoCtrl($scope, $state, $q, Dlg, UserInfo, Table, ArrayHelper, User, FileHelper, PrintHelper) {
        var options;
        var vm = $scope;
        var helper = UserInfo.formHelper;
        vm.upload = upload;

        vm.visibleOptions = [
            {name: '基本信息', value: 0x01},
            {name: '党组织信息', value: 0x02},
            {name: '居住信息', value: 0x04},
            {name: '工作信息', value: 0x08},
            {name: '医疗信息', value: 0x10},
            {name: '安置信息', value: 0x20},
            {name: '待遇信息', value: 0x40},
            {name: '全部信息', value: 0xff}
        ];
        vm.optionSelectedFn = optionSelectedFn;
        vm.show = show;
        vm.edit = edit;
        vm.transfer = transfer;
        vm.changePwd = changePwd;
        vm.exportDn = exportDn;
        vm.clearWxBind = clearWxBind;
        vm.download = download;
        vm.select = select;
        vm.option = {name: '基本信息', value: 1};
        vm.print = print;
        vm.batchPrint = batchPrint;
        var checker = Table.loadMultiSelectedFn(vm);

        init();


        function init() {
            helper.init(vm);
            vm.sexes = UserInfo.getSexes();
            vm.yesNos = UserInfo.getYesNos();
            vm.hasOrNot = UserInfo.getHasOrNot();

            $q.all([
                UserInfo.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                helper.bindAsyncOptions(vm, respArray[0]);
                setupOption();
                var optionFn = Table.load(vm, options, function (resp, startSn) {
                    Table.loadItem(resp, startSn, function (item, i) {
                        item.work_state = ArrayHelper.getItem(item.work_state, vm.workStates);
                        item.house_type = ArrayHelper.getItem(item.house_type, vm.houseTypes);
                        item.soldier_type = ArrayHelper.getItem(item.soldier_type, vm.soldierTypes);
                        item.live_type = ArrayHelper.getItem(item.live_type, vm.liveTypes);
                        item.marry_type = ArrayHelper.getItem(item.marry_type, vm.marryTypes);
                        item.self_care = ArrayHelper.getItem(item.self_care, vm.selfCares);
                        item.relative_type = ArrayHelper.getItem(item.relative_type, vm.relativeTypes);

                        item.male = ArrayHelper.getItem(item.male, vm.sexes);
                        item.has_children = ArrayHelper.getItem(item.has_children, vm.hasOrNot);
                        item.same_city = ArrayHelper.getItem(item.same_city, vm.yesNos);
                        item.identity = ArrayHelper.getItem(item.identity, vm.identities);
                        item.mi_servant = ArrayHelper.getItem(item.mi_servant, vm.yesNos);
                        item.disability = ArrayHelper.getItem(item.disability, vm.yesNos);
                        item.ex_serviceman = ArrayHelper.getItem(item.ex_serviceman, vm.yesNos);
                        item.servant = ArrayHelper.getItem(item.servant, vm.yesNos);
                        item.incapable = ArrayHelper.getItem(item.incapable, vm.yesNos);
                        item.difficulty = ArrayHelper.getItem(item.difficulty, vm.yesNos);
                        item.illness = ArrayHelper.getItem(item.illness, vm.yesNos);
                        item.recuperation = ArrayHelper.getItem(item.recuperation, vm.yesNos);

                    });
                }).options;

                optionSelectedFn(vm.option);

                optionFn().cols[3].data = Table.getNgTableOpts(vm.sexes);
                optionFn().cols[5].data = Table.getNgTableOpts(vm.nations);
                optionFn().cols[7].data = Table.getNgTableOpts(vm.politicalStatuses);
                optionFn().cols[18].data = Table.getNgTableOpts(vm.houseTypes);
                optionFn().cols[21].data = Table.getNgTableOpts(vm.liveTypes);
                optionFn().cols[22].data = Table.getNgTableOpts(vm.marryTypes);
                optionFn().cols[23].data = Table.getNgTableOpts(vm.hasOrNot);
                optionFn().cols[24].data = Table.getNgTableOpts(vm.yesNos);
                optionFn().cols[25].data = Table.getNgTableOpts(vm.workStates);
                optionFn().cols[29].data = Table.getNgTableOpts(vm.identities);
                optionFn().cols[30].data = Table.getNgTableOpts(vm.retirementTypes);
                optionFn().cols[37].data = Table.getNgTableOpts(vm.manageTypes);
                optionFn().cols[40].data = Table.getNgTableOpts(vm.yesNos);
                optionFn().cols[41].data = Table.getNgTableOpts(vm.yesNos);
                optionFn().cols[42].data = Table.getNgTableOpts(vm.disableLevels);
                optionFn().cols[43].data = Table.getNgTableOpts(vm.selfCares);
                optionFn().cols[51].data = Table.getNgTableOpts(vm.soldierTypes);
                optionFn().cols[52].data = Table.getNgTableOpts(vm.yesNos);
                optionFn().cols[74].data = Table.getNgTableOpts(vm.yesNos);
                optionFn().cols[76].data = Table.getNgTableOpts(vm.yesNos);
                optionFn().cols[77].data = Table.getNgTableOpts(vm.yesNos);
                optionFn().cols[78].data = Table.getNgTableOpts(vm.yesNos);
                optionFn().cols[79].data = Table.getNgTableOpts(vm.yesNos);
            })
        }

        function setupOption() {
            options = {
                service: UserInfo,
                params: {op: 'personnel_info'},
                optInFront: true,
                optColWidth: Table._3_BTN,
                count: 10,
                counts: [10, 30, 50, 500],
                cols: [
                    /* 基本信息 */
                    { // 0
                        title: '序号',
                        field: 'sn',
                        type: 0xff,
                        width: Table._1_CHAR
                    },
                    { // 1
                        title: '姓名',
                        filter: {name: 'text'},
                        field: 'name',
                        width: 100,
                        type: 0xff
                    },
                    { // 2
                        title: '身份证',
                        filter: {id_card: 'text'},
                        field: 'id_card',
                        type: 0xff
                    },
                    { // 3
                        title: '性别',
                        filter: {male: 'select'},
                        field: 'male',
                        type: 0x01
                    },
                    { // 4
                        title: '出生日期',
                        filter: {birthday: 'date_range'},
                        field: 'birthday',
                        type: 0x01
                    },
                    { // 5
                        title: '民族',
                        filter: {nation_id: 'select'},
                        field: 'nation',
                        type: 0x01
                    },
                    { // 6
                        title: '籍贯',
                        filter: {native_place: 'text'},
                        field: 'native_place',
                        type: 0x01
                    },
                    { // 7
                        title: '政治面貌',
                        filter: {political_status_id: 'select'},
                        field: 'political_status',
                        type: 0x01
                    },
                    { // 8
                        title: '社保编号',
                        filter: {ss_number: 'text'},
                        field: 'ss_number',
                        type: 0x01
                    },
                    { // 9
                        title: '社保卡号',
                        filter: {ss_card: 'text'},
                        field: 'ss_card',
                        type: 0x01
                    },
                    { // 10
                        title: '手机号码',
                        filter: {phone: 'text'},
                        field: 'phone',
                        type: 0x01
                    },
                    { // 11
                        title: '备用联系电话',
                        filter: {telephone: 'text'},
                        field: 'telephone',
                        type: 0x01
                    },
                    { // 12
                        title: '头像',
                        filter: {photo: 'checkbox'},
                        data: '未传',
                        field: 'photo',
                        type: 0x01
                    },
                    /* 党组织信息 */
                    {// 13
                        title: '加入党组织日期',
                        filter: {party_join_time: 'date_range'},
                        field: 'party_join_time',
                        type: 0x02
                    },
                    {// 14
                        title: '转为正式党员日期',
                        filter: {party_member_time: 'date_range'},
                        field: 'party_member_time',
                        type: 0x02
                    },// 7
                    {// 15
                        title: '原党支部名称',
                        filter: {old_branch_name: 'text'},
                        field: 'old_branch_name',
                        type: 0x02
                    },
                    { // 16
                        title: '现党支部',
                        filter: {p_branch: 'text'},
                        field: 'p_branch',
                        type: 0x02
                    },
                    { // 17
                        title: '现党组织关系所在地',
                        filter: {party_place: 'text'},
                        field: 'party_place',
                        type: 0x02
                    },
                    /* 居住信息 */
                    { // 18
                        title: '住房解决方式',
                        filter: {house_type: 'select'},
                        field: 'house_type',
                        type: 0x04
                    },
                    { // 19
                        title: '长期居住地',
                        filter: {area: 'text'},
                        field: 'area',
                        type: 0x04
                    },
                    { // 20
                        title: '详细地址',
                        filter: {address: 'text'},
                        field: 'address',
                        type: 0x04
                    },
                    { // 21
                        title: '居住状态',
                        filter: {live_type: 'select'},
                        field: 'live_type',
                        type: 0x04
                    },
                    { // 22
                        title: '婚姻状态',
                        filter: {marry_type: 'select'},
                        field: 'marry_type',
                        type: 0x04
                    },
                    { // 23
                        title: '有无子女',
                        filter: {has_children: 'select'},
                        field: 'has_children',
                        type: 0x04
                    },
                    { // 24
                        title: '子女是否居住同一个城市',
                        filter: {same_city: 'select'},
                        field: 'same_city',
                        type: 0x04
                    },
                    /* 工作信息 */
                    { // 25
                        title: '工作状态',
                        filter: {work_state: 'select'},
                        field: 'work_state',
                        type: 0x08
                    },
                    { // 26
                        title: '工作单位',
                        filter: {work_company: 'text'},
                        field: 'work_company',
                        type: 0x08
                    },
                    { // 27
                        title: '职务',
                        filter: {post: 'text'},
                        field: 'post',
                        type: 0x08
                    },
                    { // 28
                        title: '职别',
                        filter: {title: 'text'},
                        field: 'title',
                        type: 0x08
                    },
                    { // 29
                        title: '身份',
                        filter: {identity: 'select'},
                        field: 'identity',
                        type: 0x08
                    },
                    { // 30
                        title: '离退休方式',
                        filter: {retirement_type: 'select'},
                        field: 'retirement_type',
                        type: 0x08
                    },
                    { // 31
                        title: '参加工作时间',
                        filter: {started_work: 'date_range'},
                        field: 'started_work',
                        type: 0x08
                    },
                    { // 32
                        title: '进藏工作时间',
                        filter: {tibet_work: 'date_range'},
                        field: 'tibet_work',
                        type: 0x08
                    },
                    { // 33
                        title: '离退休时间',
                        filter: {leave_time: 'date_range'},
                        field: 'leave_time',
                        type: 0x08
                    },
                    { // 34
                        title: '连续工龄',
                        filter: {work_time: 'num_range'},
                        field: 'work_time',
                        type: 0x08
                    },
                    { // 35
                        title: '在藏工龄',
                        filter: {tibet_time: 'num_range'},
                        field: 'tibet_time',
                        type: 0x08
                    },
                    { // 36
                        title: '主管单位',
                        filter: {manage_company: 'text'},
                        field: 'manage_company',
                        type: 0x08
                    },
                    { // 37
                        title: '管理方式',
                        filter: {manage_type_id: 'select'},
                        field: 'manage_type',
                        type: 0x08
                    },
                    /* 医疗信息 */
                    { // 38
                        title: '医保类型',
                        filter: {mi: 'text'},
                        field: 'mi',
                        type: 0x10
                    },
                    { // 39
                        title: '医疗保险参保地',
                        filter: {mi_place: 'text'},
                        field: 'mi_place',
                        type: 0x10
                    },
                    { // 40
                        title: '是否享受公务员医疗补助',
                        filter: {mi_servant: 'select'},
                        field: 'mi_servant',
                        type: 0x10
                    },
                    { // 41
                        title: '是否残疾',
                        filter: {disability: 'select'},
                        field: 'disability',
                        type: 0x10
                    },
                    { // 42
                        title: '评残程度',
                        filter: {disable_level: 'select'},
                        field: 'disable_level',
                        type: 0x10
                    },
                    { // 43
                        title: '生活自理能力',
                        filter: {self_care: 'select'},
                        field: 'self_care',
                        type: 0x10
                    },
                    { // 44
                        title: '慢性疾病',
                        filter: {disease: 'text'},
                        field: 'disease',
                        type: 0x10
                    },
                    { // 45
                        title: '门诊特殊疾病定点医院',
                        filter: {fixed_hospital: 'text'},
                        field: 'fixed_hospital',
                        type: 0x10
                    },
                    { // 46
                        title: '联络站',
                        filter: {dept: 'text'},
                        field: 'dept',
                        type: 0x10
                    },
                    { // 47
                        title: '信息更新时间',
                        filter: {change_time: 'date_range'},
                        field: 'change_time',
                        type: 0x10
                    },
                    { // 48
                        title: '死亡时间',
                        filter: {dead_time: 'date_range'},
                        field: 'dead_time',
                        type: 0x10
                    },
                    /* 安置信息 */
                    { // 49
                        title: '安置时间',
                        filter: {resettlement_time: 'date_range'},
                        field: 'resettlement_time',
                        type: 0x20
                    },
                    { // 50
                        title: '供给时间',
                        filter: {supply_time: 'date_range'},
                        field: 'supply_time',
                        type: 0x20
                    },
                    { // 51
                        title: '老战士类型',
                        filter: {soldier_type: 'select'},
                        field: 'soldier_type',
                        type: 0x20
                    },
                    { // 52
                        title: '是否军转干部',
                        filter: {ex_serviceman: 'select'},
                        field: 'ex_serviceman',
                        type: 0x20
                    },
                    { // 53
                        title: '开户银行',
                        filter: {bank: 'text'},
                        field: 'bank',
                        type: 0x20
                    },
                    { // 54
                        title: '银行账号',
                        filter: {bank_account: 'text'},
                        field: 'bank_account',
                        type: 0x20
                    },
                    { // 55
                        title: '月工资',
                        filter: {wage: 'num_range'},
                        field: 'wage',
                        type: 0x20
                    },
                    { // 56
                        title: '管理费',
                        filter: {manage_fee: 'num_range'},
                        field: 'manage_fee',
                        type: 0x20
                    },
                    { // 57
                        title: '活动费',
                        filter: {activity_fee: 'num_range'},
                        field: 'activity_fee',
                        type: 0x20
                    },
                    { // 58
                        title: '加发工资',
                        filter: {add_fee: 'num_range'},
                        field: 'add_fee',
                        type: 0x20
                    },
                    { // 59
                        title: '健康老人补贴',
                        filter: {health_fee: 'num_range'},
                        field: 'health_fee',
                        type: 0x20
                    },
                    { // 60
                        title: '福利费',
                        filter: {welfare_fee: 'num_range'},
                        field: 'welfare_fee',
                        type: 0x20
                    },
                    { // 61
                        title: '护理费',
                        filter: {nurse_fee: 'num_range'},
                        field: 'nurse_fee',
                        type: 0x20
                    },
                    { // 62
                        title: '电话费',
                        filter: {phone_fee: 'num_range'},
                        field: 'phone_fee',
                        type: 0x20
                    },
                    { // 63
                        title: '体检费标准',
                        filter: {examine_fee: 'num_range'},
                        field: 'examine_fee',
                        type: 0x20
                    },
                    { // 64
                        title: '月退休金',
                        filter: {retire_fee: 'num_range'},
                        field: 'retire_fee',
                        type: 0x20
                    },
                    { // 65
                        title: '门诊包干费',
                        filter: {clinc_fee: 'num_range'},
                        field: 'clinc_fee',
                        type: 0x20
                    },
                    { // 66
                        title: '高龄护理费',
                        filter: {age_fee: 'num_range'},
                        field: 'age_fee',
                        type: 0x20
                    },
                    { // 67
                        title: '电话月租费',
                        filter: {month_fee: 'num_range'},
                        field: 'month_fee',
                        type: 0x20
                    },
                    { // 68
                        title: '节日慰问费',
                        filter: {festival_fee: 'num_range'},
                        field: 'festival_fee',
                        type: 0x20
                    },
                    { // 69
                        title: '其他工资',
                        filter: {other_fee: 'num_range'},
                        field: 'other_fee',
                        type: 0x20
                    },

                    { // 70
                        title: '护工费',
                        filter: {maintenance_fee: 'num_range'},
                        field: 'maintenance_fee',
                        type: 0x20
                    },
                    { // 71
                        title: '交通费',
                        filter: {traffic_fee: 'num_range'},
                        field: 'traffic_fee',
                        type: 0x20
                    },
                    { // 72
                        title: '取暖费',
                        filter: {heating_fee: 'num_range'},
                        field: 'heating_fee',
                        type: 0x20
                    },
                    { // 73
                        title: '福利金',
                        filter: {welfare_fund: 'num_range'},
                        field: 'welfare_fund',
                        type: 0x20
                    },
                    { // 74
                        title: '是否公务员',
                        filter: {servant: 'select'},
                        field: 'servant',
                        type: 0x20
                    },
                    { // 75
                        title: '联行号',
                        filter: {line_number: 'text'},
                        field: 'line_number',
                        type: 0x20
                    },
                    { // 76
                        title: '是否失能',
                        filter: {incapable: 'select'},
                        field: 'incapable',
                        type: 0x20
                    },
                    { // 77
                        title: '是否生活困难',
                        filter: {difficulty: 'select'},
                        field: 'difficulty',
                        type: 0x20
                    },
                    { // 78
                        title: '是否重病',
                        filter: {illness: 'select'},
                        field: 'illness',
                        type: 0x20
                    },
                    { // 79
                        title: '是否疗养',
                        filter: {recuperation: 'select'},
                        field: 'recuperation',
                        type: 0x20
                    },
                    { // 80
                        title: '险种',
                        filter: {insurance: 'text'},
                        field: 'insurance',
                        type: 0x40
                    },
                    { // 81
                        title: '待遇享受起始年月',
                        filter: {provide_time: 'text'},
                        field: 'provide_time',
                        type: 0x40
                    },
                    { // 82
                        title: '待遇发放状态',
                        filter: {provide_state: 'text'},
                        field: 'provide_state',
                        type: 0x40
                    },
                    { // 83
                        title: '待遇发放方式',
                        filter: {provide_type: 'text'},
                        field: 'provide_type',
                        type: 0x40
                    },
                    { // 84
                        title: '待遇合计',
                        filter: {total: 'text'},
                        field: 'total',
                        type: 0x40
                    },
                    { // 85
                        title: '历年调待',
                        filter: {history_sum: 'text'},
                        field: 'history_sum',
                        type: 0x40
                    },
                    { // 86
                        title: '退休退职费',
                        filter: {retirement_fee: 'text'},
                        field: 'retirement_fee',
                        type: 0x40
                    },
                    { // 87
                        title: '防寒补贴',
                        filter: {cold_proof_fee: 'text'},
                        field: 'cold_proof_fee',
                        type: 0x40
                    },
                    { // 88
                        title: '过渡期福利金',
                        filter: {transitional_benefit: 'text'},
                        field: 'transitional_benefit',
                        type: 0x40
                    },
                    { // 89
                        title: '交通补贴',
                        filter: {traffic_subsidy: 'text'},
                        field: 'traffic_subsidy',
                        type: 0x40
                    },
                    { // 90
                        title: '综合性补贴',
                        filter: {comprehensive_subsidy: 'text'},
                        field: 'comprehensive_subsidy',
                        type: 0x40
                    },
                    { // 91
                        title: '离退休帐户金额',
                        filter: {account_amount: 'text'},
                        field: 'account_amount',
                        type: 0x40
                    },
                    { // 92
                        title: '基础养老金',
                        filter: {main_pension: 'text'},
                        field: 'main_pension',
                        type: 0x40
                    },
                    { // 93
                        title: '个人帐户',
                        filter: {self_amount: 'text'},
                        field: 'self_amount',
                        type: 0x40
                    },
                    { // 94
                        title: '过渡性养老金',
                        filter: {transitional_pension: 'text'},
                        field: 'transitional_pension',
                        type: 0x40
                    },
                    { // 95
                        title: '高原补贴',
                        filter: {plateau_subsidy: 'text'},
                        field: 'plateau_subsidy',
                        type: 0x40
                    },
                    { // 96
                        title: '基本养老金',
                        filter: {basic_pension: 'text'},
                        field: 'basic_pension',
                        type: 0x40
                    },
                    { // 97
                        title: '增加基本养老金',
                        filter: {add_pension: 'text'},
                        field: 'add_pension',
                        type: 0x40
                    },
                    { // 98
                        title: '户籍所在地',
                        filter: {domicile: 'text'},
                        field: 'domicile',
                        type: 0x01
                    },
                    { // 99
                        title: '档案管理单位',
                        filter: {archive_co: 'text'},
                        field: 'archive_co',
                        type: 0x01
                    },
                    { // 100
                        title: '户籍所在地派出所',
                        filter: {police_station: 'text'},
                        field: 'police_station',
                        type: 0x01
                    },
                    { // 101
                        title: '社保发放单位',
                        filter: {ss_co: 'text'},
                        field: 'ss_co',
                        type: 0x01
                    },
                    { // 102
                        title: '安置办事处',
                        filter: {resettlement_office: 'text'},
                        field: 'resettlement_office',
                        type: 0x01
                    },
                    { // 103
                        title: '专业特长',
                        filter: {speciality: 'text'},
                        field: 'speciality',
                        type: 0x01
                    },
                    { // 104
                        title: '兴趣爱好',
                        filter: {interest: 'text'},
                        field: 'interest',
                        type: 0x01
                    },
                    { // 105
                        title: '特殊困难',
                        filter: {special_difficulty: 'text'},
                        field: 'special_difficulty',
                        type: 0x01
                    },
                    { // 102
                        title: '个性需求',
                        filter: {individual_need: 'text'},
                        field: 'individual_need',
                        type: 0x01
                    },
                ]
            };
        }

        function optionSelectedFn(option) {
            vm.option = option;
            angular.forEach(vm.cols, function (col) {
                if (col.type & option.value) {
                    col.show = true;
                    col.download = true;
                } else {
                    col.show = false;
                    col.download = false;
                }
            });
        }

        function exportDn() {
            Dlg.show({
                template: 'pages/personnel/userInfo/exportDlg.html',
                ctrl: 'ExportUserInfoDlgCtrl',
                data: {}
            }).then(function () {
                Dlg.s('用户信息导出成功!');
            })
        }

        function edit(m) {
            Dlg.show({
                template: 'pages/personnel/userInfo/editDlg.html',
                ctrl: 'PersonnelUserEditCtrl',
                data: {
                    id: m.id, op: 'personnel_confirm'
                }, size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }

        function changePwd(user) {
            Dlg.show({
                template: 'pages/personnel/userInfo/changePasswordDlg.html',
                ctrl: 'changePasswordDlgCtrl',
                data: {user: user.user}
            }).then(function () {
                vm.tableReload();
            });
        }

        function transfer(user) {
            Dlg.show({
                template: 'pages/personnel/deptRecordDlg.html',
                ctrl: 'DeptRecordDlgCtrl',
                data: {user: user, hideOpt: false},
                size: 'lg'
            });
        }

        function clearWxBind(m) {
            User.update({id: m.user.id}, {
                op: 'clear_wx_bind'
            }).$promise.then(function (resp) {
                Dlg.s(resp.msg);
                vm.tableReload();
            }, function (error) {
                Dlg.e(error.msg);
            });
        }

        function show(m) {
            Dlg.show({
                template: 'pages/personnel/userInfo/showDlg.html',
                ctrl: 'PersonnelUserShowCtrl',
                data: {
                    id: m.id
                }, size: 'lg'
            });
        }

        function upload(type) {
            Dlg.show({
                template: 'pages/personnel/userInfo/wageImportDlg.html',
                ctrl: 'WageImportDlgCtrl',
                data: {type: type},
                size: 'full'
            }).then(function () {
                vm.tableReload();
            });
        }

        function select(type) {
            angular.forEach(vm.cols, function (col) {
                col.download = type;
            });
        }

        function download() {
            var pa = {items: []};
            angular.forEach(vm.cols, function (col) {
                if (col.download && col.field != 'sn' && col.field != 'photo') pa.items.push(col)
            });
            var defer = $q.defer();
            FileHelper.dnExcel(UserInfo.urls.EXPORT_USER_INFO, pa, '人员信息导出.csv')
                .finally(function () {
                    defer.resolve();
                });
            return defer.promise;
        }


        function print(m) {
            PrintHelper.print(window.open(), function () {
                return getPrintHtml(m);
            });
        }

        function getPrintHtml(m) {
            var html = '<div style="page-break-after: always">';
            html += '<h1 style="text-align: center">西藏离退休人员基本信息调查表</h1>';
            html += '<div style="float: right">填表日期&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日</div>';
            html += '<table width="100%">' + '<tbody><tr>';
            html += '<td width="60">姓名</td>';
            html += '<td>' + m.name + '</td>';
            html += '<td width="60">性别</td>';
            html += '<td>' + m.male.name + '</td>';
            html += '<td width="60">民族</td>';
            html += '<td>' + (m.nation ? m.nation.name : '') + '</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>出生日期</td>';
            html += '<td>' + m.birthday + '</td>';
            html += '<td>籍贯</td>';
            html += '<td>' + (m.native_place ? m.native_place : '') + '</td>';
            html += '<td>学历</td>';
            html += '<td></td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>工作时间</td>';
            html += '<td>' + (m.started_work ? m.started_work : '') + '</td>';
            html += '<td>原职务职级</td>';
            html += '<td>' + (m.post ? m.post : '') + (m.title ? m.title : '') + '</td>';
            html += '<td>子女人数</td>';
            html += '<td></td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>入党时间</td>';
            html += '<td>' + (m.party_join_time ? m.party_join_time : '') + '</td>';
            html += '<td>是否安置</td>';
            html += '<td><input type="checkbox">已安置<input type="checkbox">未安置</td>';
            html += '<td>月养老金</td>';
            html += '<td>' + (m.wage ? m.wage : '') + '</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>身份</td>';
            html += '<td colspan="2"><input type="checkbox">干部&nbsp;&nbsp;&nbsp;&nbsp;<input type="checkbox">工人</td>';
            html += '<td>党员关系</td>';
            html += '<td colspan="2"><input type="checkbox">在西藏&nbsp;&nbsp;&nbsp;&nbsp;<input type="checkbox">已转入内地</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>本人电话</td>';
            html += '<td colspan="2">' + (m.phone ? m.phone : '') + '</td>';
            html += '<td>亲人电话</td>';
            html += '<td colspan="2">' + (m.telephone ? m.telephone : '') + '</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>家庭住址</td>';
            html += '<td colspan="5">' + (m.address ? m.address : '') + '</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>身份证号</td>';
            html += '<td colspan="5">' + (m.id_card ? m.id_card : '') + '</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>原工作单位</td>';
            html += '<td colspan="5">' + (m.work_company ? m.work_company.name : '') + '</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>现所在党支部名称</td>';
            html += '<td colspan="5">' + (m.p_branch ? m.p_branch.name : (m.branch_name ? m.branch_name : '')) + '</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>参加党组织活动</td>';
            html += '<td colspan="5"><input type="checkbox">正常&nbsp;&nbsp;<input type="checkbox">不正常&nbsp;&nbsp;<input type="checkbox">多年未参加</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>党组织关系去向要求</td>';
            html += '<td colspan="5"><input type="checkbox">转成办&nbsp;&nbsp;<input type="checkbox">转所在地&nbsp;&nbsp;<input type="checkbox">不转</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>安置人员希望管理方式</td>';
            html += '<td colspan="5"><input type="checkbox">联络站&nbsp;&nbsp;<input type="checkbox">代管&nbsp;&nbsp;<input type="checkbox">其它</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>家庭子女基本情况</td>';
            html += '<td colspan="5">在藏（&nbsp;&nbsp;&nbsp;&nbsp;）人&nbsp;&nbsp;外地（&nbsp;&nbsp;&nbsp;&nbsp;）人&nbsp;&nbsp;身边（&nbsp;&nbsp;&nbsp;&nbsp;）人</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>家庭子女就业情况</td>';
            html += '<td colspan="5"><input type="checkbox">工作&nbsp;&nbsp;<input type="checkbox">失业&nbsp;&nbsp;<input type="checkbox">低保</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>家庭生活状况</td>';
            html += '<td colspan="5"><input type="checkbox">好&nbsp;&nbsp;<input type="checkbox">良好&nbsp;&nbsp;<input type="checkbox">一般&nbsp;&nbsp;' +
                '<input type="checkbox">困难&nbsp;&nbsp;<input type="checkbox">比较困难&nbsp;&nbsp;<input type="checkbox">特别困难</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>身体状况</td>';
            html += '<td colspan="5"><input type="checkbox">良好&nbsp;&nbsp;<input type="checkbox">慢性病&nbsp;&nbsp;<input type="checkbox">重病&nbsp;&nbsp;' +
                '<input type="checkbox">失能</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>户籍情况</td>';
            html += '<td colspan="5"><input type="checkbox">在藏&nbsp;&nbsp;&nbsp;&nbsp;<input type="checkbox">已迁移内地</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>现居住房屋所属产权</td>';
            html += '<td colspan="5"><input type="checkbox">大产权&nbsp;&nbsp;<input type="checkbox">小产权&nbsp;&nbsp;<input type="checkbox">其它</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td height="300px">存在哪些困难</td>';
            html += '<td colspan="5"></td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td height="300px">对办事处的意见建议</td>';
            html += '<td colspan="5"></td>';
            html += '</tr>';
            html += '</tbody></table>';
            html += '<div>备注：请如实在“<input type="checkbox">”内“√”，“（）”内填数据</div>';
            html += '<br/>';
            html += '<br/>';
            html += '</div>';
            return html;
        }

        function batchPrint() {
            var checkItems = checker.getChecked();
            if (!checker.hasChecked() || checkItems.length == 0) {
                Dlg.w('请选择处理对象');
                return;
            }

            PrintHelper.print(window.open('', '打印预览'), function () {
                var html = '';
                angular.forEach(checkItems, function (item) {
                    html += getPrintHtml(item);
                });
                return html;
            }, true);
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('UserRegCtrl', UserRegCtrl);

    /** @ngInject */
    function UserRegCtrl($scope, Dlg, $q, FormHelper, DeptGroup, UserInfo, City, County, Street, ExtHelper) {
        var copy;
        var vm = this;
        var helper = UserInfo.formHelper;
        vm.provinceSelected = provinceSelected;
        vm.citySelected = citySelected;
        vm.countySelected = countySelected;

        vm.submit = submit;
        vm.reset = reset;

        init();


        function init() {
            ExtHelper.chkCardReadExt(vm);
            vm.showRelative = true;
            vm.queryInfo = true;
            helper.init(vm);

            $q.all([
                UserInfo.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                helper.bindAsyncOptions(vm, respArray[0]);
                vm.m = {
                    id: '-',
                    male: 1,
                    // manage_type: vm.manageTypes[0],
                    nation: vm.nations[1],
                    political_status: vm.politicalStatuses[1],
                    relatives: [],
                    diseases: [],
                    workCompany: [],
                    manageCompany: [],
                    fd_type: 0,
                    free: false
                };
                copy = angular.copy(vm.m);
            });
        }

        var editProvince = true;

        function provinceSelected(item, m) {
            City.query({opt: 2, province_id: item.id}, function (resp) {
                vm.cities = resp.items;
                if (m.id && editProvince) {
                    editProvince = false;
                    if (m.city) {
                        m.city = ArrayHelper.getItem(m.city.id, vm.cities);
                    }
                } else {
                    m.city = vm.cities[0];
                }
                if (m.city) {
                    citySelected(m.city, m);
                }
            });
        }

        var editCity = true;

        function citySelected(item, m) {
            County.query({opt: 2, city_id: item.id}, function (resp) {
                vm.counties = resp.items;
                if (m.id && editCity) {
                    editCity = false;
                    if (m.county) {
                        m.county = ArrayHelper.getItem(m.county.id, vm.counties);
                    }
                } else {
                    m.county = vm.counties[0];
                }
                if (m.county) {
                    countySelected(m.county, m);
                }
            });
        }

        var editCounty = true;

        function countySelected(item, m) {
            Street.query({opt: 2, county_id: item.id}, function (resp) {
                vm.streets = resp.items;
                if (m.id && editCounty) {
                    editCounty = false;
                    if (m.street) {
                        m.street = ArrayHelper.getItem(m.street.id, vm.streets);
                    }
                } else {
                    // m.street = vm.streets[0];
                }
            });
        }

        function reset() {
            vm.Form.$setUntouched();
            vm.Form.$setPristine();
            vm.m = angular.copy(copy);
        }

        function submit(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = helper.loadParams(m);
                if (m.relatives.length > 0) {
                    var num = 0, typeNum = 0;
                    var relatives = [];
                    for (var i = 0; i < m.relatives.length; i++) {
                        var r = m.relatives[i];
                        //同为退休人员
                        if (r.id_card) {
                            if (r.id_card === m.id_card) {
                                Dlg.w('用户和离退休亲属的身份证信息相同');
                                return
                            }
                            num++;
                            var relative = helper.loadParams(r);
                            relative.type = r.type;
                            relatives.push(relative)
                        } else {
                            relatives.push(r)
                        }

                        if (r.type && r.type.id == 1) {
                            typeNum++;
                        }
                    }
                    pa.relatives = relatives;
                }

                if (num > 1) {
                    Dlg.w('同为退休人员的亲属最多允许添加一个');
                    return
                }
                if (typeNum > 1) {
                    Dlg.w('配偶关系最多允许添加一个');
                    return
                }

                var promise;
                if (m.id && m.id != '-') {
                    pa.op = 'personnel_confirm';
                    promise = UserInfo.update({id: m.id}, pa).$promise;
                } else {
                    pa.op = 'reg';
                    promise = UserInfo.save(pa).$promise;
                }
                promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    reset();
                }, function (err) {
                    if (err.data.msg) Dlg.error(err.data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('UserTransferDeptDlgCtrl', UserTransferDeptDlgCtrl);

    function UserTransferDeptDlgCtrl($uibModalInstance, FormHelper, Dept, UserInfo, Dlg, data, DateHelper) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init(data.user, data.dept);


        function init(user, dept) {
            vm.user = user;
            vm.dept = dept; // 原部门

            Dept.query({op: 'option', type: vm.dept.type, dept_id: vm.dept.id}).$promise.then(function (resp) {
                vm.depts = resp.items;
                vm.m = {
                    leave_time: new Date(),
                    entry_time: new Date()
                };
            });
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                UserInfo.transferDept(vm.user.id, vm.dept.id, {
                    dept_id: m.dept.id,
                    leave_time: DateHelper.date2Str(m.leave_time),
                    entry_time: DateHelper.date2Str(m.entry_time)
                }).then(function (resp) {
                    if (resp.data) Dlg.s(resp.data.msg);
                    $uibModalInstance.close(m.dept);
                }, function (err) {
                    if (err.data.msg) Dlg.error(err.data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('ArticleCtrl', ArticleCtrl);

    /** @ngInject */
    function ArticleCtrl($stateParams, $http, $sce, C, FileHelper, WxHelper, deviceDetector, OS, Dlg) {
        var isNews = $stateParams.type === 'news';
        var vm = this;
        vm.download = download;


        init($stateParams.id);


        function init(id) {
            vm.ios = deviceDetector.os === OS.IOS;
            var path = isNews ? 'news/news' : 'bulletin/bulletins';
            $http.get('/api/v1/' + path + '/' + id).then(function (resp) {
                var article = resp.data;
                article.body = $sce.trustAsHtml(article.body);
                vm.article = article;
            }, function (e) {
                if (path === 'news/news') {
                    if (e.data.msg) {
                        vm.error = e.data.msg;
                    } else {
                        vm.error2 = '没有找到该新闻';
                    }
                } else if (path === 'bulletin/bulletins') {
                    if (e.data.msg) {
                        vm.error = e.data.msg;
                    } else {
                        vm.error2 = '没有找到该公告';
                    }
                }
            });
        }

        function download(attachment) {
            if (WxHelper.isWechatBrowser()) {
                Dlg.show({
                    template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                    ctrl: 'attachmentDownloadDlgCtrl', data: {attachment: attachment}, size: 'sm'
                });
            } else {
                FileHelper.download1(C.URL.BULLETIN_DOWNLOAD, attachment);
            }
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('AttendanceAbnormalDayCtrl', AttendanceAbnormalDayCtrl);

    /** @ngInject */
    function AttendanceAbnormalDayCtrl ($scope, $stateParams, $http, NgTableParams, Dlg) {
        var vm = $scope;


        init($stateParams.day);

        function init (day) {
            vm.hideFilter = true;
            vm.hideOpt = true;
            vm.showSn = true;
            vm.cols = [
                {field: "dept", title: "所在部门", show: true},
                {field: "name", title: "姓名", show: true},
                {field: "abnormal_numbers", title: "异常次数", show: true}
            ];
            vm.tableParams = new NgTableParams({page: 1, count: 10, sorting: {}}, {
                counts: [10, 30, 50], total: 0,
                getData: function ($defer, params) {
                    var url = params.url();
                    url['op'] = 'AbnormalDay';
                    url['day'] = day;
                    $http({
                        method: 'GET',
                        url: '/api/v1/attendance/attendances',
                        params: url
                    }).then(function (resp) {
                        var data = resp.data;
                        params.total(data.total);
                        $defer.resolve(data['items']);
                    }, function (err) {
                        if (err.data.msg) Dlg.error(err.data.msg);
                        $defer.resolve();
                    });
                }
            });
        }
    }

})();






(function () {
    'use strict';

    angular.module('c')
        .controller('EmailShowCtrl', EmailShowCtrl);

    /** @ngInject */
    function EmailShowCtrl($stateParams, $http, $sce, C, WxHelper, FileHelper, deviceDetector, OS, Dlg) {
        var vm = this;
        vm.download = download;


        init($stateParams.id);


        function init(id) {
            vm.ios = deviceDetector.os === OS.IOS;
            $http.get('/api/v1/emails/' + id).then(function (resp) {
                var m = resp.data.mail;
                m.body = $sce.trustAsHtml(m.body);
                vm.m = m;
            }, function (e) {
                if (e.data.msg) {
                    vm.error = e.data.msg;
                }
                else {
                    vm.error2 = '没有找到该邮件';
                }
            });
        }

        function download(attachment) {
            if (WxHelper.isWechatBrowser()) {
                Dlg.show({
                    template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                    ctrl: 'attachmentDownloadDlgCtrl', data: {attachment: attachment}, size: 'sm'
                });
            } else {
                FileHelper.download1(C.URL.MAIL_DOWNLOAD, attachment);
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('MeetingPreviewCtrl', MeetingPreviewCtrl);

    /** @ngInject */
    function MeetingPreviewCtrl($stateParams, $http, $sce, C, FileHelper, WxHelper, deviceDetector, OS, Dlg) {
        var vm = this;
        vm.download = download;


        init($stateParams.id);


        function init(id) {
            vm.ios = deviceDetector.os === OS.IOS;
            $http.get('/api/v1/meeting/meetings/' + id).then(function (resp) {
                var meeting = resp.data.meeting;
                meeting.content = $sce.trustAsHtml(meeting.content);
                meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
                vm.meeting = meeting;
            }, function (e) {
                if (e.data.msg) {
                    vm.error = e.data.msg;
                } else {
                    vm.error2 = '没有找到该会议';
                }
            });
        }

        function download(attachment) {
            if (WxHelper.isWechatBrowser()) {
                Dlg.show({
                    template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                    ctrl: 'attachmentDownloadDlgCtrl', data: {attachment: attachment}, size: 'sm'
                });
            } else {
                FileHelper.download1(C.URL.MEETING_DOWNLOAD, attachment);
            }
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('MeetingCommentCtrl', MeetingCommentCtrl);

    /** @ngInject */
    function MeetingCommentCtrl(FormHelper, $http, Dlg, $timeout, $window, $stateParams) {
        var vm = this;
        vm.ok = ok;

        init($stateParams.id);


        function init(id) {
            $http.get('api/v1/meeting/meeting_attendances/query_meeting/' + id)
                .success(function (resp) {
                    vm.m = {
                        msg: resp.msg,
                        meeting: resp.meeting,
                        id: id
                    };
                }).error(function (err) {
                if (err.msg) Dlg.e(err.msg);
            });
            vm.satLvs = [
                {id: 1, name: '非常不满意'},
                {id: 2, name: '不满意'},
                {id: 3, name: '较满意'},
                {id: 4, name: '满意'},
                {id: 5, name: '非常满意'}
            ];
        }

        function close() {
            if (typeof(WeixinJSBridge) != "undefined") {
                WeixinJSBridge.invoke('closeWindow');
            } else {
                $window.location.href = 'about:blank ';
                $window.close();
            }
        }

        function ok(m) {
            if (!m.rate) {
                Dlg.e('请在1-5分中选择一个！');
            } else {
                FormHelper.handleSubmit(vm, function () {
                    $http.post('api/v1/meeting/meeting_attendances/comment', {id: m.id, rate: m.rate, note: m.note})
                        .success(function (resp) {
                            Dlg.s(resp.msg);
                            $timeout(function () {
                                close();
                            }, 2000);
                        }).error(function (err) {
                        if (err.msg) Dlg.e(err.msg);
                        $timeout(function () {
                            close();
                        }, 2000);
                    });
                });
            }

        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('MissionPreviewCtrl', MissionPreviewCtrl);

    /** @ngInject */
    function MissionPreviewCtrl($stateParams, $http, $sce, C, FileHelper, WxHelper, deviceDetector, OS, Dlg) {

        var vm = this;
        vm.download = download;

        init($stateParams.id);

        function init(id) {
            vm.ios = deviceDetector.os === OS.IOS;
            $http.get('/api/v1/mission/missions/' + id).then(function (resp) {
                var mission = resp.data.mission;
                mission.content = $sce.trustAsHtml(mission.content);
                mission.time_range = mission.start_time.substr(0, 16) + ' - ' + mission.end_time.substr(0, 16);
                vm.mission = mission;
            }, function (e) {
                if (e.data.msg) {
                    vm.error = e.data.msg;
                }
                else {
                    vm.error2 = '没有找到该任务';
                }
            });
        }

        function download(attachment) {
            if (WxHelper.isWechatBrowser()) {
                Dlg.show({
                    template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                    ctrl: 'attachmentDownloadDlgCtrl', data: {attachment: attachment}, size: 'sm'
                });
            } else {
                FileHelper.download1(C.URL.MISSION_DOWNLOAD, attachment);
            }
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('PreviewShowDlgCtrl', PreviewShowDlgCtrl);

    /** @ngInject */
    function PreviewShowDlgCtrl($uibModalInstance, $sce, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.url, data.name);


        function init(url, name) {
            vm.name = name;
            vm.url = $sce.trustAsResourceUrl(url);
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('TopicPreviewCtrl', TopicPreviewCtrl);

    /** @ngInject */
    function TopicPreviewCtrl ($stateParams, $http, $sce, FileHelper, WxHelper, deviceDetector, OS, Dlg) {
        var vm = this;
        vm.download = download;


        init($stateParams.id);


        function init (id) {
            vm.ios = deviceDetector.os === OS.IOS;
            $http.get('/api/v1/topic/topics/' + id).then(function (resp) {
                var topic = resp.data.item;
                topic.body = $sce.trustAsHtml(topic.body);
                vm.topic = topic;
            }, function (e) {
                if (e.data.msg) {
                    vm.error = e.data.msg;
                } else {
                    vm.error2 = '没有找到该议题';
                }
            });
        }

        function download (attachment) {
            if (WxHelper.isWechatBrowser()) {
                Dlg.show({
                    template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                    ctrl: 'attachmentDownloadDlgCtrl', data: {attachment: attachment}, size: 'sm'
                });
            } else {
                FileHelper.download1('/api/v1/topic/topics/attachment/download', attachment);
            }
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('DeptRecordCtrl', DeptRecordCtrl);

    /** @ngInject */
    function DeptRecordCtrl($scope, Table, UserDept) {
        var vm = $scope;

        init();


        function init() {
            var options = {
                service: UserDept,
                params: {opt: '3', user_id: $scope.account.user_id},
                hideOpt: true,
                showSn: true,
                sorting: {entry_time: 'desc'},
                items: 'depts',
                cols: [
                    {title: '名称', field: 'name'},
                    {title: '类型', field: 'type'},
                    {title: '进入时间', field: 'entry_time', sortable: 'entry_time'},
                    {title: '离开时间', field: 'leave_time', sortable: 'leave_time'}
                ]
            };
            Table.load(vm, options);
        }
    }

})();




angular.module('c')
    .controller('UserHelpCtrl', function ($scope, $sce, $http,
                                          HelpPage, HelpContent, DateHelper, F) {

        HelpPage.query(function (data) {
            $scope.pages = data;
            if (data.length > 0) {
                var page = data[0];
                $scope.selectPage(page);
            }
        });

        HelpContent.get({id: 1}).$promise.then(function (resp) {
            if (resp.root && resp.root['1']) {
                $scope.content = resp.root['1'].children;
            }
        });

        $scope.selectPage = function (page) {
            var time = DateHelper.datetime2Str(new Date(), 'yyMMddHHmmss');
            var url = $sce.getTrustedResourceUrl(page.url + "?" + time);
            $http.get(url).success(function (resp) {
                $scope.curPage.body = $sce.trustAsHtml(resp);
            });
            $scope.curPage = page;
        }

    });


(function () {
        'use strict';

        angular.module('c')
            .controller('ProfileCtrl', ProfileCtrl)
            .controller('ContactInfoCtrl', ContactInfoCtrl)
            .controller('PasswordDlgCtrl', PasswordDlgCtrl);

        /** @ngInject */
        function ProfileCtrl($rootScope, $stateParams, $scope, User, UserInfo, Auth, Dlg, ArrayHelper) {
            var account = Auth.getAccount();
            var vm = $scope;
            vm.reload = reload;
            vm.addUserPhoto = addUserPhoto;
            vm.changePasswd = changePasswd;
            vm.editContact = editContact;
            var helper = UserInfo.formHelper;

            init($stateParams.data.requireChangePasswd);


            function init(requireChangePasswd) {
                helper.init(vm);
                reload(requireChangePasswd);
            }

            function reload(requireChangePasswd) {
                User.get({id: account.id}, function (resp) {
                    var item = resp.item;
                    if (item.user_info) {
                        var m = item.user_info;
                        loadItem(m);
                        var relatives = [];
                        angular.forEach(m.s_users, function (item) {
                            loadItem(item);
                            item.type = ArrayHelper.getItem(item.pivot.type, vm.relativeTypes);
                            relatives.push(item);
                        });

                        angular.forEach(m.relatives, function (item) {
                            item.type = ArrayHelper.getItem(item.pivot.type, vm.relativeTypes);
                            relatives.push(item);
                        });

                        m.relatives = relatives;
                        vm.user = m;
                    } else {
                        vm.user = item;
                    }

                    if (requireChangePasswd) {
                        Dlg.show({
                            template: 'password_dlg.html',
                            ctrl: 'PasswordDlgCtrl',
                            data: {id: '-', requireChangePasswd: requireChangePasswd}
                        });
                    }
                });
            }

            function addUserPhoto(user) {
                Dlg.show({
                    template: 'pages/user/profile/userPhotoDlg.html',
                    ctrl: 'UserPhotoDlgCtrl',
                    data: {id: user.id}
                }).then(function (resp) {
                    user.photo = resp[0]
                    // account.photo = user.photo = resp[0];
                    // $rootScope.header.account = account;
                    // Auth.setAccount(account);
                });
            }

            function changePasswd() {
                Dlg.show({
                    template: 'password_dlg.html',
                    ctrl: 'PasswordDlgCtrl',
                    data: {id: '-'}
                });
            }

            function loadItem(item) {
                item.work_state = ArrayHelper.getItem(item.work_state, vm.workStates);
                item.house_type = ArrayHelper.getItem(item.house_type, vm.houseTypes);
                item.soldier_type = ArrayHelper.getItem(item.soldier_type, vm.soldierTypes);
                item.live_type = ArrayHelper.getItem(item.live_type, vm.liveTypes);
                item.marry_type = ArrayHelper.getItem(item.marry_type, vm.marryTypes);
                item.self_care = ArrayHelper.getItem(item.self_care, vm.selfCares);
                item.relative_type = ArrayHelper.getItem(item.relative_type, vm.relativeTypes);
                item.identity = ArrayHelper.getItem(item.identity, vm.identities);
                item.elderly_service_type = ArrayHelper.getItem(item.elderly_service_type, vm.elderlyServiceTypes);
                item.elderly_service_grade = ArrayHelper.getItem(item.elderly_service_grade, vm.elderlyServiceGrades);
            }

            function editContact(user) {
                if (user.id_card) {
                    Dlg.show({
                        template: 'pages/personnel/userInfo/editDlg.html',
                        ctrl: 'PersonnelUserEditCtrl',
                        data: {
                            id: user.id, op: 'personnel_confirm', hideIllInfo: true
                        }, size: 'lg'
                    }).then(function () {
                        reload();
                    });
                } else {
                    Dlg.show({
                        template: 'pages/user/profile/contactInfoDlg.html',
                        ctrl: 'ContactInfoCtrl',
                        data: {user_id: user.id},
                        size: 'lg'
                    }).then(function () {
                        reload();
                    });
                    // account.more_contact_info = false;
                    // Auth.setAccount(account);
                }

            }
        }

        /** @ngInject */
        function PasswordDlgCtrl($uibModalInstance, Dlg, data, FormHelper, User) {

            var vm = this;
            vm.m = {id: data.id};
            vm.requireChangePasswd = data.requireChangePasswd;
            vm.cancel = $uibModalInstance.dismiss;
            vm.ok = ok;

            function ok(m) {
                return FormHelper.handleSubmit(vm, function (defer) {
                    User.update({id: m.id}, {password: m.password, op: 'password'})
                        .$promise.then(function (resp) {
                        Dlg.s(resp.msg);
                        $uibModalInstance.close();
                        // if (m.toUserInfoChangeDoc) {
                        //     // 4 表示“个人信息纠正申请”公文，金堂专属
                        //     UIHelper.tabTo('new', {op: 'loadType', type: 4}, 'app.coop_doc');
                        // }
                    }, function (error) {
                        if (error.data.msg) Dlg.e(error.data.msg);
                    }).finally(function () {
                        defer.resolve();
                    });
                });
            }
        }

        /** @ngInject */
        function ContactInfoCtrl(FormHelper, $uibModalInstance, Dlg, User, data, $q, ArrayHelper,
                                 DeptGroup, DateHelper, $scope) {
            var vm = this;
            vm.ok = ok;
            var helper = User.formHelper;
            vm.cancel = $uibModalInstance.dismiss;
            var required = {
                status: true, entryTime: true, startedWork: false, annualDays: true
            };
            init();


            function init() {
                helper.init(vm, $scope);

                vm.cfg = {
                    disable: {
                        dept: true,
                        company: true,
                        username: true,
                        status: true,
                        post: true,
                        cardre: true
                    },
                    enableTransferDept: false,
                    hideUpdateAnnualChecker: true,
                    hideChangeNote: false,
                    required: required
                    // contactBodyStyle: {height: '280px'} // 下面再设置
                };

                $q.all([
                    User.get({id: data.user_id, op: 'default'}).$promise
                ]).then(function (respArray) {
                    var m = respArray[0].item;
                    vm.cfg.workBodyStyle = {height: '100%'};
                    vm.m = m;
                });
            }

            function ok(m) {
                return FormHelper.handleSubmit(vm, function (defer) {
                    var pa = helper.loadParams(m, 'contact_info');

                    if (m.group) pa.group_id = m.group.id;

                    User.update({id: m.id}, pa).$promise.then(function (resp) {
                        if (resp.msg) Dlg.s(resp.msg);
                        $uibModalInstance.close();
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Dlg.e(data.msg);
                    }).finally(function () {
                        defer.resolve();
                    });
                });
            }
        }

    }

)();

(function () {
    'use strict';

    angular.module('c')
        .controller('appCfgCtrl', appCfgCtrl)
    ;

    function appCfgCtrl($scope, toaster, Setting) {
        $scope.reload = function () {
            Setting.query(function (resp) {
                var setting = {};
                angular.forEach(resp, function (s) {
                    setting[s.name] = s.value;
                    if (s.name === 'duty_count_disable') {
                        setting[s.name] = s.value === '1';
                    }
                });
                $scope.setting = setting;
                $scope.backup = angular.copy(setting);
                $scope.params_diff = false;
            });
            $scope.tab = 1;
        };

        $scope.submit = function (setting) {
            var params = {};
            var params_check = $scope.params_check;
            for (var k in params_check) {
                params[k] = setting[k];
            }

            Setting.update({id: 0}, params).$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        toaster.success('应用配置修改成功!');
                        $scope.reload();
                        break;
                    case 1:
                        toaster.warning('应用配置修改失败,因为参数格式错误!');
                        break;
                }
            }, function () {
                toaster.error('应用配置修改失败!');
            });
        };

        $scope.reset = $scope.reload;
        $scope.reload();

        $scope.params_check = {};
        $scope.$watch('setting', function (newVal, oldVal, scope) {
            scope.params_diff = false;
            for (var k in newVal) {
                if (!angular.equals(newVal[k], scope.backup[k])) {
                    scope.params_check[k] = true;
                    scope.params_diff = true;
                } else {
                    delete scope.params_check[k];
                }
            }
        }, true);
    }


})();
(function () {
    'use strict';

    angular.module('c')
        .controller('AuthorityCtrl', AuthorityCtrl)
        .controller('RoleUsersCtrl', RoleUsersCtrl)
        .controller('PermSetDlgCtrl', PermSetDlgCtrl)
        .controller('RoleAddDlgCtrl', RoleAddDlgCtrl)
    ;

    /** @ngInject */
    function AuthorityCtrl($scope, Dlg, Table, Role) {
        var vm = $scope;
        vm.maxProtectId = 2;
        vm.addEdit = addEdit;
        // vm.edit = edit;
        vm.roleUsers = roleUsers;
        vm.setPerms = setPerms;
        vm.remove = remove;

        init();

        function init() {
            var options = {
                service: Role,
                params: {op: 'sys'/*INDEX_ALL*/},
                optColWidth: Table._4_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: "name", title: "角色名称", filter: {name: "text"}},
                    {field: "description", title: "备注"}
                ]
            };

            Table.load(vm, options, function (resp) {
                vm.roles = [];
                angular.forEach(resp.items, function (i) {
                    vm.roles.push(i.name);
                })
            });
        }

        function addEdit(m) {
            var pa = {roles: vm.roles};
            if (m) {
                pa.id = m.id;
                pa.name = m.name;
            }
            Dlg.show({
                template: 'RoleAddDlg.html',
                ctrl: 'RoleAddDlgCtrl',
                data: pa
            }).then(function () {
                vm.tableReload();
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的角色吗？', function (resp) {
                Role.delete({id: m.id, op: 'sys'}).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除角色');
        }

        function setPerms(m) {
            Dlg.show({
                template: 'PermSetDlg.html',
                ctrl: 'PermSetDlgCtrl',
                data: {
                    role: m
                }
            }).then(function (params) {
                params['op'] = 'setPerms';
                Role.update({id: m.id}, params).$promise.then(function (success) {
                    Dlg.s(m.display_name + '权限设置成功!');
                }, function (error) {
                    Dlg.e(m.display_name + '权限设置失败!');
                });
            });
        }


        function roleUsers(m) {
            Dlg.show({
                template: 'RoleUsersDlg.html',
                ctrl: 'RoleUsersCtrl',
                data: {
                    role: m
                },
                size: 'lg'
            });
        }
    }

    /** @ngInject */
    function RoleUsersCtrl($scope, $uibModalInstance, Table, Dlg, Role, data) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.role = data.role;
        vm.add = add;
        vm.remove = remove;
        vm.members = [];


        init(data.role.id);

        function init(id) {
            var options = {
                service: Role,
                params: {op: 'member', role_id: id},
                optColWidth: Table._1_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "username", title: "用户名", filter: {username: "text"}},
                    {field: "roles", title: "角色"}
                ]
            };

            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    vm.members.push({id: item.id});
                })
            });
        }

        function add() {
            Dlg.show({
                template: 'directives/form/user-selector/user_selector_dlg.html',
                ctrl: 'UserSelectCtrl',
                data: {
                    title: '添加' + data.role.name + '用户', multiSelect: true, existMembers: vm.members
                }
            }).then(function (members) {
                if (members.length > 0) {
                    var params = {};
                    params['op'] = 'attachUsers';
                    params['members'] = members;
                    //为角色添加用户
                    Role.update({id: data.role.id}, params).$promise.then(function (resp) {
                        Dlg.s('添加成功!');
                        vm.tableReload();
                    }, function (error) {
                        if (error.data) Dlg.e(error.data.msg);
                        else console.log('error', error);
                    });
                }
            });
        }

        function remove(user) {
            Dlg.confirm('确定要删除名为<strong>' + user.name + '</strong>的<strong>' + data.role.name + '</strong>角色吗？', function (resp) {
                var params = {};
                params['op'] = 'detachUsers';
                params['members'] = [{id: user.id}];
                Role.update({id: data.role.id}, params).$promise.then(function () {
                    Dlg.s('角色移除成功!');
                    vm.tableReload();
                }, function (error) {
                    if (error.data) Dlg.e(error.data.msg);
                    else console.log('error', error);
                });
            }, '去掉员工角色');
        }
    }

    /** @ngInject */
    function PermSetDlgCtrl($uibModalInstance, Permission, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.role = data.role;
        vm.setCheckedAll = setCheckedAll;
        vm.onChange = onChange;
        vm.ok = ok;
        vm.loading = true;

        var setParentOfChildren = function (node) {
            angular.forEach(node.children, function (child) {
                child.parent = node;
                if (child.children != null && child.children.length > 0) {
                    setParentOfChildren(child);
                }
            });
        };

        Permission.get({id: data.role.id}).$promise.then(function (data) {
            setParentOfChildren(data[1]);
            vm.data = data[1];
        }, function (error) {
        }).finally(function () {
            vm.loading = false;
        });

        function setCheckedAll(node, checked) {
            node.is_checked = checked;
            setCheckedChildren(node);
        }

        function setCheckedChildren(node) {
            if (node.children != null && node.children.length > 0) {
                angular.forEach(node.children, function (child) {
                    child.is_checked = node.is_checked;
                    setCheckedChildren(child);
                });
            }
        }

        function setCheckedAncestors(node) {
            if (node.parent) {
                if (node.is_checked) {
                    if (!node.parent.is_checked) {
                        node.parent.is_checked = node.is_checked;
                        setCheckedAncestors(node.parent);
                    }
                } else {
                    if (node.parent.is_checked) {
                        var allUnchecked = true;
                        var children = node.parent.children;
                        for (var i = 0; i < children.length; i++) {
                            if (children[i].is_checked) {
                                allUnchecked = false;
                                break;
                            }
                        }
                        if (allUnchecked) {
                            node.parent.is_checked = node.is_checked;
                            setCheckedAncestors(node.parent);
                        }
                    }
                }
            }
        }

        function onChange(node) {
            setCheckedChildren(node);
            setCheckedAncestors(node);
        }

        function ok(data) {
            var perms = [];

            function setPerms(node) {
                if (node.is_checked) {
                    perms.push({id: node.permission.id});
                }
                if (node.children != null && node.children.length > 0) {
                    angular.forEach(node.children, function (child) {
                        setPerms(child);
                    });
                }
            }

            setPerms(data);
            $uibModalInstance.close({permissions: perms});
        }
    }

    /** @ngInject */
    function RoleAddDlgCtrl($uibModalInstance, data, Dlg, Role, $q, FormHelper) {
        var vm = this;
        vm.roles = data.roles;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init(id) {
            if (id) {
                Role.get({id: id, op: 'sys'}, function (resp) {
                    vm.role = resp;
                });
            } else {
                vm.role = {};
            }
        }

        function ok(m) {
            var defer = $q.defer();
            if (!vm.Form.$valid) {
                FormHelper.handleError('#Form', vm.Form);
                defer.reject();
            } else {
                var pa = {
                    name: m.name,
                    display_name: m.name,
                    description: m.description,
                    op: 'sys'
                };
                var promise;
                if (m.id) {
                    promise = Role.update({id: m.id}, pa).$promise;
                } else {
                    promise = Role.save(pa).$promise;
                }
                promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    if (error.data) Dlg.e(error.data.msg);
                    else console.log('error', error);
                }).finally(function () {
                    defer.resolve();
                });
            }

            return defer.promise;
        }
    }


})();
angular.module('c')
    .controller('BasicCtrl', ['$scope', BasicCtrl]);

function BasicCtrl($scope) {

}


angular.module('c')
    .controller('HelpCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams,
                                      HelpPage, HelpContent, Table) {
        $scope.cols = [
            {title: '标题', filter: {title: 'text'}, show: true}, //0
            {title: '链接', width: '55%', show: true}
        ];

        $scope.optColWidth = 73;
        $scope.tableParams = new NgTableParams({page: 1, count: 30, sorting: {sorting: 'asc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                if (!$scope.pages) {
                    HelpPage.query(function (data) {
                        angular.forEach(data, function (page) {
                            page.items = [];
                        });
                        $scope.pages = data;
                        Table.getTableData(data, $defer, params, $filter);
                    });
                } else {
                    var data = $scope.pages;
                    Table.getTableData(data, $defer, params, $filter);
                }
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.tableReload = function () {
            $scope.pages = null;
            $scope.tableParams.reload();
        };

        $scope.add = function () {
            dialogs.create('PageDlg.html', 'PageDlgCtrl', {}, {
                size: 'lg'
            }).result.then(function (page) {
                HelpPage.save(page).$promise.then(function (data) {
                    toaster.success('添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('添加失败!');
                });
            });
        };

        $scope.edit = function (page) {
            dialogs.create('PageDlg.html', 'PageDlgCtrl', {page: page}, {
                size: 'lg'
            }).result.then(function (page) {
                HelpPage.update({id: page.id}, page).$promise.then(function (data) {
                    toaster.success('添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('添加失败!');
                });
            });
        };

        $scope.delete = function (page) {
            dialogs.confirm('删除页面', '确定要删除页面<strong>' + page.title + '</strong>吗?')
                .result.then(function () {
                HelpPage.delete({id: page.id}).$promise.then(function (resp) {
                    toaster.success('删除成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        };

        $scope.visible = function (item, query) {
            return !(query && query.length > 0
            && item.title.indexOf(query) == -1);
        };

        function convert2MenuItem(items, menu) {
            angular.forEach(items, function (item) {
                var menuItem = {page_id: item.id, subject: item.title};
                menu.children.push(menuItem);
                if (item.items && item.items.length > 0) {
                    menuItem.children = [];
                    convert2MenuItem(item.items, menuItem);
                }
            });
        }

        $scope.save = function (content) {
            var menu = {children: []};
            convert2MenuItem(content, menu);
            HelpContent.save({menu: menu}, function (content) {
                toaster.success('保存成功');
            });
        };

        function convert2Item(menus, content) {
            angular.forEach(menus, function (menu) {
                var item = {id: menu.page.id, title: menu.page.title, items: []};
                content.push(item);
                if (menu.children && menu.children.length > 0) {
                    convert2Item(menu.children, item.items);
                }
            });
        }

        $scope.contentReload = function () {
            HelpContent.get({id: 1}).$promise.then(function (resp) {
                var content = [];
                if (resp.root && resp.root['1']) {
                    var children = resp.root['1'].children;
                    convert2Item(children, content);
                }
                $scope.content = content;
            });
        };

        $scope.contentReload();
    });


angular.module('c').controller('PageDlgCtrl',
    function ($scope, $uibModalInstance, $sce, $http, toaster, data) {
        if (data.page) {
            $scope.page = data.page;
            var url = $sce.getTrustedResourceUrl(data.page.url);
            $http.get(url + "?" + new Date().toString()).success(function (resp) {
                $scope.page.body = resp;
            });
            $scope.$edit = true;
        } else {
            $scope.page = {title: ''};
        }

        $scope.ok = function (page) {
            if (page.title == '') {
                toaster.warning('标题不能为空');
            } else if (page.body == '') {
                toaster.warning('内容不能为空');
            } else {
                $uibModalInstance.close(page);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
(function () {
    'use strict';

    angular.module('c')
        .controller('MajorCtrl', MajorCtrl)

    ;


    function MajorCtrl($scope, $q, Api, dialogs, Major) {
        var vm = $scope;
        vm.add = add;
        vm.ok = ok;
        vm.save = save;
        vm.rmItem = rmItem;
        vm.reload = reload;
        //vm.remove = remove;

        init();


        function init() {
            vm.types = [];
            vm.op = {};
            reload();
        }

        function add(parent) {
            var nItem = {name: '新专业', children: []};
            nItem.nameChange = nItem.name;
            vm.op.eItem = nItem;
            if (angular.isDefined(parent)) {
                parent.children.push(nItem);
            } else {
                vm.types.push(nItem);
            }
        }

        function ok(item) {
            if (item.nameChange) {
                item.name = item.nameChange;
                vm.op.eItem = null;
            }
        }

        function convert(types) {
            angular.forEach(types, function (type) {
                delete type.nameChange;
                if (type.children && type.children.length > 0) {
                    convert(type.children);
                }
            });
        }

        function save(types) {
            var defer = $q.defer();
            vm.op.eItem = null;
            convert(types);
            Major.save(types, function (resp) {
                var types = [];
                angular.forEach(resp.items, function (type) {
                    types.push(type);
                });
                vm.types = types;

                Api.s(resp.msg);

                defer.resolve();
            });
            return defer.promise;
        }

        function rmItem(item, rmFn, self) {
            if (item.id) {
                dialogs.confirm('删除专业类型', '确定要删除<strong>' + item.name + '</strong>类型吗？')
                    .result.then(function () {
                    Major.delete({id: item.id}, function (resp) {
                        if (resp.result != 0) {
                            Api.w(resp.msg);
                        } else {
                            rmFn(self);
                        }
                    });
                });
            }
            else {
                rmFn(self);
            }
        }

        function reload() {
            var defer = $q.defer();
            Major.query({opt: 1}, function (resp) {
                var types = [];
                angular.forEach(resp.items, function (type) {
                    types.push(type);
                });
                vm.types = types;
                defer.resolve();
            });
            return defer.promise;
        }


    }


})();


(function () {
    'use strict';
    angular.module('c')
        .controller('SignCtrl', SignCtrl)
        .controller('SealDlgCtrl', SealDlgCtrl)
        .controller('SignDlgCtrl', SignDlgCtrl);

    function SignCtrl($scope, Dlg, User, UserType, Table, FileHelper, PrintHelper) {
        var vm = $scope;
        vm.setSign = setSign;
        vm.setSeal = setSeal;
        vm.print = print;
        vm.export = exportAllDepts;

        init();


        function init() {
            var options = {
                service: User,
                params: {op: 'sys_sign'},
                optColWidth: Table._2_BTN,
                hideOpt: true,
                cols: [{field: 'sn', title: '序号', width: Table._1_CHAR},
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "username", title: "用户名", filter: {username: "text"}},
                    {field: "type", title: "类别", filter: {type_id: "select"}, width: Table._1_CHAR},
                    {field: "dept", title: "部门", filter: {dept: "text"}, width: Table._3_CHAR},
                    {field: "sign", title: "签名", filter: {no_sign: "checkbox"}, data: '未传', width: Table._5_CHAR},
                    {field: "seal", title: "印鉴", filter: {no_seal: "checkbox"}, data: '未传', width: Table._5_CHAR}
                ]
            };

            var optionFn = Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn, function (item) {
                    if (item.signature) {
                        item.sign = item.signature.sign;
                        item.seal = item.signature.seal;
                    }
                });
            }).options;

            UserType.query(function (resp) {
                optionFn().cols[3].data = Table.getNgTableOpts(resp);
            });
        }

        function setSign(m) {
            Dlg.show({
                template: 'SignDlg.html', ctrl: 'SignDlgCtrl',
                data: {id: m.id}
            }).then(function (sign) {
                m.sign = sign;
            });
        }

        function setSeal(m) {
            Dlg.show({
                template: 'SealDlg.html', ctrl: 'SealDlgCtrl',
                data: {id: m.id}
            }).then(function (seal) {
                m.seal = seal;
            });
        }

        function exportAllDepts(justSign) {
            FileHelper.dnExcel(User.urls.EXPORT_DEPT_NOT_SIGN, {justSign: justSign}, '全院核算部门未签名名单.xls');
        }

        function print() {
            PrintHelper.print(window.open(), PrintHelper.STYLE.TEMP2, function () {
                var html = '<html><body><table><tbody>';
                html += '<tr><td>用户名</td>';
                html += '<td>姓名</td>';
                html += '<td>签名</td>';
                html += '<td>印章</td></tr>';
                angular.forEach(vm.tableParams.settings().$scope.$data, function (user) {
                    html += '<tr>';
                    html += '<td>' + user.username + '</td>';
                    html += '<td>' + user.name + '</td>';

                    if (user.sign) {
                        html += '<td><img height="50" width="160" src="' + user.sign + '"/></td>';
                    } else {
                        html += '<td></td>';
                    }
                    if (user.seal) {
                        html += '<td><img height="50" width="160" src="' + user.seal + '"/></td>';
                    } else {
                        html += '<td></td>';
                    }
                    html += '</tr>';
                });
                html += '</tbody></table></body></html>';
                return html;
            });
        }

    }

    function SignDlgCtrl($scope, $uibModalInstance, User, Dlg, data) {
        var vm = $scope;
        vm.image = {croppedDataUrl: ''};
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        function ok(image) {
            User.update({id: data.id}, {
                op: 'sys_sign',
                sign: image.croppedDataUrl
            }).$promise.then(function (resp) {
                Dlg.s(resp.msg);
                $uibModalInstance.close(image.croppedDataUrl);
            }, function (err) {
                if (err.data.msg) Dlg.e(err.data.msg);
            });
        }
    }

    function SealDlgCtrl($scope, $uibModalInstance, User, Dlg, data) {
        var vm = $scope;
        vm.image = {croppedDataUrl: ''};
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        function ok(image) {
            User.update({id: data.id}, {
                op: 'sys_seal',
                seal: image.croppedDataUrl
            }).$promise.then(function (resp) {
                Dlg.s(resp.msg);
                $uibModalInstance.close(image.croppedDataUrl);
            }, function (err) {
                if (err.data.msg) Dlg.e(err.data.msg);
            });
        }
    }

})();

(function(){
    var elif = angular.module('elif', []);

    var CONDITIONALS = 'elif.conditionals';

    // This is copied from AngularJS because it is not
    // part of the public interface.
    var getBlockElements = function(nodes){
        if(!nodes || !nodes.length){
            return angular.element();
        }

        var startNode = nodes[0];
        var endNode = nodes[nodes.length - 1];

        if(startNode === endNode){
            return angular.element(startNode);
        }

        var element = startNode;
        var elements = [element];

        do {
            element = element.nextSibling;
            if(!element){
                break;
            }
            elements.push(element);
        }
        while(element !== endNode);

        return angular.element(elements);
    };

    elif.factory('elif', [
        function(){
            // By requiring the scope have it's own copy of `elif.conditionals`
            // we avoid if/else-if/else structures that span AngularJS scopes.
            var getConditionals = function(scope){
                if(angular.hasOwnProperty.call(scope, CONDITIONALS)){
                    var conditionals = scope[CONDITIONALS];
                    return conditionals[conditionals.length - 1];
                }
            };

            return {
                create: function(scope, fn, callback){
                    var conditionals = [{
                        fn: fn,
                        callback: callback || angular.identity
                    }];
                    var conditionalValues = [];

                    scope.$watch(function(){
                        // Watch the boolean conditionals; we only need
                        // to run through the if/else-if/else chain if one
                        // of them changes.  We can also take the chance to
                        // short-circuit when we've found our first true
                        // condition.
                        var i;
                        var len = conditionals.length;
                        conditionalValues.length = len;
                        for(i = 0; i < len; i++){
                            if((conditionalValues[i] = !!conditionals[i].fn())){
                                i++;
                                break;
                            }
                        }
                        for(; i < len; i++){
                            conditionalValues[i] = false;
                        }
                        return conditionalValues;
                    }, function(conditionalValues){

                        // Update each block; also find first matching if/else-if.
                        var index = -1;
                        for(var i = 0, len = conditionals.length; i < len; i++){
                            if(conditionalValues[i]){
                                conditionals[i].callback(true);
                                index = i;
                            }
                            else {
                                conditionals[i].callback(false);
                            }
                        }

                        // Handle else, if there is one.
                        conditionals.fallthrough && conditionals.fallthrough(index === -1);

                    }, true); // Deep watch; we know that it is a simple list of booleans.

                    // Keep track of if/else-if/else structures per AngularJS scope.
                    if(!angular.hasOwnProperty.call(scope, CONDITIONALS)){
                        scope[CONDITIONALS] = [];
                    }
                    scope[CONDITIONALS].push(conditionals);
                },
                extend: function(scope, fn, callback){
                    var conditionals = getConditionals(scope);
                    if(!conditionals){
                        throw new Error('elif.extend: no if found at this level');
                    }
                    if(conditionals.fallthrough){
                        throw new Error('elif.extend: else-if after else');
                    }

                    conditionals.push({
                        fn: fn,
                        callback: callback
                    });
                },
                fallthrough: function(scope, fn, callback){
                    var conditionals = getConditionals(scope);
                    if(!conditionals){
                        throw new Error('elif.fallthrough: no if found at this level');
                    }
                    if(conditionals.fallthrough){
                        throw new Error('elif.fallthrough: else already found at this level');
                    }
                    conditionals.fallthrough = callback;
                }
            };
        }
    ]);

    // This implementation is basically the built-in `ng-if`, hooked into the `elif` service.
    var elifDirective = function(name, method, getter){
        elif.directive(name, [
            '$animate',
            '$document',
            '$injector',
            'elif',
            function($animate, $document, $injector, elif){
                var getterFn = getter && $injector.invoke(getter);

                return {
                    transclude: 'element',
                    restrict: 'A',
                    priority: 600,
                    terminal: true,
                    link: function(scope, element, attrs, ctrls, transcludeFn){
                        var watchFn = getterFn && getterFn(scope, element, attrs);
                        var childScope;
                        var childElement;
                        var previousElements;

                        elif[method](scope, watchFn, function(value){
                            if(value){
                                if(!childScope){
                                    childScope = scope.$new();
                                    transcludeFn(childScope, function(clone){
                                        clone[clone.length + 1] = $document[0].createComment(' end ' + name + ': ' + attrs[name] + ' ');
                                        childElement = clone;
                                        $animate.enter(clone, element.parent(), element);
                                    });
                                }
                            }
                            else {
                                if(childScope){
                                    childScope.$destroy();
                                    childScope = null;
                                }
                                if(previousElements){
                                    previousElements.remove();
                                    previousElements = null;
                                }
                                if(childElement){
                                    previousElements = getBlockElements(childElement);
                                    $animate.leave(previousElements, function(){
                                        previousElements = null;
                                    });
                                    childElement = null;
                                }
                            }
                        });
                    }
                };
            }
        ]);
    };

    // Reads the attribute given by `name` and converts it to a boolean.
    var getter = function(name){
        return [
            '$parse',
            function($parse){
                return function(scope, element, attrs){
                    var testFn = $parse(attrs[name]);
                    return function(){
                        return !!testFn(scope);
                    };
                };
            }
        ];
    };

    // We rely on the built-in `ng-if` directive to actually perform
    // the transclusion, and simply tie it in to the `elif` service.
    elif.directive('ngIf', [
        '$injector',
        'elif',
        function($injector, elif){
            var getterFn = $injector.invoke(getter('ngIf'));
            return {
                priority: 600,
                link: function(scope, element, attrs){
                    var watchFn = getterFn(scope, element, attrs);
                    elif.create(scope, watchFn);
                }
            }
        }
    ]);

    // Else-if and else perform their own transclusions.
    elifDirective('ngElseIf', 'extend', getter('ngElseIf'));
    elifDirective('ngElif', 'extend', getter('ngElif'));

    // Else doesn't take an argument.
    elifDirective('ngElse', 'fallthrough');
})();
angular.module('c')
    .directive('compareTo', function () {
        return {
            require: "ngModel",
            scope: {
                otherModelValue: "=compareTo"
            },
            link: function(scope, element, attributes, ngModel) {

                ngModel.$validators.compareTo = function(modelValue) {
                    return modelValue == scope.otherModelValue;
                };

                scope.$watch("otherModelValue", function() {
                    ngModel.$validate();
                });
            }
        };
    });
(function () {
    'use strict';

    angular.module('c')
        .directive('editor', editor);

    // https://github.com/wayou/wayou.github.io/issues/5
    var ckSimpleConfig = {
        height: 120,
        toolbarGroups: [
            {name: 'basicstyles', groups: ['basicstyles']},
            {name: 'paragraph', groups: ['list', 'align']},
            {name: 'styles', groups: ['styles', 'colors']},
            {name: 'insert', groups: ['insert']},
            // {name: 'tools', groups: ['tools']}
        ],
        removeButtons: 'Subscript,Superscript,Styles,Format,JustifyBlock,ShowBlocks,' +
            'Flash,HorizontalRule,Smiley,PageBreak,Iframe,Table'
    };

    /** @ngInject */
    function editor($compile, UIHelper) {
        return {
            restrict: 'E',
            scope: {
                model: '=ngModel',
                height: '=height'
            },
            require: ['^ngModel', '?^form'],
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {
                        var id = 'editor' + (new Date()).getTime() + (Math.floor(Math.random() * 100000));
                        var ngModelCtrl = r[0], formCtrl = r[1];
                        var vm = scope;
                        vm.onReady = UIHelper.onCKReady;


                        init();


                        function init() {
                            // scope.$on('$destroy', function () {
                            //     var editor = CKEDITOR.instances[id];
                            //     if (editor) editor.destroy();
                            // });

                            scope.$watch('model', function (newValue, oldValue) {
                                if (angular.isDefined(oldValue)) ngModelCtrl.$setTouched();
                            });

                            var elem;
                            if (angular.isDefined(iAttrs.simple)) {
                                vm.ckConfig = angular.copy(ckSimpleConfig);
                                if (vm.height) vm.ckConfig.height = vm.height;
                                elem = '<div ckeditor="ckConfig" ng-model="model" ready=onReady("' + id + '") id="' + id + '"></div>';
                            } else {
                                elem = '<div ckeditor ng-model="model" ready=onReady("' + id + '") id="' + id + '"></div>';
                            }
                            var layer = angular.element(elem);
                            iElement.append(layer);
                            $compile(iElement.contents())(scope);

                            checkValidity();

                            if (formCtrl) {
                                scope.$watch(function () {
                                    return formCtrl.$submitted;
                                }, function (submitted) {
                                    if (submitted) iElement.addClass('submitted')
                                });
                            }
                        }

                        function checkValidity() {
                            var valid = iAttrs.required ? (!!ngModelCtrl.$viewValue) : true;
                            ngModelCtrl.$setValidity('required', valid);
                        }
                    }
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .directive('requireMultiple', requireMultiple);

    /** @ngInject */
    function requireMultiple($parse) {
        return {
            require: 'ngModel',
            link: function postLink(scope, element, attrs, ngModel) {
                var require = $parse(attrs.requireMultiple)();
                if (require !== false) {
                    ngModel.$validators.required = function (value) {
                        return angular.isArray(value) && value.length > 0;
                    };
                }
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('scrollForm', scrollForm);

    /** @ngInject */
    function scrollForm($timeout, $anchorScroll, $location) {
        return {
            restrict: 'A',
            link: function (scope, elem) {
                elem.on('submit', function () {
                    $timeout(function(){
                        var firstInvalid = elem[0].querySelector('.ng-invalid');

                        if (firstInvalid) {
                            if ($location.hash() !== firstInvalid.id) {
                                $location.hash(firstInvalid.id);
                            }
                            $anchorScroll();
                            firstInvalid.focus();
                        }
                    });

                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('startDate', startDate);

    function startDate() {
        return {
            restrict: "A",
            require: "?ngModel",
            link: function (scope, element, attributes, ngModel) {
                function validateEndDate(endDate, startDate) {

                    if (endDate && startDate) {
                        startDate = new Date(startDate);
                        startDate.setHours(0, 0, 0, 0);
                        endDate = new Date(endDate);
                        endDate.setHours(0, 0, 0, 0);
                        return endDate >= startDate;
                    } else {
                        return true;
                    }
                }

                ngModel.$validators.startDate = function (modelValue) {
                    var startDate = Date.parse(attributes.startDate);
                    return validateEndDate(modelValue, startDate);
                };

                attributes.$observe('startDate', function (value) {
                    var startDate = Date.parse(value);
                    var endDate = Date.parse(ngModel.$viewValue);
                    ngModel.$setValidity("startDate", validateEndDate(endDate, startDate));
                });
            }
        };
    }
})();

// 因为点击选项造成的失去焦点，无法辨别
// (function () {
//     'use strict';
//
//     angular.module('c')
//         .directive('tagOnBlur', tagOnBlur);
//
//     /** @ngInject */
//     function tagOnBlur($timeout) {
//
//         var directive = {
//             require: 'uiSelect',
//             link: link
//         };
//
//         return directive;
//
//         function link(scope, elm, attrs, ctrl) {
//             scope.$on('uis:select', function (event, item) {
//                 ctrl.search = '';
//             });
//             ctrl.searchInput.on('blur', function (e) {
//                 if ((ctrl.items.length > 0 || ctrl.tagging.isActivated)) {
//                     $timeout(function () {
//                         ctrl.searchInput.triggerHandler('tagged');
//                         var newItem = ctrl.search;
//                         if (ctrl.tagging.fct) {
//                             newItem = ctrl.tagging.fct(newItem);
//                         }
//                         if (newItem) ctrl.select(newItem, true);
//                         ctrl.search = '';
//                     });
//                 }
//             });
//         }
//
//     }
//
// })();
(function () {
    'use strict';

    angular.module('c')
        .directive('autoCompleteDropdown', autoCompleteDropdown);

    /** @ngInject */
    function autoCompleteDropdown($compile, $sce, $document, $timeout, ArrayHelper, UIHelper) {
        return {
            restrict: 'A',
            scope: {
                // {data:array|function, trigLen:number}
                option: '=autoCompleteDropdown',
                inputText: '=ngModel'
            },
            require: 'ngModel',
            compile: function () {
                var template =
                    '<ul class="auto-complete-dropdown" is-open="isOpen"' +
                    ' style="visibility:hidden;display:block;top:-9999px;left:-9999px;">' +
                    '<li ng-repeat="i in items" ng-class="{\'selected\':$index===selectedIndex}" ' +
                    'ng-bind-html="highlight(i,inputText)" ng-click="itemSelected(i)"></li></ul>';

                var acdLinker = $compile(template);

                return function (scope, element, attrs, ctrl) {
                    var elem = angular.element(element[0]);
                    if (angular.isUndefined(scope.option.trigLen)) scope.option.trigLen = 1;
                    var acdScope = scope.$new(true);
                    acdScope.selectedIndex = 0;
                    var onSelect = scope.option.onSelect;
                    var acdLinkedScope;
                    var acd;
                    var observers = [];

                    init();


                    function init() {
                        elem.on('focus', show);
                        elem.on('keydown', onKeyDownFn);
                        acdScope.$watch('isOpen', openChanged);
                        $document.on('click', bodyHideAcdBind);
                        scope.$on('$destroy', function onDestroyTooltip() {
                            removeAcd();
                            acdScope = null;
                        });
                    }

                    function onKeyDownFn(e) {
                        if ([13, 38, 40].indexOf(e.keyCode) === -1) return;
                        if (acdLinkedScope && acdLinkedScope.items.length > 0) { // down arrow
                            var n = acdLinkedScope.items.length;
                            var i = acdLinkedScope.selectedIndex;
                            if (e.keyCode === 13) { // enter key
                                var selectedItem = acdLinkedScope.items[i];
                                $timeout(function () {
                                    itemSelected(selectedItem);
                                    elem.blur();
                                });
                                return;
                            }

                            if (e.keyCode === 40) {  // down arrow
                                i = (i + 1) % n;
                            } else if (e.keyCode === 38) { // up arrow
                                i = (n + i - 1) % n;
                            }
                            if (i !== acdLinkedScope.selectedIndex) {
                                acdLinkedScope.$evalAsync(function () {
                                    acdLinkedScope.selectedIndex = i;
                                });
                            }
                            return false;
                        }
                    }

                    function bodyHideAcdBind(e) {
                        if (!acdScope || !acdScope.isOpen || !acd) {
                            return;
                        }

                        if (!element[0].contains(e.target) && !acd[0].contains(e.target)) {
                            hide();
                        }
                    }

                    function inputTextChanged(newVal) {
                        if (newVal) {
                            // 包含中文，长度x2，即将中文字符看做2个字符
                            var len = /[\u3400-\u9FBF]/.test(newVal) ? newVal.length * 2 : newVal.length;
                            if (len >= scope.option.trigLen) {
                                if (angular.isFunction(scope.option.data)) {
                                    scope.option.data(newVal).then(function (value) {
                                        var nowVal = scope.inputText;
                                        if (!nowVal) len = 0;
                                        else len = /[\u3400-\u9FBF]/.test(nowVal) ? nowVal.length * 2 : nowVal.length;
                                        if (len >= scope.option.trigLen) {
                                            acdLinkedScope.inputText = nowVal;
                                            acdLinkedScope.items = value.data;
                                            hideItemsIfJustInputText();
                                        } else {
                                            acdLinkedScope.items = [];
                                        }
                                        acdLinkedScope.selectedIndex = 0;
                                    });
                                } else {
                                    acdLinkedScope.inputText = newVal;
                                    acdLinkedScope.items = ArrayHelper.filter(scope.option.data, function (itemStr) {
                                        return itemStr.indexOf(newVal) === 0;
                                    });
                                    hideItemsIfJustInputText();
                                    acdLinkedScope.selectedIndex = 0;
                                }
                            } else {
                                acdLinkedScope.items = [];
                                acdLinkedScope.selectedIndex = 0;
                            }
                        }
                    }

                    function hideItemsIfJustInputText() {
                        if (acdLinkedScope.items.length === 1) {
                            var item = acdLinkedScope.items[0].split(" ")[0];
                            var input = acdLinkedScope.inputText.split(" ")[0];
                            if (item === input) {
                                acdLinkedScope.items = [];
                            }
                        }
                    }

                    function openChanged(newVal, oldVal) {

                    }

                    function show() {
                        createAcd();
                        acdScope.$evalAsync(function () {
                            acdScope.isOpen = true;
                            positionAcd();
                        });
                    }

                    function hide() {
                        if (!acdScope) return;
                        acdScope.$evalAsync(function () {
                            acdScope.isOpen = false;
                            removeAcd();
                        });
                    }

                    function positionAcd() {
                        if (!acd || !acd.html()) {
                            return;
                        }
                        var hostEl = element;
                        var targetEl = acd;

                        var hostElPos;

                        hostElPos = UIHelper.offset(hostEl);

                        var top = (hostElPos.top + hostElPos.height) + 'px';
                        var left = hostElPos.left + 'px';
                        var width = hostElPos.width + 'px';
                        targetEl.css({top: top, left: left, width: width, visibility: 'visible'});
                    }

                    function createAcd() {
                        if (acd) return;

                        acdLinkedScope = acdScope.$new();
                        acdLinkedScope.highlight = highlight;
                        acdLinkedScope.itemSelected = itemSelected;
                        acd = acdLinker(acdLinkedScope, function (acd) {
                            $document.find('body').append(acd);
                        });
                        prepObservers();
                    }

                    function removeAcd() {
                        unregisterObservers();
                        if (acd) {
                            acd.remove();
                            acd = null;
                        }
                        if (acdLinkedScope) {
                            acdLinkedScope.$destroy();
                            acdLinkedScope = null;
                        }
                    }

                    function prepObservers() {
                        observers.push(
                            scope.$watch('inputText', inputTextChanged)
                        );
                        // observers.push(
                        //     scope.$watch('option.data', optionDataChanged, true)
                        // );
                    }

                    function unregisterObservers() {
                        if (observers.length) {
                            angular.forEach(observers, function (observer) {
                                observer();
                            });
                            observers.length = 0;
                        }
                    }

                    function highlight(text, search) {
                        if (angular.isDefined(scope.option.forFile)) {
                            text = text.split("#id:")[0];
                        }
                        if (!search) return $sce.trustAsHtml(text);
                        return $sce.trustAsHtml(text.replace(new RegExp(search, 'gi'), '<strong>$&</strong>'));
                    }

                    function itemSelected(itemText) {
                        var oldVal, newVal;
                        if (angular.isDefined(scope.option.forFile)) {
                            oldVal = scope.inputText;
                            newVal = itemText;
                        } else {
                            oldVal = scope.inputText.split(" ")[0];
                            newVal = itemText.split(" ")[0];
                        }

                        if (oldVal !== newVal) {
                            scope.inputText = newVal;
                            if (attrs.ngChange) {
                                $timeout(function () {
                                    scope.$parent.$eval(attrs.ngChange);
                                });
                            }
                            if (onSelect) {
                                $timeout(function () {
                                    onSelect(newVal);
                                });
                            }
                        }
                        hide();
                    }
                }

            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('c')
        .directive('dragScroll', DragScroll);

    DragScroll.$inject = ['$document', '$window', '$parse'];

    /* @ngInject */
    function DragScroll($document, $window, $parse) {
        //Usage:
        //<div drag-scroll>Lorem ipsum dolor sit amet</div>
        var directive = {
            restrict: 'A',
            link: function ($scope, $element, $attributes) {
                var enabled = true;
                var allowedClickOffset = 5;
                var pushed = false;
                var onDragStart = $parse($attributes.onDragStart);
                var onDragEnd = $parse($attributes.onDragEnd);
                var axis = $attributes.axis || false;
                var excludedClasses = $attributes.dragScrollExcludedClasses ? $attributes.dragScrollExcludedClasses.split(',') : [];
                var startClientX;
                var startClientY;
                var lastClientX;
                var lastClientY;

                $scope.$watch($attributes.dragScroll, function (newValue) {
                    enabled = newValue !== undefined ? newValue : true;
                });

                // Set event listeners
                $element.on('mousedown', handleMouseDown);

                // Set destroy listener
                $scope.$on('$destroy', destroy);

                /**
                 * Sets the event listeners for the mouseup and mousedown events
                 */
                function setDragListeners() {
                    angular.element($window).on('mouseup', handleMouseUp);
                    angular.element($window).on('mousemove', handleMouseMove);
                }

                /**
                 * Removes the event listeners for the mouseup and mousedown events
                 */
                function removeDragListeners() {
                    angular.element($window).off('mouseup', handleMouseUp);
                    angular.element($window).off('mousemove', handleMouseMove);
                }

                /**
                 * Handles mousedown event
                 * @param {object} e MouseDown event
                 */
                function handleMouseDown(e) {
                    if (enabled) {
                        for (var i = 0; i < excludedClasses.length; i++) {
                            if (angular.element(e.target).hasClass(excludedClasses[i])) {
                                return false;
                            }
                        }

                        $scope.$apply(function () {
                            onDragStart($scope);
                        });

                        // Set mouse drag listeners
                        setDragListeners();

                        // Set 'pushed' state
                        pushed = true;
                        lastClientX = startClientX = e.clientX;
                        lastClientY = startClientY = e.clientY;

                        clearSelection();

                        e.preventDefault();
                        e.stopPropagation();
                    }

                }

                /**
                 * Handles mouseup event
                 * @param {object} e MouseUp event
                 */
                function handleMouseUp(e) {
                    if (enabled) {
                        var selectable = (e.target.attributes && 'drag-scroll-text' in e.target.attributes);
                        var withinXConstraints = (e.clientX >= (startClientX - allowedClickOffset) && e.clientX <= (startClientX + allowedClickOffset));
                        var withinYConstraints = (e.clientY >= (startClientY - allowedClickOffset) && e.clientY <= (startClientY + allowedClickOffset));

                        // Set 'pushed' state
                        pushed = false;

                        // Check if cursor falls within X and Y axis constraints
                        if (selectable && withinXConstraints && withinYConstraints) {
                            // If so, select the text inside the target element
                            selectText(e.target);
                        }

                        $scope.$apply(function () {
                            onDragEnd($scope);
                        });

                        removeDragListeners();
                    }

                }

                /**
                 * Handles mousemove event
                 * @param {object} e MouseMove event
                 */
                function handleMouseMove(e) {
                    if (enabled) {
                        if (pushed) {
                            if (!axis || axis === 'x') {
                                $element[0].scrollLeft -= (-lastClientX + (lastClientX = e.clientX));
                            }
                            if (!axis || axis === 'y') {
                                $element[0].scrollTop -= (-lastClientY + (lastClientY = e.clientY));
                            }
                        }

                        e.preventDefault();
                    }
                }

                /**
                 * Destroys all the event listeners
                 */
                function destroy() {
                    $element.off('mousedown', handleMouseDown);
                    angular.element($window).off('mouseup', handleMouseUp);
                    angular.element($window).off('mousemove', handleMouseMove);
                }

                /**
                 * Selects text for a specific element
                 * @param {object} element Selected element
                 */
                function selectText(element) {
                    var range;
                    if ($window.document.selection) {
                        range = $window.document.body.createTextRange();
                        range.moveToElementText(element);
                        range.select();
                    } else if ($window.getSelection) {
                        range = $window.document.createRange();
                        range.selectNode(element);
                        $window.getSelection().addRange(range);
                    }
                }

                /**
                 * Clears text selection
                 */
                function clearSelection() {
                    if ($window.getSelection) {
                        if ($window.getSelection().empty) {  // Chrome
                            $window.getSelection().empty();
                        } else if ($window.getSelection().removeAllRanges) {  // Firefox
                            $window.getSelection().removeAllRanges();
                        }
                    } else if ($document.selection) {  // IE?
                        $document.selection.empty();
                    }
                }


            }
        };
        return directive;

    }

})();
angular.module('c')
    .directive('dateRange', function () {
        return {
            templateUrl: 'templates/date_range.html',
            restrict: 'E',
            replace: true,
            scope: {
                'name': '@',
                'dateRangeFilter': '=',
                'placeHolder': '@'
            }
            //, controller: function($scope) {}
        }
    });
angular.module('c')
    .directive('focusMe', function ($timeout) {
        return {
            link: function (scope, element, attrs) {
                scope.$watch(attrs.focusMe, function (value) {
                    if (value === true) {
                        $timeout(function () {
                            element[0].focus();
                        });
                    }
                });
            }
        };
    });
angular.module('c')
.directive('ngIndeterminate', function($compile) {
    return {
        restrict: 'A',
        link: function(scope, element, attributes) {
            scope.$watch(attributes['ngIndeterminate'], function (value) {
                element.prop('indeterminate', !!value);
            });
        }
    };
});
(function () {
    'use strict';

    angular.module('c')
        .directive('loadingContainer', function () {
            return {
                restrict: 'A',
                scope: false,
                link: function (scope, element, attrs) {
                    if (angular.isUndefined(attrs.loadingIcon)) attrs.loadingIcon = 'fa-spinner fa-2x fa-pulse';
                    if (angular.isUndefined(attrs.loadingTitle)) attrs.loadingTitle = '加载中，请稍后...';
                    var elem = '<div class="loading d-flex align-items-center justify-content-center">' +
                        '<div><i class="fa ' + attrs.loadingIcon + ' mr-2"></i>' +
                        (attrs.loadingTitle ? '<span>' + attrs.loadingTitle + '</span></div>' : '') +
                        '</div>';
                    var loadingLayer = angular.element(elem);
                    element.append(loadingLayer);
                    element.addClass('loading-container');
                    scope.$watch(attrs.loadingContainer, function (value) {
                        loadingLayer.toggleClass('ng-hide', !value);
                    });
                }
            };
        });

})();
angular.module('c').directive('modalDraggable', function ($document) {
    "use strict";
    return function (scope, element) {
        var startX = 0,
            startY = 0,
            x = 0,
            y = 0;
        element = angular.element(document.getElementsByClassName("modal-dialog"));
        if (element.length > 0) {
            element = element.last();


        }
        element.css({
            position: 'fixed',
            left: '50%',
            transform: 'translateX(-50%)'
        });

        var header = element.find('.modal-header');
        //var footer = element.find('.modal-footer');
        //var body = element.find('.modal-body');
        //
        //body.css({
        //    'min-width': '300px'
        //    //'max-height': '480px',
        //    //'overflow-y': 'scroll'
        //});

        header.on('mousedown', function (event) {
            // Prevent default dragging of selected content
            event.preventDefault();
            x = element.prop('offsetLeft');
            startX = event.screenX - x;
            startY = event.screenY - y;
            $document.on('mousemove', mousemove);
            $document.on('mouseup', mouseup);
        });


        function mousemove(event) {
            y = event.screenY - startY;
            x = event.screenX - startX;
            if (y + 60 <= 0 || y + 60 >= window.innerHeight ||
                x <= 0 || x >= window.innerWidth)
                return;

            element.css({
                top: y + 'px',
                left: x + 'px'
            });
        }

        function mouseup() {
            $document.unbind('mousemove', mousemove);
            $document.unbind('mouseup', mouseup);
        }
    };
});
angular.module('c')
    .directive('numberRange', function () {
        return {
            templateUrl: 'templates/number_range.html',
            restrict: 'E',
            replace: true,
            scope: {
                'name': '@',
                'numRangeFilter': '=',
                'placeHolder': '@'
            }
            //, controller: function($scope) {}
        }
    });
angular.module('c')
    .directive('selectOnClick', ['$window', function ($window) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('click', function () {
                if (!$window.getSelection().toString()) {
                    // Required for mobile Safari
                    this.setSelectionRange(0, this.value.length)
                }
            });
        }
    };
}]);
angular.module('c').controller('BasicDataDlgCtrl', function ($scope, $uibModalInstance, toaster, data) {
    $scope.data = {title: data.title};
    $scope.ok = function (data) {
        if ($scope.data_form.$valid) {
            $uibModalInstance.close(data);
        } else {
            $scope.data_form.submitted = true;
            toaster.warning('表单中有错误!');
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});
angular.module('c').controller('FloatDlgCtrl', function ($scope, $uibModalInstance, toaster, data) {
    $scope.pa = {title: data.title, label: data.label, icon: data.icon, label_time: data.label_time};

    $scope.put_int = data.put_int;
    $scope.ok = function (pa) {
        if ($scope.c_form.$valid) {
            $uibModalInstance.close(pa);
        } else {
            toaster.warning('请填写数值!');
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});
(function () {
    'use strict';

    angular.module('c')
        .controller('DeptMembersInCtrl', DeptMembersInCtrl)
    ;

    /** @ngInject */
    function DeptMembersInCtrl($scope, $q, Auth, UserInfo, UserDept, Dlg, Table, ArrayHelper, UIHelper, Api, Dept) {
        var vm = $scope;
        vm.edit = edit;
        vm.changePwd = changePwd;
        vm.show = show;

        init();


        function init() {
            UIHelper.loadTab(vm, 'in');

            $q.all([
                UserInfo.get({id: '-', op: 'form_options'}).$promise,
                Dept.query({op: 'led_by', type: 0}).$promise
            ]).then(function (respArray) {
                UserInfo.formHelper.bindAsyncOptions(vm, respArray[0]);
                vm.depts = respArray[1].items;

                var options = {
                    service: UserDept,
                    params: {op: 'dept_member_led_by'},
                    optColWidth: Table._3_BTN,
                    optInFront: true,
                    cols: [
                        {field: "sn", title: "序号", width: Table._2_CHAR},
                        {field: "name", title: "姓名", filter: {name: "text"}},
                        {field: "id_card", title: "身份证", filter: {id_card: "text"}},
                        {field: "phone", title: "手机号", filter: {phone: "text"}},
                        {field: "entry_time", title: "加入时间", width: Table._4_CHAR}
                    ]
                };

                Table.load(vm, options, Table.loadItem);
                vm.clearFilters = function () {
                    vm.tableParams.filter({'user_depts.dept_id': vm.tableParams.filter()['user_depts.dept_id']});
                }
            });
        }

        function edit(m) {
            Dlg.show({
                template: 'pages/personnel/userInfo/editDlg.html',
                ctrl: 'PersonnelUserEditCtrl',
                data: {
                    id: m.user_id, op: 'personnel_confirm'
                }, size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }

        function changePwd(m) {
            Dlg.show({
                template: 'pages/personnel/userInfo/changePasswordDlg.html',
                ctrl: 'changePasswordDlgCtrl',
                data: {user: {id: m.user_id}}
            }).then(function () {
                vm.tableReload();
            });
        }

        function show(m) {
            Dlg.show({
                template: 'pages/personnel/userInfo/showDlg.html',
                ctrl: 'PersonnelUserShowCtrl',
                data: {
                    id: m.user_id
                }, size: 'lg'
            });
        }
    }


})();

(function () {
    'use strict';

    angular.module('c')
        .controller('DeptMembersOutCtrl', DeptMembersOutCtrl);

    /** @ngInject */
    function DeptMembersOutCtrl($scope, UIHelper, $q, UserDept, Table, Dept) {
        var vm = $scope;

        init();


        function init() {
            UIHelper.loadTab(vm, 'out');

            $q.all([
                Dept.query({op: 'led_by', type: 0}).$promise
            ]).then(function (respArray) {
                vm.depts = respArray[0].items;
                var options = {
                    service: UserDept,
                    params: {op: 'dept_member_out'},
                    hideOpt: true,
                    optInFront: true,
                    cols: [
                        {title: '序号', field: 'sn'},
                        {title: '姓名', filter: {name: 'text'}, field: 'name'},
                        {title: '身份证', filter: {id_card: 'text'}, field: 'id_card'},
                        {title: '用户名', filter: {phone: 'text'}, field: 'phone'},
                        {title: '加入时间', field: 'entry_time'},
                        {title: '离开时间', field: 'leave_time'},
                    ]
                };

                Table.load(vm, options, Table.loadItem);
                vm.clearFilters = function () {
                    vm.tableParams.filter({'user_depts.dept_id': vm.tableParams.filter()['user_depts.dept_id']});
                }
            });
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('DeptMembersPartyInCtrl', DeptMembersPartyInCtrl)
    ;

    /** @ngInject */
    function DeptMembersPartyInCtrl($scope, $q, Auth, UserInfo, UserDept, Dlg, Table, ArrayHelper, UIHelper, Api, Dept) {
        var vm = $scope;
        vm.edit = edit;
        vm.changePwd = changePwd;
        vm.show = show;

        init();


        function init() {
            UIHelper.loadTab(vm, 'partyIn');

            $q.all([
                UserInfo.get({id: '-', op: 'form_options'}).$promise,
                Dept.query({op: 'led_by', type: 1}).$promise
            ]).then(function (respArray) {
                UserInfo.formHelper.bindAsyncOptions(vm, respArray[0]);
                vm.depts = respArray[1].items;

                var options = {
                    service: UserDept,
                    params: {op: 'dept_member_led_by'},
                    optColWidth: Table._3_BTN,
                    optInFront: true,
                    cols: [
                        {field: "sn", title: "序号", width: Table._2_CHAR},
                        {field: "name", title: "姓名", filter: {name: "text"}},
                        {field: "id_card", title: "身份证", filter: {id_card: "text"}},
                        {field: "phone", title: "手机号", filter: {phone: "text"}},
                        {field: "entry_time", title: "加入时间", width: Table._4_CHAR}
                    ]
                };

                Table.load(vm, options, Table.loadItem);
                vm.clearFilters = function () {
                    vm.tableParams.filter({'user_depts.dept_id': vm.tableParams.filter()['user_depts.dept_id']});
                }
            });
        }

        function edit(m) {
            Dlg.show({
                template: 'pages/personnel/userInfo/editDlg.html',
                ctrl: 'PersonnelUserEditCtrl',
                data: {
                    id: m.user_id, op: 'personnel_confirm'
                }, size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }

        function changePwd(m) {
            Dlg.show({
                template: 'pages/personnel/userInfo/changePasswordDlg.html',
                ctrl: 'changePasswordDlgCtrl',
                data: {user: {id: m.user_id}}
            }).then(function () {
                vm.tableReload();
            });
        }

        function show(m) {
            Dlg.show({
                template: 'pages/personnel/userInfo/showDlg.html',
                ctrl: 'PersonnelUserShowCtrl',
                data: {
                    id: m.user_id
                }, size: 'lg'
            });
        }
    }


})();

(function () {
    'use strict';

    angular.module('c')
        .controller('DeptMembersPartyOutCtrl', DeptMembersPartyOutCtrl);

    /** @ngInject */
    function DeptMembersPartyOutCtrl($scope, UIHelper, $q, UserDept, Table, Dept) {
        var vm = $scope;

        init();


        function init() {
            UIHelper.loadTab(vm, 'partyOut');

            $q.all([
                Dept.query({op: 'led_by', type: 1}).$promise
            ]).then(function (respArray) {
                vm.depts = respArray[0].items;
                var options = {
                    service: UserDept,
                    params: {op: 'dept_member_out'},
                    hideOpt: true,
                    optInFront: true,
                    cols: [
                        {title: '序号', field: 'sn'},
                        {title: '姓名', filter: {name: 'text'}, field: 'name'},
                        {title: '身份证', filter: {id_card: 'text'}, field: 'id_card'},
                        {title: '用户名', filter: {phone: 'text'}, field: 'phone'},
                        {title: '加入时间', field: 'entry_time'},
                        {title: '离开时间', field: 'leave_time'},
                    ]
                };

                Table.load(vm, options, Table.loadItem);
                vm.clearFilters = function () {
                    vm.tableParams.filter({'user_depts.dept_id': vm.tableParams.filter()['user_depts.dept_id']});
                }
            });
        }
    }

})();



(function () {
    'use strict';

    angular.module('c').controller('EDRCtrl', EDRCtrl);

    /** @ngInject */
    function EDRCtrl($uibModalInstance, FormHelper, FileHelper, DateHelper, data) {
        var vm = this;
        vm.title = data.title;
        vm.icon = data.icon ? data.icon : 'fa-bar-chart';
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            if (data.start) {
                vm.m = {start: data.start, end: data.end};
            } else {
                var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                vm.m = {start: new Date(y, m, 1), end: new Date(y, m + 1, 0)};
            }
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {start: DateHelper.date2Str(m.start), end: DateHelper.date2Str(m.end)};
                if (data.params) {
                    pa = angular.extend(pa, data.params);
                }
                FileHelper.dnExcel(data.url, pa, pa.start + '到' + pa.end + data.title + '.xls', function () {
                    $uibModalInstance.close();
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CommentDlgCtrl', CommentDlgCtrl);

    /** @ngInject */
    function CommentDlgCtrl($uibModalInstance, FormHelper, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.ok = ok;

        init();


        function init() {
            vm.m = {};
            vm.params = {
                title: data.title,
                label: data.label ? data.label : '理由',
                icon: data.icon ? data.icon : 'edit',
                withRate: data.withRate,
                notRequired: data.notRequired
            };
            if (data.withRate) {
                vm.satLvs = [
                    {id: 1, name: '非常不满意'},
                    {id: 2, name: '不满意'},
                    {id: 3, name: '较满意'},
                    {id: 4, name: '满意'},
                    {id: 5, name: '非常满意'}
                ];
            }
            if (data.text) {
                vm.m.opinion = data.text;
            }
        }

        function ok(m) {
            FormHelper.handleSubmit(vm, function () {
                if (data.withRate) {
                    vm.close(m);
                } else {
                    vm.close(m.opinion);
                }
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c').controller('imageCroppedUploadCtrl', imageCroppedUploadCtrl);

    /** @ngInject */
    function imageCroppedUploadCtrl($scope, $uibModalInstance, toaster, FileHelper, C, data) {
        var vm = $scope;
        vm.title = data.title;
        vm.width = data.width;
        vm.height = data.height;
        vm.m = {toUrl: FileHelper.urls.UPLOAD, croppedDataUrl: ''};
        vm.upload = upload;
        vm.cancel = $uibModalInstance.dismiss;

        function upload(m) {
            FileHelper.uploadCroppedImage(m).then(function (resp) {
                $uibModalInstance.close(resp.filename);
            }, function (errMsg) {
                toaster.error(errMsg);
            });
        }
    }

})();

//angular.module('c').controller('UploadImageDlg',
//    function ($scope, $uibModalInstance, Upload, C, dialogs) {
//        $scope.image = {progress: 0, height: 240};
//
//        $scope.upload = function (file, image, e) {
//            if (e && e[0] && e[0].$error == 'maxSize') {
//                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
//                return;
//            }
//
//            if (file == null) {
//                return;
//            }
//
//            Upload.upload({
//                url: C.URL.IMG_UPLOAD, file: file
//            }).progress(function (evt) {
//                image.progress = parseInt(100.0 * evt.loaded / evt.total);
//            }).success(function (resp) {
//                switch (resp.result) {
//                    case 0:
//                        image.progress = 0;
//                        image.link = resp.link;
//                        image.height = resp.height * 320 / resp.width;
//                        break;
//                    case 1:
//                        image.progress = 101;
//                        image.errorInfo = '服务器空间不足!';
//                        break;
//                }
//            }).error(function () {
//                image.progress = 102;
//                image.errorInfo = '服务器错误!';
//            });
//        };
//
//        $scope.insert = function (image) {
//            $uibModalInstance.close(image.link);
//        };
//
//        $scope.cancel = function () {
//            $uibModalInstance.dismiss('cancel');
//        };
//    });
angular.module('c').controller('UploadUserpicDlg',
    function ($scope, $uibModalInstance, Upload, C, data) {
        $scope.image = {progress: 0, croppedDataUrl: ''};

        $scope.upload = function (image) {
            var file = Upload.dataUrltoBlob(image.croppedDataUrl);

            if (!file.$error) {
                Upload.upload({
                    url: C.URL.IMG_UPLOAD, data: {file: file, is_user_photo: true, user_id: data.user_id}
                }).progress(function (evt) {
                    image.progress = parseInt(100.0 * evt.loaded / evt.total);
                }).success(function (resp) {
                    switch (resp.result) {
                        case 0:
                            image.progress = 0;
                            image.url = resp.url;
                            $uibModalInstance.close(image.url);
                            break;
                        case 1:
                            image.progress = 101;
                            image.errorInfo = '服务器空间不足!';
                            break;
                    }
                }).error(function () {
                    image.progress = 102;
                    image.errorInfo = '服务器错误!';
                });
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
(function () {
    'use strict';

    angular.module('c')
        .controller('HospitalBadgeFinishCtrl', HospitalBadgeFinishCtrl)


    ;
    /** @ngInject */
    function HospitalBadgeFinishCtrl($scope, Table, User, UIHelper, Dlg, FileHelper) {
        var vm = $scope;
        vm.zoomIn = zoomIn;
        vm.dnWorkPhoto = dnWorkPhoto;

        init();

        function init() {
            UIHelper.loadTab(vm, 'finish');

            var options = {
                service: User,
                params: {op: 'Badge', badge: User.BADGE.FINISH},
                optColWidth: Table._2_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: 'name', title: '姓名', filter: {name: 'text'}},
                    {field: 'username', title: '用户名', filter: {username: 'text'}},
                    {field: 'phone', title: '手机', filter: {phone: 'text'}},
                    {field: 'dept', title: '部门', filter: {dept: 'text'}}
                ]
            };

            Table.load(vm, options);
        }

        function dnWorkPhoto(m) {
            var pa = {
                name: m.dept.name + '-' + m.name + '-' + m.username + '.jpg',
                filename: m.work_photo,
                mime: 'image/jpg'
            };
            FileHelper.download1(User.urls.DN_WORK_PHOTO, pa);
        }

        function zoomIn(m) {
            if (m.work_photo) {
                Dlg.show({
                    template: 'pages/hospital_office/badge/preview.html',
                    ctrl: 'PhotoImgDlgCtrl',
                    data: {photo: m.work_photo}
                });
            } else {
                Dlg.w('用户没有上传工作照,请通知用户上传工作照');
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('HospitalBadgeMakingCtrl', HospitalBadgeMakingCtrl)


    ;
    /** @ngInject */
    function HospitalBadgeMakingCtrl($scope, Table, User, UIHelper, Dlg, FileHelper, $q) {
        var vm = $scope;
        var checker = null;
        vm.made = made;
        vm.dnWorkPhoto = dnWorkPhoto;
        vm.zoomIn = zoomIn;
        vm.passChecked = passChecked;

        init();

        function init() {
            UIHelper.loadTab(vm, 'making');

            var options = {
                service: User,
                params: {op: 'Badge', badge: User.BADGE.MAKING},
                optColWidth: Table._3_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: 'name', title: '姓名', filter: {name: 'text'}},
                    {field: 'username', title: '用户名', filter: {username: 'text'}},
                    {field: 'phone', title: '手机', filter: {phone: 'text'}},
                    {field: 'dept', title: '部门', filter: {dept: 'text'}}
                ]
            };

            Table.load(vm, options);
            checker = Table.loadMultiSelectedFn(vm);
        }

        function made(m) {
            var pa = {
                op: 'badge',
                badge: User.BADGE.RECEIVE
            };
            Dlg.confirm('确认<strong>' + m.name + '</strong>的胸牌制作完成了吗？', function (resp) {
                User.update({id: m.id}, pa).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '胸牌制作');

        }

        function dnWorkPhoto(m) {
            var pa = {
                name: m.dept.name + '-' + m.name + '-' + m.username + '.jpg',
                filename: m.work_photo,
                mime: 'image/jpg'
            };
            FileHelper.download1(User.urls.DN_WORK_PHOTO, pa);
        }

        function zoomIn(m) {
            if (m.work_photo) {
                Dlg.show({
                    template: 'pages/hospital_office/badge/preview.html',
                    ctrl: 'PhotoImgDlgCtrl',
                    data: {photo: m.work_photo}
                });
            } else {
                Dlg.w('用户没有上传工作照,请通知用户上传工作照');
            }
        }

        function passChecked() {
            var items = checker.getChecked();
            var userIds = [];
            var count = items.length;
            if (count === 0) {
                checker.clearChecked();
                Dlg.w("请至少选中一个待处理申请");
                return;
            }
            var defer = $q.defer();
            vm.tableParams.settings().$loading = true;
            angular.forEach(items, function (item) {
                userIds.push(item.id);
            });
            var pa = {
                userIds: userIds,
                badge: User.BADGE.RECEIVE
            };
            User.batchBadge(pa).$promise.then(function (resp) {
                Dlg.s(resp.msg);
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
            defer.resolve();
            checker.clearChecked();
            vm.tableReload();
            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('HospitalBadgePendingCtrl', HospitalBadgePendingCtrl)


    ;
    /** @ngInject */
    function HospitalBadgePendingCtrl($scope, Table, User, UIHelper, Dlg, FileHelper, $q) {
        var vm = $scope;
        var checker = null;
        vm.making = making;
        vm.zoomIn = zoomIn;
        vm.dnWorkPhoto = dnWorkPhoto;
        vm.passChecked = passChecked;

        init();

        function init() {
            UIHelper.loadTab(vm, 'pending');

            var options = {
                service: User,
                params: {op: 'Badge', badge: User.BADGE.PENDING},
                optColWidth: Table._3_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: 'name', title: '姓名', filter: {name: 'text'}},
                    {field: 'username', title: '用户名', filter: {username: 'text'}},
                    {field: 'phone', title: '手机', filter: {phone: 'text'}},
                    {field: 'dept', title: '部门', filter: {dept: 'text'}}
                ]
            };

            Table.load(vm, options);
            checker = Table.loadMultiSelectedFn(vm);
        }

        function dnWorkPhoto(m) {
            var pa = {
                name: m.dept.name + '-' + m.name + '-' + m.username + '.jpg',
                filename: m.work_photo,
                mime: 'image/jpg'
            };
            FileHelper.download1(User.urls.DN_WORK_PHOTO, pa);
        }

        function making(m) {
            if (m.work_photo) {
                Dlg.confirm('开始制作<strong>' + m.name + '</strong>的胸牌了吗？', function (resp) {
                    var pa = {
                        op: 'badge',
                        badge: User.BADGE.MAKING
                    };
                    User.update({id: m.id}, pa).$promise.then(function (resp) {
                        if (resp.msg) Dlg.s(resp.msg);
                        vm.tableReload();
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Dlg.e(data.msg);
                    });
                }, '制作胸牌');
            } else {
                Dlg.w('用户没有上传工作照,请通知用户上传工作照');
            }
        }

        function zoomIn(m) {
            if (m.work_photo) {
                Dlg.show({
                    template: 'pages/hospital_office/badge/preview.html',
                    ctrl: 'PhotoImgDlgCtrl',
                    data: {photo: m.work_photo}
                });
            } else {
                Dlg.w('用户没有上传工作照,请通知用户上传工作照');
            }
        }

        function passChecked() {
            var items = checker.getChecked();
            var userIds = [];
            var count = items.length;
            if (count === 0) {
                checker.clearChecked();
                Dlg.w("请至少选中一个待处理申请");
                return;
            }
            var defer = $q.defer();
            vm.tableParams.settings().$loading = true;
            angular.forEach(items, function (item) {
                userIds.push(item.id);
            });
            var pa = {
                userIds: userIds,
                badge: User.BADGE.MAKING
            };
            User.batchBadge(pa).$promise.then(function (resp) {
                Dlg.s(resp.msg);
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
            defer.resolve();
            checker.clearChecked();
            vm.tableReload();
            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('HospitalBadgeReceiveCtrl', HospitalBadgeReceiveCtrl)


    ;
    /** @ngInject */
    function HospitalBadgeReceiveCtrl($scope, Table, User, UIHelper, Dlg, FileHelper, $q) {
        var vm = $scope;
        var checker = null;
        vm.finish = finish;
        vm.zoomIn = zoomIn;
        vm.dnWorkPhoto = dnWorkPhoto;
        vm.passChecked = passChecked;

        init();

        function init() {
            UIHelper.loadTab(vm, 'receive');

            var options = {
                service: User,
                params: {op: 'Badge', badge: User.BADGE.RECEIVE},
                optColWidth: Table._3_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: 'name', title: '姓名', filter: {name: 'text'}},
                    {field: 'username', title: '用户名', filter: {username: 'text'}},
                    {field: 'phone', title: '手机', filter: {phone: 'text'}},
                    {field: 'dept', title: '部门', filter: {dept: 'text'}}
                ]
            };

            Table.load(vm, options);
            checker = Table.loadMultiSelectedFn(vm);
        }

        function finish(m) {
            Dlg.confirm('确认<strong>' + m.name + '</strong>的胸牌已经领取了吗？', function (resp) {
                var pa = {
                    op: 'badge',
                    badge: User.BADGE.FINISH
                };
                User.update({id: m.id}, pa).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '胸牌领取');

        }

        function zoomIn(m) {
            if (m.work_photo) {
                Dlg.show({
                    template: 'pages/hospital_office/badge/preview.html',
                    ctrl: 'PhotoImgDlgCtrl',
                    data: {photo: m.work_photo}
                });
            } else {
                Dlg.w('用户没有上传工作照,请通知用户上传工作照');
            }
        }

        function dnWorkPhoto(m) {
            var pa = {
                name: m.dept.name + '-' + m.name + '-' + m.username + '.jpg',
                filename: m.work_photo,
                mime: 'image/jpg'
            };
            FileHelper.download1(User.urls.DN_WORK_PHOTO, pa);
        }

        function passChecked() {
            var items = checker.getChecked();
            var userIds = [];
            var count = items.length;
            if (count === 0) {
                checker.clearChecked();
                Dlg.w("请至少选中一个待处理申请");
                return;
            }
            var defer = $q.defer();
            vm.tableParams.settings().$loading = true;
            angular.forEach(items, function (item) {
                userIds.push(item.id);
            });
            var pa = {
                userIds: userIds,
                badge: User.BADGE.FINISH
            };
            User.batchBadge(pa).$promise.then(function (resp) {
                Dlg.s(resp.msg);
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
            defer.resolve();
            checker.clearChecked();
            vm.tableReload();
            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('CallCenterNetworkSelfCtrl', CallCenterNetworkSelfCtrl);

    /** @ngInject */
    function CallCenterNetworkSelfCtrl($scope, $q, Auth, Dlg, UserInfo, ServiceRecord, Table, ArrayHelper, UIHelper) {
        var states = ServiceRecord.getStates();
        var account = Auth.getAccount();
        var STATE = ServiceRecord.STATE;
        var vm = $scope;
        vm.assign = assign;
        vm.unassign = unassign;
        vm.confirm = confirm;
        vm.show = show;
        vm.init = init;


        function init(tab) {
            UIHelper.loadTab(vm, tab);
            var options = {
                service: ServiceRecord,
                params: {
                    op: 'network_self', tab: tab
                },
                optInFront: true,
                optColWidth: Table._4_BTN,
                count: 30,
                cols: [
                    {title: '序号', field: 'sn', width: Table._1_CHAR}, //0
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {
                        field: "male",
                        title: "性别",
                        filter: {male: 'select'},
                        data: Table.getNgTableOpts(UserInfo.getSexes())
                    },
                    {field: "id_card", title: "身份证号", filter: {id_card: "text"}},
                    {
                        field: "handle_time",
                        title: "确认时间",
                        filter: {handle_time: "date_range"},
                        show: tab === 'handle'
                    }
                ]
            };

            Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn, loadItem);
            });
        }

        function loadItem(item) {
            item.state = ArrayHelper.getItem(item.state, states);
            item.handleable = item.handler_id === account.id;
        }

        function unassign(m) {
            Dlg.confirm('该操作会清空认领人，确定要撤销吗？', function () {
                var defer = $q.defer();
                ServiceRecord.update({id: m.id, op: 'info_confirm_unassign'}, {}).$promise.then(
                    function (resp) {
                        m.handler = m.handler_id = null;
                        m.state = STATE.PENDING_ASSIGN;
                        loadItem(m);
                        Dlg.s(resp.msg);
                    }, function (error) {
                        var resp = error.data;
                        if (resp.msg) Dlg.error(resp.msg);
                    }).finally(function () {
                    defer.resolve();
                });
                return defer.promise;
            });
        }

        function assign(m) {
            var defer = $q.defer();
            ServiceRecord.update({id: m.id, op: 'info_confirm_assign'}, {}).$promise.then(
                function (resp) {
                    m.handler_id = resp.handler.id;
                    m.handler = resp.handler;
                    m.state = resp.state;
                    loadItem(m);
                    Dlg.s(resp.msg);
                }, function (error) {
                    var resp = error.data;
                    if (resp.msg) Dlg.error(resp.msg);
                }).finally(function () {
                defer.resolve();
            });
            return defer.promise;
        }

        function confirm(m) {
            Dlg.show({
                template: 'pages/call_center/recordEditDlg.html',
                ctrl: 'CallCenterRecordEditCtrl',
                data: {
                    id: m.id
                }, size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }

        function show(m) {
            Dlg.show({
                template: 'pages/call_center/recordDetailDlg.html',
                ctrl: 'CallCenterRecordDetailCtrl',
                data: {
                    id: m.id
                }, size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CallCenterNetworkCtrl', CallCenterNetworkCtrl);

    /** @ngInject */
    function CallCenterNetworkCtrl($scope, $q, Auth, Dlg, UserInfo, ServiceRecord, Table, ArrayHelper, UIHelper) {
        var states = ServiceRecord.getStates();
        var account = Auth.getAccount();
        var STATE = ServiceRecord.STATE;
        var vm = $scope;
        vm.assign = assign;
        vm.unassign = unassign;
        vm.confirm = confirm;
        vm.show = show;

        init();


        function init() {
            UIHelper.loadTab(vm, 'total');
            var options = {
                service: ServiceRecord,
                params: {
                    op: 'network'
                },
                optInFront: true,
                optColWidth: Table._4_BTN,
                count: 30,
                cols: [
                    {title: '序号', field: 'sn', width: Table._1_CHAR}, //0
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {
                        field: "male",
                        title: "性别",
                        filter: {male: 'select'},
                        data: Table.getNgTableOpts(UserInfo.getSexes())
                    },
                    {field: "id_card", title: "身份证号", filter: {id_card: "text"}},
                    {
                        field: "state",
                        title: "确认状态",
                        filter: {state: "select"},
                        data: Table.getNgTableOpts(states)
                    },
                    {
                        field: "handle_time",
                        title: "确认时间",
                        filter: {handle_time: "date_range"}
                    },
                    {
                        field: "handler",
                        title: "确认人",
                        filter: {handler: "text"},
                    },
                ]
            };

            Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn, loadItem);
            });
        }

        function loadItem(item) {
            item.state = ArrayHelper.getItem(item.state, states);
            item.handleable = item.handler_id === account.id;
        }

        function unassign(m) {
            Dlg.confirm('该操作会清空认领人，确定要撤销吗？', function () {
                var defer = $q.defer();
                ServiceRecord.update({id: m.id, op: 'info_confirm_unassign'}, {}).$promise.then(
                    function (resp) {
                        m.handler = m.handler_id = null;
                        m.state = STATE.PENDING_ASSIGN;
                        loadItem(m);
                        Dlg.s(resp.msg);
                    }, function (error) {
                        var resp = error.data;
                        if (resp.msg) Dlg.error(resp.msg);
                    }).finally(function () {
                    defer.resolve();
                });
                return defer.promise;
            });
        }

        function assign(m) {
            var defer = $q.defer();
            ServiceRecord.update({id: m.id, op: 'info_confirm_assign'}, {}).$promise.then(
                function (resp) {
                    m.handler_id = resp.handler.id;
                    m.handler = resp.handler;
                    m.state = resp.state;
                    loadItem(m);
                    Dlg.s(resp.msg);
                }, function (error) {
                    var resp = error.data;
                    if (resp.msg) Dlg.error(resp.msg);
                }).finally(function () {
                defer.resolve();
            });
            return defer.promise;
        }

        function confirm(m) {
            Dlg.show({
                template: 'pages/call_center/recordEditDlg.html',
                ctrl: 'CallCenterRecordEditCtrl',
                data: {
                    id: m.id
                }, size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }

        function show(m) {
            Dlg.show({
                template: 'pages/call_center/recordDetailDlg.html',
                ctrl: 'CallCenterRecordDetailCtrl',
                data: {
                    id: m.id
                }, size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CallCenterApplyCtrl', CallCenterApplyCtrl);

    /** @ngInject */
    function CallCenterApplyCtrl($scope, $q, Dlg, CallCenterType, CallCenterTemplate, CallCenterRecord, UserInfo, Table,
                                 ArrayHelper, Api, Regex, FormHelper) {
        var vm = this;
        vm.clearQuery = clearQuery;
        vm.queryTemp = queryTemp;
        vm.insertText = insertText;
        vm.ok = ok;
        vm.chooseUser = chooseUser;
        vm.history = history;
        vm.show = show;
        vm.saveUser = saveUser;
        vm.reset = reset;
        vm.states = CallCenterRecord.getStates();
        vm.tempShow = false;

        init();


        function init() {
            vm.idCardAcdOption = {trigLen: 3, data: Api.idCardLoadFn, onSelect: chooseUser};
            vm.phoneRegex = Regex.PHONE;
            vm.pager = {count: 5, page: 1, total: 0};
            $q.all([
                CallCenterType.query({opt: '2'}).$promise,
                CallCenterTemplate.query({op: 'options'}).$promise,
            ]).then(function (respArray) {
                vm.types = respArray[0].items;
                vm.temps = respArray[1].items;
                vm.oldTemps = angular.copy(respArray[1].items);
                vm.m = {attachments: [], state: vm.states[1], types: []};
                vm.pager.page = 1;
                vm.pager.total = vm.temps.length;
                pageChanged();
            });
        }

        function reset() {
            vm.Form.$setUntouched();
            vm.Form.$setPristine();
            vm.m = {attachments: [], state: vm.states[1], types: []};
            vm.user = null;
            vm.idCard = null;
            clearQuery();
        }

        function pageChanged() {
            var pager = vm.pager;
            pager.data = vm.temps.slice((pager.page - 1) * pager.count, pager.page * pager.count);
        }

        function clearQuery() {
            vm.temps = vm.oldTemps
            vm.queryStr = '';
            vm.pager.page = 1;
            vm.pager.total = vm.temps.length;
            vm.tempShow = false;
            pageChanged();
        }

        function queryTemp(qStr) {
            if (qStr) {
                vm.queryStr = qStr;
                vm.tempShow = true;
                CallCenterTemplate.query({op: 'options', qStr: qStr}).$promise.then(function (resp) {
                    vm.temps = resp.items;
                    vm.pager.page = 1;
                    vm.pager.total = vm.temps.length;
                    pageChanged();
                });
            } else {
                clearQuery();
            }
        }

        function insertText(m, temp) {
            var str = '\n' + temp.body + '\n';
            var obj = document.getElementById('input-handle_content');
            obj.focus();
            if (document.selection) {
                var sel = document.selection.createRange();
                sel.text = str;
            } else if (typeof obj.selectionStart == 'number'
                && typeof obj.selectionEnd == 'number') {
                var startPos = obj.selectionStart, endPos = obj.selectionEnd, cursorPos = startPos, tmpStr = obj.value;
                obj.value = tmpStr.substring(0, startPos) + str
                    + tmpStr.substring(endPos, tmpStr.length);
                cursorPos += str.length;
                obj.selectionStart = obj.selectionEnd = cursorPos;
            } else {
                obj.value += str;
            }
            m.handle_content = obj.value;
        }

        function chooseUser(idCard) {
            if (idCard) {
                UserInfo.get({id: '-', id_card: idCard, op: 'by_id_card'}).$promise.then(function (resp) {
                    vm.user = resp.item;
                }, function (err) {
                    if (err.data.msg) Dlg.e(err.data.msg);
                });
            } else Dlg.e('请先输入身份证号码！');
        }

        function history(user) {
            if (user && user.id) {
                Dlg.show({
                    template: 'pages/call_center/phone/recordHistoryDlg.html',
                    ctrl: 'CallCenterRecordHistoryCtrl',
                    data: {
                        userId: user.id
                    }, size: 'lg'
                });
            } else {
                Dlg.e('暂时无法查询到用户信息')
            }
        }

        function show(user) {
            if (user && user.id) {
                Dlg.show({
                    template: 'pages/personnel/userInfo/editDlg.html',
                    ctrl: 'PersonnelUserEditCtrl',
                    data: {
                        id: user.id, op: 'personnel_confirm'
                    }, size: 'lg'
                }).then(function (resp) {
                    user.name = resp.name;
                    user.phone = resp.phone;
                    user.address = resp.address;
                });
            } else {
                Dlg.e('暂时无法查询到用户信息')
            }
        }

        function saveUser(user, cb) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    op: 'simple',
                    id_card: vm.idCard,
                    name: user.name,
                    phone: user.phone,
                    address: user.address,
                }
                var promise;
                if (user.id) { //修改
                    promise = UserInfo.update({id: user.id}, pa).$promise;
                } else { //添加
                    promise = UserInfo.save(pa).$promise;
                }
                promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    user.id = resp.user.id;
                    if (cb) cb();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }

        function ok(m, user) {
            return FormHelper.handleSubmit(vm, function (defer) {
                if (m.types.length == 0) {
                    Dlg.w('请选择咨询类型');
                    defer.reject();
                } else if (m.apply_content == null || m.apply_content == '') {
                    Dlg.w('请输入来电内容');
                    defer.reject();
                } else {
                    saveUser(user, function () {
                        if (user.id) {
                            var pa = {
                                types: ArrayHelper.map(m.types, function (type) {
                                    return type.id;
                                }),
                                apply_content: m.apply_content,
                                handle_content: m.handle_content,
                                user_id: user.id,
                                state: m.state.id
                            }
                            if (m.attachments.length > 0) {
                                pa.attachments = ArrayHelper.map(m.attachments, function (attachment) {
                                    return attachment.id ? {id: attachment.id} : {
                                        name: attachment.name, mime: attachment.mime,
                                        filename: attachment.filename, size: attachment.size
                                    };
                                });
                            }
                            CallCenterRecord.save(pa).$promise.then(function (resp) {
                                reset();
                            }, function (error) {
                                var data = error.data;
                                if (data.msg) Dlg.e(data.msg);
                            }).finally(function () {
                                defer.resolve();
                            });
                        } else {
                            Dlg.w('请先更新或增加用户信息');
                        }
                    });
                }

            });
        }
    }
})
();

(function () {
    'use strict';

    angular.module('c')
        .controller('CallCenterPhonePendingCtrl', CallCenterPhonePendingCtrl);

    /** @ngInject */
    function CallCenterPhonePendingCtrl($scope, Dlg, CallCenterRecord, Table, UIHelper) {
        var vm = $scope;
        vm.handle = handle;

        init();


        function init() {
            UIHelper.loadTab(vm, 'pending');
            var options = {
                service: CallCenterRecord,
                params: {
                    op: 'pending'
                },
                optInFront: true,
                optColWidth: Table._2_BTN,
                count: 10,
                cols: [
                    {title: '序号', field: 'sn', width: Table._1_CHAR}, //0
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {
                        field: "phone",
                        title: "电话",
                        filter: {phone: 'text'},
                    },
                    {field: "id_card", title: "身份证号", filter: {id_card: "text"}},
                    {
                        field: "types",
                        title: "咨询类型",
                        filter: {types: "text"}
                    },
                    {
                        field: "created_at",
                        title: "咨询时间",
                        filter: {created_at: "date_range"}
                    },
                    {
                        field: "handler",
                        title: "接听人",
                        filter: {handler: "text"},
                    },
                    {
                        field: "handle_time",
                        title: "处理时间",
                        filter: {handle_time: "date_range"}
                    },
                ]
            };

            Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn);
            });
        }

        function handle(m) {
            Dlg.addEdit(vm, 'pages/call_center/phone/recordEditDlg.html', 'CallCenterEditCtrl', m, {}, 'lg');
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CallCenterPhoneCtrl', CallCenterPhoneCtrl);

    /** @ngInject */
    function CallCenterPhoneCtrl($scope, $q, Auth, Dlg, UserInfo, CallCenterRecord, Table, ArrayHelper, UIHelper) {
        var states = CallCenterRecord.getStates();
        var vm = $scope;
        vm.handle = handle;
        vm.show = show;
        vm.download = download;

        init();


        function init() {
            UIHelper.loadTab(vm, 'record');
            var options = {
                service: CallCenterRecord,
                params: {
                    op: 'default'
                },
                optInFront: true,
                optColWidth: Table._2_BTN,
                count: 10,
                cols: [
                    {title: '序号', field: 'sn', width: Table._1_CHAR}, //0
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {
                        field: "phone",
                        title: "电话",
                        filter: {phone: 'text'},
                    },
                    {field: "id_card", title: "身份证号", filter: {id_card: "text"}},
                    {
                        field: "types",
                        title: "咨询类型",
                        filter: {types: "text"}
                    },
                    {
                        field: "created_at",
                        title: "咨询时间",
                        filter: {created_at: "date_range"}
                    },
                    {
                        field: "handler",
                        title: "接听人",
                        filter: {handler: "text"},
                    },
                    {
                        field: "handle_time",
                        title: "处理时间",
                        filter: {handle_time: "date_range"}
                    },
                    {
                        field: "state",
                        title: "状态",
                        filter: {state: "select"},
                        data: Table.getNgTableOpts(states)
                    }
                ]
            };

            Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn, loadItem);
            });
        }

        function loadItem(item) {
            item.state = ArrayHelper.getItem(item.state, states);
        }

        function handle(m) {
            Dlg.addEdit(vm, 'pages/call_center/phone/recordEditDlg.html', 'CallCenterEditCtrl', m, {}, 'lg');
        }

        function show(m) {
            Dlg.show({
                template: 'pages/call_center/phone/recordDetailDlg.html',
                ctrl: 'CallCenterDetailCtrl',
                data: {
                    id: m.id
                }, size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }

        function download() {
            Dlg.exportDR('/api/v1/service/call_center_records/export', '接听记录导出');
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CallCenterDetailCtrl', CallCenterDetailCtrl);

    /** @ngInject */
    function CallCenterDetailCtrl($uibModalInstance, ArrayHelper, Dlg, CallCenterRecord, FileHelper, Api, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data.id);


        function init(id) {
            if (id) {
                vm.loading = true;
                vm.m = {id: id};
                CallCenterRecord.get({id: id}).$promise.then(function (resp) {
                    vm.m = resp.item;
                    vm.m.apply_content = Api.fixText(vm.m.apply_content);
                    vm.m.handle_content = Api.fixText(vm.m.handle_content);
                }, function (err) {
                    Dlg.error(err.data.msg);
                    vm.cancel();
                }).finally(function () {
                    vm.loading = false;
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CallCenterEditCtrl', CallCenterEditCtrl);

    /** @ngInject */
    function CallCenterEditCtrl($uibModalInstance, $q, $timeout, ArrayHelper, Dlg, CallCenterRecord, CallCenterType,
                                CallCenterTemplate, FileHelper, data
    ) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.pageChanged = pageChanged;
        vm.clearQuery = clearQuery;
        vm.queryTemp = queryTemp;
        vm.insertText = insertText;


        init(data.id);


        function init(id) {
            vm.pager = {count: 5, page: 1, total: 0};
            $q.all([
                CallCenterType.query({opt: '2'}).$promise,
                CallCenterTemplate.query({op: 'options'}).$promise,
            ]).then(function (respArray) {
                vm.types = respArray[0].items;
                vm.temps = respArray[1].items;
                vm.oldTemps = angular.copy(respArray[1].items);
                vm.pager.page = 1;
                vm.pager.total = vm.temps.length;
                pageChanged();
                if (id) {
                    vm.loading = true;

                    CallCenterRecord.get({id: id}).$promise.then(function (resp) {
                        vm.m = resp.item;
                        var backup = vm.m.types;
                        vm.m.types = [];
                        $timeout(function () {
                            var types = [];
                            angular.forEach(backup, function (t) {
                                var type = ArrayHelper.getItem(t.id, vm.types);
                                if (type) {
                                    types.push(type);
                                }
                            });
                            vm.m.types = types;
                        });
                    }, function (err) {
                        Dlg.error(err.data.msg);
                        vm.cancel();
                    }).finally(function () {
                        vm.loading = false;
                    });
                }
            });
        }

        function pageChanged() {
            var pager = vm.pager;
            pager.data = vm.temps.slice((pager.page - 1) * pager.count, pager.page * pager.count);
        }

        function clearQuery() {
            vm.temps = vm.oldTemps
            vm.queryStr = '';
            vm.pager.page = 1;
            vm.pager.total = vm.temps.length;
            pageChanged();
        }

        function queryTemp(qStr) {
            if (qStr) {
                vm.queryStr = qStr;
                CallCenterTemplate.query({op: 'options', qStr: qStr}).$promise.then(function (resp) {
                    vm.temps = resp.items;
                    vm.pager.page = 1;
                    vm.pager.total = vm.temps.length;
                    pageChanged();
                });
            } else {
                clearQuery();
            }
        }

        function insertText(m, temp) {
            var str = '\n' + temp.body + '\n';
            var obj = document.getElementById('input-handle_content');
            obj.focus();
            if (document.selection) {
                var sel = document.selection.createRange();
                sel.text = str;
            } else if (typeof obj.selectionStart == 'number'
                && typeof obj.selectionEnd == 'number') {
                var startPos = obj.selectionStart, endPos = obj.selectionEnd, cursorPos = startPos, tmpStr = obj.value;
                obj.value = tmpStr.substring(0, startPos) + str
                    + tmpStr.substring(endPos, tmpStr.length);
                cursorPos += str.length;
                obj.selectionStart = obj.selectionEnd = cursorPos;
            } else {
                obj.value += str;
            }
            m.handle_content = obj.value;
        }


        function ok(m) {
            return Dlg.addEditOk(vm, CallCenterRecord, function () {
                var pa = {
                    types: ArrayHelper.map(m.types, function (type) {
                        return type.id;
                    }),
                    apply_content: m.apply_content,
                    handle_content: m.handle_content
                }
                if (m.attachments.length > 0) {
                    pa.attachments = ArrayHelper.map(m.attachments, function (attachment) {
                        return attachment.id ? {id: attachment.id} : {
                            name: attachment.name, mime: attachment.mime,
                            filename: attachment.filename, size: attachment.size
                        };
                    });
                }
                return pa;
            });
        }
    }

})();

angular.module('c')
    .controller('CallCenterRecordHistoryCtrl', CallCenterRecordHistoryCtrl);

/** @ngInject */
function CallCenterRecordHistoryCtrl($scope, $uibModalInstance, $q, Auth, Dlg, UserInfo, CallCenterRecord, Table, ArrayHelper, data) {
    var states = CallCenterRecord.getStates();
    var vm = $scope;
    vm.handle = handle;
    vm.show = show;
    vm.cancel = $uibModalInstance.dismiss;
    vm.close = $uibModalInstance.close;

    init();


    function init() {
        var options = {
            service: CallCenterRecord,
            params: {
                op: 'user', userId: data.userId
            },
            optInFront: true,
            optColWidth: Table._2_BTN,
            count: 10,
            cols: [
                {title: '序号', field: 'sn', width: Table._1_CHAR}, //0
                {field: "name", title: "名称", filter: {name: "text"}},
                {
                    field: "phone",
                    title: "电话",
                    filter: {phone: 'text'},
                },
                {field: "id_card", title: "身份证号", filter: {id_card: "text"}},
                {
                    field: "types",
                    title: "咨询类型",
                    filter: {types: "text"}
                },
                {
                    field: "created_at",
                    title: "咨询时间",
                    filter: {created_at: "date_range"}
                },
                {
                    field: "handler",
                    title: "接听人",
                    filter: {handler: "text"},
                },
                {
                    field: "handle_time",
                    title: "处理时间",
                    filter: {handle_time: "date_range"}
                },
                {
                    field: "state",
                    title: "状态",
                    filter: {state: "select"},
                    data: Table.getNgTableOpts(states)
                }
            ]
        };

        Table.load(vm, options, function (resp, startSn) {
            Table.loadItem(resp, startSn, loadItem);
        });
    }

    function loadItem(item) {
        item.state = ArrayHelper.getItem(item.state, states);
    }

    function handle(m) {
        Dlg.addEdit(vm, 'pages/call_center/phone/recordEditDlg.html', 'CallCenterEditCtrl', m, {}, 'lg');
    }

    function show(m) {
        Dlg.show({
            template: 'pages/call_center/phone/recordDetailDlg.html',
            ctrl: 'CallCenterDetailCtrl',
            data: {
                id: m.id
            }, size: 'lg'
        }).then(function () {
            vm.tableReload();
        });
    }
}
(function () {
    'use strict';

    angular.module('c')
        .controller('CallCenterStaCtrl', CallCenterStaCtrl);

    /** @ngInject */
    function CallCenterStaCtrl($scope, $timeout, $q, DateHelper, CallCenterRecord, FileHelper, Dlg) {
        var vm = $scope;
        vm.download = download;
        vm.loadData = loadData;


        init();

        function init() {
            var date = new Date(), y = date.getFullYear(), m = date.getMonth();
            vm.m = {
                start: new Date(y, m, 1),
                end: new Date(y, m + 1, 0)
            };

            $scope.$watch('m', function (m) {
                var old = m;
                $timeout(function () {
                    if (old = vm.m) {
                        loadData();
                    }
                }, 1000);
            }, true);
        }

        function loadData() {
            if (checkParams()) {
                vm.loading = true;
                var params = {
                    start: DateHelper.date2Str(vm.m.start),
                    end: DateHelper.date2Str(vm.m.end),
                    op: 'sta'
                };
                CallCenterRecord.sta(params).$promise.then(function (resp) {
                    vm.total = resp.total;
                    vm.types = resp.types;
                    vm.persons = resp.persons;
                    vm.loading = false;
                }, function (error) {
                    vm.loading = false;
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }
        }

        function download() {
            if (checkParams()) {
                var defer = $q.defer();
                var params = {
                    start: DateHelper.date2Str(vm.m.start),
                    end: DateHelper.date2Str(vm.m.end),
                    op: 'sta',
                    download: true
                };
                params.title = params.start + '至' + params.end + '报表统计';
                FileHelper.dnExcel('/api/v1/service/call_center_records/sta', params, params.title + '.xls')
                    .finally(function () {
                        defer.resolve();
                    });
                return defer.promise;
            }
        }

        function checkParams() {
            var check = false;
            if (!vm.m.start || !vm.m.end) {
                Dlg.w('请填入正确的开始时间和结束时间');
            } else {
                check = true;
            }
            return check;
        }

    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CallCenterTemplateCtrl', CallCenterTemplateCtrl);

    /** @ngInject */
    function CallCenterTemplateCtrl($scope, Dlg, Api, CallCenterTemplate, Table, UIHelper) {
        var vm = $scope;
        vm.addEdit = addEdit;
        vm.remove = remove;
        vm.disable = disable;

        init();


        function init() {
            UIHelper.loadTab(vm, 'template');
            var options = {
                service: CallCenterTemplate,
                params: {
                    op: 'default'
                },
                optInFront: true,
                optColWidth: Table._3_BTN,
                count: 10,
                cols: [
                    {field: 'sorting', title: '序号', width: Table._1_CHAR},
                    {field: "type", title: "类型", filter: {type: "text"}, width: 30},
                    {field: "body", title: "内容", filter: {body: 'text'}},
                ]
            };

            Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn);
            });
        }

        function addEdit(m) {
            Dlg.addEdit(vm, 'pages/call_center/phone/templateEditDlg.html', 'CallCenterTemplateEditCtrl', m);
        }

        function disable(m) {
            Api.setDisable(CallCenterTemplate, m);
        }


        function remove(m) {
            Dlg.confirm('确定要删除模板吗？', function () {
                CallCenterTemplate.delete({id: m.id}).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            });
        }

    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CallCenterTemplateEditCtrl', CallCenterTemplateEditCtrl);

    /** @ngInject */
    function CallCenterTemplateEditCtrl($uibModalInstance, Dlg, CallCenterType, CallCenterTemplate, data) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;


        init(data.id);


        function init(id) {
            vm.loading = true;
            CallCenterType.query({opt: '2'}, function (resp) {
                vm.types = resp.items;
                if (id) {
                    CallCenterTemplate.get({id: id}, function (resp) {
                        vm.m = resp.item;
                        vm.loading = false;
                    });
                } else {
                    vm.m = {sorting: 100};
                    vm.loading = false;
                }
            });

        }


        function ok(m) {
            return Dlg.addEditOk(vm, CallCenterTemplate, function () {
                var pa = {
                    type_id: m.type.id,
                    body: m.body,
                    sorting: m.sorting
                }
                return pa;
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('InfoCensusPhoneCtrl', InfoCensusPhoneCtrl);

    /** @ngInject */
    function InfoCensusPhoneCtrl($scope, $q, Auth, Dlg, UserInfo, ServiceRecord, Table, ArrayHelper, FileHelper,
                                 ServiceActivity, UIHelper, Company) {
        var states = ServiceRecord.getStatesForInfoConfirm();
        var account = Auth.getAccount();
        var STATE = ServiceRecord.STATE;
        var vm = $scope;
        vm.assign = assign;
        vm.unassign = unassign;
        vm.confirm = confirm;
        vm.unconfirm = unconfirm;
        vm.show = show;
        vm.download = download;
        vm.download2 = download2;
        vm.download3 = download3;
        vm.exportError = exportError;
        vm.activitySelectedFn = activitySelectedFn;
        vm.companySelectedFn = companySelectedFn;
        vm.showFd = showFd;
        vm.showOlder = showOlder;
        vm.showQuestion = showQuestion;
        var optionFn;

        init();


        function init() {
            UIHelper.loadTab(vm, 'all');
            $q.all([
                Company.query({op: 'manage_option'}).$promise,
                ServiceActivity.query({op: 'info_option'}).$promise
            ]).then(function (respArray) {
                vm.companies = respArray[0].items;
                vm.companies.splice(0, 0, {id: 0, name: '全部单位'});
                vm.company = vm.companies[0];
                vm.activities = respArray[1].items;
                vm.activity = null;
                if (vm.activities.length > 0) {
                    vm.activity = vm.activities[0];
                }
                var options = {
                    service: ServiceRecord,
                    params: {
                        op: 'info_confirm',
                        activity_id: vm.activity ? vm.activity.id : null,
                        company_id: vm.company.id
                    },
                    filter: {'has_error': 0, 'hospital': false},
                    optInFront: true,
                    optColWidth: Table._4_BTN,
                    count: 30,
                    cols: [
                        {title: '序号', field: 'sn', width: Table._1_CHAR}, //0
                        {field: "name", title: "名称", filter: {name: "text"}},
                        {
                            field: "male",
                            title: "性别",
                            filter: {male: 'select'},
                            data: Table.getNgTableOpts(UserInfo.getSexes())
                        },
                        {field: "id_card", title: "身份证号", filter: {id_card: "text"}},
                        {
                            field: "state",
                            title: "确认状态",
                            filter: {state: "select"},
                            data: Table.getNgTableOpts(states)
                        },
                        {
                            field: "handle_time",
                            title: "确认时间",
                            filter: {handle_time: "date_range"}
                        },
                        {
                            field: "handler",
                            title: "确认人",
                            filter: {handler: "text"},
                        },
                    ]
                };

                optionFn = Table.load(vm, options, function (resp, startSn) {
                    vm.activity = resp.activity;
                    Table.loadItem(resp, startSn, loadItem);
                }).options;

                vm.clearFilters = function () {
                    vm.tableParams.filter({
                        'has_error': vm.tableParams.filter()['has_error'],
                        'fd': vm.tableParams.filter()['fd'],
                        'hospital': vm.tableParams.filter()['hospital']
                    });
                }
            });
        }

        function activitySelectedFn(activity) {
            optionFn().params['activity_id'] = activity.id;
            vm.tableParams.page(1);
            vm.tableReload();
        }

        function companySelectedFn(activity) {
            optionFn().params['company_id'] = activity.id;
            vm.tableParams.page(1);
            vm.tableReload();
        }

        function loadItem(item) {
            item.state = ArrayHelper.getItem(item.state, states);
            item.handleable = item.handler_id === account.id;
        }

        function unassign(m) {
            Dlg.confirm('该操作会清空认领人，确定要撤销吗？', function () {
                var defer = $q.defer();
                ServiceRecord.update({id: m.id, op: 'info_confirm_unassign'}, {}).$promise.then(
                    function (resp) {
                        m.handler = m.handler_id = null;
                        m.state = STATE.PENDING_ASSIGN;
                        loadItem(m);
                        Dlg.s(resp.msg);
                    }, function (error) {
                        var resp = error.data;
                        if (resp.msg) Dlg.error(resp.msg);
                    }).finally(function () {
                    defer.resolve();
                });
                return defer.promise;
            });
        }

        function showQuestion(m) {
            Dlg.show({
                template: 'pages/info_census/phone/questionDlg.html',
                ctrl: 'QuestionDlgCtrl',
                data: {
                    id: m.user.id,
                    serviceRecordId: m.id,
                    handlerId: m.handler_id
                }, size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }

        function assign(m) {
            var defer = $q.defer();
            ServiceRecord.update({id: m.id, op: 'info_confirm_assign'}, {}).$promise.then(
                function (resp) {
                    m.handler_id = resp.handler.id;
                    m.handler = resp.handler;
                    m.state = resp.state;
                    loadItem(m);
                    Dlg.s(resp.msg);
                }, function (error) {
                    var resp = error.data;
                    if (resp.msg) Dlg.error(resp.msg);
                }).finally(function () {
                defer.resolve();
            });
            return defer.promise;
        }

        function confirm(m, type) {
            var show;
            if (type === 2) {
                show = {
                    template: 'pages/info_census/phone/questionDlg.html',
                    ctrl: 'QuestionDlgCtrl',
                    data: {
                        id: m.user.id,
                        serviceRecordId: m.id,
                    }, size: 'lg'
                }
            } else {
                show = {
                    template: 'pages/personnel/userInfo/editDlg.html',
                    ctrl: 'PersonnelUserEditCtrl',
                    data: {
                        id: m.user.id,
                        op: 'info_confirm',
                        serviceRecordId: m.id,
                        phoneConfirm: true,
                        phoneConfirm1: m.activity_id == 2
                    }, size: 'lg'
                }
            }
            Dlg.show(show).then(function () {
                vm.tableReload();
            });
        }


        function unconfirm(m) {
            var defer = $q.defer();
            ServiceRecord.update({id: m.id, op: 'info_unconfirm'}, {}).$promise.then(
                function (resp) {
                    m.state = STATE.PENDING;
                    loadItem(m);
                    Dlg.s(resp.msg);
                }, function (error) {
                    var resp = error.data;
                    if (resp.msg) Dlg.error(resp.msg);
                }).finally(function () {
                defer.resolve();
            });
            return defer.promise;
        }

        function show(m) {
            Dlg.show({
                template: 'pages/personnel/userInfo/showDlg.html',
                ctrl: 'PersonnelUserShowCtrl',
                data: {
                    id: m.user_id
                }, size: 'lg'
            });
        }

        function download() {
            if (vm.activity) {
                var defer = $q.defer();
                FileHelper.dnExcel(ServiceRecord.STA_URL, {activity_id: vm.activity.id}, '电话信息确认统计.xls')
                    .finally(function () {
                        defer.resolve();
                    });
                return defer.promise;
            }
        }

        function download2() {
            var defer = $q.defer();
            FileHelper.dnExcel(ServiceRecord.STA_DETAIL_URL, {}, '电话信息确认回答人数统计.xls')
                .finally(function () {
                    defer.resolve();
                });
            return defer.promise;
        }

        function download3() {
            var defer = $q.defer();
            FileHelper.dnExcel(ServiceRecord.STA_EC_URL, {}, '养老需求详情.xls')
                .finally(function () {
                    defer.resolve();
                });
            return defer.promise;
        }

        function exportError() {
            if (vm.activity) {
                var defer = $q.defer();
                FileHelper.dnExcel(ServiceRecord.ERROR_EXPORT, {
                    activity_id: vm.activity.id,
                    company_id: vm.company.id
                }, '无法确认信息名单.xls')
                    .finally(function () {
                        defer.resolve();
                    });
                return defer.promise;
            }
        }

        function showFd(m) {
            Dlg.show({
                template: 'pages/personnel/userInfo/showFdDlg.html',
                ctrl: 'PersonnelUserShowFdCtrl',
                data: {
                    id: m.user_id
                }, size: 'md'
            });
        }

        function showOlder(m) {
            Dlg.show({
                template: 'pages/personnel/userInfo/showOlderDlg.html',
                ctrl: 'PersonnelUserShowOlderCtrl',
                data: {
                    id: m.user_id
                }, size: 'md'
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('InfoCensusPhoneAssignCtrl', InfoCensusPhoneAssignCtrl);

    /** @ngInject */
    function InfoCensusPhoneAssignCtrl($scope, $q, Auth, Dlg, UserInfo, ServiceRecord, Table, ArrayHelper, FileHelper,
                                       ServiceActivity, UIHelper, Company) {
        var states = ServiceRecord.getStatesForInfoConfirm();
        var account = Auth.getAccount();
        var STATE = ServiceRecord.STATE;
        var vm = $scope;
        vm.init = init;
        vm.assign = assign;
        vm.unassign = unassign;
        vm.confirm = confirm;
        vm.unconfirm = unconfirm;
        vm.show = show;
        vm.activitySelectedFn = activitySelectedFn;
        vm.companySelectedFn = companySelectedFn;
        vm.showFd = showFd;
        vm.showOlder = showOlder;
        vm.showQuestion = showQuestion;
        var optionFn;


        function init(tab) {
            UIHelper.loadTab(vm, tab);
            $q.all([
                Company.query({op: 'manage_option'}).$promise,
                ServiceActivity.query({op: 'info_option'}).$promise
            ]).then(function (respArray) {
                vm.companies = respArray[0].items;
                vm.companies.splice(0, 0, {id: 0, name: '全部单位'});
                vm.company = vm.companies[0];
                vm.activities = respArray[1].items;
                vm.activity = null;
                if (vm.activities.length > 0) {
                    vm.activity = vm.activities[0];
                }
                var options = {
                    service: ServiceRecord,
                    params: {op: 'info_confirm_self', activity_id: vm.activity ? vm.activity.id : null, tab: tab},
                    filter: {'has_error': 0, 'fd': false, 'hospital': false},
                    optInFront: true,
                    optColWidth: Table._4_BTN,
                    count: 30,
                    cols: [
                        {title: '序号', field: 'sn', width: Table._1_CHAR}, //0
                        {field: "name", title: "名称", filter: {name: "text"}},
                        {
                            field: "male",
                            title: "性别",
                            filter: {male: 'select'},
                            data: Table.getNgTableOpts(UserInfo.getSexes())
                        },
                        {field: "id_card", title: "身份证号", filter: {id_card: "text"}},
                        {
                            field: "handle_time",
                            title: "确认时间",
                            filter: {handle_time: "date_range"},
                            show: tab === 'handle'
                        }
                    ]
                };

                optionFn = Table.load(vm, options, function (resp, startSn) {
                    vm.activity = resp.activity;
                    Table.loadItem(resp, startSn, loadItem);
                }).options;

                vm.clearFilters = function () {
                    vm.tableParams.filter({
                        'has_error': vm.tableParams.filter()['has_error'],
                        'fd': vm.tableParams.filter()['fd'],
                        'hospital': vm.tableParams.filter()['hospital']
                    });
                }
            });
        }

        function activitySelectedFn(activity) {
            optionFn().params['activity_id'] = activity.id;
            vm.tableParams.page(1);
            vm.tableReload();
        }

        function companySelectedFn(activity) {
            optionFn().params['company_id'] = activity.id;
            vm.tableParams.page(1);
            vm.tableReload();
        }

        function loadItem(item) {
            item.state = ArrayHelper.getItem(item.state, states);
            item.handleable = item.handler_id === account.id;
        }

        function unassign(m) {
            Dlg.confirm('该操作会清空认领人，确定要撤销吗？', function () {
                var defer = $q.defer();
                ServiceRecord.update({id: m.id, op: 'info_confirm_unassign'}, {}).$promise.then(
                    function (resp) {
                        m.handler = m.handler_id = null;
                        m.state = STATE.PENDING_ASSIGN;
                        loadItem(m);
                        Dlg.s(resp.msg);
                    }, function (error) {
                        var resp = error.data;
                        if (resp.msg) Dlg.error(resp.msg);
                    }).finally(function () {
                    defer.resolve();
                });
                return defer.promise;
            });
        }

        function assign(m) {
            var defer = $q.defer();
            ServiceRecord.update({id: m.id, op: 'info_confirm_assign'}, {}).$promise.then(
                function (resp) {
                    m.handler_id = resp.handler.id;
                    m.handler = resp.handler;
                    m.state = resp.state;
                    loadItem(m);
                    Dlg.s(resp.msg);
                }, function (error) {
                    var resp = error.data;
                    if (resp.msg) Dlg.error(resp.msg);
                }).finally(function () {
                defer.resolve();
            });
            return defer.promise;
        }

        function confirm(m, type) {
            var show;
            if (type === 2) {
                show = {
                    template: 'pages/info_census/phone/questionDlg.html',
                    ctrl: 'QuestionDlgCtrl',
                    data: {
                        id: m.user.id,
                        serviceRecordId: m.id,
                    }, size: 'lg'
                }
            } else {
                show = {
                    template: 'pages/personnel/userInfo/editDlg.html',
                    ctrl: 'PersonnelUserEditCtrl',
                    data: {
                        id: m.user.id,
                        op: 'info_confirm',
                        serviceRecordId: m.id,
                        phoneConfirm: true,
                        phoneConfirm1: m.activity_id == 2
                    }, size: 'lg'
                }
            }
            Dlg.show(show).then(function () {
                vm.tableReload();
            });
        }

        function showQuestion(m) {
            Dlg.show({
                template: 'pages/info_census/phone/questionDlg.html',
                ctrl: 'QuestionDlgCtrl',
                data: {
                    id: m.user.id,
                    serviceRecordId: m.id,
                    handlerId: m.handler_id
                }, size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }


        function unconfirm(m) {
            var defer = $q.defer();
            ServiceRecord.update({id: m.id, op: 'info_unconfirm'}, {}).$promise.then(
                function (resp) {
                    m.state = STATE.PENDING;
                    loadItem(m);
                    Dlg.s(resp.msg);
                }, function (error) {
                    var resp = error.data;
                    if (resp.msg) Dlg.error(resp.msg);
                }).finally(function () {
                defer.resolve();
            });
            return defer.promise;
        }

        function show(m) {
            Dlg.show({
                template: 'pages/personnel/userInfo/showDlg.html',
                ctrl: 'PersonnelUserShowCtrl',
                data: {
                    id: m.user_id
                }, size: 'lg'
            });
        }


        function showFd(m) {
            Dlg.show({
                template: 'pages/personnel/userInfo/showFdDlg.html',
                ctrl: 'PersonnelUserShowFdCtrl',
                data: {
                    id: m.user_id
                }, size: 'md'
            });
        }

        function showOlder(m) {
            Dlg.show({
                template: 'pages/personnel/userInfo/showOlderDlg.html',
                ctrl: 'PersonnelUserShowOlderCtrl',
                data: {
                    id: m.user_id
                }, size: 'md'
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('QuestionDlgCtrl', QuestionDlgCtrl);

    /** @ngInject */
    function QuestionDlgCtrl($scope, $uibModalInstance, $timeout, ServiceRecord, UserInfo, ArrayHelper, DeptGroup, Auth,
                             data, $q, Dlg, FormHelper, DateHelper, $interval, City, County, Street, ExtHelper) {
        var vm = this;
        var helper = UserInfo.formHelper;
        var op = data.op;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;
        vm.showRelative = true;
        vm.queryInfo = false;
        vm.cancelError = cancelError;
        vm.phoneConfirm = data.phoneConfirm;
        vm.provinceSelected = provinceSelected;
        vm.citySelected = citySelected;
        vm.countySelected = countySelected;
        vm.hideIllInfo = data.hideIllInfo;
        vm.phoneConfirm1 = data.phoneConfirm1;
        vm.userId = Auth.getAccount().id;
        vm.types = [{id: 1, name: '回原籍'}, {id: 2, name: '配偶户口所在地'}, {id: 3, name: '子女工作所在地'}, {id: 4, name: '实际购房所在地'}];
        if (data.handlerId) vm.handlerId = data.handlerId;

        // vm.timer = $interval(function () {
        //     saveData();
        // }, 5000);
        //
        // $scope.$on('$destroy', function () {
        //     $interval.cancel(vm.timer);
        // });


        init();


        function init() {
            console.log(vm.handlerId)
            console.log(vm.userId)
            console.log(vm.handlerId && vm.userId != vm.handlerId)

            ExtHelper.chkCardReadExt(vm);
            helper.init(vm);
            vm.partyMode = 1;
            $q.all([
                UserInfo.get({id: data.id}).$promise,
                UserInfo.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                helper.bindAsyncOptions(vm, respArray[1]);
                localStorage.removeItem('userInfo' + data.id);
                // var info = localStorage.getItem('userInfo' + data.id);
                // if (info) {
                //     vm.m = JSON.parse(info);
                //     if (vm.m.province) vm.provinceSelected(vm.m.province, vm.m);
                // } else {
                var item = respArray[0].item;
                helper.loadItem(item);
                vm.m = item;
                if (vm.m.supply_time) {
                    vm.m.mode = '1';
                } else {
                    vm.m.mode = '0';
                }
                if (vm.m.placement_type) {
                    vm.m.mode = '1';
                    vm.m.placement_type = ArrayHelper.getItem(vm.m.placement_type, vm.types);

                }
                if (vm.m.branch_name != null && vm.m.branch_name != '' && vm.m.p_branch == null) {
                    vm.partyMode = 2;
                }

                vm.m.is_cd_home = vm.m.is_cd_home == 1 ? '1' : '0';
                vm.m.is_placement = vm.m.is_placement == 1 ? '1' : '0';
                vm.m.is_into = vm.m.is_into == 1 ? '1' : '0';
                vm.m.disability = vm.m.disability == 1 ? '1' : '0';
                vm.m.is_dc = vm.m.is_dc == 1 ? '1' : '0';


                // }
            });
        }

        var editProvince = true;

        function provinceSelected(item, m) {
            City.query({opt: 2, province_id: item.id}, function (resp) {
                vm.cities = resp.items;
                if (m.id && editProvince) {
                    editProvince = false;
                    if (m.city) {
                        m.city = ArrayHelper.getItem(m.city.id, vm.cities);
                    }
                } else {
                    m.city = vm.cities[0];
                }
                if (m.city) {
                    citySelected(m.city, m);
                }
            });
        }

        var editCity = true;

        function citySelected(item, m) {
            County.query({opt: 2, city_id: item.id}, function (resp) {
                vm.counties = resp.items;
                if (m.id && editCity) {
                    editCity = false;
                    if (m.county) {
                        m.county = ArrayHelper.getItem(m.county.id, vm.counties);
                    }
                } else {
                    m.county = vm.counties[0];
                }
                if (m.county) {
                    countySelected(m.county, m);
                }
            });
        }

        var editCounty = true;

        function countySelected(item, m) {
            Street.query({opt: 2, county_id: item.id}, function (resp) {
                vm.streets = resp.items;
                if (m.id && editCounty) {
                    editCounty = false;
                    if (m.street) {
                        m.street = ArrayHelper.getItem(m.street.id, vm.streets);
                    }
                } else {
                    // m.street = vm.streets[0];
                }
            });
        }

        // function saveData() {
        //     if (vm.m) {
        //         localStorage.setItem('userInfo' + vm.m.id, JSON.stringify(vm.m));
        //     }
        // }

        function cancelError() {
            vm.errorReason = null;
        }

        function ok(m) {
            if (vm.errorReason) {
                var reason;
                switch (vm.errorReason) {
                    case '1':
                        reason = '电话信息有误';
                        break;
                    case '2':
                        reason = '电话未接通';
                        break;
                    case '3':
                        reason = '当事人不配合';
                        break;
                }
                ServiceRecord.update({id: data.serviceRecordId}, {
                    op: 'error_confirm',
                    reason: reason
                }).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    // localStorage.removeItem('userInfo' + m.id);
                    $uibModalInstance.close();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            } else {
                return FormHelper.handleSubmit(vm, function (defer) {
                    var pa = helper.loadParams(m);
                    if (m.mode == 0) {
                        pa.supply_time = null;
                        pa.placement_type = null;
                    }
                    var num = 0, typeNum = 0;
                    if (m.relatives.length > 0) {
                        var relatives = [];
                        for (var i = 0; i < m.relatives.length; i++) {
                            var r = m.relatives[i];
                            //同为退休人员
                            if (r.id_card) {
                                if (r.id_card === m.id_card) {
                                    Dlg.w('用户和离退休亲属的身份证信息相同');
                                    return
                                }
                                num++;
                                var relative = helper.loadParams(r);
                                relative.type = r.type;
                                relatives.push(relative)
                            } else {
                                relatives.push(r)
                            }

                            if (r.type && r.type.id == 1) {
                                typeNum++;
                            }
                        }
                        pa.relatives = relatives;
                    }
                    if (num > 1) {
                        Dlg.w('同为退休人员的亲属最多允许添加一个');
                        return
                    }
                    if (typeNum > 1) {
                        Dlg.w('配偶关系最多允许添加一个');
                        return
                    }

                    var id, service;
                    id = data.serviceRecordId;
                    pa.user_id = m.id;
                    service = ServiceRecord;

                    pa.op = 'info_confirm';
                    service.update({id: id}, pa).$promise.then(function (resp) {
                        if (resp.msg) Dlg.s(resp.msg);
                        // localStorage.removeItem('userInfo' + m.id);
                        $uibModalInstance.close();
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Dlg.e(data.msg);
                    }).finally(function () {
                        defer.resolve();
                    });
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('UserInfoStaCtrl', UserInfoStaCtrl);

    /** @ngInject */
    function UserInfoStaCtrl($scope, UserInfo) {
        var vm = $scope;
        vm.tableReload = init;


        init();

        function init() {
            vm.loading = true;
            UserInfo.query({op: 'sta'}).$promise.then(function (resp) {
                vm.m = resp;
            }).finally(function () {
                vm.loading = false;
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('UserInfoSta2Ctrl', UserInfoSta2Ctrl);

    /** @ngInject */
    function UserInfoSta2Ctrl($scope, UserInfo) {
        var vm = $scope;
        vm.tableReload = init;


        init();

        function init() {
            vm.loading = true;
            UserInfo.query({op: 'sta2'}).$promise.then(function (resp) {
                vm.m = resp;
            }).finally(function () {
                vm.loading = false;
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('LetterAllCtrl', LetterAllCtrl);

    /** @ngInject */
    function LetterAllCtrl($scope, $q, Auth, Dlg, UserInfo, Table, ArrayHelper, FileHelper,
                           LetterRegister, UIHelper, Company) {
        var account = Auth.getAccount();
        var states = LetterRegister.getHandleStates();
        var type1States = LetterRegister.getLetterTypeOneStates();
        var type2States = LetterRegister.getLetterTypeTwoStates();
        var contentStates = LetterRegister.getLetterContentStates();
        var vm = $scope;
        vm.type1State = type1State;
        vm.type2State = type2State;
        vm.contentAllState = contentAllState;
        vm.handleTime = handleTime;
        vm.download = download;
        vm.confirm = confirm;
        vm.deleteLetter = deleteLetter;
        vm.ChangePage = ChangePage;

        init();

        function init() {
            UIHelper.loadTab(vm, 'all');
            $q.all([
                Company.query({op: 'manage_option'}).$promise,
            ]).then(function (respArray) {
                vm.companies = respArray[0].items;
                vm.companies.splice(0, 0, {id: 0, name: '全部单位'});
                vm.company = vm.companies[0];
                var options = {
                    service: LetterRegister,
                    params: {
                        // op: 'self_watched',
                        op: 'info_confirm',
                        company_id: vm.company.id
                    },
                    optInFront: true,
                    optColWidth: Table._4_BTN,
                    count: 10,
                    cols: [
                        {title: '序号', field: 'sn', width: Table._1_CHAR}, //0
                        {field: "name", title: "名称", filter: {name: "text"}},
                        {
                            field: "male",
                            title: "性别",
                            filter: {male: 'select'},
                            data: Table.getNgTableOpts(UserInfo.getSexes())
                        },
                        {field: "id_card", title: "身份证号", filter: {id_card: "text"}},
                        {field: "phone", title: "电话号码", filter: {phone: "text"}},
                        {
                            field: "state",
                            title: "处理状态",
                            filter: {state: "select"},
                            data: Table.getNgTableOpts(states)
                        },
                        {
                            field: "register_time",
                            title: "录入时间",
                            filter: {register_time: "date_range"}
                        },
                        {
                            field: "handle_time",
                            title: "处理时间",
                            filter: {handle_time: "date_range"},
                        },
                        {
                            field: "handler",
                            title: "处理人",
                            filter: {handler: "text"},
                        },
                    ]
                };
                Table.load(vm, options, function (resp, startSn) {
                    if (resp.total % vm.tableParams.$params.count !== 0) {
                        vm.pageTotal = Math.floor(resp.total / vm.tableParams.$params.count) + 1;
                    } else {
                        vm.pageTotal = Math.floor(resp.total / vm.tableParams.$params.count);
                    }
                    Table.loadItem(resp, startSn, loadItem);
                }).options;

                vm.clearFilters = function () {
                    vm.tableParams.filter({
                        'fd': vm.tableParams.filter()['fd'],
                    });
                }
            });
        }

        function loadItem(item) {
            item.state = ArrayHelper.getItem(item.state, states);
            // item.handleable = item.handle_id === account.id;
        }

        function type1State(id) {
            return type1States[id - 1].name
        }

        function type2State(id) {
            return type2States[id - 1].name
        }

        function contentAllState(id) {
            return contentStates[id - 1].name
        }

        function handleTime(time) {
            if (time === null) {
                return '处理中';
            }
            return time;
        }

        function download() {
            /*            var show;
                        show = {
                            template: 'pages/letter/receive/exportLetter.html',
                            ctrl: 'ExportLetterCtrl',
                            data: {},
                            size: 'md'
                        }
                        Dlg.show(show).then(function () {
                            vm.tableReload();
                        });*/
            Dlg.exportDR('/api/v1/letter/letter_registers/sta', '统计数据导出');
        }


        function confirm(m) {
            var show;
            show = {
                template: 'pages/letter/receive/updateRegisterMessage.html',
                ctrl: 'ShowRegisterMessageCtrl',
                data: {
                    allInfo: m
                }, size: 'lg'
            }
            Dlg.show(show).then(function () {
                vm.tableReload();
            });
        }

        function deleteLetter(m) {
            Dlg.confirm('该操作会清除该条信函记录，确定要删除吗？', function () {
                var defer = $q.defer();
                LetterRegister.delete({id: m.id}, {}).$promise.then(
                    function (resp) {
                        vm.tableReload();
                        Dlg.s(resp.msg);
                    }, function (error) {
                        var resp = error.data;
                        if (resp.msg) Dlg.error(resp.msg);
                    }).finally(function () {
                    defer.resolve();
                });
                return defer.promise;
            });
        }

        function ChangePage(m) {
            if (m == null || m.page == null || m.page <= 0 || m.page > vm.pageTotal) {
                return Dlg.w('请输入正确页码');
            }
            vm.tableParams.$params.page = m.page;
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('ExportLetterCtrl', ExportLetterCtrl);

    /** @ngInject */
    function ExportLetterCtrl($scope,$q,Dlg,LetterRegister,$uibModalInstance, $filter, FileHelper) {
        var vm = this;
        vm.ok=ok;
        vm.cancel = $uibModalInstance.dismiss;
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        vm.letter = {
            start: new Date(y, m, 1),
            end: new Date(y, m + 1, 0)
        };

       function ok (letter) {
                if (vm.letter.start > vm.letter.end) {
                    Dlg.w('开始日期不能大于结束日期!');
                    return;
                }
                var params = {};
                params['start'] = $filter('date')(letter.start, 'yyyy-MM-dd');
                params['end'] = $filter('date')(letter.end, 'yyyy-MM-dd');

           var defer = $q.defer();
           FileHelper.dnExcel(LetterRegister.STA_URL, params, params['start']+'到'+params['end']+'信函信息确认统计.xls')
               .finally(function () {
                   defer.resolve();
               });
           $uibModalInstance.close();
           return defer.promise;


            }
        }
    })();
(function () {
    'use strict';

    angular.module('c')
        .controller('LetterPendingCtrl', LetterPendingCtrl);

    /** @ngInject */
    function LetterPendingCtrl($scope, $q, Auth, Dlg, UserInfo, Table, ArrayHelper, FileHelper,
                               LetterRegister,UIHelper, Company) {
        var states = LetterRegister.getHandleStates();
        var account = Auth.getAccount();
        var vm = $scope;
        vm.init = init;
        // vm.assign = assign;
        vm.unassign = unassign;
        vm.confirm = confirm;
        vm.unconfirm = unconfirm;
        vm.showInfo=showInfo;
        var optionFn;


        function init(tab) {
            UIHelper.loadTab(vm, tab);
            $q.all([
                Company.query({op: 'manage_option'}).$promise,
            ]).then(function (respArray) {
                vm.companies = respArray[0].items;
                vm.companies.splice(0, 0, {id: 0, name: '全部单位'});
                vm.company = vm.companies[0];
                var options = {
                    service: LetterRegister,
                    params: {op: 'info_confirm_self', tab: tab},
                    filter: {'fd': false},
                    optInFront: true,
                    optColWidth: Table._1_BTN,
                    count: 10,
                    cols: [
                        {title: '序号', field: 'sn', width: Table._1_CHAR}, //0
                        {field: "name", title: "名称", filter: {name: "text"}},
                        {
                            field: "male",
                            title: "性别",
                            filter: {male: 'select'},
                            data: Table.getNgTableOpts(UserInfo.getSexes())
                        },
                        {field: "id_card", title: "身份证号", filter: {id_card: "text"}},
                        {
                            field: "register_time",
                            title: "登记时间",
                            filter: {register_time: "date_range"},
                            show: tab === 'pending'
                        },
                        {
                            field: "handle_time",
                            title: "确认时间",
                            filter: {handle_time: "date_range"},
                            show: tab === 'handle'
                        }
                    ]
                };

                optionFn = Table.load(vm, options, function (resp, startSn) {
                    Table.loadItem(resp, startSn, loadItem);
                }).options;

                vm.clearFilters = function () {
                    vm.tableParams.filter({
                        'fd': vm.tableParams.filter()['fd'],
                    });
                }
            });
        }


        function loadItem(item) {
            item.state = ArrayHelper.getItem(item.state, states);
            item.handleable = item.handler_id === account.id;
        }

        function unassign(m) {
            Dlg.confirm('该操作会清空认领人，确定要撤销吗？', function () {
                var defer = $q.defer();
                LetterRegister.update({id: m.id, op: 'letter_info_unassign'}, {}).$promise.then(
                    function (resp) {
                        console.log(resp)
                        m.handler.name = m.handler_id = null;
                        loadItem(m);
                        Dlg.s(resp.msg);
                    }, function (error) {
                        var resp = error.data;
                        if (resp.msg) Dlg.error(resp.msg);
                    }).finally(function () {
                    defer.resolve();
                });
                return defer.promise;
            });
        }
/*
        function assign(m) {
            var defer = $q.defer();
            ServiceRecord.update({id: m.id, op: 'letter_info_unassign'}, {}).$promise.then(
                function (resp) {
                    m.handler_id = resp.handler.id;
                    m.handler = resp.handler;
                    m.state = resp.state;
                    loadItem(m);
                    Dlg.s(resp.msg);
                }, function (error) {
                    var resp = error.data;
                    if (resp.msg) Dlg.error(resp.msg);
                }).finally(function () {
                defer.resolve();
            });
            return defer.promise;
        }*/

        function confirm(m) {
            var show;
                show = {
                    template: 'pages/letter/receive/showRegisterMessage.html',
                    ctrl: 'ShowRegisterMessageCtrl',
                    data: {
                        allInfo: m
                    }, size: 'lg'
                }
            Dlg.show(show).then(function () {
                vm.tableReload();
            });
        }

        function showInfo(m) {
            var show;
            show = {
                template: 'pages/letter/receive/showInfo.html',
                ctrl: 'ShowRegisterMessageCtrl',
                data: {
                    allInfo: m
                }, size: 'lg'
            }
            Dlg.show(show).then(function () {
                vm.tableReload();
            });
        }
        function unconfirm(m) {
            var defer = $q.defer();
            LetterRegister.update({id: m.id, op: 'info_unconfirm'}, {}).$promise.then(
                function (resp) {
                    loadItem(m);
                    Dlg.s(resp.msg);
                }, function (error) {
                    var resp = error.data;
                    if (resp.msg) Dlg.error(resp.msg);
                }).finally(function () {
                defer.resolve();
            });
            return defer.promise;
        }

    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('LetterReceiveCtrl', LetterReceiveCtrl);

    /** @ngInject */
    function LetterReceiveCtrl($scope, $q, Dlg, LetterRegister) {
        var vm = this;
        vm.ok=ok;
        vm.reset = reset;
        vm.showContent = showContent;
        vm.nextContent = nextContent;
        vm.lastContent = lastContent;
        vm.handleMessage = handleMessage;
        vm.showButton = showButton;
        vm.handleStates = LetterRegister.getHandleStates();
        vm.contentStates = LetterRegister.getLetterContentStates();
        vm.contentShow = false;
        vm.buttonShow = false;
        vm.pageNumber=0;
        init();


        function init() {

        }

        function reset() {
            vm.Form.$setUntouched();
            vm.Form.$setPristine();
            vm.userAll = null;
            vm.user = null;
            vm.idCard = null;
            vm.contentState=null;
            vm.letter_content=null;
            vm.contentShow=null;
            vm.buttonShow = false;
            vm.handleState=null;
        }
        function handleMessage(user_data){
            vm.handleState=vm.handleStates[user_data.state-1];
            vm.contentState=vm.contentStates[user_data.content_type-1];
            vm.showContent(vm.user.content_type);
            if(user_data.state!==1){
                user_data.handle_time=null;
                vm.handleState.name='处理中'
            }
        }
        function showButton(content_length) {
            vm.buttonShow = content_length !== 1;
        }

        function showContent(content_id) {
            vm.contentShow = content_id === 10;
        }

        function nextContent() {
            if(vm.pageNumber>=vm.userAll.length-1){
                return Dlg.w('已经是最后一个了！');
            }
            vm.pageNumber++;
            vm.user=vm.userAll[vm.pageNumber]
            handleMessage(vm.user);
        }


        function lastContent() {
            if(vm.pageNumber===0){
                return Dlg.w('已经是第一个了！');
            }
            vm.pageNumber--;
            vm.user=vm.userAll[vm.pageNumber]
            handleMessage(vm.user);
        }
        function ok(id_card) {
            if (id_card) {
                LetterRegister.query({id: '-', id_card: id_card,op: 'self_watched'}).$promise.then(function (resp) {
                    vm.userAll = resp.items;
                    if(vm.userAll.length<=0){
                        return Dlg.e('未查找到结果，请检查输入是否正确');
                    }
                    vm.user=vm.userAll[0]
                    handleMessage(vm.user);
                    showButton(vm.userAll.length);
                }, function (err) {
                    if (err.data.msg) Dlg.e(err.data.msg);
                });
            } else Dlg.e('请先输入身份证号！');

        }
    }
})
();

(function () {
    'use strict';

    angular.module('c')
        .controller('ShowRegisterMessageCtrl', ShowRegisterMessageCtrl);

    /** @ngInject */
    function ShowRegisterMessageCtrl($scope, $q, Dlg, LetterRegister, UserInfo, Table,
                                ArrayHelper, Api, Regex, FormHelper,$uibModalInstance,data) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.handleStates = LetterRegister.getHandleStates();
        vm.typeOneStates = LetterRegister.getLetterTypeOneStates();
        vm.typeTwoStates = LetterRegister.getLetterTypeTwoStates();
        vm.contentStates = LetterRegister.getLetterContentStates();
        vm.chooseUserName = chooseUserName;
        vm.cancelUpdate =cancelUpdate;
        vm.updateLetter=updateLetter;
        vm.m=data.allInfo;
        vm.changeTitle = changeTitle;
        vm.changeAddress = changeAddress;
        vm.contentShow = false;
        vm.contentShow2 = false;
        var oldTitle;
        var oldAddress;

        init();


        function init() {
            vm.m.userNameAcdOption = {trigLen: 1, data: Api.idCardLoadFn, onSelect: chooseUserName};
            vm.m.typeOneState=vm.typeOneStates[vm.m.type1-1]
            vm.m.typeTwoState=vm.typeTwoStates[vm.m.type2-1]
            vm.m.contentState=vm.contentStates[vm.m.content_type-1]
            vm.m.handleState=vm.handleStates[vm.m.state.id-1]
            oldTitle=vm.m.user.title;
            oldAddress=vm.m.user.address;
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa ={}
                var id;
                id = m.id;
                pa.op = 'letter_info';
                LetterRegister.update({id:id},pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
        function changeTitle(title){
            return title!==oldTitle ;
        }

        function changeAddress(address){
            return address!==oldAddress ;
        }

        function chooseUserName(idCard) {
            if (idCard) {
                UserInfo.get({id: '-', id_card: idCard, op: 'by_id_card'}).$promise.then(function (resp) {
                    vm.m.user = resp.item;
                }, function (err) {
                    if (err.data.msg) Dlg.e(err.data.msg);
                });
            } else Dlg.e('请先输入名字或者身份证号！');
        }
        function cancelUpdate(){
            init();
            $uibModalInstance.close();
        }

        function updateLetter(m,handler) {
            if (m.handleState.id!==1&&(m.recipients == null || m.recipients.length === 0)){
                    return  Dlg.w('请填写收件人!');
            }
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa ={
                    letter_no: m.letter_no,
                    type1: m.typeOneState.id,
                    type2: m.typeTwoState.id,
                    user_id: m.user.id,
                    content_type: m.contentState.id,
                    letter_content: m.letter_content,
                    handle_id:handler,
                    state: m.handleState.id
                }
                if(m.user.title!==oldTitle||m.user.address!==oldAddress) {
                    var id = m.user.id;
                    m.user.op = 'info';
                    UserInfo.update({id: id}, m.user).$promise.then(function (resp) {
                        Dlg.s(resp.msg);
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Dlg.e(data.msg);
                    }).finally(function () {
                        defer.resolve();
                    });
                }
                var idLetter;
                idLetter = m.id;
                pa.op = 'letter_message';
                LetterRegister.update({id:idLetter},pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }
})
();

(function () {
    'use strict';

    angular.module('c')
        .controller('SmsExcelSendController', SmsExcelSendController);

    /** @ngInject */
    function SmsExcelSendController($scope, $q, FileHelper, FormHelper, Upload, Dlg, UserInfo, ArrayHelper, C, DateHelper, dialogs) {
        var vm = $scope;
        vm.download = download;
        vm.upload = upload;
        vm.send = send;
        vm.pageChanged = pageChanged;
        vm.remove = remove;
        vm.mustKnow = mustKnow;
        vm.reset = reset;
        // vm.sendWage = sendWage;

        init();

        function init() {
            vm.phoneRegex = /^(0|86|17951)?1(3[0-9]|4[57]|5[0-9]|7[0-9]|6[0-9]|8[0-9]|9[0-9])\d{8}$/;
            vm.text = '短信';
            vm.pager = {count: 10, page: 1, total: 0};
            vm.m = {
                type: 1,
                doc: {},
                items: [],
                lack_items: []
            };
            vm.cols = [{name: '序号'}, {name: '身份证'}, {name: '姓名'}, {name: '发送手机号'}, {name: '表格手机号'}];
        }

        function reset() {
            init();
        }

        function upload(file, data, e, rename, extra) {
            if (file == null) {
                return;
            }
            vm.loading = true;
            vm.m.items = [];
            if (angular.isUndefined(rename) || !rename) {
                rename = {};
            }
            if (!rename.name) rename.name = 'attach_name';
            if (!rename.mime) rename.mime = 'mime';
            if (!rename.filename) rename.filename = 'filename';
            if (!rename.size) rename.size = 'size';
            if (e && e[0] && e[0].$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }
            data.progress = 0;
            var pa = {file: file, id: data.id, remap: rename};
            if (angular.isDefined(extra) && extra) {
                ArrayHelper.mergeObj(pa, extra);
            }
            delete data[rename.filename];
            Upload.upload({
                url: FileHelper.urls.UPLOAD, data: pa
            }).progress(function (evt) {
                data.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        data[rename.name] = resp[rename.name];
                        data[rename.mime] = resp[rename.mime];
                        data[rename.filename] = resp[rename.filename];
                        data[rename.size] = resp[rename.size];
                        UserInfo.query({
                            op: 'excel',
                            filename: resp[rename.filename],
                            type: 3
                        }, function (excelData) {
                            vm.m.lack_items = excelData.lackItems;
                            angular.forEach(excelData.items, function (item, i) {
                                item.index = i;
                                if (item.phone != '' || item.old_phone != '') {
                                    vm.m.items.push(item);
                                } else {
                                    vm.m.lack_items.push({'idCard': item.idCard, 'name': item.name});
                                }
                            });
                            vm.pager.page = 1;
                            vm.pager.total = vm.m.items.length;
                            pageChanged();
                            vm.loading = false;
                            Dlg.s('上传完毕')
                        }, function (error) {
                            vm.loading = false;
                            Dlg.e('上传失败');
                        });
                        break;
                    case 1:
                        data.progress = 101;
                        data.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                data.progress = 102;
                data.errorInfo = '服务器错误!';
            });
        }

        function download() {
            var defer = $q.defer();
            FileHelper.dnExcel(UserInfo.urls.DN_WAGE_EXAMPLE, {type: 3}, vm.text + "模板.xls")
                .finally(function () {
                    defer.resolve();
                });
            return defer.promise;
        }

        function pageChanged() {
            var pager = vm.pager;
            pager.data = vm.m.items.slice((pager.page - 1) * pager.count, pager.page * pager.count);
        }


        function remove(index, data, item, m) {
            data.splice(index, 1);
            var i = ArrayHelper.indexOfKey(item.index, m.items, 'index');
            m.items.splice(i, 1);
            m.lack_items.push({'idCard': item.idCard, 'name': item.name});
        }

        function mustKnow() {
            Dlg.show({
                template: 'pages/message/temp/must_know_dlg.html',
                ctrl: 'SimpleDlgCtrl',
                data: {},
                size: 'lg'
            });
        }

        function send(m) {
            var defer = $q.defer();
            if (vm.Form.$valid) {
                var pa = {
                    items: [],
                    op: 'excel',
                    note: m.content,
                    type: 3,
                    sendType: m.type
                };

                for (var i = 0; i < m.items.length; i++) {
                    var item = m.items[i];
                    if (!item.phone || item.phone == '' || !item.phone.match(vm.phoneRegex)) {
                        vm.pager.page = parseInt(i / 10) + 1;
                        pageChanged();
                        defer.reject();
                        FormHelper.handleError('#Form', vm.Form);
                        return
                    }
                    if (m.type == 1) {
                        pa.items.push(item.phone);
                    } else {
                        pa.items.push({userId: item.userId, phone: item.phone});
                    }

                }

                if (pa.items.length == 0) {
                    Dlg.w('请上传短信人员名单');
                    return;
                } else if ((m.content == null || m.content == '') && m.type == 1) {
                    Dlg.w('发送内容不能为空');
                    return;
                }

                Dlg.confirm('确认要批量发送短信吗？', function () {
                    UserInfo.save(pa).$promise.then(function (resp) {
                        Dlg.s(resp.msg);
                        reset();
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Dlg.e(data.msg);
                    }).finally(function () {
                        defer.resolve();
                    });
                });
            } else {
                FormHelper.handleError('#Form', vm.Form);
                defer.reject();
            }
            return defer.promise;

        }

        // function sendWage(m) {
        //
        // }

    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('SmsHistoryController', SmsHistoryController);

    /** @ngInject */
    function SmsHistoryController($scope, Table, UIHelper, ArrayHelper, Sms, Dlg, $q) {
        var vm = $scope;
        vm.show = show;
        vm.remove = remove;
        vm.removeChecked = removeChecked;
        var checker = null;
        var successOrNotOpts = Table.getNgTableOpts(ArrayHelper.get('successOrNot'));


        init();

        function init() {
            UIHelper.loadTab($scope, 'history');

            var options = {
                service: Sms,
                params: {op: 'default'},
                optColWidth: Table._2_BTN,
                optInFront: true,
                // showSn: true,
                cols: [
                    {title: '收件人', filter: {recipient: 'text'}, field: 'recipients'},
                    {title: '内容', filter: {content: 'text'}, field: 'content'},
                    {
                        title: '时间',
                        filter: {updated_at: 'date_range'},
                        field: 'updated_at'
                    },
                    {
                        title: '状态',
                        field: 'result_info',
                        filter: {result_info: 'select'},
                        data: successOrNotOpts
                    }
                ]
            };

            Table.load(vm, options);
            checker = Table.loadMultiSelectedFn(vm);
        }

        function removeChecked() {
            var items = checker.getChecked();
            var sms = [];
            var count = items.length;
            if (count === 0) {
                checker.clearChecked();
                Dlg.w("请至少选中一个短信!");
                return;
            }
            var defer = $q.defer();
            vm.tableParams.settings().$loading = true;
            angular.forEach(items, function (item) {
                sms.push(item.id);
            });
            Sms.batchRemove({sms: sms}).$promise.then(function (resp) {
                if (resp.msg) Dlg.s(resp.msg);
                vm.tableReload();
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
            defer.resolve();
            checker.clearChecked();
            vm.tableReload();
            return defer.promise;
        }

        function remove(m) {
            Sms.delete({id: m.id}).$promise.then(function (resp) {
                if (resp.msg) Dlg.s(resp.msg);
                vm.tableReload();
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
        }

        function show(m) {
            Dlg.show({
                template: 'pages/message/temp/show_dlg.html',
                ctrl: 'SmsShowDlgCtrl',
                data: {
                    sms: m,
                    is_outbox: true
                }
            }).then(function (resp) {
                switch (resp.opt) {
                    case 5:     //再次编辑
                        UIHelper.tabTo('send', resp.sms);
                        break;
                }
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('SmsSendController', SmsSendController);

    /** @ngInject */
    function SmsSendController($rootScope, $scope, UIHelper, Auth, Dlg, Sms) {
        var vm = $scope;
        vm.mustKnow = mustKnow;
        vm.send = send;
        vm.reset = reset;
        $scope.$on('missionSms', function (ev, sms) {
            vm.sms['recipients'] = sms;
        });

        UIHelper.loadTab(vm, 'send', function (sms) {
            var content = sms.content.substr(sms.sign.length, sms.content.length - sms.sign.length);
            var sign = sms.sign.substr(1, sms.sign.length - 2);
            vm.sms = {sign: sign, content: content, recipients: sms.recipients};
        });

        var account = Auth.getAccount();

        function mustKnow() {
            Dlg.show({
                template: 'pages/message/temp/must_know_dlg.html',
                ctrl: 'SimpleDlgCtrl',
                data: {},
                size: 'lg'
            });
        }

        function send(sms) {
            if (sms.sign == null || sms.sign == "") {
                Dlg.w('短信签名不能为空!');
            } else if (sms.recipients == null || sms.recipients.length == 0) {
                Dlg.w('请填写收件人!');
            } else if (sms.content == null || sms.content.length == 0) {
                Dlg.w('短信内容不能为空!');
            } else {
                var params = {};
                params['sign'] = '【西藏成办】';
                params['content'] = sms.content;
                params['content'] += '(' + account.name + account.phone + ')';
                params['recipients'] = [];
                angular.forEach(sms.recipients, function (recipient) {
                    params['recipients'].push(recipient.id);
                });

                Sms.send(params, function (resp) {
                    if (resp.phoneNull) {
                        Dlg.notify(resp.msg)
                    } else {
                        Dlg.s('短信请求成功!');
                        vm.reset();
                    }
                    $rootScope.$broadcast('smsSend');
                }, function (resp) {
                    Dlg.e('短信请求失败!');
                });
            }
        }

        reset();

        function reset() {
            vm.sms = {recipients: [], sign: account.name};
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('SmsStatisticController', SmsStatisticController);

    /** @ngInject */
    function SmsStatisticController($scope, Table, UIHelper, ArrayHelper, Sms, Dlg, $q) {
        var vm = $scope;

        init();

        function init() {
            UIHelper.loadTab($scope, 'statistic');

            var options = {
                service: Sms,
                params: {op: 'statistic'},
                hideOpt: true,
                hideFilter: true,
                cols: [
                    {title: '短信类型', field: 'type'},
                    {title: '短信条数', field: 'count'},
                    {title: '短信示例', field: 'content', width: 500},
                ]
            };

            Table.load(vm, options);
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('PartyWorkTurnedCtrl', PartyWorkTurnedCtrl)


    ;
    /** @ngInject */
    function PartyWorkTurnedCtrl($scope, $q, User, Table, UIHelper) {
        var vm = $scope;
        init();

        function init() {
            $q.all([
                User.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                UIHelper.loadTab(vm, 'turned');

                var options = {
                    service: User,
                    params: {op: 'PartyWorkTurned'},
                    optColWidth: Table._1_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}, width: 140},
                        {field: "username", title: "用户名", filter: {username: "text"}, width: 140},
                        {field: "dept", title: "部门", filter: {dept: "text"}},
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}, width: 200}
                    ]
                };

                Table.load(vm, options);
            });
        }

    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('PartyWorkTurningCtrl', PartyWorkTurningCtrl)


    ;
    /** @ngInject */
    function PartyWorkTurningCtrl($scope, $q, User, Table, UIHelper, Dlg) {
        var vm = $scope;
        vm.turn = turn;
        init();

        function init() {
            $q.all([
                User.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                UIHelper.loadTab(vm, 'turning');

                var options = {
                    service: User,
                    params: {op: 'PartyWorkTurning'},
                    optColWidth: Table._2_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}, width: 140},
                        {field: "username", title: "用户名", filter: {username: "text"}, width: 140},
                        {field: "dept", title: "部门", filter: {dept: "text"}},
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}, width: 200}
                    ]
                };

                Table.load(vm, options);
            });
        }

        function turn(m) {
            var pa = {
                turned: true
            };
            Dlg.confirm('确认<strong>' + m.name + '</strong>的党组织关系已转？', function (resp) {
                User.update({id: m.id, op: 'party_turn'}, pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    Dlg.e(error.msg);
                });
            }, '确认党组织关系已转');
        }
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('PartyWorkSignedCtrl', PartyWorkSignedCtrl)


    ;
    /** @ngInject */
    function PartyWorkSignedCtrl($scope, $q, User, Table, UIHelper) {
        var vm = $scope;
        init();

        function init() {
            $q.all([
                User.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                UIHelper.loadTab(vm, 'signed');

                var options = {
                    service: User,
                    params: {op: 'PartyWorkSigned'},
                    optColWidth: Table._1_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}, width: 140},
                        {field: "username", title: "用户名", filter: {username: "text"}, width: 140},
                        {field: "dept", title: "部门", filter: {dept: "text"}},
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}, width: 200}
                    ]
                };

                Table.load(vm, options);
            });
        }

    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('PartyWorkSigningCtrl', PartyWorkSigningCtrl)


    ;

    /** @ngInject */
    function PartyWorkSigningCtrl($scope, $q, User, Dlg, Table, UIHelper) {
        var vm = $scope;
        vm.sign = sign;
        init();

        function init() {
            $q.all([
                User.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                UIHelper.loadTab(vm, 'signing');

                var options = {
                    service: User,
                    params: {op: 'PartyWorkSigning'},
                    optColWidth: Table._2_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}, width: 140},
                        {field: "username", title: "用户名", filter: {username: "text"}, width: 140},
                        {field: "dept", title: "部门", filter: {dept: "text"}},
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}, width: 200}
                    ]
                };

                Table.load(vm, options);
            });
        }

        function sign(m) {
            var pa = {
                signed: true
            };
            Dlg.confirm('确认<strong>' + m.name + '</strong>的承诺书已签订？', function (resp) {
                User.update({id: m.id, op: 'party_sign'}, pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    Dlg.e(error.msg);
                });
            }, '确认承诺书已签订');
        }
    }
})();
(function () {
    'use strict';
    angular.module('c')

        .controller('MemberCtrl', MemberCtrl)
        .controller('AddMemberCtrl', AddMemberCtrl)
        .controller('DeptMemberCtrl', DeptMemberCtrl)
        .controller('LeaveMemberCtrl', LeaveMemberCtrl)
        .controller('SelectLeaderCtrl', SelectLeaderCtrl)
    ;

    /** @ngInject */
    function DeptMemberCtrl($scope, Dlg, Dept, UIHelper, Table) {
        var vm = $scope;
        vm.leader = leader;
        vm.member = member;
        vm.init = init;


        function init(op) {
            UIHelper.loadTab(vm, op);
            vm.type = op === 'dept' ? 0 : 1;
            var options = {
                service: Dept,
                params: {op: 'personnel'},
                filter: {type: vm.type},
                optColWidth: Table._2_BTN,
                optInFront: true,
                cols: [
                    {field: "sn", title: "序号"},
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "leader", title: "负责人", filter: {leader: "text"}},
                    {field: "manager", title: "管理员", filter: {manager: "text"}},
                    {field: 'members_count', title: '成员数', width: Table._2_CHAR}
                ]
            };
            Table.load(vm, options, Table.loadItem);
        }

        function leader(m) {
            Dlg.show({
                template: 'LeaderDlg.html', ctrl: 'SelectLeaderCtrl', data: {dept: m}
            }).then(function () {
                vm.tableReload();
            });
        }

        function member(m) {
            Dlg.show({
                template: 'MemberDlg.html',
                ctrl: 'MemberCtrl',
                data: {dept: m},
                size: 'lg'
            }).finally(function () {
                vm.tableReload();
            });
        }
    }

    function MemberCtrl($scope, $uibModalInstance, Table, Dlg, ArrayHelper, UserDept, data) {
        var vm = $scope;
        vm.dept = data.dept;
        vm.edit = edit;
        vm.add = add;
        vm.transfer = transfer;
        vm.leave = leave;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            var options = {
                service: UserDept,
                params: {
                    op: 'dept_member',
                    dept_id: data.dept.id
                },
                optColWidth: Table._2_BTN,
                cols: [
                    {title: '序号', field: 'sn'}, //0
                    {title: '姓名', field: 'name', filter: {name: 'text'}}, //0
                    {title: '身份证', field: 'id_card', filter: {id_card: 'text'}}, //0
                    {title: '手机号', field: 'phone', filter: {phone: 'text'}}, //0
                    {title: '进入时间', field: 'entry_time'}

                ]
            };
            Table.load(vm, options, Table.loadItem);
        }

        function add() {
            Dlg.show({
                template: 'AddMemberDlg.html',
                ctrl: 'AddMemberCtrl',
                size: 'md'
            }).then(function (params) {
                params['dept_id'] = data.dept.id;
                UserDept.save(params).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function () {
                    Dlg.e('添加失败!');
                });
            });
        }

        function edit(user) {
            Dlg.show({
                template: 'AddMemberDlg.html',
                ctrl: 'AddMemberCtrl',
                data: {user: user},
                size: 'md'
            }).then(function (params) {
                params['dept_id'] = data.dept.id;
                params['op'] = 'edit';
                UserDept.update({id: user.id}, params).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function () {
                    Dlg.e('修改失败!');
                });
            });
        }

        function leave(user) {
            Dlg.show({
                template: 'LeaveMemberDlg.html',
                ctrl: 'LeaveMemberCtrl',
                data: {user: user, dept: user.dept},
                size: 'md'
            }).then(function (params) {
                params['op'] = 'leave';
                UserDept.update({id: user.id}, params).$promise.then(function () {
                    Dlg.s('移出成功');
                    vm.tableReload();
                }, function () {
                    Dlg.e('移出失败');
                });
            });
        }

        function transfer(m) {
            Dlg.show({
                template: 'pages/personnel/userTransferDeptDlg.html',
                ctrl: 'UserTransferDeptDlgCtrl',
                data: {user: {id: m.user_id, name: m.name}, dept: m.dept}
            }).then(function (dept) {
                vm.tableReload();
            });
        }
    }

    function LeaveMemberCtrl($scope, $uibModalInstance, $filter, toaster, data) {
        $scope.m = {leave_time: new Date()};
        $scope.user = data.user;
        $scope.dept = data.dept;

        $scope.dateOptions = {
            minDate: new Date(1920, 0, 1),
            //maxDate: new Date(),
            initDate: new Date()
        };

        $scope.ok = function (m) {
            if ($scope.u_form.$valid) {
                var p = {};
                p['leave_time'] = $filter('date')(m.leave_time, 'yyyy-MM-dd');
                $uibModalInstance.close(p);
            } else {
                toaster.warning('表单中有错误!');
                $scope.u_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function AddMemberCtrl($scope, $uibModalInstance, $filter, toaster, uibDateParser, data) {

        if (data.user) {
            $scope.$edit = true;
            var user = data.user;
            $scope.m = {
                user: {id: user.user_id, name: user.name},
                entry_time: uibDateParser.parse(user.entry_time.substr(0, 10), 'yyyy-MM-dd')
            };
        } else {
            $scope.m = {entry_time: new Date()};
        }

        $scope.dateOptions = {
            minDate: new Date(1920, 0, 1),
            maxDate: new Date(),
            initDate: new Date()
        };

        $scope.ok = function (m) {
            if (m.user == null) {
                toaster.warning('成员未选择!');
            } else if ($scope.u_form.$valid) {
                var p = {};
                p['user_id'] = m.user.id;
                p['entry_time'] = $filter('date')(m.entry_time, 'yyyy-MM-dd');
                $uibModalInstance.close(p);
            } else {
                toaster.warning('表单中有错误!');
                $scope.u_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function SelectLeaderCtrl($uibModalInstance, $q, Dlg, Dept, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init(data.dept);


        function init(m) {
            vm.m = {
                id: m.id, name: m.name,
                leader: m.leader, manager: m.manager,
            };
        }

        function ok(m) {
            var defer = $q.defer();
            var pa = {
                op: 'set_leader',
                leader_id: m.leader ? m.leader.id : null,
                manager_id: m.manager ? m.manager.id : null,
            };

            Dept.update({id: m.id}, pa).$promise.then(
                function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    var resp = error.data;
                    Dlg.error(resp.msg);
                }).finally(function () {
                defer.resolve();
            });

            return defer.promise;
        }
    }
})();


(function () {
    'use strict';

    angular.module('c')
        .controller('SecondUserDlgCtrl', SecondUserDlgCtrl);

    /** @ngInject */
    function SecondUserDlgCtrl($scope, Dlg, $q, $uibModalInstance, FormHelper, DeptGroup, UserInfo, data, City, County,
                               Street, ArrayHelper, ExtHelper) {
        var vm = this;
        var helper = UserInfo.formHelper;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.provinceSelected = provinceSelected;
        vm.citySelected = citySelected;
        vm.countySelected = countySelected;
        vm.phoneConfirm = data.phoneConfirm;
        vm.phoneConfirm1 = data.phoneConfirm1;

        init();

        function init() {
            ExtHelper.chkCardReadExt(vm);
            vm.showRelative = false;
            vm.queryInfo = true;
            helper.init(vm);

            $q.all([
                UserInfo.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                helper.bindAsyncOptions(vm, respArray[0]);
                vm.m = data.r;
                if (angular.isUndefined(vm.m.id)) vm.m.id = '-';
                if (vm.m.type.id === 1) {
                    vm.m.male = 1;
                } else {
                    vm.m.male = 0;
                }
                if (angular.isUndefined(vm.m.nation)) vm.m.nation = vm.nations[1];
                if (angular.isUndefined(vm.m.political_status)) vm.m.political_status = vm.politicalStatuses[1];
                if (angular.isUndefined(vm.m.diseases)) vm.m.diseases = [];
                if (angular.isUndefined(vm.m.workCompany)) vm.m.workCompany = [];
                if (angular.isUndefined(vm.m.manageCompany)) vm.m.manageCompany = [];
                if (angular.isUndefined(vm.m.fd_type)) vm.m.fd_type = 0;
                if (angular.isUndefined(vm.m.free)) vm.m.free = false;
            });
        }

        var editProvince = true;

        function provinceSelected(item, m) {
            City.query({opt: 2, province_id: item.id}, function (resp) {
                vm.cities = resp.items;
                if (m.id && editProvince) {
                    editProvince = false;
                    if (m.city) {
                        m.city = ArrayHelper.getItem(m.city.id, vm.cities);
                    }
                } else {
                    m.city = vm.cities[0];
                }
                if (m.city) {
                    citySelected(m.city, m);
                }
            });
        }

        var editCity = true;

        function citySelected(item, m) {
            County.query({opt: 2, city_id: item.id}, function (resp) {
                vm.counties = resp.items;
                if (m.id && editCity) {
                    editCity = false;
                    if (m.county) {
                        m.county = ArrayHelper.getItem(m.county.id, vm.counties);
                    }
                } else {
                    m.county = vm.counties[0];
                }
                if (m.county) {
                    countySelected(m.county, m);
                }
            });
        }

        var editCounty = true;

        function countySelected(item, m) {
            Street.query({opt: 2, county_id: item.id}, function (resp) {
                vm.streets = resp.items;
                if (m.id && editCounty) {
                    editCounty = false;
                    if (m.street) {
                        m.street = ArrayHelper.getItem(m.street.id, vm.streets);
                    }
                } else {
                    // m.street = vm.streets[0];
                }
            });
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                $uibModalInstance.close(m);
            });

        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('UserChangeTypeCtrl', UserChangeTypeCtrl);

    /** @ngInject */
    function UserChangeTypeCtrl($scope, $uibModalInstance, toaster, data) {
        var user = data.user;
        $scope.statuses = data.statuses;
        $scope.user = {id: user.id, username: user.username, status: user.status, time: new Date()};
        $scope.ok = function (user) {
            if ($scope.otype_form.$valid) {
                var pa = {};
                pa['username'] = user.username;
                pa['status_id'] = user.status.id;
                pa['user_id'] = user.id;
                pa['time'] = user.time;
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                $scope.otype_form.submitted = true;
            }
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('changePasswordDlgCtrl', changePasswordDlgCtrl);

    /** @ngInject */
    function changePasswordDlgCtrl($uibModalInstance, Dlg, data, User,
                                   FormHelper, $q) {
        var vm = this;
        vm.m = data.user;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        function ok(m) {
            var defer = $q.defer();
            if (!vm.password_form.$valid) {
                FormHelper.handleError('#password_form', vm.password_form);
                defer.reject();
            } else {
                User.update({id: m.id}, {
                    password: m.password,
                    op: 'password'
                }).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    Dlg.e(error.msg);
                });
            }
            defer.resolve();

            return defer.promise;
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('ChangeTypeRecordCtrl', ChangeTypeRecordCtrl);

    /** @ngInject */
    function ChangeTypeRecordCtrl($scope, $uibModalInstance, NgTableParams, UserOnType, Table, data) {
        $scope.user = data.user;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [5, 10], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['user_id'] = data.user.id;
                Table.query(UserOnType, url, $defer, params, 'onTypes');
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('PersonnelUserEditCtrl', PersonnelUserEditCtrl);

    /** @ngInject */
    function PersonnelUserEditCtrl($scope, $uibModalInstance, $timeout, ServiceRecord, UserInfo, ArrayHelper, DeptGroup,
                                   data, $q, Dlg, FormHelper, DateHelper, $interval, City, County, Street, ExtHelper) {
        var vm = this;
        var helper = UserInfo.formHelper;
        var op = data.op;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;
        vm.showRelative = true;
        vm.queryInfo = false;
        vm.cancelError = cancelError;
        vm.phoneConfirm = data.phoneConfirm;
        vm.provinceSelected = provinceSelected;
        vm.citySelected = citySelected;
        vm.countySelected = countySelected;
        vm.hideIllInfo = data.hideIllInfo;
        vm.phoneConfirm1 = data.phoneConfirm1;


        // vm.timer = $interval(function () {
        //     saveData();
        // }, 5000);
        //
        // $scope.$on('$destroy', function () {
        //     $interval.cancel(vm.timer);
        // });


        init();


        function init() {
            ExtHelper.chkCardReadExt(vm);
            helper.init(vm);

            switch (op) {
                case 'info_confirm':
                    vm.title = '确认退休人员信息';
                    break;
                default: // personnel_confirm
                    vm.title = '修改退休人员信息';
            }

            $q.all([
                UserInfo.get({id: data.id}).$promise,
                UserInfo.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                helper.bindAsyncOptions(vm, respArray[1]);
                localStorage.removeItem('userInfo' + data.id);
                // var info = localStorage.getItem('userInfo' + data.id);
                // if (info) {
                //     vm.m = JSON.parse(info);
                //     if (vm.m.province) vm.provinceSelected(vm.m.province, vm.m);
                // } else {
                var item = respArray[0].item;
                helper.loadItem(item);
                vm.m = item;
                // }
            });
        }

        var editProvince = true;

        function provinceSelected(item, m) {
            City.query({opt: 2, province_id: item.id}, function (resp) {
                vm.cities = resp.items;
                if (m.id && editProvince) {
                    editProvince = false;
                    if (m.city) {
                        m.city = ArrayHelper.getItem(m.city.id, vm.cities);
                    }
                } else {
                    m.city = vm.cities[0];
                }
                if (m.city) {
                    citySelected(m.city, m);
                }
            });
        }

        var editCity = true;

        function citySelected(item, m) {
            County.query({opt: 2, city_id: item.id}, function (resp) {
                vm.counties = resp.items;
                if (m.id && editCity) {
                    editCity = false;
                    if (m.county) {
                        m.county = ArrayHelper.getItem(m.county.id, vm.counties);
                    }
                } else {
                    m.county = vm.counties[0];
                }
                if (m.county) {
                    countySelected(m.county, m);
                }
            });
        }

        var editCounty = true;

        function countySelected(item, m) {
            Street.query({opt: 2, county_id: item.id}, function (resp) {
                vm.streets = resp.items;
                if (m.id && editCounty) {
                    editCounty = false;
                    if (m.street) {
                        m.street = ArrayHelper.getItem(m.street.id, vm.streets);
                    }
                } else {
                    // m.street = vm.streets[0];
                }
            });
        }

        // function saveData() {
        //     if (vm.m) {
        //         localStorage.setItem('userInfo' + vm.m.id, JSON.stringify(vm.m));
        //     }
        // }

        function cancelError() {
            vm.errorReason = null;
        }

        function ok(m) {
            if (vm.errorReason) {
                var reason;
                switch (vm.errorReason) {
                    case '1':
                        reason = '电话信息有误';
                        break;
                    case '2':
                        reason = '电话未接通';
                        break;
                    case '3':
                        reason = '当事人不配合';
                        break;
                }
                ServiceRecord.update({id: data.serviceRecordId}, {
                    op: 'error_confirm',
                    reason: reason
                }).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    // localStorage.removeItem('userInfo' + m.id);
                    $uibModalInstance.close();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            } else {
                return FormHelper.handleSubmit(vm, function (defer) {
                    var pa = helper.loadParams(m);
                    var num = 0, typeNum = 0;
                    if (m.relatives.length > 0) {
                        var relatives = [];
                        for (var i = 0; i < m.relatives.length; i++) {
                            var r = m.relatives[i];
                            //同为退休人员
                            if (r.id_card) {
                                if (r.id_card === m.id_card) {
                                    Dlg.w('用户和离退休亲属的身份证信息相同');
                                    return
                                }
                                num++;
                                var relative = helper.loadParams(r);
                                relative.type = r.type;
                                relatives.push(relative)
                            } else {
                                relatives.push(r)
                            }

                            if (r.type && r.type.id == 1) {
                                typeNum++;
                            }
                        }
                        pa.relatives = relatives;
                    }
                    if (num > 1) {
                        Dlg.w('同为退休人员的亲属最多允许添加一个');
                        return
                    }
                    if (typeNum > 1) {
                        Dlg.w('配偶关系最多允许添加一个');
                        return
                    }

                    var id, service;
                    switch (op) {
                        case 'info_confirm':
                            id = data.serviceRecordId;
                            pa.user_id = m.id;
                            service = ServiceRecord;
                            break;
                        default: // personnel_confirm
                            id = m.id;
                            service = UserInfo;
                    }
                    pa.op = op;
                    service.update({id: id}, pa).$promise.then(function (resp) {
                        if (resp.msg) Dlg.s(resp.msg);
                        // localStorage.removeItem('userInfo' + m.id);
                        $uibModalInstance.close(resp.user);
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Dlg.e(data.msg);
                    }).finally(function () {
                        defer.resolve();
                    });
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('ExportUserInfoDlgCtrl', ExportUserInfoDlgCtrl);

    /** @ngInject */
    function ExportUserInfoDlgCtrl($uibModalInstance, User, FileHelper, $q) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init();


        function init() {
            $q.all([
                User.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                console.log('respArray', respArray);
                vm.types = respArray[0].items.types;
                vm.statuses = respArray[0].items.statuses;
                vm.political_statuses = respArray[0].items.political_statuses;
            });
        }

        function ok(m) {
            var pa = {
                phoneNull: m.phoneNull,
                not_confirm: m.not_confirm,
                not_photo: m.not_photo,
                depts: [],
                types: [],
                status: [],
                political_status: []
            };

            angular.forEach(m.dept, function (dept) {
                pa.depts.push(dept.id)
            });
            angular.forEach(m.type, function (type) {
                pa.types.push(type.id)
            });
            angular.forEach(m.status, function (status) {
                pa.status.push(status.id)
            });
            angular.forEach(m.political_status, function (political_status) {
                pa.political_status.push(political_status.id)
            });

            FileHelper.dnExcel(User.urls.EXPORT_STA, pa, '统计信息表.xls');
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('PersonnelUserShowCtrl', PersonnelUserShowCtrl)
    ;

    /** @ngInject */
    function PersonnelUserShowCtrl($scope, $uibModalInstance, data, UserInfo, ArrayHelper) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        var helper = UserInfo.formHelper;

        init(data.id);


        function init(id) {
            helper.init(vm);
            UserInfo.get({id: id}, function (resp) {
                var m = resp.item;
                loadItem(m);
                var relatives = [];
                angular.forEach(m.s_users, function (item) {
                    loadItem(item);
                    item.type = ArrayHelper.getItem(item.pivot.type, vm.relativeTypes);
                    relatives.push(item);
                });

                angular.forEach(m.relatives, function (item) {
                    item.type = ArrayHelper.getItem(item.pivot.type, vm.relativeTypes);
                    relatives.push(item);
                });

                m.relatives = relatives;
                vm.user = m;
            });
        }

        function loadItem(item) {
            item.work_state = ArrayHelper.getItem(item.work_state, vm.workStates);
            item.house_type = ArrayHelper.getItem(item.house_type, vm.houseTypes);
            item.soldier_type = ArrayHelper.getItem(item.soldier_type, vm.soldierTypes);
            item.live_type = ArrayHelper.getItem(item.live_type, vm.liveTypes);
            item.marry_type = ArrayHelper.getItem(item.marry_type, vm.marryTypes);
            item.self_care = ArrayHelper.getItem(item.self_care, vm.selfCares);
            item.relative_type = ArrayHelper.getItem(item.relative_type, vm.relativeTypes);
            item.identity = ArrayHelper.getItem(item.identity, vm.identities);
            item.elderly_service_type = ArrayHelper.getItem(item.elderly_service_type, vm.elderlyServiceTypes);
            item.elderly_service_grade = ArrayHelper.getItem(item.elderly_service_grade, vm.elderlyServiceGrades);
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('PersonnelUserShowFdCtrl', PersonnelUserShowFdCtrl);

    /** @ngInject */
    function PersonnelUserShowFdCtrl($uibModalInstance, ArrayHelper, Dlg, UserInfo, data) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;


        init(data.id);


        function init(id) {
            UserInfo.get({id: id}).$promise.then(function (resp) {
                vm.m = resp.item;
            })
        }

        function ok(m) {
            return Dlg.addEditOk(vm, UserInfo, function () {
                return {
                    fd: m.fd
                };
            }, {op: 'fd'});
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('PersonnelUserShowOlderCtrl', PersonnelUserShowOlderCtrl);

    /** @ngInject */
    function PersonnelUserShowOlderCtrl($uibModalInstance, ArrayHelper, Dlg, UserInfo, data) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;


        init(data.id);


        function init(id) {
            UserInfo.formHelper.init(vm);
            UserInfo.get({id: id}).$promise.then(function (resp) {
                vm.m = resp.item;
                vm.m.elderly_service_type = ArrayHelper.getItem(vm.m.elderly_service_type, vm.elderlyServiceTypes);
                vm.m.elderly_service_grade = ArrayHelper.getItem(vm.m.elderly_service_grade, vm.elderlyServiceGrades);
            })
        }

        function ok(m) {
            return Dlg.addEditOk(vm, UserInfo, function () {
                return {
                    elderly_service: m.elderly_service ? 1 : 0,
                    elderly_service_type: m.elderly_service_type ? m.elderly_service_type.id : null,
                    elderly_service_grade: m.elderly_service_grade ? m.elderly_service_grade.id : null,
                };
            }, {op: 'older'});
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('UserInfoCdCtrl', UserInfoCdCtrl);

    /** @ngInject */
    function UserInfoCdCtrl($scope, $state, $q, Dlg, UserInfo, Table, ArrayHelper, User, FileHelper, PrintHelper, UIHelper) {
        var options;
        var vm = $scope;
        var helper = UserInfo.formHelper;
        vm.upload = upload;

        vm.visibleOptions = [
            {name: '基本信息', value: 0x01},
            {name: '党组织信息', value: 0x02},
            {name: '居住信息', value: 0x04},
            {name: '工作信息', value: 0x08},
            {name: '医疗信息', value: 0x10},
            {name: '安置信息', value: 0x20},
            {name: '待遇信息', value: 0x40},
            {name: '全部信息', value: 0xff}
        ];
        vm.optionSelectedFn = optionSelectedFn;
        vm.show = show;
        vm.edit = edit;
        vm.transfer = transfer;
        vm.changePwd = changePwd;
        vm.exportDn = exportDn;
        vm.clearWxBind = clearWxBind;
        vm.download = download;
        vm.select = select;
        vm.option = {name: '基本信息', value: 1};
        vm.print = print;
        vm.batchPrint = batchPrint;
        var checker = Table.loadMultiSelectedFn(vm);
        vm.init = init;

        // init();


        function init(tab) {
            UIHelper.loadTab(vm, tab);
            helper.init(vm);
            vm.sexes = UserInfo.getSexes();
            vm.yesNos = UserInfo.getYesNos();
            vm.hasOrNot = UserInfo.getHasOrNot();

            $q.all([
                UserInfo.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                helper.bindAsyncOptions(vm, respArray[0]);
                setupOption(tab);
                var optionFn = Table.load(vm, options, function (resp, startSn) {
                    Table.loadItem(resp, startSn, function (item, i) {
                        item.work_state = ArrayHelper.getItem(item.work_state, vm.workStates);
                        item.house_type = ArrayHelper.getItem(item.house_type, vm.houseTypes);
                        item.soldier_type = ArrayHelper.getItem(item.soldier_type, vm.soldierTypes);
                        item.live_type = ArrayHelper.getItem(item.live_type, vm.liveTypes);
                        item.marry_type = ArrayHelper.getItem(item.marry_type, vm.marryTypes);
                        item.self_care = ArrayHelper.getItem(item.self_care, vm.selfCares);
                        item.relative_type = ArrayHelper.getItem(item.relative_type, vm.relativeTypes);

                        item.male = ArrayHelper.getItem(item.male, vm.sexes);
                        item.has_children = ArrayHelper.getItem(item.has_children, vm.hasOrNot);
                        item.same_city = ArrayHelper.getItem(item.same_city, vm.yesNos);
                        item.identity = ArrayHelper.getItem(item.identity, vm.identities);
                        item.mi_servant = ArrayHelper.getItem(item.mi_servant, vm.yesNos);
                        item.disability = ArrayHelper.getItem(item.disability, vm.yesNos);
                        item.ex_serviceman = ArrayHelper.getItem(item.ex_serviceman, vm.yesNos);
                        item.servant = ArrayHelper.getItem(item.servant, vm.yesNos);
                        item.incapable = ArrayHelper.getItem(item.incapable, vm.yesNos);
                        item.difficulty = ArrayHelper.getItem(item.difficulty, vm.yesNos);
                        item.illness = ArrayHelper.getItem(item.illness, vm.yesNos);
                        item.recuperation = ArrayHelper.getItem(item.recuperation, vm.yesNos);
                        item.ss_number = item.ss_number ? item.ss_number : '暂无';
                        item.ss_card = item.ss_card ? item.ss_card : '暂无';

                    });
                }).options;

                optionSelectedFn(vm.option, tab);

                optionFn().cols[3].data = Table.getNgTableOpts(vm.sexes);
                optionFn().cols[5].data = Table.getNgTableOpts(vm.nations);
                optionFn().cols[7].data = Table.getNgTableOpts(vm.politicalStatuses);
                optionFn().cols[18].data = Table.getNgTableOpts(vm.houseTypes);
                optionFn().cols[21].data = Table.getNgTableOpts(vm.liveTypes);
                optionFn().cols[22].data = Table.getNgTableOpts(vm.marryTypes);
                optionFn().cols[23].data = Table.getNgTableOpts(vm.hasOrNot);
                optionFn().cols[24].data = Table.getNgTableOpts(vm.yesNos);
                optionFn().cols[25].data = Table.getNgTableOpts(vm.workStates);
                optionFn().cols[29].data = Table.getNgTableOpts(vm.identities);
                optionFn().cols[30].data = Table.getNgTableOpts(vm.retirementTypes);
                optionFn().cols[37].data = Table.getNgTableOpts(vm.manageTypes);
                optionFn().cols[40].data = Table.getNgTableOpts(vm.yesNos);
                optionFn().cols[41].data = Table.getNgTableOpts(vm.yesNos);
                optionFn().cols[42].data = Table.getNgTableOpts(vm.disableLevels);
                optionFn().cols[43].data = Table.getNgTableOpts(vm.selfCares);
                optionFn().cols[51].data = Table.getNgTableOpts(vm.soldierTypes);
                optionFn().cols[52].data = Table.getNgTableOpts(vm.yesNos);
                optionFn().cols[74].data = Table.getNgTableOpts(vm.yesNos);
                optionFn().cols[76].data = Table.getNgTableOpts(vm.yesNos);
                optionFn().cols[77].data = Table.getNgTableOpts(vm.yesNos);
                optionFn().cols[78].data = Table.getNgTableOpts(vm.yesNos);
                optionFn().cols[79].data = Table.getNgTableOpts(vm.yesNos);
            })
        }

        function setupOption(tab) {
            options = {
                service: UserInfo,
                params: {op: 'personnel_info', type: tab},
                optInFront: true,
                optColWidth: Table._3_BTN,
                count: 10,
                counts: [10, 30, 50, 500],
                cols: [
                    /* 基本信息 */
                    { // 0
                        title: '序号',
                        field: 'sn',
                        type: 0xff,
                        width: Table._1_CHAR
                    },
                    { // 1
                        title: '姓名',
                        filter: {name: 'text'},
                        field: 'name',
                        width: 100,
                        type: 0xff
                    },
                    { // 2
                        title: '身份证',
                        filter: {id_card: 'text'},
                        field: 'id_card',
                        type: 0xff
                    },
                    { // 3
                        title: '性别',
                        filter: {male: 'select'},
                        field: 'male',
                        type: 0x01
                    },
                    { // 4
                        title: '出生日期',
                        filter: {birthday: 'date_range'},
                        field: 'birthday',
                        type: 0x01
                    },
                    { // 5
                        title: '民族',
                        filter: {nation_id: 'select'},
                        field: 'nation',
                        type: 0x01
                    },
                    { // 6
                        title: '籍贯',
                        filter: {native_place: 'text'},
                        field: 'native_place',
                        type: 0x01
                    },
                    { // 7
                        title: '政治面貌',
                        filter: {political_status_id: 'select'},
                        field: 'political_status',
                        type: 0x01
                    },
                    { // 8
                        title: '社保编号',
                        filter: {ss_number: 'text'},
                        field: 'ss_number',
                        type: 0x01
                    },
                    { // 9
                        title: '社保卡号',
                        filter: {ss_card: 'text'},
                        field: 'ss_card',
                        type: 0x01
                    },
                    { // 10
                        title: '手机号码',
                        filter: {phone: 'text'},
                        field: 'phone',
                        type: 0x01
                    },
                    { // 11
                        title: '备用联系电话',
                        filter: {telephone: 'text'},
                        field: 'telephone',
                        type: 0x01
                    },
                    { // 12
                        title: '头像',
                        filter: {photo: 'checkbox'},
                        data: '未传',
                        field: 'photo',
                        type: 0x01
                    },
                    /* 党组织信息 */
                    {// 13
                        title: '加入党组织日期',
                        filter: {party_join_time: 'date_range'},
                        field: 'party_join_time',
                        type: 0x02
                    },
                    {// 14
                        title: '转为正式党员日期',
                        filter: {party_member_time: 'date_range'},
                        field: 'party_member_time',
                        type: 0x02
                    },// 7
                    {// 15
                        title: '原党支部名称',
                        filter: {old_branch_name: 'text'},
                        field: 'old_branch_name',
                        type: 0x02
                    },
                    { // 16
                        title: '现党支部',
                        filter: {p_branch: 'text'},
                        field: 'p_branch',
                        type: 0x02
                    },
                    { // 17
                        title: '现党组织关系所在地',
                        filter: {party_place: 'text'},
                        field: 'party_place',
                        type: 0x02
                    },
                    /* 居住信息 */
                    { // 18
                        title: '住房解决方式',
                        filter: {house_type: 'select'},
                        field: 'house_type',
                        type: 0x04
                    },
                    { // 19
                        title: '长期居住地',
                        filter: {area: 'text'},
                        field: 'area',
                        type: 0x04
                    },
                    { // 20
                        title: '详细地址',
                        filter: {address: 'text'},
                        field: 'address',
                        type: 0x04
                    },
                    { // 21
                        title: '居住状态',
                        filter: {live_type: 'select'},
                        field: 'live_type',
                        type: 0x04
                    },
                    { // 22
                        title: '婚姻状态',
                        filter: {marry_type: 'select'},
                        field: 'marry_type',
                        type: 0x04
                    },
                    { // 23
                        title: '有无子女',
                        filter: {has_children: 'select'},
                        field: 'has_children',
                        type: 0x04
                    },
                    { // 24
                        title: '子女是否居住同一个城市',
                        filter: {same_city: 'select'},
                        field: 'same_city',
                        type: 0x04
                    },
                    /* 工作信息 */
                    { // 25
                        title: '工作状态',
                        filter: {work_state: 'select'},
                        field: 'work_state',
                        type: 0x08
                    },
                    { // 26
                        title: '工作单位',
                        filter: {work_company: 'text'},
                        field: 'work_company',
                        type: 0x08
                    },
                    { // 27
                        title: '职务',
                        filter: {post: 'text'},
                        field: 'post',
                        type: 0x08
                    },
                    { // 28
                        title: '职别',
                        filter: {title: 'text'},
                        field: 'title',
                        type: 0x08
                    },
                    { // 29
                        title: '身份',
                        filter: {identity: 'select'},
                        field: 'identity',
                        type: 0x08
                    },
                    { // 30
                        title: '离退休方式',
                        filter: {retirement_type: 'select'},
                        field: 'retirement_type',
                        type: 0x08
                    },
                    { // 31
                        title: '参加工作时间',
                        filter: {started_work: 'date_range'},
                        field: 'started_work',
                        type: 0x08
                    },
                    { // 32
                        title: '进藏工作时间',
                        filter: {tibet_work: 'date_range'},
                        field: 'tibet_work',
                        type: 0x08
                    },
                    { // 33
                        title: '离退休时间',
                        filter: {leave_time: 'date_range'},
                        field: 'leave_time',
                        type: 0x08
                    },
                    { // 34
                        title: '连续工龄',
                        filter: {work_time: 'num_range'},
                        field: 'work_time',
                        type: 0x08
                    },
                    { // 35
                        title: '在藏工龄',
                        filter: {tibet_time: 'num_range'},
                        field: 'tibet_time',
                        type: 0x08
                    },
                    { // 36
                        title: '主管单位',
                        filter: {manage_company: 'text'},
                        field: 'manage_company',
                        type: 0x08
                    },
                    { // 37
                        title: '管理方式',
                        filter: {manage_type_id: 'select'},
                        field: 'manage_type',
                        type: 0x08
                    },
                    /* 医疗信息 */
                    { // 38
                        title: '医保类型',
                        filter: {mi: 'text'},
                        field: 'mi',
                        type: 0x10
                    },
                    { // 39
                        title: '医疗保险参保地',
                        filter: {mi_place: 'text'},
                        field: 'mi_place',
                        type: 0x10
                    },
                    { // 40
                        title: '是否享受公务员医疗补助',
                        filter: {mi_servant: 'select'},
                        field: 'mi_servant',
                        type: 0x10
                    },
                    { // 41
                        title: '是否残疾',
                        filter: {disability: 'select'},
                        field: 'disability',
                        type: 0x10
                    },
                    { // 42
                        title: '评残程度',
                        filter: {disable_level: 'select'},
                        field: 'disable_level',
                        type: 0x10
                    },
                    { // 43
                        title: '生活自理能力',
                        filter: {self_care: 'select'},
                        field: 'self_care',
                        type: 0x10
                    },
                    { // 44
                        title: '慢性疾病',
                        filter: {disease: 'text'},
                        field: 'disease',
                        type: 0x10
                    },
                    { // 45
                        title: '门诊特殊疾病定点医院',
                        filter: {fixed_hospital: 'text'},
                        field: 'fixed_hospital',
                        type: 0x10
                    },
                    { // 46
                        title: '联络站',
                        filter: {dept: 'text'},
                        field: 'dept',
                        type: 0x10
                    },
                    { // 47
                        title: '信息更新时间',
                        filter: {change_time: 'date_range'},
                        field: 'change_time',
                        type: 0x10
                    },
                    { // 48
                        title: '死亡时间',
                        filter: {dead_time: 'date_range'},
                        field: 'dead_time',
                        type: 0x10
                    },
                    /* 安置信息 */
                    { // 49
                        title: '安置时间',
                        filter: {resettlement_time: 'date_range'},
                        field: 'resettlement_time',
                        type: 0x20
                    },
                    { // 50
                        title: '供给时间',
                        filter: {supply_time: 'date_range'},
                        field: 'supply_time',
                        type: 0x20
                    },
                    { // 51
                        title: '老战士类型',
                        filter: {soldier_type: 'select'},
                        field: 'soldier_type',
                        type: 0x20
                    },
                    { // 52
                        title: '是否军转干部',
                        filter: {ex_serviceman: 'select'},
                        field: 'ex_serviceman',
                        type: 0x20
                    },
                    { // 53
                        title: '开户银行',
                        filter: {bank: 'text'},
                        field: 'bank',
                        type: 0x20
                    },
                    { // 54
                        title: '银行账号',
                        filter: {bank_account: 'text'},
                        field: 'bank_account',
                        type: 0x20
                    },
                    { // 55
                        title: '月工资',
                        filter: {wage: 'num_range'},
                        field: 'wage',
                        type: 0x20
                    },
                    { // 56
                        title: '管理费',
                        filter: {manage_fee: 'num_range'},
                        field: 'manage_fee',
                        type: 0x20
                    },
                    { // 57
                        title: '活动费',
                        filter: {activity_fee: 'num_range'},
                        field: 'activity_fee',
                        type: 0x20
                    },
                    { // 58
                        title: '加发工资',
                        filter: {add_fee: 'num_range'},
                        field: 'add_fee',
                        type: 0x20
                    },
                    { // 59
                        title: '健康老人补贴',
                        filter: {health_fee: 'num_range'},
                        field: 'health_fee',
                        type: 0x20
                    },
                    { // 60
                        title: '福利费',
                        filter: {welfare_fee: 'num_range'},
                        field: 'welfare_fee',
                        type: 0x20
                    },
                    { // 61
                        title: '护理费',
                        filter: {nurse_fee: 'num_range'},
                        field: 'nurse_fee',
                        type: 0x20
                    },
                    { // 62
                        title: '电话费',
                        filter: {phone_fee: 'num_range'},
                        field: 'phone_fee',
                        type: 0x20
                    },
                    { // 63
                        title: '体检费标准',
                        filter: {examine_fee: 'num_range'},
                        field: 'examine_fee',
                        type: 0x20
                    },
                    { // 64
                        title: '月退休金',
                        filter: {retire_fee: 'num_range'},
                        field: 'retire_fee',
                        type: 0x20
                    },
                    { // 65
                        title: '门诊包干费',
                        filter: {clinc_fee: 'num_range'},
                        field: 'clinc_fee',
                        type: 0x20
                    },
                    { // 66
                        title: '高龄护理费',
                        filter: {age_fee: 'num_range'},
                        field: 'age_fee',
                        type: 0x20
                    },
                    { // 67
                        title: '电话月租费',
                        filter: {month_fee: 'num_range'},
                        field: 'month_fee',
                        type: 0x20
                    },
                    { // 68
                        title: '节日慰问费',
                        filter: {festival_fee: 'num_range'},
                        field: 'festival_fee',
                        type: 0x20
                    },
                    { // 69
                        title: '其他工资',
                        filter: {other_fee: 'num_range'},
                        field: 'other_fee',
                        type: 0x20
                    },

                    { // 70
                        title: '护工费',
                        filter: {maintenance_fee: 'num_range'},
                        field: 'maintenance_fee',
                        type: 0x20
                    },
                    { // 71
                        title: '交通费',
                        filter: {traffic_fee: 'num_range'},
                        field: 'traffic_fee',
                        type: 0x20
                    },
                    { // 72
                        title: '取暖费',
                        filter: {heating_fee: 'num_range'},
                        field: 'heating_fee',
                        type: 0x20
                    },
                    { // 73
                        title: '福利金',
                        filter: {welfare_fund: 'num_range'},
                        field: 'welfare_fund',
                        type: 0x20
                    },
                    { // 74
                        title: '是否公务员',
                        filter: {servant: 'select'},
                        field: 'servant',
                        type: 0x20
                    },
                    { // 75
                        title: '联行号',
                        filter: {line_number: 'text'},
                        field: 'line_number',
                        type: 0x20
                    },
                    { // 76
                        title: '是否失能',
                        filter: {incapable: 'select'},
                        field: 'incapable',
                        type: 0x20
                    },
                    { // 77
                        title: '是否生活困难',
                        filter: {difficulty: 'select'},
                        field: 'difficulty',
                        type: 0x20
                    },
                    { // 78
                        title: '是否重病',
                        filter: {illness: 'select'},
                        field: 'illness',
                        type: 0x20
                    },
                    { // 79
                        title: '是否疗养',
                        filter: {recuperation: 'select'},
                        field: 'recuperation',
                        type: 0x20
                    },
                    { // 80
                        title: '险种',
                        filter: {insurance: 'text'},
                        field: 'insurance',
                        type: 0x40
                    },
                    { // 81
                        title: '待遇享受起始年月',
                        filter: {provide_time: 'text'},
                        field: 'provide_time',
                        type: 0x40
                    },
                    { // 82
                        title: '待遇发放状态',
                        filter: {provide_state: 'text'},
                        field: 'provide_state',
                        type: 0x40
                    },
                    { // 83
                        title: '待遇发放方式',
                        filter: {provide_type: 'text'},
                        field: 'provide_type',
                        type: 0x40
                    },
                    { // 84
                        title: '待遇合计',
                        filter: {total: 'text'},
                        field: 'total',
                        type: 0x40
                    },
                    { // 85
                        title: '历年调待',
                        filter: {history_sum: 'text'},
                        field: 'history_sum',
                        type: 0x40
                    },
                    { // 86
                        title: '退休退职费',
                        filter: {retirement_fee: 'text'},
                        field: 'retirement_fee',
                        type: 0x40
                    },
                    { // 87
                        title: '防寒补贴',
                        filter: {cold_proof_fee: 'text'},
                        field: 'cold_proof_fee',
                        type: 0x40
                    },
                    { // 88
                        title: '过渡期福利金',
                        filter: {transitional_benefit: 'text'},
                        field: 'transitional_benefit',
                        type: 0x40
                    },
                    { // 89
                        title: '交通补贴',
                        filter: {traffic_subsidy: 'text'},
                        field: 'traffic_subsidy',
                        type: 0x40
                    },
                    { // 90
                        title: '综合性补贴',
                        filter: {comprehensive_subsidy: 'text'},
                        field: 'comprehensive_subsidy',
                        type: 0x40
                    },
                    { // 91
                        title: '离退休帐户金额',
                        filter: {account_amount: 'text'},
                        field: 'account_amount',
                        type: 0x40
                    },
                    { // 92
                        title: '基础养老金',
                        filter: {main_pension: 'text'},
                        field: 'main_pension',
                        type: 0x40
                    },
                    { // 93
                        title: '个人帐户',
                        filter: {self_amount: 'text'},
                        field: 'self_amount',
                        type: 0x40
                    },
                    { // 94
                        title: '过渡性养老金',
                        filter: {transitional_pension: 'text'},
                        field: 'transitional_pension',
                        type: 0x40
                    },
                    { // 95
                        title: '高原补贴',
                        filter: {plateau_subsidy: 'text'},
                        field: 'plateau_subsidy',
                        type: 0x40
                    },
                    { // 96
                        title: '基本养老金',
                        filter: {basic_pension: 'text'},
                        field: 'basic_pension',
                        type: 0x40
                    },
                    { // 97
                        title: '增加基本养老金',
                        filter: {add_pension: 'text'},
                        field: 'add_pension',
                        type: 0x40
                    },
                    { // 98
                        title: '户籍所在地',
                        filter: {domicile: 'text'},
                        field: 'domicile',
                        type: 0x01
                    },
                    { // 99
                        title: '档案管理单位',
                        filter: {archive_co: 'text'},
                        field: 'archive_co',
                        type: 0x01
                    },
                    { // 100
                        title: '户籍所在地派出所',
                        filter: {police_station: 'text'},
                        field: 'police_station',
                        type: 0x01
                    },
                    { // 101
                        title: '社保发放单位',
                        filter: {ss_co: 'text'},
                        field: 'ss_co',
                        type: 0x01
                    },
                    { // 102
                        title: '安置办事处',
                        filter: {resettlement_office: 'text'},
                        field: 'resettlement_office',
                        type: 0x01
                    },
                    { // 103
                        title: '专业特长',
                        filter: {speciality: 'text'},
                        field: 'speciality',
                        type: 0x01
                    },
                    { // 104
                        title: '兴趣爱好',
                        filter: {interest: 'text'},
                        field: 'interest',
                        type: 0x01
                    },
                    { // 105
                        title: '特殊困难',
                        filter: {special_difficulty: 'text'},
                        field: 'special_difficulty',
                        type: 0x01
                    },
                    { // 102
                        title: '个性需求',
                        filter: {individual_need: 'text'},
                        field: 'individual_need',
                        type: 0x01
                    },
                ]
            };
        }

        function optionSelectedFn(option, tab) {
            vm.option = option;
            angular.forEach(vm.cols, function (col) {
                if (col.type & option.value) {
                    col.show = true;
                    col.download = true;
                    if (tab == 'is_sos' && (col.title == '民族' || col.title == '籍贯' || col.title == '社保卡号' || col.title == '社保编号')) {
                        col.show = false;
                        col.download = false;
                    }
                } else {
                    col.show = false;
                    col.download = false;
                }
            });
        }

        function exportDn() {
            Dlg.show({
                template: 'pages/personnel/userInfo/exportDlg.html',
                ctrl: 'ExportUserInfoDlgCtrl',
                data: {}
            }).then(function () {
                Dlg.s('用户信息导出成功!');
            })
        }

        function edit(m) {
            Dlg.show({
                template: 'pages/personnel/userInfo/editDlg.html',
                ctrl: 'PersonnelUserEditCtrl',
                data: {
                    id: m.id, op: 'personnel_confirm'
                }, size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }

        function changePwd(user) {
            Dlg.show({
                template: 'pages/personnel/userInfo/changePasswordDlg.html',
                ctrl: 'changePasswordDlgCtrl',
                data: {user: user.user}
            }).then(function () {
                vm.tableReload();
            });
        }

        function transfer(user) {
            Dlg.show({
                template: 'pages/personnel/deptRecordDlg.html',
                ctrl: 'DeptRecordDlgCtrl',
                data: {user: user, hideOpt: false},
                size: 'lg'
            });
        }

        function clearWxBind(m) {
            User.update({id: m.user.id}, {
                op: 'clear_wx_bind'
            }).$promise.then(function (resp) {
                Dlg.s(resp.msg);
                vm.tableReload();
            }, function (error) {
                Dlg.e(error.msg);
            });
        }

        function show(m) {
            Dlg.show({
                template: 'pages/personnel/userInfo/showDlg.html',
                ctrl: 'PersonnelUserShowCtrl',
                data: {
                    id: m.id
                }, size: 'lg'
            });
        }

        function upload(type) {
            Dlg.show({
                template: 'pages/personnel/userInfo/wageImportDlg.html',
                ctrl: 'WageImportDlgCtrl',
                data: {type: type},
                size: 'full'
            }).then(function () {
                vm.tableReload();
            });
        }

        function select(type) {
            angular.forEach(vm.cols, function (col) {
                col.download = type;
            });
        }

        function download(tab) {
            var pa
            if (tab) {
                pa = {items: [], type: tab};
            } else {
                pa = {items: []};
            }
            angular.forEach(vm.cols, function (col) {
                if (col.download && col.field != 'sn' && col.field != 'photo') pa.items.push(col)
            });
            var defer = $q.defer();
            FileHelper.dnExcel(UserInfo.urls.EXPORT_USER_INFO, pa, '人员信息导出.csv')
                .finally(function () {
                    defer.resolve();
                });
            return defer.promise;
        }


        function print(m) {
            PrintHelper.print(window.open(), function () {
                return getPrintHtml(m);
            });
        }

        function getPrintHtml(m) {
            var html = '<div style="page-break-after: always">';
            html += '<h1 style="text-align: center">西藏离退休人员基本信息调查表</h1>';
            html += '<div style="float: right">填表日期&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日</div>';
            html += '<table width="100%">' + '<tbody><tr>';
            html += '<td width="60">姓名</td>';
            html += '<td>' + m.name + '</td>';
            html += '<td width="60">性别</td>';
            html += '<td>' + m.male.name + '</td>';
            html += '<td width="60">民族</td>';
            html += '<td>' + (m.nation ? m.nation.name : '') + '</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>出生日期</td>';
            html += '<td>' + m.birthday + '</td>';
            html += '<td>籍贯</td>';
            html += '<td>' + (m.native_place ? m.native_place : '') + '</td>';
            html += '<td>学历</td>';
            html += '<td></td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>工作时间</td>';
            html += '<td>' + (m.started_work ? m.started_work : '') + '</td>';
            html += '<td>原职务职级</td>';
            html += '<td>' + (m.post ? m.post : '') + (m.title ? m.title : '') + '</td>';
            html += '<td>子女人数</td>';
            html += '<td></td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>入党时间</td>';
            html += '<td>' + (m.party_join_time ? m.party_join_time : '') + '</td>';
            html += '<td>是否安置</td>';
            html += '<td><input type="checkbox">已安置<input type="checkbox">未安置</td>';
            html += '<td>月养老金</td>';
            html += '<td>' + (m.wage ? m.wage : '') + '</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>身份</td>';
            html += '<td colspan="2"><input type="checkbox">干部&nbsp;&nbsp;&nbsp;&nbsp;<input type="checkbox">工人</td>';
            html += '<td>党员关系</td>';
            html += '<td colspan="2"><input type="checkbox">在西藏&nbsp;&nbsp;&nbsp;&nbsp;<input type="checkbox">已转入内地</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>本人电话</td>';
            html += '<td colspan="2">' + (m.phone ? m.phone : '') + '</td>';
            html += '<td>亲人电话</td>';
            html += '<td colspan="2">' + (m.telephone ? m.telephone : '') + '</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>家庭住址</td>';
            html += '<td colspan="5">' + (m.address ? m.address : '') + '</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>身份证号</td>';
            html += '<td colspan="5">' + (m.id_card ? m.id_card : '') + '</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>原工作单位</td>';
            html += '<td colspan="5">' + (m.work_company ? m.work_company.name : '') + '</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>现所在党支部名称</td>';
            html += '<td colspan="5">' + (m.p_branch ? m.p_branch.name : (m.branch_name ? m.branch_name : '')) + '</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>参加党组织活动</td>';
            html += '<td colspan="5"><input type="checkbox">正常&nbsp;&nbsp;<input type="checkbox">不正常&nbsp;&nbsp;<input type="checkbox">多年未参加</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>党组织关系去向要求</td>';
            html += '<td colspan="5"><input type="checkbox">转成办&nbsp;&nbsp;<input type="checkbox">转所在地&nbsp;&nbsp;<input type="checkbox">不转</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>安置人员希望管理方式</td>';
            html += '<td colspan="5"><input type="checkbox">联络站&nbsp;&nbsp;<input type="checkbox">代管&nbsp;&nbsp;<input type="checkbox">其它</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>家庭子女基本情况</td>';
            html += '<td colspan="5">在藏（&nbsp;&nbsp;&nbsp;&nbsp;）人&nbsp;&nbsp;外地（&nbsp;&nbsp;&nbsp;&nbsp;）人&nbsp;&nbsp;身边（&nbsp;&nbsp;&nbsp;&nbsp;）人</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>家庭子女就业情况</td>';
            html += '<td colspan="5"><input type="checkbox">工作&nbsp;&nbsp;<input type="checkbox">失业&nbsp;&nbsp;<input type="checkbox">低保</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>家庭生活状况</td>';
            html += '<td colspan="5"><input type="checkbox">好&nbsp;&nbsp;<input type="checkbox">良好&nbsp;&nbsp;<input type="checkbox">一般&nbsp;&nbsp;' +
                '<input type="checkbox">困难&nbsp;&nbsp;<input type="checkbox">比较困难&nbsp;&nbsp;<input type="checkbox">特别困难</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>身体状况</td>';
            html += '<td colspan="5"><input type="checkbox">良好&nbsp;&nbsp;<input type="checkbox">慢性病&nbsp;&nbsp;<input type="checkbox">重病&nbsp;&nbsp;' +
                '<input type="checkbox">失能</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>户籍情况</td>';
            html += '<td colspan="5"><input type="checkbox">在藏&nbsp;&nbsp;&nbsp;&nbsp;<input type="checkbox">已迁移内地</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td>现居住房屋所属产权</td>';
            html += '<td colspan="5"><input type="checkbox">大产权&nbsp;&nbsp;<input type="checkbox">小产权&nbsp;&nbsp;<input type="checkbox">其它</td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td height="300px">存在哪些困难</td>';
            html += '<td colspan="5"></td>';
            html += '</tr>';
            html += '<tr>';
            html += '<td height="300px">对办事处的意见建议</td>';
            html += '<td colspan="5"></td>';
            html += '</tr>';
            html += '</tbody></table>';
            html += '<div>备注：请如实在“<input type="checkbox">”内“√”，“（）”内填数据</div>';
            html += '<br/>';
            html += '<br/>';
            html += '</div>';
            return html;
        }

        function batchPrint() {
            var checkItems = checker.getChecked();
            if (!checker.hasChecked() || checkItems.length == 0) {
                Dlg.w('请选择处理对象');
                return;
            }

            PrintHelper.print(window.open('', '打印预览'), function () {
                var html = '';
                angular.forEach(checkItems, function (item) {
                    html += getPrintHtml(item);
                });
                return html;
            }, true);
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('WageImportDlgCtrl', WageImportDlgCtrl);

    /** @ngInject */
    function WageImportDlgCtrl($q, FileHelper, FormHelper, Upload, $uibModalInstance, Dlg,
                               UserInfo, ArrayHelper, data, C, DateHelper, dialogs) {
        var vm = this;
        vm.download = download;
        vm.upload = upload;
        vm.ok = ok;
        vm.pageChanged = pageChanged;
        vm.cancel = $uibModalInstance.dismiss;
        vm.text = data.type === 1 ? '待遇记录' : '调资记录';
        vm.type = data.type;

        init();

        function init() {
            vm.pager = {count: 10, page: 1, total: 0};
            vm.m = {
                month: new Date((new Date()).setDate(1)),
                doc: {},
                items: [],
                lack_items: []
            };
            vm.cols = data.type === 1 ? [{name: '序号'}, {name: '身份证'}, {name: '姓名'},
                    // {name: '人员状态'}, {name: '险种'}, {name: '待遇享受起始年月'}, {name: '待遇发放状态'}, {name: '待遇发放方式'},
                    {name: '离退休帐户金额'}, {name: '基本养老金'}, {name: '退休退职费'}, {name: '防寒补贴'}, {name: '过渡期福利金'},
                    {name: '交通补贴'}, {name: '综合性补贴'}, {name: '待遇合计'}, {name: '基础养老金'},
                    {name: '个人帐户'}, {name: '过渡性养老金'}, {name: '高原补贴'}, {name: '历年调待'}, {name: '增加基本养老金'}]
                : [{name: '序号'}, {name: '身份证'}, {name: '姓名'}, {name: '调资合计'}, {name: '待遇合计'}];
        }

        function upload(file, data, e, rename, extra) {
            if (file == null) {
                return;
            }
            vm.loading = true;
            vm.m.items = [];
            if (angular.isUndefined(rename) || !rename) {
                rename = {};
            }
            if (!rename.name) rename.name = 'attach_name';
            if (!rename.mime) rename.mime = 'mime';
            if (!rename.filename) rename.filename = 'filename';
            if (!rename.size) rename.size = 'size';
            if (e && e[0] && e[0].$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }
            data.progress = 0;
            var pa = {file: file, id: data.id, remap: rename};
            if (angular.isDefined(extra) && extra) {
                ArrayHelper.mergeObj(pa, extra);
            }
            delete data[rename.filename];
            Upload.upload({
                url: FileHelper.urls.UPLOAD, data: pa
            }).progress(function (evt) {
                data.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        data[rename.name] = resp[rename.name];
                        data[rename.mime] = resp[rename.mime];
                        data[rename.filename] = resp[rename.filename];
                        data[rename.size] = resp[rename.size];
                        UserInfo.query({
                            op: 'excel',
                            filename: resp[rename.filename],
                            type: vm.type
                        }, function (excelData) {
                            angular.forEach(excelData.items, function (item, i) {
                                item.index = i;
                            });
                            vm.m.items = excelData.items;
                            vm.m.lack_items = excelData.lackItems;
                            vm.pager.page = 1;
                            vm.pager.total = vm.m.items.length;
                            pageChanged();
                            vm.loading = false;
                            Dlg.s('上传完毕')
                        }, function (error) {
                            vm.loading = false;
                            Dlg.e('上传失败');
                        });
                        break;
                    case 1:
                        data.progress = 101;
                        data.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                data.progress = 102;
                data.errorInfo = '服务器错误!';
            });
        }

        function download() {
            var defer = $q.defer();
            FileHelper.dnExcel(UserInfo.urls.DN_WAGE_EXAMPLE, {type: data.type}, vm.text + "模板.xls")
                .finally(function () {
                    defer.resolve();
                });
            return defer.promise;
        }

        function pageChanged() {
            var pager = vm.pager;
            pager.data = vm.m.items.slice((pager.page - 1) * pager.count, pager.page * pager.count);
        }

        function ok(m) {
            console.log(m);
            var defer = $q.defer();
            if (vm.Form.$valid) {
                var pa = {
                    items: [],
                    type: vm.type,
                    op: 'excel'
                };

                for (var i = 0; i < m.items.length; i++) {
                    var item = m.items[i];
                    if (vm.type == 1) {
                        pa.items.push({
                            user_id: item.userId,
                            insurance: item.insurance,
                            provide_time: item.provide_time,
                            provide_state: item.provide_state,
                            provide_type: item.provide_type,
                            account_amount: item.account_amount,
                            basic_pension: item.basic_pension,
                            retirement_fee: item.retirement_fee,
                            cold_proof_fee: item.cold_proof_fee,
                            transitional_benefit: item.transitional_benefit,
                            traffic_subsidy: item.traffic_subsidy,
                            main_pension: item.main_pension,
                            total: item.total,
                            self_amount: item.self_amount,
                            transitional_pension: item.transitional_pension,
                            plateau_subsidy: item.plateau_subsidy,
                            history_sum: item.history_sum,
                            month: DateHelper.date2Str(m.month)
                        });
                    } else {
                        pa.items.push({
                            user_id: item.userId,
                            money: item.money,
                            total: item.total,
                            month: DateHelper.date2Str(m.month)
                        });
                    }
                }

                UserInfo.save(pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                FormHelper.handleError('#Form', vm.Form);
                defer.reject();
            }
            return defer.promise;
        }

    }

})();


(function () {
    'use strict';

    angular.module('c').controller('UserPhotoDlgCtrl', UserPhotoDlgCtrl);

    /** @ngInject */
    function UserPhotoDlgCtrl($uibModalInstance, $q, Upload, UserInfo, data, Dlg) {
        var vm = this;
        vm.m = {croppedDataUrl: ''};
        vm.upload = upload;
        vm.cancel = $uibModalInstance.dismiss;

        function upload(m) {
            var defer = $q.defer();

            var croppedFile = Upload.dataUrltoBlob(m.croppedDataUrl);
            croppedFile.name = "avatar.png";

            $q.all([
                Upload.upload({url: UserInfo.urls.API + '/' + data.id + '/photo', data: {file: croppedFile}}),
            ]).then(function (respArr) {
                Dlg.s(respArr[0].data.msg);
                $uibModalInstance.close([respArr[0].data.item.photo]);
            }, function (error) {
                if (error.data) Dlg.e(error.data.msg)
            }).finally(function () {
                defer.resolve();
            });

            return defer.promise;
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('SysDeptCtrl', SysDeptCtrl)
        .controller('DeptManageCtrl', DeptManageCtrl)
    ;

    /** @ngInject */
    function SysDeptCtrl($scope, $stateParams, UIHelper) {
        UIHelper.loadTabs($scope, $stateParams);
    }

    /** @ngInject */
    function DeptManageCtrl($scope, Table, UIHelper, Dept, Dlg, Api, ArrayHelper) {
        var vm = $scope;
        vm.addEdit = addEdit;
        vm.setStop = setStop;
        vm.remove = remove;
        vm.init = init;


        function init(op) {
            UIHelper.loadTab(vm, op);

            vm.type = op === 'dept' ? 0 : 1;
            var options = {
                service: Dept,
                params: {op: 'sys'},
                filter: {type: vm.type},
                optInFront: true,
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "sorting", title: "序号", width: Table._2_CHAR},
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "contact_phone", title: '联系电话', filter: {contact_phone: 'text'}},
                ]
            };

            Table.load(vm, options);
        }


        function addEdit(m) {
            Dlg.addEdit(vm, 'pages/sys/dept/deptDlg.html', 'DeptDlgCtrl', m, {type: vm.type});
        }

        function setStop(m) {
            Api.setDisable(Dept, m)
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的部门吗？', function () {
                Dept.delete({id: m.id}).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除部门');
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('DeptDlgCtrl', DeptDlgCtrl);

    /** @ngInject */
    function DeptDlgCtrl($uibModalInstance, Dlg, Dept, data) {
        var vm = this;

        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.type = data.type;

        init(data.id);


        function init(id) {
            if (id) {
                Dept.get({id: id}, function (resp) {
                    var item = resp;
                    vm.m = item;
                });
            } else {
                vm.m = {
                    sorting: 1
                };
            }
        }

        function ok(m) {
            return Dlg.addEditOk(vm, Dept, function () {
                return {
                    name: m.name,
                    type: vm.type,
                    party_cboa: m.party_cboa ? 1 : 0,
                    sorting: m.sorting,
                    contact_phone: m.contact_phone,
                    note: m.note,
                };
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CompanyCtrl', CompanyCtrl)
    ;

    /** @ngInject */
    function CompanyCtrl($scope, Table, ArrayHelper, Dlg, Api, Company) {
        var vm = $scope;
        vm.addEdit = addEdit;
        vm.addUser = addUser;
        vm.setStop = setStop;
        vm.remove = remove;

        init();


        function init() {
            var levels = Company.getLevels();
            var types = Company.getTypes();
            var classes = Company.getClasses();

            var options = {
                service: Company,
                params: {op: 'sys'},
                optInFront: true,
                optColWidth: Table._4_BTN,
                cols: [
                    {field: "sorting", title: "序号", width: '72'},
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "address", title: '地址', filter: {address: 'text'}},
                    {field: "class", title: '类别', filter: {class: 'select'}, data: Table.getNgTableOpts(classes)},
                    {field: "level", title: '性质', filter: {level: 'select'}, data: Table.getNgTableOpts(levels)},
                    {field: "type", title: '分类', filter: {type: 'select'}, data: Table.getNgTableOpts(types)},
                    {field: "note", title: '备注', filter: {note: 'text'}}
                ]
            };

            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.level = ArrayHelper.getItem(item.level, levels);
                    item.class = ArrayHelper.getItem(item.class, classes);
                    item.type = ArrayHelper.getItem(item.type, types);
                });
            });
        }

        function addEdit(m) {
            Dlg.addEdit(vm, 'pages/sys/basic/companyDlg.html', 'CompanyDlgCtrl', m);
        }

        function addUser(m) {
            Dlg.addEdit(vm, 'pages/sys/basic/companyUserDlg.html', 'CompanyUserDlgCtrl', m, {}, 'lg');
        }

        function setStop(m) {
            Api.setDisable(Company, m)
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的单位吗？', function () {
                Company.delete({id: m.id}).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除单位');
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CompanyAddUserDlg', CompanyAddUserDlg);

    /** @ngInject */
    function CompanyAddUserDlg($uibModalInstance, ArrayHelper, Dlg, CompanyUser, data) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.company_id = null;


        init(data.company_id);

        function init(company_id) {
            vm.company_id = company_id;
        }

        function ok(m) {
            return Dlg.addEditOk(vm, CompanyUser, function () {
                var user_id = m.users.map(function (item) {
                    return item.id;
                });

                return {
                    company_id: vm.company_id,
                    user_ids: user_id
                };
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CompanyDlgCtrl', CompanyDlgCtrl);

    /** @ngInject */
    function CompanyDlgCtrl($uibModalInstance, ArrayHelper, Dlg, Company, data, Province, City, County) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.provinceSelected = provinceSelected;
        vm.citySelected = citySelected;


        init(data.id);


        function init(id) {
            vm.levels = Company.getLevels();
            vm.types = Company.getTypes();
            vm.classes = Company.getClasses();

            vm.id = id;
            Province.query({opt: 2}, function (resp) {
                vm.provinces = resp.items;
                if (id) {
                    vm.m = Company.get({id: id}).$promise.then(function (resp) {
                        vm.m = resp;
                        vm.m.type = ArrayHelper.getItem(vm.m.type, vm.types);
                        vm.m.level = ArrayHelper.getItem(vm.m.level, vm.levels);
                        vm.m.class = ArrayHelper.getItem(vm.m.class, vm.classes);
                        if (vm.m.province) {
                            provinceSelected(vm.m.province);
                        }
                    });
                } else {
                    vm.m = {
                        sorting: 1
                    };
                }
            });
        }

        var editProvince = true;

        function provinceSelected(m) {
            City.query({opt: 2, province_id: m.id}, function (resp) {
                vm.cities = resp.items;
                if (vm.id && editProvince) {
                    editProvince = false;
                    if (vm.m.city) {
                        vm.m.city = ArrayHelper.getItem(vm.m.city.id, vm.cities);
                    }
                } else {
                    vm.m.city = vm.cities[0];
                }
                citySelected(vm.m.city);
            });
        }

        var editCity = true;

        function citySelected(m) {
            County.query({opt: 2, city_id: m.id}, function (resp) {
                vm.counties = resp.items;
                if (vm.id && editCity) {
                    editCity = false;
                    if (vm.m.county) {
                        vm.m.county = ArrayHelper.getItem(vm.m.county.id, vm.counties);
                    }
                } else {
                    vm.m.county = vm.counties[0];
                }
            });
        }

        function ok(m) {
            return Dlg.addEditOk(vm, Company, function () {
                return {
                    name: m.name,
                    sorting: m.sorting,
                    level: m.level.id,
                    class: m.class.id,
                    type: m.type.id,
                    province_id: m.province.id,
                    city_id: m.city.id,
                    county_id: m.county ? m.county.id : null,
                    note: m.note
                };
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CompanyUserDlgCtrl', CompanyUserDlgCtrl);

    /** @ngInject */
    function CompanyUserDlgCtrl($scope, $uibModalInstance, ArrayHelper, Dlg, Company, data, CompanyUser, Table) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.editUser = editUser;
        vm.addUser = addUser;
        vm.removeUser = removeUser;
        vm.company_id = null;

        init(data.id);

        function init(id) {
            vm.company_id = id;
            var options = {
                service: CompanyUser,
                params: {op: 'default', company_id: id},
                optInFront: true,
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "user", title: "用户名", filter: {user: "text"}},
                    {field: "post", title: "职务", filter: {post: "text"}},
                ]
            };

            Table.load($scope, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                });
            });
            vm.tableReload = $scope.tableReload;
        }

        function editUser(m) {
            Dlg.comment({title: '员工职务', label: '职务'}, function (post) {
                CompanyUser.update({id: m.id}, {post: post}).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    Dlg.e(data.msg);
                });
            });
        }

        function addUser() {
            Dlg.addEdit(vm, 'pages/sys/basic/companyAddUserDlg.html', 'CompanyAddUserDlg', {},
                {company_id: vm.company_id});
        }

        function removeUser(m) {
            Dlg.delTableItem(CompanyUser, m.id, vm, '人员', m.user.name);
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('ManageUserRegCtrl', ManageUserRegCtrl)
    ;

    /** @ngInject */
    function ManageUserRegCtrl(User, Dlg, FormHelper) {
        var vm = this;
        vm.reset = reset;
        vm.ok = ok;
        var defVal = {name: '', username: ''};

        init();


        function init() {
            vm.m = angular.copy(defVal);
        }

        function ok(m) {
            FormHelper.handleSubmit(vm, function (defer) {
                var params = {
                    name: m.name,
                    username: m.username,
                    op: 'reg'
                };
                User.save(params).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    reset()
                }, function (error) {
                    var resp = error.data;
                    Dlg.error(resp.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }

        function reset() {
            vm.Form.$setUntouched();
            vm.Form.$setPristine();
            delete vm.m;
            vm.m = angular.copy(defVal);
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .directive('deptSelector', deptSelector)
        .controller('DeptSelectCtrl', DeptSelectCtrl);

    /** @ngInject */
    function deptSelector(Dlg) {
        return {
            templateUrl: 'directives/form/dept-selector/dept-selector.html',
            restrict: 'E',
            replace: true,
            scope: {
                model: '=ngModel',
                updateMod: '=?', // 是否修改模式，否则是追加模式
                multiSelect: '=?',
                existDepts: '=?',
                placeHolder: '@',
                disabled: '=?'
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.selectDeptFn = selectDeptFn;
                vm.selectTag = selectTag;
                vm.removeChoice = removeChoice;

                init();


                function init() {
                    vm.multiSelect = angular.isDefined(iAttrs.multiSelect);
                    vm.updateMod = angular.isDefined(iAttrs.updateMod);

                    ngModelCtrl.$isEmpty = vm.multiSelect ? function () {
                            return !vm.model || vm.model.length === 0;
                        } : ngModelCtrl.$isEmpty;
                    if (angular.isUndefined(vm.updateMod)) vm.updateMod = false;
                    if (angular.isUndefined(vm.multiSelect)) vm.multiSelect = false;
                    if (angular.isUndefined(vm.existDepts)) vm.existDepts = [];
                    if (angular.isUndefined(vm.model)) {
                        if (vm.multiSelect) {
                            vm.model = [];
                        }
                    }
                    if (angular.isUndefined(vm.placeHolder)) {
                        vm.placeHolder = '选择部门';
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    if (vm.multiSelect) {
                        valid = (!!iAttrs.required) ? (!!ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.length > 0) : true;
                    } else {
                        valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    }
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectDeptFn(multiSelect, existDepts) {
                    vm.activeMatchIndex = -1;
                    Dlg.show({
                        template: 'directives/form/dept-selector/dept_selector_dlg.html',
                        ctrl: 'DeptSelectCtrl',
                        data: {
                            multiSelect: multiSelect,
                            model: vm.model,
                            existDepts: existDepts,
                            updateMod: vm.updateMod
                        }
                    }).then(function (params) {
                        if (params.length > 0) {
                            if (!multiSelect) {
                                vm.model = params[0];
                            } else {
                                if (vm.updateMod) {
                                    vm.model = params;
                                } else {
                                    angular.forEach(params, function (dept) {
                                        vm.model.push(dept);
                                    });
                                }
                            }
                        } else {
                            if (!multiSelect) {
                                vm.model = null;
                            } else {
                                vm.model = [];
                            }
                        }
                        ngModelCtrl.$setViewValue(vm.model);
                        checkValidity();
                    }).finally(function () {
                        ngModelCtrl.$setTouched();
                    });
                }

                function selectTag($event, $index) {
                    $event.stopPropagation();
                    vm.activeMatchIndex = $index;
                }

                function removeChoice($event, $index) {
                    vm.activeMatchIndex = -1;
                    $event.stopPropagation();
                    vm.model.splice($index, 1);
                    ngModelCtrl.$setTouched();
                    checkValidity();
                }
            }
        }
    }

    /** @ngInject */
    function DeptSelectCtrl($scope, $uibModalInstance, ArrayHelper, DeptType, Dept, data) {
        var vm = $scope;
        var updateMod;
        vm.selectTypes = [
            {id: 1, name: '按部门选择', exAll: false, fresh: true},
            {id: 3, name: '按名称选择', fresh: true}
        ];
        vm.curType = vm.selectTypes[0];
        vm.selected = []; //所有选中的人
        vm.loading = false;

        vm.typeSelectedFn = typeSelectedFn;
        vm.toggleDeptTypeNode = toggleDeptTypeNode;
        vm.selectTypeDepts = selectTypeDepts;
        vm.selectDepts = selectDepts;
        vm.removeSelected = removeSelected;
        vm.clearQuery = clearQuery;
        vm.queryDept = queryDept;
        vm.selectDept = selectDept;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '部门选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.updateMod)) {
                updateMod = false;
            } else {
                updateMod = data.updateMod;
            }
            if (angular.isUndefined(data.existDepts)) {
                data.existDepts = [];
            }
            if (angular.isUndefined(data.model)) {
                if (data.multiSelect) data.model = [];
            }
            if (vm.multiSelect && updateMod) {
                vm.selected = angular.copy(data.model);
            }
            vm.typeSelectedFn(0);
        }

        function typeSelectedFn($index) {
            var toType = vm.selectTypes[$index];
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            vm.curType = toType;
        }

        //
        function selectDept(dept) {
            if (vm.multiSelect) {
                var index = ArrayHelper.indexOfKey(dept.id, vm.selected);
                if (index === -1) {
                    vm.selected.push(dept);
                }
            } else {
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, dept);
                } else {
                    vm.selected.push(dept);
                }
            }
        }

        function initDeptSelector() {
            vm.loading = true;
            Dept.query({op: 'option'}, function (resp) {
                vm.depts = resp.items;
            }).$promise.finally(function () {
                vm.loading = false;
            });
        }

        function toggleDeptTypeNode(type, toggle, node) {
            if (type.depts) {
                toggle(node);
            } else {
                DeptType.getDepts(type.id).then(function (resp) {
                    var items = resp.data.items;
                    if (items.length > 0) {
                        tagHideIfInExist(items);
                        type.depts = items;
                        toggle(node);
                    }
                });
            }
        }

        function selectTypeDepts(type, $event) {
            $event.stopPropagation();
            if (type.depts) {
                vm.selectDepts(type.depts);
            } else {
                DeptType.getDepts(type.id).then(function (resp) {
                    var items = resp.data.items;
                    if (items.length > 0) {
                        tagHideIfInExist(items);
                        type.depts = items;
                        vm.selectDepts(type.depts);
                    }
                });
            }
        }

        function selectDepts(depts) {
            angular.forEach(depts, function (d) {
                if (!d.hide) {
                    selectDept(d);
                }
            });
        }

        function removeSelected($index) {
            vm.selected.splice($index, 1);
        }

        function clearQuery() {
            vm.depts = [];
            vm.filterName = '';
        }

        function queryDept(name) {
            if (name && name.length > 0) {
                vm.filterName = name;
                vm.loading = true;
                Dept.ov.query({opt: 4, name: name}, function (resp) {
                    var depts = resp.depts;
                    tagHideIfInExist(depts);
                    vm.depts = depts;
                }).$promise.finally(function () {
                    vm.loading = false;
                });
            } else {
                // toaster.warning('请输入部门名称');
                clearQuery();
            }
        }

        function tagHideIfInExist(depts) {
            angular.forEach(depts, function (dept) {
                if (ArrayHelper.indexOfKey(dept.id, data.existDepts) !== -1 ||
                    (!updateMod && vm.multiSelect && ArrayHelper.indexOfKey(dept.id, data.model) !== -1)) {
                    dept.hide = true;
                }
            });
        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .directive('adminGroupSelector', adminGroupSelector);

    /** @ngInject */
    function adminGroupSelector(AdminGroup) {
        return {
            templateUrl: 'directives/form/admin-group-selector/groupSelector.html',
            restrict: 'E',
            // replace: true,
            scope: {
                onSelect: '&',
                model: '=ngModel'
            },
            require: ['^ngModel', '?^form'],
            link: function (scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.touch = touch;
                vm.onSelectItem = onSelectItem;

                init();


                function init() {
                    checkValidity();

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) iElement.addClass('submitted')
                        });
                    }

                    AdminGroup.query({op: 'option'}).$promise.then(function (resp) {
                        vm.groups = resp.items;
                    });
                }

                function touch() {
                    ngModelCtrl.$setTouched();
                }

                function onSelectItem(model, clear) {
                    ngModelCtrl.$setViewValue(model);
                    checkValidity();
                    if (scope.onSelect()) {
                        scope.onSelect()(model)
                    }
                }

                function checkValidity() {
                    var valid = iAttrs.required ? (!!ngModelCtrl.$viewValue) : true;
                    ngModelCtrl.$setValidity('required', valid);
                }
            }
        }
    }
})();
angular.module('c')
    .directive('formInputDate', function () {
        return {
            templateUrl: 'directives/form/form-input-date/form-input-date.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'minDate': '=',
                'maxDate': '=',
                'dateOptions': '=',
                'label': '@',
                'name': '@',
                'dForm': '=',
                'tip': '@',
                'minMode':'@',
                'mode':'@',
                'format':'@'
            },

            controller: function ($scope) {
                if (angular.isUndefined($scope.minMode)) {
                    $scope.minMode = 'day';
                }

                if (angular.isUndefined($scope.mode)) {
                    $scope.mode = 'year';
                }

                if (angular.isUndefined($scope.format)) {
                    $scope.format = 'yyyy-MM-dd';
                }

            }

        }
    });
angular.module('c')
    .directive('formInputFloat', function () {
        return {
            templateUrl: 'directives/form/form-input-float/form-input-float.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'label': '@',
                'decimal': '@',
                'name': '@',
                'minLen': '@',
                'maxLen': '@',
                'pattern': '@',
                'dForm': '=',
                'labelTip': '@',
                'tip': '@'
            },
            controller: function ($scope) {
                if ($scope.minLen == null) {
                    $scope.minLen = 0;
                }
                if ($scope.maxLen == null) {
                    $scope.maxLen = 9999;
                }
            }
        }
    });
angular.module('c')
    .directive('formInputDatetime', function () {
        return {
            templateUrl: 'directives/form/form-input-datetime/form-input-datetime.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'minDate': '=',
                'maxDate': '=',
                'dateOptions': '=',
                'label': '@',
                'name': '@',
                'dForm': '=',
                'tip': '@',
                'format':'@'
            },

            controller: function ($scope) {
                if (angular.isUndefined($scope.format)) {
                    $scope.format = 'yyyy-MM-dd';
                }

            }

        }
    });
angular.module('c')
    .directive('formInputNumber', function () {
        return {
            templateUrl: 'directives/form/form-input-number/form-input-number.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'label': '@',
                'name': '@',
                'minLen': '@',
                'maxLen': '@',
                'pattern': '@',
                'dForm': '=',
                'tip': '@',
                'labelTip': '@',
                'labelCol': '@',
                'formCol': '@'
            },
            controller: function ($scope) {
                if ($scope.minLen == null) {
                    $scope.minLen = 0;
                }
                if ($scope.maxLen == null) {
                    $scope.maxLen = 9999;
                }

                if ($scope.labelCol == undefined || $scope.labelCol == null) {
                    $scope.labelCol = "col-md-4 control-label";
                }

                if ($scope.formCol == undefined || $scope.formCol == null) {
                    $scope.formCol = "col-md-6";
                }
            }
        }
    });
// function inputTableItemPaste(e) {
//     var scope = angular.element(e.srcElement).scope();
//     scope.itemsPaste(e, scope.$parent.$index, scope.$index);
//     e.preventDefault = true;
//     return false;
// }

(function () {
    'use strict';

    angular.module('c')
        .directive('inputTable', inputTable);

    function inputTable() {
        return {
            templateUrl: 'directives/form/inputTable/inputTable.html',
            // replace: true,
            restrict: 'EA',
            scope: {
                cols: '=',
                rows: '=',
                $data: '=ngModel',
                changed: '&',
                params: '='
            },
            require: ['^ngModel', '?^form'],
            link: link
        }
    }


    function link(scope, iElement, iAttrs, r) {
        var ngModelCtrl = r[0], formCtrl = r[1];
        var vm = scope;
        var rowCnt = vm.rows;
        var colCnt = vm.cols.length;
        vm.rowCnt = new Array(rowCnt);

        // vm.itemsPaste = itemsPaste;

        init();


        function init() {
            if (angular.isUndefined(vm.$data)) {
                vm.$data = {};
            } else {
                for (var key in vm.$data) {
                    if (isNaN(parseInt(key))) {
                        delete vm.$data[key];
                    }
                }
            }

            if (formCtrl) {
                scope.$watch(function () {
                    return formCtrl.$submitted;
                }, function (submitted) {
                    if (submitted) {
                        checkValidity(vm.$data);
                        iElement.addClass('submitted')
                    }
                });
            }
        }

        // function updateData(row, col, data) {
        //     for (var nr in data) {
        //         for (var nc in data[nr]) {
        //             var r = parseInt(row) + parseInt(nr);
        //             var c = parseInt(col) + parseInt(nc);
        //             if (c < colCnt && r < rowCnt) {
        //                 if (!vm.$data[r]) vm.$data[r] = {};
        //                 vm.$data[r][c] = data[nr][nc];
        //             }
        //         }
        //     }
        // }
        //
        // function itemsPaste(e, row, col) {
        //     if (e && e.clipboardData && e.clipboardData.getData) {
        //         var text = e.clipboardData.getData('text/plain');
        //         var data = [];
        //         var rows = text.split("\n");
        //         for (var r in rows) {
        //             data.push(rows[r].split("\t"));
        //         }
        //         updateData(row, col, data);
        //     }
        //     return false;
        // }

        function checkValidity($data) {
            var valid = true;
            if (!!iAttrs.required) {
                valid = !angular.equals($data, {});
            }
            ngModelCtrl.$setValidity('required', valid);
        }


        scope.$watch('$data', function ($data) {
            for (var i = 0; i < rowCnt; i++) {
                if ($data[i]) {
                    for (var j = 0; j < colCnt; j++) {
                        if ($data[i][j] === "") {
                            delete $data[i][j];
                        }
                    }
                    if (angular.equals($data[i], {})) {
                        delete $data[i];
                    }
                }
            }

            checkValidity($data);
            ngModelCtrl.$setTouched();
            if (vm.changed) {
                vm.changed({params: vm.params});
            }

        }, true);

    }

})();
angular.module('c')
    .directive('formInputText', function () {
        return {
            templateUrl: 'directives/form/form-input-text/form-input-text.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'label': '@',
                'name': '@',
                'maxLen': '@',
                'minLen': '@',
                'pattern': '@',
                'dForm': '=',
                'tip': '@',
                'labelTip': '@'
            }

        }
    });
(function () {
    'use strict';

    angular.module('c')
        .directive('userInfoSelector', userInfoSelector)
        .controller('userInfoSelectCtrl', userInfoSelectCtrl);

    /** @ngInject */
    function userInfoSelector(ArrayHelper, Dlg) {
        return {
            templateUrl: 'directives/form/user-info-selector/user-info-selector.html',
            restrict: 'E',
            scope: {
                model: '=ngModel',
                multiSelect: '=?',
                min: "=?",
                max: '=?',
                maxLimit: '@', // 限制只能选择max人，多的自动截取
                onSelect: '&',
                existMembers: '=?',
                placeHolder: '@',
                disabled: '=?',
                showDutyGroupMember: '=?',
                // showMeetingAbsentUser: '=?',
                // meetingId: '=?',
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.selectUserFn = selectUserFn;
                vm.selectTag = selectTag;
                vm.removeChoice = removeChoice;
                vm.removeAll = removeAll;

                init();


                function init() {
                    vm.multiSelect = angular.isDefined(iAttrs.multiSelect);
                    ngModelCtrl.$isEmpty = vm.multiSelect ? function () {
                        return !vm.model || vm.model.length === 0;
                    } : ngModelCtrl.$isEmpty;
                    if (angular.isUndefined(vm.existMembers)) {
                        vm.existMembers = [];
                    }
                    if (angular.isUndefined(vm.model)) {
                        if (vm.multiSelect) vm.model = [];
                    }
                    if (angular.isUndefined(vm.placeHolder)) {
                        vm.placeHolder = '选择成员';
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }
                    if (angular.isUndefined(vm.showDutyGroupMember)) {
                        vm.showDutyGroupMember = false;
                    }
                    // if (angular.isUndefined(vm.showMeetingAbsentUser)) {
                    //     vm.showMeetingAbsentUser = false;
                    // }

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    if (vm.multiSelect) {
                        var min = vm.min > 0 ? vm.min : 0;
                        var max = angular.isDefined(vm.max) ? vm.max : 9999;
                        var minValid, maxValid;
                        if (iAttrs.required) {
                            if (ngModelCtrl.$viewValue) {
                                minValid = ngModelCtrl.$viewValue.length >= min;
                                maxValid = ngModelCtrl.$viewValue.length <= max;
                            } else {
                                minValid = maxValid = true;
                            }
                            valid = ngModelCtrl.$viewValue.length > 0;
                        } else {
                            valid = true;
                        }
                        if (min > 0) ngModelCtrl.$setValidity('min', minValid);
                        if (angular.isDefined(vm.max)) ngModelCtrl.$setValidity('max', maxValid);
                    } else {
                        valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    }
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectUserFn(multiSelect, existMembers) {
                    vm.activeMatchIndex = -1;
                    Dlg.show({
                        template: 'directives/form/user-info-selector/user_info_selector_dlg.html',
                        ctrl: 'userInfoSelectCtrl',
                        data: {
                            multiSelect: multiSelect,
                            model: vm.model,
                            existMembers: existMembers,
                            showDutyGroupMember: vm.showDutyGroupMember,
                        }
                    }).then(function (params) {
                        if (params.length > 0) {
                            if (!multiSelect) {
                                vm.model = params[0];
                            } else {
                                if (angular.isDefined(vm.maxLimit) && vm.max > 0 && params.length > vm.max) {
                                    vm.model = params.splice(0, vm.max);
                                    scope.$emit('userInfoSelector.maxLimit', {id: iAttrs.id, max: vm.max});
                                } else vm.model = angular.copy(params);
                            }
                        } else {
                            if (!multiSelect) {
                                vm.model = null;
                            } else {
                                vm.model = [];
                            }
                        }
                        ngModelCtrl.$setViewValue(vm.model);
                        checkValidity();
                        if (vm.onSelect) {
                            vm.onSelect({selectedUser: vm.model});
                        }

                    }).finally(function () {
                        ngModelCtrl.$setTouched();
                    });
                }

                function selectTag($event, $index) {
                    $event.stopPropagation();
                    vm.activeMatchIndex = $index;
                }

                function removeChoice($event, $index) {
                    vm.activeMatchIndex = -1;
                    $event.stopPropagation();
                    vm.model.splice($index, 1);
                    ngModelCtrl.$setTouched();
                    checkValidity();
                }

                function removeAll($event) {
                    $event.stopPropagation();
                    vm.model = ArrayHelper.filter(vm.model, function (item) {
                        return item._fixed;
                    });
                    ngModelCtrl.$setTouched();
                    checkValidity();
                }
            }
        }
    }

    /** @ngInject */
    function userInfoSelectCtrl($scope, $uibModalInstance, $localStorage, ArrayHelper, Api, Dept, UserInfo,
                                AdminGroup, ContactGroup, data, $q, DeptGroup) {
        var cacheGroup;
        var vm = $scope;
        vm.query = {};

        vm.selectTypes = [
            // {id: 1, name: '部门', exAll: false, fresh: true},
            {id: 3, name: '姓名/用户名', fresh: true},
            // {id: 4, name: '科管组', fresh: true},
            // {id: 5, name: '群', fresh: true}
        ];
        vm.curType = vm.selectTypes[0];
        vm.selected = []; //所有选中的人
        vm.pager = {total: 0, page: 1, count: 5};
        vm.loading = false;
        vm.search = {};

        vm.clearQuery = clearQuery;
        vm.queryUser = queryUser;
        vm.typeSelectedFn = typeSelectedFn;
        vm.pageChanged = pageChanged;

        vm.toggleDeptTypeNode = toggleDeptTypeNode;
        vm.toggleDeptNode = toggleDeptNode;
        vm.toggleDeptGroupNode = toggleDeptGroupNode;
        vm.toggleContactGroupNode = toggleContactGroupNode;

        vm.selectDeptMembers = selectDeptMembers;
        vm.selectTypeMembers = selectTypeMembers;
        vm.selectContactGroupMembers = selectContactGroupMembers;

        vm.selectUsers = selectUsers;
        vm.selectUser = selectUser;
        vm.removeSelected = removeSelected;
        vm.removeAll = removeAll;

        vm.deptGroupVisible = deptGroupVisible;
        vm.contactGroupVisible = contactGroupVisible;
        vm.deptTypeVisible = deptTypeVisible;
        vm.deptVisible = deptVisible;

        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;


        init();


        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '用户选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.existMembers)) {
                data.existMembers = [];
            }
            if (angular.isUndefined(data.model)) {
                if (data.multiSelect) {
                    data.model = [];
                }
            }

            vm.selected = vm.multiSelect ? angular.copy(data.model) : data.model ? [data.model] : [];
            if (angular.isUndefined(data.showDutyGroupMember)) {
                vm.showDutyGroupMember = false;
            } else {
                vm.showDutyGroupMember = data.showDutyGroupMember;
            }
            // if (angular.isUndefined(data.showMeetingAbsentUser)) {
            //     vm.showMeetingAbsentUser = false;
            // } else {
            //     vm.showMeetingAbsentUser = data.showMeetingAbsentUser;
            // }

            if (data.showDutyGroupMember) {
                vm.selectTypes.splice(0, 0, {id: 4, name: '值班组成员', fresh: true});
            }
            // if (data.showMeetingAbsentUser) {
            //     vm.selectTypes.splice(0, 0, {id: 6, name: '会议缺席员工', fresh: true});
            // }
            var initIdx = $localStorage.userInfoSelectTypeIdx;
            vm.curTypeId = initIdx ? initIdx : 0;
            vm.typeSelectedFn(vm.curTypeId);
        }

        function typeSelectedFn($index) {
            $localStorage.userInfoSelectTypeIdx = $index;
            var toType = vm.selectTypes[$index];
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
                case 3:
                    if (toType.fresh) {
                        initNameSelector();
                        toType.fresh = false;
                    }
                    break;
                case 4:
                    if (toType.fresh) {
                        initDeptAdminGroupSelector();
                        toType.fresh = false;
                    }
                    break;
                case 5:
                    if (toType.fresh) {
                        initContactGroupMembersSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            vm.curType = toType;
        }

        function clearQuery() {
            vm.users = [];
            vm.query.str = '';
            vm.pager.total = 0;
        }

        function queryUser(qStr) {
            if (qStr) {
                vm.query.str = qStr;
                var urlParams = Api.param2Url({
                    op: 'search',
                    page: vm.pager.page,
                    count: vm.pager.count
                });
                urlParams.queryStr = qStr;
                vm.loading = true;
                UserInfo.query(urlParams).$promise.then(function (resp) {
                    vm.users = resp.items;
                    vm.pager.total = resp.total;
                    tagHideIfInExistMembers(vm.users);
                }).finally(function () {
                    vm.loading = false;
                });
            } else {
                clearQuery();
            }
        }

        function pageChanged() {
            queryUser(vm.query.str);
        }

        function selectUser(user) {
            if (vm.multiSelect) {
                var index = ArrayHelper.indexOfKey(user.id, vm.selected);
                if (index === -1) {
                    vm.selected.push(user);
                }
            } else {
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, user);
                } else {
                    vm.selected.push(user);
                }
            }
        }

        function initDeptSelector() {
            vm.loading = true;
            Dept.query({op: 'contact'}, function (resp) {
                vm.depts = resp.items;
            }).$promise.finally(function () {
                vm.loading = false;
            });
        }

        function initDeptAdminGroupSelector() {
            vm.loading = true;
            vm.adminGroups = [];
            AdminGroup.query({op: 'with_members'}, function (resp) {
                angular.forEach(resp.items, function (item) {
                    if (item.group !== null && item.group.members.length > 0) {
                        vm.adminGroups.push(item);
                        tagHideIfInExistMembers(item.group.members);
                    }
                });
            }).$promise.finally(function () {
                vm.loading = false;
            });
        }

        function initNameSelector() {

        }

        function initContactGroupMembersSelector() {
            vm.loading = true;
            ContactGroup.query({opt: 2}, function (resp) {
                cacheGroup = resp.groups;
                vm.groups = ArrayHelper.map(cacheGroup, function (g) {
                    return {id: g.id, name: g.name, memberCount: g.members.length};
                });
            }).$promise.finally(function () {
                vm.loading = false;
            });
        }

        function tagDeptLeaderAndHide(dept) {
            var index, item;
            if (dept.mail_recipient_id) {
                index = ArrayHelper.indexOfKey(dept.mail_recipient_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.mail_recipient_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }

            if (dept.leader_id) {
                index = ArrayHelper.indexOfKey(dept.leader_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.leader_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }
            tagHideIfInExistMembers(dept.members);
        }

        function toggleDeptTypeNode(type, toggle, node) {
            if (type.depts) {
                toggle(node);
            }
        }

        function toggleDeptGroupNode(toggle, node) {
            toggle(node);
        }

        function toggleDeptNode(dept, toggle, node) {
            if (dept.members) {
                toggle(node);
            } else {
                $q.all([
                    DeptGroup.query({op: 'option', dept_id: dept.id}).$promise,
                    Dept.getMembers(dept.id)
                ]).then(function (respArray) {
                    var items = respArray[1].data.items;
                    if (items.length > 0) {
                        var groups = []; // 部门小组
                        var no = [];     // 没有部门小组的人员
                        if (respArray[0].items.length > 0) {
                            angular.forEach(respArray[0].items, function (group) {
                                var array1 = [];  // 有部门小组的人
                                var array2 = [];  // 没有...
                                angular.forEach(items, function (item) {
                                    if (item.group_id) {
                                        if (item.group_id === group.id) {
                                            if (item.id == group.user_id) {
                                                array1.unshift(item)
                                            } else {
                                                array1.push(item);
                                            }
                                        }
                                    } else {
                                        array2.push(item);
                                    }
                                });
                                groups.push({
                                    group: group,
                                    members: array1
                                });
                                no = array2;
                            });
                            dept.members = no.concat(groups);
                        } else {
                            dept.members = items;
                        }

                        dept.mail_recipient_id = respArray[1].data.mail_recipient_id;
                        tagDeptLeaderAndHide(dept);
                        toggle(node);
                    }
                });
                // Dept.getMembers(dept.id).then(function (resp) {
                //     var items = resp.data.items;
                //     if (items.length > 0) {
                //         dept.members = items;
                //         dept.mail_recipient_id = resp.data.mail_recipient_id;
                //         tagDeptLeaderAndHide(dept);
                //         toggle(node);
                //     }
                // });
            }
        }

        function toggleContactGroupNode(group, toggle, node) {
            if (!group.members) {
                var members = ArrayHelper.getItem(group.id, cacheGroup).members;
                tagHideIfInExistMembers(members);
                group.members = members;
            }
            toggle(node);
        }

        function selectDeptMembers(dept, $event) {
            $event.stopPropagation();
            if (dept.members) {
                vm.selectUsers(dept.members);
            } else {
                $q.all([
                    DeptGroup.query({op: 'option', dept_id: dept.id}).$promise,
                    Dept.getMembers(dept.id)
                ]).then(function (respArray) {
                    var items = respArray[1].data.items;
                    if (items.length > 0) {
                        vm.selectUsers(items);

                        var groups = []; // 部门小组
                        var no = [];     // 没有部门小组的人员
                        if (respArray[0].items.length > 0) {
                            angular.forEach(respArray[0].items, function (group) {
                                var array1 = [];  // 有部门小组的人
                                var array2 = [];  // 没有...
                                angular.forEach(items, function (item) {
                                    if (item.group_id) {
                                        if (item.group_id === group.id) {
                                            if (item.id == group.user_id) {
                                                array1.unshift(item)
                                            } else {
                                                array1.push(item);
                                            }
                                        }
                                    } else {
                                        array2.push(item);
                                    }
                                });
                                groups.push({
                                    group: group,
                                    members: array1
                                });
                                no = array2;
                            });
                            dept.members = no.concat(groups);
                        } else {
                            dept.members = items;
                        }

                        dept.mail_recipient_id = respArray[1].data.mail_recipient_id;
                        tagDeptLeaderAndHide(dept);

                    }
                })
            }
        }

        function selectTypeMembers(type, $event) {
            angular.forEach(type.depts, function (dept) {
                $event.stopPropagation();
                if (dept.members) {
                    vm.selectUsers(dept.members);
                } else {
                    Dept.getMembers(dept.id).then(function (resp) {
                        var items = resp.data.items;
                        if (items.length > 0) {
                            dept.members = items;
                            dept.mail_recipient_id = resp.data.mail_recipient_id;
                            tagDeptLeaderAndHide(dept);
                            vm.selectUsers(dept.members);
                        }
                    });
                }
            });

        }

        function selectContactGroupMembers(group, $event) {
            $event.stopPropagation();
            if (!group.members) {
                var members = ArrayHelper.getItem(group.id, cacheGroup).members;
                tagHideIfInExistMembers(members);
                group.members = members;
            }
            vm.selectUsers(group.members);
        }

        function selectUsers(members) {
            angular.forEach(members, function (m) {
                if (m.members && m.members.length > 0) {
                    angular.forEach(m.members, function (user) {
                        if (!user.hide) selectUser(user);
                    });
                } else {
                    if (!m.hide) selectUser(m);
                }
            });
        }

        function tagHideIfInExistMembers(members) {
            if (data.existMembers && data.existMembers.length > 0) {
                angular.forEach(members, function (m) {
                    if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1) {
                        m.hide = true;
                    }
                });
            }
        }

        function deptGroupVisible(group) {
            return !(vm.search.deptGroup && vm.search.deptGroup.length > 0
                && group.name.indexOf(vm.search.deptGroup) === -1);
        }

        function contactGroupVisible(group) {
            return !(vm.search.contactGroup && vm.search.contactGroup.length > 0
                && group.name.indexOf(vm.search.contactGroup) === -1);
        }

        function deptTypeVisible(type) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            if (!visible) {
                for (var i = 0; i < type.depts.length; i++) {
                    var dept = type.depts[i];
                    if (dept.name.indexOf(vm.search.dept) !== -1) {
                        visible = true;
                        break;
                    }
                }
            }
            return visible;
        }

        function deptVisible(dept) {
            return !(vm.search.dept && vm.search.dept.length > 0
                && dept.name.indexOf(vm.search.dept) === -1);
        }

        function removeAll() {
            vm.selected = ArrayHelper.filter(vm.selected, function (item) {
                return item._fixed;
            });
        }

        function removeSelected($index) {
            vm.selected.splice($index, 1);
        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .directive('userSelector', userSelector)
        .controller('UserSelectCtrl', UserSelectCtrl);

    /** @ngInject */
    function userSelector(ArrayHelper, Dlg) {
        return {
            templateUrl: 'directives/form/user-selector/user-selector.html',
            restrict: 'E',
            scope: {
                model: '=ngModel',
                multiSelect: '=?',
                min: "=?",
                max: '=?',
                maxLimit: '@', // 限制只能选择max人，多的自动截取
                onSelect: '&',
                existMembers: '=?',
                placeHolder: '@',
                disabled: '=?',
                showDutyGroupMember: '=?',
                // showMeetingAbsentUser: '=?',
                // meetingId: '=?',
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.selectUserFn = selectUserFn;
                vm.selectTag = selectTag;
                vm.removeChoice = removeChoice;
                vm.removeAll = removeAll;

                init();


                function init() {
                    vm.multiSelect = angular.isDefined(iAttrs.multiSelect);
                    ngModelCtrl.$isEmpty = vm.multiSelect ? function () {
                        return !vm.model || vm.model.length === 0;
                    } : ngModelCtrl.$isEmpty;
                    if (angular.isUndefined(vm.existMembers)) {
                        vm.existMembers = [];
                    }
                    if (angular.isUndefined(vm.model)) {
                        if (vm.multiSelect) vm.model = [];
                    }
                    if (angular.isUndefined(vm.placeHolder)) {
                        vm.placeHolder = '选择成员';
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }
                    if (angular.isUndefined(vm.showDutyGroupMember)) {
                        vm.showDutyGroupMember = false;
                    }
                    // if (angular.isUndefined(vm.showMeetingAbsentUser)) {
                    //     vm.showMeetingAbsentUser = false;
                    // }

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    if (vm.multiSelect) {
                        var min = vm.min > 0 ? vm.min : 0;
                        var max = angular.isDefined(vm.max) ? vm.max : 9999;
                        var minValid, maxValid;
                        if (iAttrs.required) {
                            if (ngModelCtrl.$viewValue) {
                                minValid = ngModelCtrl.$viewValue.length >= min;
                                maxValid = ngModelCtrl.$viewValue.length <= max;
                            } else {
                                minValid = maxValid = true;
                            }
                            valid = ngModelCtrl.$viewValue.length > 0;
                        } else {
                            valid = true;
                        }
                        if (min > 0) ngModelCtrl.$setValidity('min', minValid);
                        if (angular.isDefined(vm.max)) ngModelCtrl.$setValidity('max', maxValid);
                    } else {
                        valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    }
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectUserFn(multiSelect, existMembers) {
                    vm.activeMatchIndex = -1;
                    Dlg.show({
                        template: 'directives/form/user-selector/user_selector_dlg.html',
                        ctrl: 'UserSelectCtrl',
                        data: {
                            multiSelect: multiSelect,
                            model: vm.model,
                            existMembers: existMembers,
                            showDutyGroupMember: vm.showDutyGroupMember,
                        }
                    }).then(function (params) {
                        if (params.length > 0) {
                            if (!multiSelect) {
                                vm.model = params[0];
                            } else {
                                if (angular.isDefined(vm.maxLimit) && vm.max > 0 && params.length > vm.max) {
                                    vm.model = params.splice(0, vm.max);
                                    scope.$emit('userSelector.maxLimit', {id: iAttrs.id, max: vm.max});
                                } else vm.model = angular.copy(params);
                            }
                        } else {
                            if (!multiSelect) {
                                vm.model = null;
                            } else {
                                vm.model = [];
                            }
                        }
                        ngModelCtrl.$setViewValue(vm.model);
                        checkValidity();
                        if (vm.onSelect) {
                            vm.onSelect({selectedUser: vm.model});
                        }

                    }).finally(function () {
                        ngModelCtrl.$setTouched();
                    });
                }

                function selectTag($event, $index) {
                    $event.stopPropagation();
                    vm.activeMatchIndex = $index;
                }

                function removeChoice($event, $index) {
                    vm.activeMatchIndex = -1;
                    $event.stopPropagation();
                    vm.model.splice($index, 1);
                    ngModelCtrl.$setTouched();
                    checkValidity();
                }

                function removeAll($event) {
                    $event.stopPropagation();
                    vm.model = ArrayHelper.filter(vm.model, function (item) {
                        return item._fixed;
                    });
                    ngModelCtrl.$setTouched();
                    checkValidity();
                }
            }
        }
    }

    /** @ngInject */
    function UserSelectCtrl($scope, $uibModalInstance, $localStorage, ArrayHelper, Api, Dept, User,
                            AdminGroup, ContactGroup, data, $q, DeptGroup) {
        var cacheGroup;
        var vm = $scope;
        vm.query = {};

        vm.selectTypes = [
            // {id: 1, name: '部门', exAll: false, fresh: true},
            {id: 3, name: '姓名/手机号/主管单位', fresh: true},
            // {id: 4, name: '科管组', fresh: true},
            {id: 5, name: '群', fresh: true}
        ];
        vm.curType = vm.selectTypes[0];
        vm.selected = []; //所有选中的人
        vm.pager = {total: 0, page: 1, count: 5};
        vm.loading = false;
        vm.search = {};

        vm.clearQuery = clearQuery;
        vm.queryUser = queryUser;
        vm.typeSelectedFn = typeSelectedFn;
        vm.pageChanged = pageChanged;

        vm.toggleDeptTypeNode = toggleDeptTypeNode;
        vm.toggleDeptNode = toggleDeptNode;
        vm.toggleDeptGroupNode = toggleDeptGroupNode;
        vm.toggleContactGroupNode = toggleContactGroupNode;

        vm.selectDeptMembers = selectDeptMembers;
        vm.selectTypeMembers = selectTypeMembers;
        vm.selectContactGroupMembers = selectContactGroupMembers;

        vm.selectUsers = selectUsers;
        vm.selectUser = selectUser;
        vm.removeSelected = removeSelected;
        vm.removeAll = removeAll;

        vm.deptGroupVisible = deptGroupVisible;
        vm.contactGroupVisible = contactGroupVisible;
        vm.deptTypeVisible = deptTypeVisible;
        vm.deptVisible = deptVisible;

        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;
        vm.selectAll = selectAll;


        init();


        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '用户选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.existMembers)) {
                data.existMembers = [];
            }
            if (angular.isUndefined(data.model)) {
                if (data.multiSelect) {
                    data.model = [];
                }
            }

            vm.selected = vm.multiSelect ? angular.copy(data.model) : data.model ? [data.model] : [];
            if (angular.isUndefined(data.showDutyGroupMember)) {
                vm.showDutyGroupMember = false;
            } else {
                vm.showDutyGroupMember = data.showDutyGroupMember;
            }
            // if (angular.isUndefined(data.showMeetingAbsentUser)) {
            //     vm.showMeetingAbsentUser = false;
            // } else {
            //     vm.showMeetingAbsentUser = data.showMeetingAbsentUser;
            // }

            if (data.showDutyGroupMember) {
                vm.selectTypes.splice(0, 0, {id: 4, name: '值班组成员', fresh: true});
            }
            // if (data.showMeetingAbsentUser) {
            //     vm.selectTypes.splice(0, 0, {id: 6, name: '会议缺席员工', fresh: true});
            // }
            var initIdx = $localStorage.userSelectTypeIdx;
            vm.curTypeId = initIdx ? initIdx : 0;
            vm.typeSelectedFn(vm.curTypeId);
        }

        function typeSelectedFn($index) {
            $localStorage.userSelectTypeIdx = $index;
            var toType = vm.selectTypes[$index];
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
                case 3:
                    if (toType.fresh) {
                        initNameSelector();
                        toType.fresh = false;
                    }
                    break;
                case 4:
                    if (toType.fresh) {
                        initDeptAdminGroupSelector();
                        toType.fresh = false;
                    }
                    break;
                case 5:
                    if (toType.fresh) {
                        initContactGroupMembersSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            vm.curType = toType;
        }

        function clearQuery() {
            vm.users = [];
            vm.query.str = '';
            vm.pager.total = 0;
        }

        function queryUser(qStr) {
            if (qStr) {
                vm.query.str = qStr;
                var urlParams = Api.param2Url({
                    op: 'search',
                    page: vm.pager.page,
                    count: vm.pager.count
                });
                urlParams.queryStr = qStr;
                vm.loading = true;
                User.query(urlParams).$promise.then(function (resp) {
                    vm.users = resp.items;
                    vm.pager.total = resp.total;
                    tagHideIfInExistMembers(vm.users);
                }).finally(function () {
                    vm.loading = false;
                });
            } else {
                clearQuery();
            }
        }

        function pageChanged() {
            queryUser(vm.query.str);
        }

        function selectAll() {
            if (vm.query.str) {
                var urlParams = Api.param2Url({
                    op: 'searchAll'
                });
                urlParams.queryStr = vm.query.str;
                vm.loading = true;
                User.query(urlParams).$promise.then(function (resp) {
                    selectUsers(resp.items)
                }).finally(function () {
                    vm.loading = false;
                });
            }
        }

        function selectUser(user) {
            if (vm.multiSelect) {
                var index = ArrayHelper.indexOfKey(user.id, vm.selected);
                if (index === -1) {
                    vm.selected.push(user);
                }
            } else {
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, user);
                } else {
                    vm.selected.push(user);
                }
            }
        }

        function initDeptSelector() {
            vm.loading = true;
            Dept.query({op: 'contact'}, function (resp) {
                vm.depts = resp.items;
            }).$promise.finally(function () {
                vm.loading = false;
            });
        }

        function initDeptAdminGroupSelector() {
            vm.loading = true;
            vm.adminGroups = [];
            AdminGroup.query({op: 'with_members'}, function (resp) {
                angular.forEach(resp.items, function (item) {
                    if (item.group !== null && item.group.members.length > 0) {
                        vm.adminGroups.push(item);
                        tagHideIfInExistMembers(item.group.members);
                    }
                });
            }).$promise.finally(function () {
                vm.loading = false;
            });
        }

        function initNameSelector() {

        }

        function initContactGroupMembersSelector() {
            vm.loading = true;
            ContactGroup.query({opt: 2}, function (resp) {
                cacheGroup = resp.groups;
                vm.groups = ArrayHelper.map(cacheGroup, function (g) {
                    return {id: g.id, name: g.name, memberCount: g.members.length};
                });
            }).$promise.finally(function () {
                vm.loading = false;
            });
        }

        function tagDeptLeaderAndHide(dept) {
            var index, item;
            if (dept.mail_recipient_id) {
                index = ArrayHelper.indexOfKey(dept.mail_recipient_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.mail_recipient_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }

            if (dept.leader_id) {
                index = ArrayHelper.indexOfKey(dept.leader_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.leader_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }
            tagHideIfInExistMembers(dept.members);
        }

        function toggleDeptTypeNode(type, toggle, node) {
            if (type.depts) {
                toggle(node);
            }
        }

        function toggleDeptGroupNode(toggle, node) {
            toggle(node);
        }

        function toggleDeptNode(dept, toggle, node) {
            if (dept.members) {
                toggle(node);
            } else {
                $q.all([
                    DeptGroup.query({op: 'option', dept_id: dept.id}).$promise,
                    Dept.getMembers(dept.id)
                ]).then(function (respArray) {
                    var items = respArray[1].data.items;
                    if (items.length > 0) {
                        var groups = []; // 部门小组
                        var no = [];     // 没有部门小组的人员
                        if (respArray[0].items.length > 0) {
                            angular.forEach(respArray[0].items, function (group) {
                                var array1 = [];  // 有部门小组的人
                                var array2 = [];  // 没有...
                                angular.forEach(items, function (item) {
                                    if (item.group_id) {
                                        if (item.group_id === group.id) {
                                            if (item.id == group.user_id) {
                                                array1.unshift(item)
                                            } else {
                                                array1.push(item);
                                            }
                                        }
                                    } else {
                                        array2.push(item);
                                    }
                                });
                                groups.push({
                                    group: group,
                                    members: array1
                                });
                                no = array2;
                            });
                            dept.members = no.concat(groups);
                        } else {
                            dept.members = items;
                        }

                        dept.mail_recipient_id = respArray[1].data.mail_recipient_id;
                        tagDeptLeaderAndHide(dept);
                        toggle(node);
                    }
                });
                // Dept.getMembers(dept.id).then(function (resp) {
                //     var items = resp.data.items;
                //     if (items.length > 0) {
                //         dept.members = items;
                //         dept.mail_recipient_id = resp.data.mail_recipient_id;
                //         tagDeptLeaderAndHide(dept);
                //         toggle(node);
                //     }
                // });
            }
        }

        function toggleContactGroupNode(group, toggle, node) {
            if (!group.members) {
                var members = ArrayHelper.getItem(group.id, cacheGroup).members;
                tagHideIfInExistMembers(members);
                group.members = members;
            }
            toggle(node);
        }

        function selectDeptMembers(dept, $event) {
            $event.stopPropagation();
            if (dept.members) {
                vm.selectUsers(dept.members);
            } else {
                $q.all([
                    DeptGroup.query({op: 'option', dept_id: dept.id}).$promise,
                    Dept.getMembers(dept.id)
                ]).then(function (respArray) {
                    var items = respArray[1].data.items;
                    if (items.length > 0) {
                        vm.selectUsers(items);

                        var groups = []; // 部门小组
                        var no = [];     // 没有部门小组的人员
                        if (respArray[0].items.length > 0) {
                            angular.forEach(respArray[0].items, function (group) {
                                var array1 = [];  // 有部门小组的人
                                var array2 = [];  // 没有...
                                angular.forEach(items, function (item) {
                                    if (item.group_id) {
                                        if (item.group_id === group.id) {
                                            if (item.id == group.user_id) {
                                                array1.unshift(item)
                                            } else {
                                                array1.push(item);
                                            }
                                        }
                                    } else {
                                        array2.push(item);
                                    }
                                });
                                groups.push({
                                    group: group,
                                    members: array1
                                });
                                no = array2;
                            });
                            dept.members = no.concat(groups);
                        } else {
                            dept.members = items;
                        }

                        dept.mail_recipient_id = respArray[1].data.mail_recipient_id;
                        tagDeptLeaderAndHide(dept);

                    }
                })
            }
        }

        function selectTypeMembers(type, $event) {
            angular.forEach(type.depts, function (dept) {
                $event.stopPropagation();
                if (dept.members) {
                    vm.selectUsers(dept.members);
                } else {
                    Dept.getMembers(dept.id).then(function (resp) {
                        var items = resp.data.items;
                        if (items.length > 0) {
                            dept.members = items;
                            dept.mail_recipient_id = resp.data.mail_recipient_id;
                            tagDeptLeaderAndHide(dept);
                            vm.selectUsers(dept.members);
                        }
                    });
                }
            });

        }

        function selectContactGroupMembers(group, $event) {
            $event.stopPropagation();
            if (!group.members) {
                var members = ArrayHelper.getItem(group.id, cacheGroup).members;
                tagHideIfInExistMembers(members);
                group.members = members;
            }
            vm.selectUsers(group.members);
        }

        function selectUsers(members) {
            angular.forEach(members, function (m) {
                if (m.members && m.members.length > 0) {
                    angular.forEach(m.members, function (user) {
                        if (!user.hide) selectUser(user);
                    });
                } else {
                    if (!m.hide) selectUser(m);
                }
            });
        }

        function tagHideIfInExistMembers(members) {
            if (data.existMembers && data.existMembers.length > 0) {
                angular.forEach(members, function (m) {
                    if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1) {
                        m.hide = true;
                    }
                });
            }
        }

        function deptGroupVisible(group) {
            return !(vm.search.deptGroup && vm.search.deptGroup.length > 0
                && group.name.indexOf(vm.search.deptGroup) === -1);
        }

        function contactGroupVisible(group) {
            return !(vm.search.contactGroup && vm.search.contactGroup.length > 0
                && group.name.indexOf(vm.search.contactGroup) === -1);
        }

        function deptTypeVisible(type) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            if (!visible) {
                for (var i = 0; i < type.depts.length; i++) {
                    var dept = type.depts[i];
                    if (dept.name.indexOf(vm.search.dept) !== -1) {
                        visible = true;
                        break;
                    }
                }
            }
            return visible;
        }

        function deptVisible(dept) {
            return !(vm.search.dept && vm.search.dept.length > 0
                && dept.name.indexOf(vm.search.dept) === -1);
        }

        function removeAll() {
            vm.selected = ArrayHelper.filter(vm.selected, function (item) {
                return item._fixed;
            });
        }

        function removeSelected($index) {
            vm.selected.splice($index, 1);
        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .directive('tableOptionTab', tableOptionTab);

    function tableOptionTab() {
        return {
            templateUrl: 'directives/table/tableOptionTab/tableOptionTab.html',
            restrict: 'E',
            scope: {
                options: '=',
                curOptionId: '=ngModel',
                filterName: '@',
                tagTitle: '@',
                redDot: '@',
                optionSelect: '&',
                noDataDesc: '@'
            },
            require: ['^ngModel'],
            link: link
        }
    }


    function link(scope) {
        var parentCtrl = scope.$parent;
        scope.optionSelected = optionSelected;

        function optionSelected(option) {
            if (scope.optionSelect()) {
                scope.optionSelect()(option);
            } else {
                var filter = parentCtrl.tableParams.filter();
                scope.curOptionId = filter[scope.filterName] = option.id;
                if (!option.id) delete filter[scope.filterName];
                parentCtrl.tableParams.filter(filter);
            }
        }
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('attachmentDownload', attachmentDownload);

    /** @ngInject */
    function attachmentDownload($compile, Dlg, WxHelper, FileHelper, deviceDetector) {
        return {
            restrict: 'EA',
            scope: {
                attachmentDownload: '=attachmentDownload', // 作为属性时用这个，作为元素时用下面的model
                model: '=ngModel',
                customClass: '@customClass',
                name: '@attachFieldName',
                url: '@',   // 下载访问连接
                // 若未指定url，将由 type + mod 构成： /api/v1/{mod}/{type}/download
                type: '@',  // 附件类型
                mod: '@'    // 模块名称
            },
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {

                        var vm = scope;
                        var att = scope.model ? scope.model : scope.attachmentDownload;
                        var url;

                        vm.download = download;

                        init();


                        function init() {
                            if (scope.attachmentDownload) {
                                $(iElement).click(function () {
                                    download();
                                });
                            } else {
                                var original = iElement.html().trim();
                                if (!original) original = '下载';
                                var elem = '<span>' +
                                    '<a ng-class="customClass" ng-click="download()">' + original;
                                if (angular.isUndefined(iAttrs.hideLoading)) {
                                    elem += '<span ng-show="model.downloading" class="fa fa-circle-o-notch fa-spin text-muted"></span>';
                                }
                                elem += '</a></span>';

                                var layer = angular.element(elem);
                                var el = $compile(layer.contents())(scope);
                                iElement.replaceWith(el);
                            }


                            if (scope.url) {
                                url = scope.url;
                            } else {
                                url = "/api/v1/";
                                if (scope.mod) url += scope.mod + "/";
                                if (scope.type) url += scope.type + "/";
                                url += "download";
                            }
                        }

                        function download() {
                            if (WxHelper.isWechatBrowser() || deviceDetector.isMobile()) {
                                Dlg.show({
                                    template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                                    ctrl: 'attachmentDownloadDlgCtrl',
                                    data: {attachment: att, name: scope.name},
                                    size: 'sm'
                                });
                            } else {
                                var rename = scope.name ? {name: scope.name} : {};
                                FileHelper.download1(url, att, rename);
                            }
                        }
                    }
                }
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('attachmentDownloadDlgCtrl', attachmentDownloadDlgCtrl);

    /** @ngInject */
    function attachmentDownloadDlgCtrl($scope, $uibModalInstance, UIHelper, $http, data) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;


        init(data.attachment, data.name);


        function init(att, name) {
            var attachment = {
                name: name ? name : att.name,
                filename: att.filename,
                mime: att.mime,
                size: att.size,
            };

            attachment.ico = UIHelper.getIconFromMime(attachment.mime);
            attachment.size = parseInt(attachment.size);

            vm.attachment = attachment;

            $http.post('api/v1/file/download/mk_pub_link', {filename: attachment.filename})
                .success(function (resp) {
                    vm.url = resp;
                });
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .directive('attachmentList', attachmentList);

    /** @ngInject */
    function attachmentList($http, $timeout, FileHelper, ArrayHelper, Dlg, WxHelper, deviceDetector) {
        return {
            templateUrl: 'directives/ui/attachmentList/attachmentList.html',
            restrict: 'E',
            scope: {
                // model.attachments
                model: '=ngModel',
                required: '=ngRequired',
                name: '@attachFieldName',
                url: '@',   // 下载访问连接
                // 若未指定url，将由 type + mod 构成： /api/v1/{mod}/{type}/download
                type: '@',  // 附件类型
                mod: '@',    // 模块名称
                size: '@'    // 尺寸 sm/md/lg
            },
            require: ['^ngModel', '?^form'],
            link: function (scope, iElement, iAttrs, r) {
                var STATE = FileHelper.UPLOAD_STATE;
                var office = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
                var pdf = ['pdf'];
                var img = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
                var url;
                var vm = scope;
                vm.editable = angular.isDefined(iAttrs.editable);
                var ngModelCtrl = r[0], formCtrl = r[1];
                vm.deleteAttachment = deleteAttachment;
                vm.preview = preview;
                vm.download = download;

                init();


                function init() {
                    scope.attachments = [];
                    scope.$watch('model', function (newVal, oldVal) {
                        if (angular.isDefined(newVal)) {
                            if (scope.model instanceof Array) {
                                scope.attachments = scope.model;
                            } else {
                                scope.attachments = scope.model.attachments;
                            }
                            // ngModelCtrl.$setViewValue(scope.attachments);
                        }
                    });
                    if (vm.url) {
                        url = vm.url;
                    } else {
                        url = "/api/v1/";
                        if (vm.mod) url += vm.mod + "/";
                        if (vm.type) url += vm.type + "/";
                        url += "download";
                    }
                    if (formCtrl) {
                        scope.$watch(function () {
                            checkValidity();
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted');
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    valid = iAttrs.required ? (!!ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.length > 0) : true;
                    ngModelCtrl.$setValidity('required', valid);
                }

                function deleteAttachment(i) {
                    if (vm.attachments[i].upload) vm.attachments[i].$upload.abort();
                    vm.attachments.splice(i, 1);
                    ngModelCtrl.$setTouched();
                    // ngModelCtrl.$setViewValue(vm.attachments);
                    if (ngModelCtrl.$viewValue.length === 0) checkValidity();
                }

                function download(attachment) {
                    if (WxHelper.isWechatBrowser() || deviceDetector.isMobile()) {
                        Dlg.show({
                            template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                            ctrl: 'attachmentDownloadDlgCtrl',
                            data: {attachment: attachment, name: attachment.name},
                            size: 'sm'
                        });
                    } else {
                        var rename = scope.name ? {name: scope.name} : {};
                        FileHelper.download1(url, attachment, rename);
                    }
                }


                function preview(attachment) {
                    var extension = attachment.filename.split('.').pop().toLowerCase();
                    var type = undefined;
                    if (ArrayHelper.inArray(extension, office) !== -1) {
                        type = 1;  // office
                    } else if (ArrayHelper.inArray(extension, pdf) !== -1) {
                        type = 2;  // pdf
                    } else if (ArrayHelper.inArray(extension, img) !== -1) {
                        type = 3;  // img
                    }
                    if (!type) {
                        Dlg.i('不支持的预览该类型附件');
                        return;
                    }
                    if (attachment.state == STATE.UPLOADING || attachment.state == STATE.FAILED) {
                        Dlg.i('附件未上传成功，无法预览');
                        return;
                    }
                    $http.post('api/v1/file/preview/mk_pub_link', {filename: attachment.filename})
                        .success(function (resp) {
                            var docFullUrl = location.protocol + "//" + location.host + resp;
                            var url = type === 1 ? 'https://view.officeapps.live.com/op/embed.aspx?src=' + docFullUrl :
                                "/api/v1/file/preview?type=" + type + "&filename=" + resp + "&name=" + attachment.name;
                            if (deviceDetector.isDesktop()) {
                                var win = window.open(url);
                                $timeout(function () {
                                    win.document.title = attachment.name;
                                });
                            } else {
                                Dlg.show({
                                    template: 'pages/preview/showDlg.html',
                                    ctrl: 'PreviewShowDlgCtrl',
                                    data: {url: url, name: attachment.name},
                                    pos: 'right', backdrop: false, size: 'full'
                                });
                            }
                        }).error(function (err) {
                        if (err.msg) Dlg.e(err.msg);
                    });
                }
            },
        };
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .directive('attachmentPreview', attachmentPreview);

    /** @ngInject */
    function attachmentPreview($compile, $http, $timeout, ArrayHelper, Dlg, deviceDetector, OS) {
        var office = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
        var pdf = ['pdf'];
        var img = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];


        return {
            restrict: 'E',
            scope: {
                model: '=ngModel',
                name: '@attachFieldName',
                customClass: '@customClass'
            },
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {
                        var vm = scope;
                        vm.op = {};
                        vm.preview = preview;
                        var type = null;
                        var att = scope.model;
                        var name = scope.name ? att[scope.name] : att.name;

                        init();


                        function init() {
                            var original = iElement.html().trim();
                            if (!original) original = '预览';
                            var elem =
                                '<span>' +
                                '<a class="attachment-preview" ng-class="customClass" ' +
                                'ng-if="type" ng-click="preview(op)"' + 'popover-trigger="outsideClick">' + original + '</a></span>';


                            var layer = angular.element(elem);
                            var el = $compile(layer.contents())(scope);
                            iElement.replaceWith(el);


                            vm.ios = deviceDetector.os === OS.IOS;
                            vm.os = deviceDetector.os;
                            if (!att.filename) return;
                            var extension = att.filename.split('.').pop().toLowerCase();
                            if (ArrayHelper.inArray(extension, office) !== -1) {
                                type = 1;  // office
                            } else if (ArrayHelper.inArray(extension, pdf) !== -1) {
                                type = 2;  // pdf
                            } else if (ArrayHelper.inArray(extension, img) !== -1) {
                                type = 3;  // img
                            }
                            vm.type = type;
                        }

                        function preview() {
                            $http.post('api/v1/file/preview/mk_pub_link', {filename: att.filename})
                                .success(function (resp) {
                                    var docFullUrl = location.protocol + "//" + location.host + resp;
                                    var url = type === 1 ? 'https://view.officeapps.live.com/op/embed.aspx?src=' + docFullUrl :
                                        "/api/v1/file/preview?type=" + type + "&filename=" + resp + "&name=" + name;
                                    if (deviceDetector.isDesktop()) {
                                        var win = window.open(url);
                                        $timeout(function () {
                                            win.document.title = name;
                                        });
                                    } else {
                                        Dlg.show({
                                            template: 'pages/preview/showDlg.html',
                                            ctrl: 'PreviewShowDlgCtrl',
                                            data: {url: url, name: name},
                                            pos: 'right', backdrop: false, size: 'full'
                                        });
                                    }
                                }).error(function (err) {
                                if (err.msg) Dlg.e(err.msg);
                            });
                        }
                    }
                }
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .directive('attachmentUploadBtn', attachmentUploadBtn);

    /** @ngInject */
    function attachmentUploadBtn($compile, Dlg, FileHelper, ArrayHelper, Upload) {
        return {
            restrict: 'E',
            scope: {
                // model.attachments
                model: '=ngModel',
                customClass: '@',
                name: '@attachFieldName',
                maxSize: '@maxSize',
                url: '@',   // 上传访问连接
                // 若未指定url，将由 type + mod 构成： /api/v1/{mod}/{type}/upload
                // 如：/api/v1/emails/upload
                type: '@',  // 附件类型
                acceptType: '@',  // 指定附件类型
                mod: '@'    // 模块名称
                // single
                // multiple 默认
            },
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {
                        var STATE = FileHelper.UPLOAD_STATE;
                        var single = angular.isDefined(iAttrs.single);
                        var acceptType = iAttrs.acceptType;
                        var url;
                        if (!scope.maxSize) scope.maxSize = '100MB';
                        var maxSize = FileHelper.humanReadableSizeToValue(scope.maxSize);

                        scope.uploadFiles = uploadFiles;

                        init();


                        function init() {
                            scope.attachments = [];
                            scope.$watch('model', function (newVal, oldVal) {
                                if (angular.isDefined(newVal)) {
                                    if (scope.model instanceof Array) {
                                        scope.attachments = scope.model;
                                    } else {
                                        scope.attachments = scope.model.attachments;
                                    }
                                }
                            });
                            var original = iElement.html().trim();

                            if (single) {
                                if (!original) {
                                    original = '<i class="fa fa-paperclip"></i>\n' +
                                        '<span ng-if="attachments.length>0">重新上传</span>\n' +
                                        '<span ng-else>添加附件</span>\n';
                                }
                                var elem = '<a type="file" name="attachments" href="#" ' + 'accept={{acceptType}} ' +
                                    'ng-class="customClass" ' + 'ngf-select="uploadFiles($files)">' + original + '</a>';
                            } else {
                                if (!original) {
                                    original = '<i class="fa fa-paperclip"></i>\n' +
                                        '<span ng-if="attachments.length>0">继续添加</span>\n' +
                                        '<span ng-else>添加附件</span>\n';
                                }
                                var elem = '<a type="file" name="attachments" href="#" ' + 'accept={{acceptType}} ' +
                                    'ng-class="customClass" ' + 'ngf-select="uploadFiles($files)" ' +
                                    'multiple="multiple">' + original + '</a>';
                            }
                            var layer = angular.element(elem);
                            iElement.append(layer);
                            $compile(iElement.contents())(scope);

                            if (scope.url) {
                                url = scope.url;
                            } else if (scope.mod || scope.type) {
                                url = "/api/v1/";
                                if (scope.mod) url += scope.mod + "/";
                                if (scope.type) url += scope.type + "/";
                                url += "upload";
                            } else {
                                url = '/api/v1/file/attachments/upload_single'
                            }
                        }

                        function uploadFiles(files) {
                            if (!files) return;
                            var uploadFiles = ArrayHelper.filter(files, function (file) {
                                return file.size <= maxSize;
                            });
                            if (uploadFiles.length === 0) {
                                Dlg.error("上传文件大小不能超过" + scope.maxSize);
                                return;
                            }
                            if (uploadFiles.length < files.length) {
                                Dlg.notify("已忽略超过限制大小（" + scope.maxSize + "）的文件");
                            }
                            for (var i = 0; i < uploadFiles.length; i++) {
                                uploadFile(uploadFiles[i]);
                            }
                        }

                        function uploadFile(file) {
                            var attachment = { name: file.name, progress: 0 };
                            var pa = {
                                url: url, file: file
                            };
                            if (single) {
                                scope.attachments.splice(0, 1, attachment);
                            } else {
                                scope.attachments.push(attachment);
                            }
                            attachment.$state = STATE.UPLOADING;
                            attachment.$upload = Upload.upload(pa).progress(function (evt) {
                                attachment.progress = parseInt(100.0 * evt.loaded / evt.total);
                            }).success(function (resp) {
                                switch (resp.result) {
                                    case 0:
                                        attachment.name = resp.name;
                                        attachment.mime = resp.mime;
                                        attachment.filename = resp.filename;
                                        attachment.size = resp.size;
                                        attachment.$state = STATE.UPLOADED;
                                        break;
                                    case 1:
                                        attachment.progress = 101;
                                        attachment.errorInfo = '服务器空间不足!';
                                        attachment.$state = STATE.FAILED;
                                        break;
                                }
                            }).error(function () {
                                attachment.progress = 102;
                                attachment.errorInfo = '服务器错误!';
                                attachment.$state = STATE.FAILED;
                            });
                        }
                    }
                }
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .directive('backTop', backTop)
        .directive('contentBackTop', contentBackTop)
    ;

    /** @ngInject */
    function contentBackTop(UIHelper) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                var e = element[0];

                var backTopIcon = '<i class="fa fa-angle-up back-top" id="backTop" title="回到顶部"></i>';
                backTopIcon = angular.element(backTopIcon);
                backTopIcon.css('position', 'fixed');
                backTopIcon.css('bottom', '80px');
                element.append(backTopIcon);
                backTopIcon.bind('click', function () {
                    UIHelper.scrollTo(undefined, e.id === '' ? undefined : e.id);
                });

                element.bind('scroll', function () {
                    var top = e.scrollTop;
                    if (top > 200) {
                        backTopIcon.fadeIn();
                    } else {
                        backTopIcon.fadeOut();
                    }
                });
            }
        };
    }

    /** @ngInject */
    function backTop() {
        return {
            restrict: 'E',
            template: '<i class="fa fa-angle-up back-top" id="backTop" title="回到顶部"></i>',
            controller: function () {
                $('#backTop').backTop({
                    'position': 200,
                    'speed': 100
                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('dateSpinner', dateSpinner);

    /** @ngInject */
    function dateSpinner ($compile, DateHelper) {
        return {
            restrict: 'E',
            scope: {
                model: '=ngModel',
                maxDate: '=',
                minDate: '=',
                mode: '@',
                maxDateToday: '@'
            },
            require: ['^ngModel'],
            compile: function () {
                return {
                    pre: function prelink (scope, iElement, iAttrs, r) {
                        var mode = iAttrs.mode;
                        var maxDateToday = angular.isDefined(iAttrs.maxDateToday);
                        var vm = scope;
                        vm.prev = prev;
                        vm.next = next;
                        vm.testPrev = testPrev;
                        vm.testNext = testNext;

                        init();


                        function init () {
                            switch (mode) {
                                case 'day':
                                case 'month':
                                case 'year':
                                    vm.dateOptions = {datepickerMode: mode, minMode: mode};
                                    break;
                                default:
                                    vm.dateOptions = {datepickerMode: 'day'};
                                    if (mode !== 'week') mode = 'day';
                            }

                            if (maxDateToday) vm.dateOptions.maxDate = new Date();
                            else if (angular.isDefined(vm.maxDate)) vm.dateOptions.maxDate = vm.maxDate;

                            if (angular.isDefined(vm.minDate)) vm.dateOptions.minDate = vm.minDate;

                            if (!vm.model) vm.model = new Date();

                            scope.$watch('model', function (newValue) {
                                if (newValue) vm.dateText = getDateText(newValue, mode);
                            });

                            var elem =
                                '<span><div class="btn-group mr-2">' +
                                '<button ng-click="prev(model)" class="btn btn-default btn-sm btn-narrow" ng-disabled="!testPrev(model)">' +
                                '<i class="fa fa-angle-left text-muted"></i>' +
                                '</button>' +
                                '<button ng-click="opened=true" class="btn btn-default btn-sm"' +
                                ' uib-datepicker-popup datepicker-popup-template-url="directives/ui/dateSpinner/temp.html"' +
                                ' datepicker-options="dateOptions"' +
                                ' ng-model="model" is-open="opened">' +
                                '<i class="fa fa-calendar text-muted"></i>' +
                                '</button>' +
                                '<button ng-click="next(model)" style="margin-left:-1px" ' +
                                'class="btn btn-default btn-sm btn-narrow" ng-disabled="!testNext(model)">' +
                                '<i class="fa fa-angle-right text-muted"></i>' +
                                '</button>' +
                                '</div><span class="text-muted">{{dateText}}</span></span>';
                            var layer = angular.element(elem);
                            iElement.append(layer);
                            $compile(iElement.contents())(scope);
                        }

                        function getDateText (d, mode) {
                            switch (mode) {
                                case 'day':
                                    return DateHelper.date2Str(d, 'yyyy-MM-dd EEEE');
                                case 'week':
                                    var day = d.getDay();
                                    var dd = angular.copy(d);
                                    var monday = new Date(dd.setDate(d.getDate() - day + (day === 0 ? -6 : 1)));
                                    var sunday = new Date(dd.setDate(d.getDate() - day + (day === 0 ? 0 : 7)));
                                    return DateHelper.date2Str(monday) + ' - ' + DateHelper.date2Str(sunday);
                                case 'month':
                                    return DateHelper.date2Str(d, 'yyyy-MM');
                                case 'year':
                                    return DateHelper.date2Str(d, 'yyyy') + '年';
                            }
                        }

                        function prev (curr) {
                            vm.model = getPrev(curr);
                        }

                        function next (curr) {
                            vm.model = getNext(curr);
                        }

                        function testPrev (curr) {
                            if (angular.isUndefined(vm.dateOptions.minDate)) return true;
                            return getPrev(curr) >= vm.dateOptions.minDate;
                        }

                        function testNext (curr) {
                            if (angular.isUndefined(vm.dateOptions.maxDate)) return true;
                            return getNext(curr) <= vm.dateOptions.maxDate;
                        }

                        function getPrev (curr) {
                            curr = angular.copy(curr);
                            var tmp, newDate;
                            switch (mode) {
                                case 'day':
                                    tmp = curr.getDate() - 1;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'week':
                                    tmp = curr.getDate() - curr.getDay() - 6;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'month':
                                    tmp = curr.getMonth() - 1;
                                    newDate = new Date(curr.setMonth(tmp));
                                    break;
                                case 'year':
                                    tmp = curr.getFullYear() - 1;
                                    newDate = new Date(curr.setFullYear(tmp));
                                    break;
                            }
                            return newDate;
                        }

                        function getNext (curr) {
                            curr = angular.copy(curr);
                            var tmp, newDate;
                            switch (mode) {
                                case 'day':
                                    tmp = curr.getDate() + 1;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'week':
                                    tmp = curr.getDate() - curr.getDay() + 8;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'month':
                                    tmp = curr.getMonth() + 1;
                                    newDate = new Date(curr.setMonth(tmp));
                                    break;
                                case 'year':
                                    tmp = curr.getFullYear() + 1;
                                    newDate = new Date(curr.setFullYear(tmp));
                                    break;
                            }
                            return newDate;
                        }
                    }
                }
            }
        }
    }
})();

/*
 * Hamster.js v1.1.2
 * (c) 2013 Monospaced http://monospaced.com
 * License: MIT
 */

(function(window, document){
    'use strict';

    /**
     * Hamster
     * use this to create instances
     * @returns {Hamster.Instance}
     * @constructor
     */
    var Hamster = function(element) {
        return new Hamster.Instance(element);
    };

// default event name
    Hamster.SUPPORT = 'wheel';

// default DOM methods
    Hamster.ADD_EVENT = 'addEventListener';
    Hamster.REMOVE_EVENT = 'removeEventListener';
    Hamster.PREFIX = '';

// until browser inconsistencies have been fixed...
    Hamster.READY = false;

    Hamster.Instance = function(element){
        if (!Hamster.READY) {
            // fix browser inconsistencies
            Hamster.normalise.browser();

            // Hamster is ready...!
            Hamster.READY = true;
        }

        this.element = element;

        // store attached event handlers
        this.handlers = [];

        // return instance
        return this;
    };

    /**
     * create new hamster instance
     * all methods should return the instance itself, so it is chainable.
     * @param   {HTMLElement}       element
     * @returns {Hamster.Instance}
     * @constructor
     */
    Hamster.Instance.prototype = {
        /**
         * bind events to the instance
         * @param   {Function}    handler
         * @param   {Boolean}     useCapture
         * @returns {Hamster.Instance}
         */
        wheel: function onEvent(handler, useCapture){
            Hamster.event.add(this, Hamster.SUPPORT, handler, useCapture);

            // handle MozMousePixelScroll in older Firefox
            if (Hamster.SUPPORT === 'DOMMouseScroll') {
                Hamster.event.add(this, 'MozMousePixelScroll', handler, useCapture);
            }

            return this;
        },

        /**
         * unbind events to the instance
         * @param   {Function}    handler
         * @param   {Boolean}     useCapture
         * @returns {Hamster.Instance}
         */
        unwheel: function offEvent(handler, useCapture){
            // if no handler argument,
            // unbind the last bound handler (if exists)
            if (handler === undefined && (handler = this.handlers.slice(-1)[0])) {
                handler = handler.original;
            }

            Hamster.event.remove(this, Hamster.SUPPORT, handler, useCapture);

            // handle MozMousePixelScroll in older Firefox
            if (Hamster.SUPPORT === 'DOMMouseScroll') {
                Hamster.event.remove(this, 'MozMousePixelScroll', handler, useCapture);
            }

            return this;
        }
    };

    Hamster.event = {
        /**
         * cross-browser 'addWheelListener'
         * @param   {Instance}    hamster
         * @param   {String}      eventName
         * @param   {Function}    handler
         * @param   {Boolean}     useCapture
         */
        add: function add(hamster, eventName, handler, useCapture){
            // store the original handler
            var originalHandler = handler;

            // redefine the handler
            handler = function(originalEvent){

                if (!originalEvent) {
                    originalEvent = window.event;
                }

                // create a normalised event object,
                // and normalise "deltas" of the mouse wheel
                var event = Hamster.normalise.event(originalEvent),
                    delta = Hamster.normalise.delta(originalEvent);

                // fire the original handler with normalised arguments
                return originalHandler(event, delta[0], delta[1], delta[2]);

            };

            // cross-browser addEventListener
            hamster.element[Hamster.ADD_EVENT](Hamster.PREFIX + eventName, handler, useCapture || false);

            // store original and normalised handlers on the instance
            hamster.handlers.push({
                original: originalHandler,
                normalised: handler
            });
        },

        /**
         * removeWheelListener
         * @param   {Instance}    hamster
         * @param   {String}      eventName
         * @param   {Function}    handler
         * @param   {Boolean}     useCapture
         */
        remove: function remove(hamster, eventName, handler, useCapture){
            // find the normalised handler on the instance
            var originalHandler = handler,
                lookup = {},
                handlers;
            for (var i = 0, len = hamster.handlers.length; i < len; ++i) {
                lookup[hamster.handlers[i].original] = hamster.handlers[i];
            }
            handlers = lookup[originalHandler];
            handler = handlers.normalised;

            // cross-browser removeEventListener
            hamster.element[Hamster.REMOVE_EVENT](Hamster.PREFIX + eventName, handler, useCapture || false);

            // remove original and normalised handlers from the instance
            for (var h in hamster.handlers) {
                if (hamster.handlers[h] == handlers) {
                    hamster.handlers.splice(h, 1);
                    break;
                }
            }
        }
    };

    /**
     * these hold the lowest deltas,
     * used to normalise the delta values
     * @type {Number}
     */
    var lowestDelta,
        lowestDeltaXY;

    Hamster.normalise = {
        /**
         * fix browser inconsistencies
         */
        browser: function normaliseBrowser(){
            // detect deprecated wheel events
            if (!('onwheel' in document || document.documentMode >= 9)) {
                Hamster.SUPPORT = document.onmousewheel !== undefined ?
                    'mousewheel' : // webkit and IE < 9 support at least "mousewheel"
                    'DOMMouseScroll'; // assume remaining browsers are older Firefox
            }

            // detect deprecated event model
            if (!window.addEventListener) {
                // assume IE < 9
                Hamster.ADD_EVENT = 'attachEvent';
                Hamster.REMOVE_EVENT = 'detachEvent';
                Hamster.PREFIX = 'on';
            }

        },

        /**
         * create a normalised event object
         * @param   {Function}    originalEvent
         * @returns {Object}      event
         */
        event: function normaliseEvent(originalEvent){
            var event = {
                // keep a reference to the original event object
                originalEvent: originalEvent,
                target: originalEvent.target || originalEvent.srcElement,
                type: 'wheel',
                deltaMode: originalEvent.type === 'MozMousePixelScroll' ? 0 : 1,
                deltaX: 0,
                deltaZ: 0,
                preventDefault: function(){
                    if (originalEvent.preventDefault) {
                        originalEvent.preventDefault();
                    } else {
                        originalEvent.returnValue = false;
                    }
                },
                stopPropagation: function(){
                    if (originalEvent.stopPropagation) {
                        originalEvent.stopPropagation();
                    } else {
                        originalEvent.cancelBubble = false;
                    }
                }
            };

            // calculate deltaY (and deltaX) according to the event

            // 'mousewheel'
            if (originalEvent.wheelDelta) {
                event.deltaY = - 1/40 * originalEvent.wheelDelta;
            }
            // webkit
            if (originalEvent.wheelDeltaX) {
                event.deltaX = - 1/40 * originalEvent.wheelDeltaX;
            }

            // 'DomMouseScroll'
            if (originalEvent.detail) {
                event.deltaY = originalEvent.detail;
            }

            return event;
        },

        /**
         * normalise 'deltas' of the mouse wheel
         * @param   {Function}    originalEvent
         * @returns {Array}       deltas
         */
        delta: function normaliseDelta(originalEvent){
            var delta = 0,
                deltaX = 0,
                deltaY = 0,
                absDelta = 0,
                absDeltaXY = 0,
                fn;

            // normalise deltas according to the event

            // 'wheel' event
            if (originalEvent.deltaY) {
                deltaY = originalEvent.deltaY * -1;
                delta  = deltaY;
            }
            if (originalEvent.deltaX) {
                deltaX = originalEvent.deltaX;
                delta  = deltaX * -1;
            }

            // 'mousewheel' event
            if (originalEvent.wheelDelta) {
                delta = originalEvent.wheelDelta;
            }
            // webkit
            if (originalEvent.wheelDeltaY) {
                deltaY = originalEvent.wheelDeltaY;
            }
            if (originalEvent.wheelDeltaX) {
                deltaX = originalEvent.wheelDeltaX * -1;
            }

            // 'DomMouseScroll' event
            if (originalEvent.detail) {
                delta = originalEvent.detail * -1;
            }

            // Don't return NaN
            if (delta === 0) {
                return [0, 0, 0];
            }

            // look for lowest delta to normalize the delta values
            absDelta = Math.abs(delta);
            if (!lowestDelta || absDelta < lowestDelta) {
                lowestDelta = absDelta;
            }
            absDeltaXY = Math.max(Math.abs(deltaY), Math.abs(deltaX));
            if (!lowestDeltaXY || absDeltaXY < lowestDeltaXY) {
                lowestDeltaXY = absDeltaXY;
            }

            // convert deltas to whole numbers
            fn = delta > 0 ? 'floor' : 'ceil';
            delta  = Math[fn](delta / lowestDelta);
            deltaX = Math[fn](deltaX / lowestDeltaXY);
            deltaY = Math[fn](deltaY / lowestDeltaXY);

            return [delta, deltaX, deltaY];
        }
    };

    if (typeof window.define === 'function' && window.define.amd) {
        // AMD
        window.define('hamster', [], function(){
            return Hamster;
        });
    } else if (typeof exports === 'object') {
        // CommonJS
        module.exports = Hamster;
    } else {
        // Browser global
        window.Hamster = Hamster;
    }

})(window, window.document);
angular.module('c')
    .directive('msdWheel', ['$parse', function ($parse) {
        return {
            restrict: 'A, C',
            link: function (scope, element, attr) {
                var expr = $parse(attr['msdWheel']),
                    fn = function (event, delta, deltaX, deltaY) {
                        scope.$apply(function () {
                            expr(scope, {
                                $event: event,
                                $delta: delta,
                                $deltaX: deltaX,
                                $deltaY: deltaY
                            });
                        });
                    },
                    hamster;

                if (typeof Hamster === 'undefined') {
                    // fallback to standard wheel event
                    element.bind('wheel', function (event) {
                        scope.$apply(function () {
                            expr(scope, {
                                $event: event
                            });
                        });
                    });
                    return;
                }

                // don't create multiple Hamster instances per element
                if (!(hamster = element.data('hamster'))) {
                    hamster = Hamster(element[0]);
                    element.data('hamster', hamster);
                }

                // bind Hamster wheel event
                hamster.wheel(fn);

                // unbind Hamster wheel event
                scope.$on('$destroy', function () {
                    hamster.unwheel(fn);
                });
            }
        };
    }]);
(function () {
    'use strict';

    angular.module('c')
        .directive('pdfPreviewer', pdfPreviewer);

    /** @ngInject */
    function pdfPreviewer($compile) {
        return {
            restrict: 'E',
            scope: {
                pdfUrl: '=url'
                // height: '=height'
            },
            require: [],
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {
                        var id = 'pdf';// + (new Date()).getTime() + (Math.floor(Math.random() * 100000));

                        init();


                        function init() {
                            var elem = '<div class="pdf-wrapper" fullscreen="isFullscreen" loading-container="loading">' +
                                '<ng-pdf template-url="directives/ui/pdfPreviewer/temp.html" canvasid="' + id + '" scale="page-fit">' +
                                '</ng-pdf></div>';
                            var layer = angular.element(elem);
                            iElement.append(layer);
                            $compile(iElement.contents())(scope);
                            scope.loading = true;
                            scope.onLoad = function () {
                                scope.loading = false;
                            }
                        }
                    }
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('c')
        .directive('richTextRender', richTextRender)
        .directive('rtrGallery', rtrGallery)
    ;

    function rtrGallery() {
        return {
            priority: 10,
            link: function(scope, element, attrs) {
                var pswpElement = document.getElementById('pswp');
                var imgItems = [];

                scope.$watch(attrs.ngBindHtml, function(newvalue) {
                    if (newvalue) {
                        imgItems = [];
                        var imgList = element[0].querySelectorAll('img');
                        for(var i = 0; i < imgList.length; i++) {
                            var img = imgList[i];
                            img.onload = function() {
                                var img = this;
                                var jqueryImg = $(this);
                                var imgWidth = img.naturalWidth,
                                    imgHeight = img.naturalHeight;
                                if (imgWidth > 50 && imgHeight > 50) {
                                    img.onclick = onThumbnailsClick;
                                    img.setAttribute('idx', imgItems.length);
                                    img.className = 'img-responsive';
                                    jqueryImg.css({margin: 'auto'});
                                    jqueryImg.addClass("fadeInDown");
                                    if (imgWidth < 576) {
                                        imgWidth *= 2;
                                        imgHeight *= 2;
                                    } else if (imgWidth >= 576 && imgWidth < 992) {
                                        imgWidth = 992;
                                        imgHeight = imgHeight * 992 / imgWidth;
                                    }
                                    imgItems.push({src: img.src, w: +imgWidth, h: +imgHeight, el: img});
                                }
                            };
                        }
                    }
                });

                function onThumbnailsClick(e) {
                    if (imgItems.length > 0) {
                        e = e || window.event;
                        e.preventDefault ? e.preventDefault() : e.returnValue = false;
                        var eTarget = e.target || e.srcElement;
                        openGallery(+eTarget.getAttribute('idx'));
                    }
                }

                function openGallery(index) {
                    var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, imgItems, {
                        index: index,
                        getThumbBoundsFn: function(index) {
                            var thumbnail = imgItems[index].el;
                            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                            var rect = thumbnail.getBoundingClientRect();
                            return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
                        }
                    });
                    gallery.init();
                }
            }
        };
    }

    /** @ngInject */
    function richTextRender($compile) {
        return {
            restrict: 'E',
            scope: {
                html: '=',
                text: '='
            },
            require: [],
            compile: function() {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {
                        init();


                        function init() {
                            var elem = '<div oc-lazy-load=["/ocLazyLoad/PhotoSwipe/photoswipe.min.js",' +
                                '"/ocLazyLoad/PhotoSwipe/photoswipe.css","/ocLazyLoad/PhotoSwipe/photoswipe-ui-default.min.js",' +
                                '"/ocLazyLoad/PhotoSwipe/default-skin/default-skin.css"]>';

                            if (angular.isUndefined(iAttrs.html)) {
                                elem += '<div ng-bind-html="text | safeHtml" rtr-gallery></div></div>';
                            } else {
                                elem += '<div ng-bind-html=html rtr-gallery></div></div>';
                            }
                            var layer = angular.element(elem);
                            iElement.append(layer);
                            $compile(iElement.contents())(scope);
                        }
                    }
                }
            }
        }
    }
})();

/*! Copyright (c) 2011 Piotr Rochala (http://rocha.la)
 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
 *
 * Version: 1.3.8
 *
 */
(function(e){e.fn.extend({slimScroll:function(f){var a=e.extend({width:"auto",height:"250px",size:"7px",color:"#000",position:"right",distance:"1px",start:"top",opacity:.4,alwaysVisible:!1,disableFadeOut:!1,railVisible:!1,railColor:"#333",railOpacity:.2,railDraggable:!0,railClass:"slimScrollRail",barClass:"slimScrollBar",wrapperClass:"slimScrollDiv",allowPageScroll:!1,wheelStep:20,touchScrollStep:200,borderRadius:"7px",railBorderRadius:"7px"},f);this.each(function(){function v(d){if(r){d=d||window.event;
var c=0;d.wheelDelta&&(c=-d.wheelDelta/120);d.detail&&(c=d.detail/3);e(d.target||d.srcTarget||d.srcElement).closest("."+a.wrapperClass).is(b.parent())&&n(c,!0);d.preventDefault&&!k&&d.preventDefault();k||(d.returnValue=!1)}}function n(d,g,e){k=!1;var f=b.outerHeight()-c.outerHeight();g&&(g=parseInt(c.css("top"))+d*parseInt(a.wheelStep)/100*c.outerHeight(),g=Math.min(Math.max(g,0),f),g=0<d?Math.ceil(g):Math.floor(g),c.css({top:g+"px"}));l=parseInt(c.css("top"))/(b.outerHeight()-c.outerHeight());g=
l*(b[0].scrollHeight-b.outerHeight());e&&(g=d,d=g/b[0].scrollHeight*b.outerHeight(),d=Math.min(Math.max(d,0),f),c.css({top:d+"px"}));b.scrollTop(g);b.trigger("slimscrolling",~~g);w();p()}function x(){u=Math.max(b.outerHeight()/b[0].scrollHeight*b.outerHeight(),30);c.css({height:u+"px"});var a=u==b.outerHeight()?"none":"block";c.css({display:a})}function w(){x();clearTimeout(B);l==~~l?(k=a.allowPageScroll,C!=l&&b.trigger("slimscroll",0==~~l?"top":"bottom")):k=!1;C=l;u>=b.outerHeight()?k=!0:(c.stop(!0,
!0).fadeIn("fast"),a.railVisible&&m.stop(!0,!0).fadeIn("fast"))}function p(){a.alwaysVisible||(B=setTimeout(function(){a.disableFadeOut&&r||y||z||(c.fadeOut("slow"),m.fadeOut("slow"))},1E3))}var r,y,z,B,A,u,l,C,k=!1,b=e(this);if(b.parent().hasClass(a.wrapperClass)){var q=b.scrollTop(),c=b.siblings("."+a.barClass),m=b.siblings("."+a.railClass);x();if(e.isPlainObject(f)){if("height"in f&&"auto"==f.height){b.parent().css("height","auto");b.css("height","auto");var h=b.parent().parent().height();b.parent().css("height",
h);b.css("height",h)}else"height"in f&&(h=f.height,b.parent().css("height",h),b.css("height",h));if("scrollTo"in f)q=parseInt(a.scrollTo);else if("scrollBy"in f)q+=parseInt(a.scrollBy);else if("destroy"in f){c.remove();m.remove();b.unwrap();return}n(q,!1,!0)}}else if(!(e.isPlainObject(f)&&"destroy"in f)){a.height="auto"==a.height?b.parent().height():a.height;q=e("<div></div>").addClass(a.wrapperClass).css({overflow:"hidden",width:a.width,height:a.height});b.css({overflow:"hidden",
width:a.width,height:a.height});var m=e("<div></div>").addClass(a.railClass).css({width:a.size,height:"100%",position:"absolute",top:0,display:a.alwaysVisible&&a.railVisible?"block":"none","border-radius":a.railBorderRadius,background:a.railColor,opacity:a.railOpacity,zIndex:90}),c=e("<div></div>").addClass(a.barClass).css({background:a.color,width:a.size,position:"absolute",top:0,opacity:a.opacity,display:a.alwaysVisible?"block":"none","border-radius":a.borderRadius,BorderRadius:a.borderRadius,MozBorderRadius:a.borderRadius,
WebkitBorderRadius:a.borderRadius,zIndex:99}),h="right"==a.position?{right:a.distance}:{left:a.distance};m.css(h);c.css(h);b.wrap(q);b.parent().append(c);b.parent().append(m);a.railDraggable&&c.bind("mousedown",function(a){var b=e(document);z=!0;t=parseFloat(c.css("top"));pageY=a.pageY;b.bind("mousemove.slimscroll",function(a){currTop=t+a.pageY-pageY;c.css("top",currTop);n(0,c.position().top,!1)});b.bind("mouseup.slimscroll",function(a){z=!1;p();b.unbind(".slimscroll")});return!1}).bind("selectstart.slimscroll",
function(a){a.stopPropagation();a.preventDefault();return!1});m.hover(function(){w()},function(){p()});c.hover(function(){y=!0},function(){y=!1});b.hover(function(){r=!0;w();p()},function(){r=!1;p()});b.bind("touchstart",function(a,b){a.originalEvent.touches.length&&(A=a.originalEvent.touches[0].pageY)});b.bind("touchmove",function(b){k||b.originalEvent.preventDefault();b.originalEvent.touches.length&&(n((A-b.originalEvent.touches[0].pageY)/a.touchScrollStep,!0),A=b.originalEvent.touches[0].pageY)});
x();"bottom"===a.start?(c.css({top:b.outerHeight()-c.outerHeight()}),n(0,!0)):"top"!==a.start&&(n(e(a.start).position().top,null,!0),a.alwaysVisible||c.hide());window.addEventListener?(this.addEventListener("DOMMouseScroll",v,!1),this.addEventListener("mousewheel",v,!1)):document.attachEvent("onmousewheel",v)}});return this}});e.fn.extend({slimscroll:e.fn.slimScroll})})(jQuery);
angular.module('c').directive('slimscroll', function () {
    'use strict';

    return {
        restrict: 'A',
        link: function ($scope, $elem, $attr) {
            var off = [];
            var option = {};

            var refresh = function () {
                if ($attr.slimscroll) {
                    option = $scope.$eval($attr.slimscroll);
                } else if ($attr.slimscrollOption) {
                    option = $scope.$eval($attr.slimscrollOption);
                }

                $($elem).slimScroll({destroy: true});

                $($elem).slimScroll(option);
            };

            var registerWatch = function () {
                if ($attr.slimscroll && !option.noWatch) {
                    off.push($scope.$watchCollection($attr.slimscroll, refresh));
                }

                if ($attr.slimscrollWatch) {
                    off.push($scope.$watchCollection($attr.slimscrollWatch, refresh));
                }

                if ($attr.slimscrolllistento) {
                    off.push($scope.$on($attr.slimscrolllistento, refresh));
                }
            };

            var destructor = function () {
                $($elem).slimScroll({destroy: true});
                off.forEach(function (unbind) {
                    unbind();
                });
                off = null;
            };

            off.push($scope.$on('$destroy', destructor));

            registerWatch();
        }
    };
});

(function () {
    'use strict';

    angular.module('c')
        .directive('baseData', baseData)
        .controller('BaseDataDlgCtrl', BaseDataDlgCtrl);


    function baseData() {
        return {
            templateUrl: 'directives/main/base-data/base-data.html',
            restrict: 'E',
            replace: true,
            scope: {
                'title': '@',
                'service': '@',
                'maxProtectId': '@'
            },
            controller: baseDataCtrl
        };
    }


    /** @ngInject */
    function baseDataCtrl($scope, $injector, Api, Table) {
        var vm = $scope;
        var service = $injector.get(vm.service);
        vm.addEdit = addEdit;
        vm.setStop = setStop;
        vm.remove = remove;

        init();

        function init() {
            if (angular.isUndefined(vm.maxProtectId)) {
                vm.maxProtectId = 0;
            } else {
                vm.maxProtectId = parseInt(vm.maxProtectId);
            }

            Table.load(vm, {
                service: service,
                params: {opt: 1/*INDEX_ALL*/},
                sorting: {sorting: 'asc'},
                optColWidth: Table._3_BTN,
                hideFilter: true,
                optInFront: true,
                cols: [
                    {field: "name", title: "名称"},
                    {field: "sorting", title: "排序"}
                ]
            });
        }

        function remove(m) {
            Api.delTableItem(service, m.id, vm, vm.title, m.name);
        }

        function setStop(m) {
            Api.setStop(service, m);
        }

        function addEdit(m) {
            Api.addEdit(vm, 'BaseDataDlg', 'BaseDataDlgCtrl', m, {service: service, title: vm.title});
        }
    }

    function BaseDataDlgCtrl($scope, $uibModalInstance, $q, Dlg, data) {
        var vm = $scope;
        var service = data.service;
        vm.title = data.title;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);


        function loadModel(id) {
            if (id) {
                vm.m = service.get({id: id});
            }
        }

        function ok(m) {
            var defer = $q.defer();
            if (vm.Form.$valid) {
                var promise;
                var pa = {
                    name: m.name,
                    sorting: m.sorting
                };
                if (m.id) { //修改
                    promise = service.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise;
                } else { //添加
                    promise = service.save(pa).$promise;
                }
                promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                Dlg.w('表单中有错误!');
                vm.Form.submitted = true;
                defer.reject();
            }
            return defer.promise;
        }
    }
})();

angular.module('c')
    .directive('basicDataTable', function () {
        var controller = function ($rootScope, $scope, $filter, $injector, dialogs, toaster, NgTableParams, Table) {
            var Data = $injector.get($scope.serverName);
            if (angular.isUndefined($scope.maxProtectId)) {
                $scope.maxProtectId = 0;
            } else {
                $scope.maxProtectId = parseInt($scope.maxProtectId);
            }
            var item = $scope.title;

            $scope.optColWidth = 56;

            $scope.tableParams = new NgTableParams({
                page: 1,
                count: 10,
                sorting: {
                    sorting: 'asc'
                }
            }, {
                counts: [5, 10, 15],
                total: 0,
                getData: function ($defer, params) {
                    if (!$scope.cachedData) {
                        Data.query(function (data) {
                            $scope.cachedData = data;
                            angular.forEach(data, function (data) {
                                data.sorting = parseInt(data.sorting);
                                data.id = parseInt(data.id)
                            });
                            if (data.length > 0 && typeof data[0]['is_stop'] != 'undefined') {
                                $scope.has_stop = true;
                            }
                            Table.getTableData(data, $defer, params, $filter);
                        });
                    } else {
                        Table.getTableData($scope.cachedData, $defer, params, $filter);
                    }
                }
            });

            $scope.tableReload = function () {
                $scope.cachedData = null;
                $scope.tableParams.reload();
            };

            $scope.add = function () {
                dialogs.create('directives/main/basic-data-table/dataDlg.html', 'BasicDataDlgCtrl', {title: $scope.title}, {
                    size: 'md'
                }).result.then(function (data) {
                    Data.save(data).$promise.then(function (data) {
                        toaster.success(item + '添加成功!');
                        $scope.tableReload();
                        $rootScope.$broadcast('basicDataChange');
                    }, function () {
                        toaster.error(item + '添加失败!');
                    })
                });
            };

            $scope.edit = function (data) {
                data.$edit = true;
                data.$nameChanged = data.name;
                data.$sortingChanged = data.sorting;
            };

            $scope.save = function (data) {
                data.$edit = false;
                if (data.$nameChanged == "") {
                    toaster.error(item + '名称不能为空!');
                } else if (data.name != data.$nameChanged || data.sorting != data.$sortingChanged) {
                    var params = {};
                    params['name'] = data.$nameChanged;
                    params['sorting'] = data.$sortingChanged;
                    Data.update({id: data.id}, params).$promise.then(function () {
                        toaster.success(item + '修改成功!');
                        data.name = data.$nameChanged;
                        data.sorting = parseInt(data.$sortingChanged);
                        $scope.tableParams.reload();
                        $rootScope.$broadcast('basicDataChange');
                    }, function (error) {
                        toaster.error(item + '修改失败!');
                    });
                }
            };

            $scope.delete = function (data) {
                dialogs.confirm('删除' + item, '确定要删除<strong>' + data.name + '</strong>' + item + '吗?')
                    .result.then(function () {
                    Data.delete({id: data.id}).$promise.then(function (data) {
                        switch (data.result) {
                            case 0:
                                toaster.success(item + '删除成功!');
                                break;
                            case 1:
                                toaster.warning('存在属于该' + item + '的员工记录,因此无法删除该分类!');
                                break;
                        }
                        $scope.tableReload();
                        $rootScope.$broadcast('basicDataChange');
                    }, function () {
                        toaster.error(item + '删除失败!');
                    });
                });
            };
        };

        return {
            templateUrl: 'directives/main/basic-data-table/basic-data-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'title': '@',
                'serverName': '@',
                'maxProtectId': '@'
            },
            controller: controller
        }
    });
angular.module('c')
    .directive('advice', function () {
        return {
            templateUrl: 'directives/main/advice/advice.html',
            restrict: 'E',
            replace: true,
            scope: {
                'warning': '@',
                'danger': '@'
            }
        }
    });
angular.module('c')
    .directive('breadcrumb', function () {
        return {
            templateUrl: 'templates/cache/breadcrumb.html',
            restrict: 'E',
            replace: true,
            scope: {
                'current': '@',
                'parent': '@'
            }
        }
    });
angular.module('c')
    .directive('footer', function () {
        return {
            templateUrl: 'templates/cache/footer.html',
            restrict: 'E',
            replace: true
        }
    });
(function () {
    'use strict';
    angular.module('c')
        .directive('header', function () {
            return {
                templateUrl: 'templates/cache/header.html',
                restrict: 'E',
                controller: ctrl,
                controllerAs: 'header'
            }
        });

    /** @ngInject */
    function ctrl($rootScope, $scope, $state, $stateParams, $timeout, $http, $q, dialogs, C,
                  ArrayHelper, Auth, Email, Sidebar) {
        var vm = $rootScope.header = this;
        vm.toggleSidebar = Sidebar.toggle;
        //header-notification
        vm.mails = [];
        vm.tasks = [];
        vm.account = Auth.getAccount();
        var taskFnList = {
            23001: meetingLeaveFn,
            13009: carFillFn
        };
        var firstToggle = true;

        vm.toggleTaskD = toggleTaskD;
        vm.reloadTask = reloadTask;
        vm.reloadMail = reloadMail;
        vm.toTask = toTask;
        vm.readMail = readMail;
        vm.logout = logout;

        init();


        function init() {
            $scope.$on(C.P + 'mail.withdraw', function (event, data) {
                var mail = data.data.mail;

                var i = ArrayHelper.indexOfKey(mail.id, vm.mails);
                if (i >= 0) {
                    vm.mails.splice(i, 1);
                }
            });

            $scope.$on('mail.send', function (event, data) {
                var mail = data;
                vm.mails.splice(0, 0, {id: mail.id, subject: mail.subject, created_at: mail.created_at});
            });

            $scope.$on('mailRead', function (event, data) {
                vm.mails = ArrayHelper.except(data, vm.mails);
            });

            $scope.$on('mailDel', function (event, data) {
                if (data) {
                    var id = data;
                    var i = ArrayHelper.indexOfKey(id, vm.mails);
                    if (i >= 0) {
                        vm.mails.splice(i, 1);
                    }
                } else {
                    loadUnreadMail();
                }
            });

            // $scope.$on('openTaskD', function () {
            //     vm.showArrow = true;
            // });

            $scope.$on('newTask', function (evt, data) {
                var task = data.task;

                if (firstToggle) {
                    firstToggle = false;
                    $http.post('/api/v1/task_all', {}).success(function (tasks) {
                        vm.tasks = tasks;
                        vm.hasTask = tasks.length > 0;
                        addTask(task);
                    });
                } else {
                    addTask(task);
                }

                function addTask(task) {
                    var index = ArrayHelper.indexOfKey(task.type, vm.tasks, 'type');
                    if (index === -1) {
                        task.isNew = true;
                        vm.tasks.unshift(task);
                    } else {
                        vm.tasks[index].isNew = true;
                        var tmp = vm.tasks[index];
                        vm.tasks[index] = vm.tasks[0];
                        vm.tasks[0] = tmp;
                    }
                    vm.hasTask = vm.tasks.length > 0;

                    document.getElementById('msgTone2').play();
                    vm.shakePoint = true;
                    $timeout(function () {
                        vm.shakePoint = false;
                    }, 2000);
                }

            });

            // 到main.js中统一加载
            $rootScope.$broadcast('headerLoaded');

            if ($stateParams.pendingDlgOpen === 'true') {
                vm.openTaskD = true;
                toggleTaskD();
            }
        }

        function meetingLeaveFn() {
            dialogs.create(C.T + 'meeting/leave.html', 'MeetingLeaveCtrl', {},
                {size: 'lg'});
        }

        function carFillFn() {
            dialogs.create('pages/dlg/car_manage/carFillDlg.html', 'CarFillCtrl', {},
                {size: 'lg'});
        }

        ////////////////////////////////////////////////////////////////////////
        ////////////////////////header-notification

        function toggleTaskD() {
            if (firstToggle) {
                reloadTask();
                firstToggle = false;
            }
        }

        function reloadMail() {
            var defer = $q.defer();
            vm.mailLoading = true;
            $http.get('/api/v1/emails', {params: {opt: 1}}).success(function (resp) {
                vm.mails = resp.mails;
                defer.resolve();
            }).finally(function () {
                vm.mailLoading = false;
                defer.reject();
            });
            return defer.promise;
        }

        function reloadTask() {
            var defer = $q.defer();
            vm.taskLoading = true;
            $http.post('/api/v1/task_all', {}).success(function (tasks) {
                vm.tasks = tasks;
                vm.hasTask = tasks.length > 0;
                defer.resolve();
            }).finally(function () {
                vm.taskLoading = false;
                defer.reject();
            });
            return defer.promise;
        }

        function loadUnreadMail() {
            // 只会拿最多10个
            Email.query({opt: 1}, function (resp) {
                vm.mails = resp.mails;
            });
        }

        function toTask(task, index) {
            //
            var pa = {tab: task.tag};
            vm.tasks.splice(index, 1);
            vm.hasTask = vm.tasks.length > 0;
            if (task.state) {
                if ($state.current.name === task.state) {
                    $rootScope.$broadcast("tabChange", pa);
                } else {
                    $state.go(task.state, pa);
                }
            } else {
                //function list
                var fn = taskFnList[task.type];
                if (fn) fn();
                else alert("该事件没有处理方法");
            }
        }

        function readMail(mail, $index) {
            if (mail.withdraw == 1) {
                dialogs.notify('确认', '该邮件已经被发送者撤回!');
            } else {
                dialogs.create(C.V + 'email/show_dlg.html', 'MailShowDlgCtrl', {mail: mail},
                    {size: 'lg'}).result.then(function (params) {
                    switch (params.opt) {
                        case 1:
                            $state.go('app.message_email', {
                                tab: 'write',
                                data: {
                                    op: 'mailReply',
                                    mail: params.mail
                                }
                            });
                            break;
                        case 2:
                            $state.go('app.message_email', {
                                tab: 'write',
                                data: {
                                    op: 'mailForward',
                                    mail: params.mail
                                }
                            });
                            break;
                        case 3:
                            Email.rm_from_inbox({mails: [mail.id]}).$promise.then(
                                function () {
                                    vm.mails.splice($index, 1);
                                    $rootScope.$broadcast('mailDel', mail.id);
                                });
                            break;
                    }
                });
            }

        }

        function logout() {
            Auth.logout(function () {
                $state.go('login');
            });
        }
    }
})();

angular.module('c').
    directive('inputFloat', function ($filter) {
        var FLOAT_REGEXP_1 = /^\$?\d+.(\d{3})*(\,\d*)$/; //Numbers like: 1.123,56
        var FLOAT_REGEXP_2 = /^\$?\d+,(\d{3})*(\.\d*)$/; //Numbers like: 1,123.56
        var FLOAT_REGEXP_3 = /^\$?\d+(\.\d*)?$/; //Numbers like: 1123.56
        var FLOAT_REGEXP_4 = /^\$?\d+(\,\d*)?$/; //Numbers like: 1123,56

        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    return;
                }
                var decimal_digit = scope.$eval(attrs.inputFloat);

                ngModelCtrl.$parsers.push(function (val) {
                    if (angular.isUndefined(val)) {
                        var val = '';
                    }
                    var minus = val[0] == '-';
                    var clean = val.replace(/[^0-9\.]/g, '');
                    var decimalCheck = clean.split('.');

                    if (!angular.isUndefined(decimalCheck[1])) {
                        decimalCheck[1] = decimalCheck[1].slice(0, decimal_digit);
                        clean = decimalCheck[0] + '.' + decimalCheck[1];
                    }

                    if (minus)
                        clean = '-' + clean;

                    if (val !== clean) {
                        ngModelCtrl.$setViewValue(clean);
                        ngModelCtrl.$render();
                    }
                    return clean;
                });

                element.bind('keypress', function (event) {
                    if (event.keyCode === 32) {
                        event.preventDefault();
                    }
                });
            }
        }
    });
angular.module('c').
    directive('inputNumber', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    var minus = text[0] == '-';
                    var allow_minus = scope.$eval(attr.inputNumber);
                    var transformedInput = text.replace(/[^0-9]/g, '');
                    if (minus && allow_minus)
                        transformedInput = '-' + transformedInput;
                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;  // or return Number(transformedInput)
                }

                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    });
(function () {
    'use strict';

    angular.module('c')
        .directive('messageRecipient', messageRecipient);

    function messageRecipient() {
        return {
            templateUrl: 'directives/main/message-recipient/message-recipient.html',
            restrict: 'E',
            scope: {
                // 表明是哪个部门的短信提醒人
                'type': '@',
                'title': '@',
                'desc': '@'
            },
            controller: controller
        }
    }

    /** @ngInject */
    function controller($scope, $q, toaster, MessageRecipient) {
        $scope.title = $scope.title ? $scope.title : '请假提醒人';
        $scope.desc = $scope.desc ? $scope.desc : '设置相应的短信提醒人';

        $scope.reload = function () {
            MessageRecipient.get({id: $scope.type}, function (resp) {
                var r = resp.item;
                if (!r) r = {id: $scope.type};
                $scope.r = r;
            });
        };

        $scope.submit = function (r) {
            var defer = $q.defer();
            if (r.id) {
                var params = {user_id: r.user ? r.user.id : null};
                MessageRecipient.update({id: r.id}, params).$promise.then(function () {
                    toaster.success('设置成功');
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                defer.reject();
            }
            return defer.promise;
        };

        $scope.reset = $scope.reload;
        $scope.reload();
    }

})();









angular.module('c')
    .directive('tabInclude', [function ($parse) {
        var selfIndex = function (element) {
            var arr = element.parent().children();
            var val = element[0];
            var i = arr.length;
            while (i--) {
                if (val == arr[i]) return i;
            }
            return -1
        };

        return {
            require: ['^uibTab', '^uibTabset'],
            restrict: 'A',
            priority: 100,
            compile: function (element, attrs, transclude) {

                var elem = angular.element('<div></div>');
                elem.attr('ng-include', '$include[' + (attrs.ngRepeat ? '$index' : selfIndex(element)) + ']');
                element.append(elem);

                return function postLink(scope, element, attrs) {
                    if (scope.$include == null) {
                        scope.$include = [];
                    }
                    scope.$include.push('');
                    var isolatedScope = scope.$$childTail;
                    // element.isolateScope().$watch('active',
                    isolatedScope.$watch('active',
                        function (newValue) {

                            if (newValue) {
                                scope.$include[scope.$index ? scope.$index : selfIndex(element)] = attrs.tabInclude;
                            }
                        }
                    );
                };
            }
        };
    }]);
(function () {
    'use strict';

    angular.module('c')
        .directive('sidebar', function () {
            return {
                templateUrl: 'templates/cache/sidebar.html',
                restrict: 'E',
                controller: ctrl,
                controllerAs: 'sidebar'
            }
        });

    /** @ngInject */
    function ctrl($scope, $rootScope, $state, Sidebar, Dlg) {
        var STATE = Sidebar.STATE;
        var lastWidth = window.innerWidth;
        var vm = this;
        vm.menuHeight = window.innerHeight - 50;
        vm.firstLvVisible = firstLvVisible;
        vm.secondLvVisible = secondLvVisible;
        vm.check = check;
        vm.subItemCollapse = subItemCollapse;
        vm.mouseOverMenuItem = mouseOverMenuItem;
        vm.mouseLeaveMenuItem = mouseLeaveMenuItem;
        vm.mouseWheelSubItem = mouseWheelSubItem;
        vm.clickSubItem = clickSubItem;

        init();


        function init() {
            $scope.$on('$destroy', function () {
                $(window).off('resize', _onWindowResize);
            });

            Sidebar.initState();

            Sidebar.bindState($scope);

            Sidebar.getMenuItems(function (menuItems) {
                vm.menuItems = menuItems;
            });

            $(window).on('resize', _onWindowResize);
        }

        function clickSubItem(event) {
            if (Sidebar.getState() !== Sidebar.STATE.ICON_ONLY) return;
            var subItem = angular.element(event.currentTarget);
            var wrapper = subItem.closest('.sub-item-wrapper');
            wrapper.hide();
        }

        function mouseWheelSubItem($event) {
            if (Sidebar.getState() !== Sidebar.STATE.ICON_ONLY) return;
            $event.stopPropagation();
        }

        function mouseOverMenuItem(event) {
            if (Sidebar.getState() !== Sidebar.STATE.ICON_ONLY) return;
            var menuItem = angular.element(event.currentTarget);
            var menuItemPos = menuItem.position();
            var submenuWrapper = $('> .sub-item-wrapper', menuItem);
            var height = submenuWrapper.outerHeight();
            var winHeight = window.innerHeight - 50;

            var secondUl = $('> .nav-second-level', submenuWrapper);
            if (height + 20 > winHeight) {
                height = winHeight - 20;
                secondUl.css({'height': height});
            } else {
                secondUl.css({'height': ""});
            }

            var top = menuItemPos.top - 26;
            if (top + height > winHeight) {
                top = winHeight - height;
            }
            submenuWrapper.css({
                top: top,
                left: menuItemPos.left + Math.round(menuItem.outerWidth() * 0.8),
                display: 'block'
            });
        }

        function mouseLeaveMenuItem(event) {
            if (Sidebar.getState() !== Sidebar.STATE.ICON_ONLY) return;
            var subItem = angular.element(event.currentTarget);
            var submenuWrapper = $('> .sub-item-wrapper', subItem);
            submenuWrapper.hide();
        }

        function subItemCollapse(index) {
            return Sidebar.getState() !== Sidebar.STATE.ICON_ONLY && $rootScope.collapseVar !== index
        }

        function _onWindowResize() {
            var newMenuHeight = window.innerHeight - 50;
            if (vm.menuHeight !== newMenuHeight) vm.menuHeight = newMenuHeight;

            var width = window.innerWidth;
            if (lastWidth < 1200 && width >= 1200) {
                Sidebar.updateState(STATE.VISIBLE);
            } else if (
                (lastWidth >= 1200 && width < 1200) ||
                (lastWidth < 992 && width >= 992)) {
                Sidebar.updateState(STATE.ICON_ONLY);
            } else if (lastWidth >= 568 && width < 568) {
                Sidebar.updateState(STATE.HIDDEN);
            }
            lastWidth = width;
        }

        function check(x) {
            if (x === $rootScope.collapseVar) {
                $rootScope.collapseVar = 0;
            } else {
                $rootScope.collapseVar = x;
            }
        }

        function firstLvVisible(item) {
            var search = vm.search;
            if (!search) return true;
            var secondLv = search.charAt(0) !== '-';
            if (!secondLv) search = search.substr(1, search.length - 1);
            var visible = !search || search.length === 0;
            if (!visible) {
                if (secondLv) {  // 二级菜单检索
                    for (var i = 0; i < item.children.length; i++) {
                        var subItem = item.children[i];
                        if (subItem.display_name.indexOf(search) !== -1) {
                            visible = true;
                            break;
                        }
                    }
                } else {
                    visible = item.display_name.indexOf(search) !== -1
                }
            }
            return visible;
        }

        function secondLvVisible(item) {
            var search = vm.search;
            if (!search) return item.state;
            var secondLv = search.charAt(0) !== '-';
            if (!secondLv) search = search.substr(1, search.length - 1);
            var visible = !search || search.length === 0;
            if (!visible) { // 有输入
                visible = secondLv ? item.display_name.indexOf(search) !== -1 : true;
            }
            return visible && item.state;
        }

    }

})();

(function () {
    'use strict';

    angular.module('c').factory('Sidebar', Sidebar);

    function Sidebar($rootScope, $state, $timeout, $http, $q, ArrayHelper, Dlg) {
        var curState, cachedMenuItems, menuItemRequesting, menuReqDefers = [];
        var STATE = {
            HIDDEN: 0,
            ICON_ONLY: 1,
            VISIBLE: 2
        };

        return {
            STATE: STATE,
            updateState: updateState,
            toggle: toggle,
            bindState: bindState,
            initState: initState,
            getState: function () {
                return curState;
            },
            setupMenuItems: setupMenuItems,
            getMenuItems: getMenuItems,
            hasMenuItems: function () {
                return cachedMenuItems;
            }
        };

        function getMenuItems(successFn, failedFn) {
            if (cachedMenuItems) {
                if (successFn) successFn(cachedMenuItems);
            } else if (menuItemRequesting) {
                var defer = $q.defer();
                menuReqDefers.push(defer);
                defer.promise.then(function () {
                    if (successFn) successFn(cachedMenuItems);
                }, function (err) {
                    if (failedFn) failedFn(err);
                });
            } else {
                menuItemRequesting = true;
                $http.get('/api/v1/menu_items')
                    .success(function (menuItems) {
                        setupMenuItems(menuItems);
                        if (successFn) successFn(menuItems);
                        angular.forEach(menuReqDefers, function (defer) {
                            defer.resolve(menuItems);
                        });
                    })
                    .error(function (err) {
                        if (err.data.msg) Dlg.error(err.data.msg);
                        if (failedFn) failedFn(err);
                        angular.forEach(menuReqDefers, function (defer) {
                            defer.reject(err);
                        });
                    })
                    .finally(function () {
                        menuItemRequesting = false;
                        menuReqDefers = [];
                    });
            }
        }

        function setupMenuItems(menuItems) {
            var states = $state.get();
            angular.forEach(states, function (s) {
                s.can = angular.isUndefined(s.params);
            });

            var index = 0;
            angular.forEach(menuItems, function (item) {
                index++;
                angular.forEach(item.children, function (m) {
                    m.state = ArrayHelper.getItem(m.id, states, 'perm');
                    if (m.state) {
                        m.state.can = true;
                        m.state.index = index;
                    } else {
                        console.error('未注册菜单:', m.id);
                    }
                });
            });

            cachedMenuItems = menuItems;
        }

        function bindState(scope) {
            scope.$on('sidebarState', function (event, state) {
                $timeout(function () {
                    scope.sidebarState = state;
                });
            });
        }

        function toggle() {
            var width = window.innerWidth;
            if (width > 768) {
                if (curState === STATE.VISIBLE) {
                    updateState(STATE.ICON_ONLY);
                } else {
                    updateState(STATE.VISIBLE);
                }
            } else {
                if (curState === STATE.HIDDEN) {
                    updateState(STATE.VISIBLE);
                } else {
                    updateState(STATE.HIDDEN);
                }
            }
        }

        function updateState(state, force) {
            if (force || curState !== state) {
                curState = state;
                $rootScope.$broadcast('sidebarState', curState);
                var nav = $('#sidebar-nav');
                if (state === STATE.ICON_ONLY) {
                    $('.sub-item-wrapper', nav).css("display", "none");
                } else {
                    $('.nav-second-level', nav).css("height", "");
                    $('.sub-item-wrapper', nav).css("display", "");
                }
            }
        }

        function initState() {
            var state;
            var width = window.innerWidth;
            if (width > 768 && width <= 1200) {
                state = STATE.ICON_ONLY;
            } else if (width > 1200) {
                state = STATE.VISIBLE;
            } else {
                state = STATE.HIDDEN;
            }
            updateState(state, true);
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CallCenterFinishedCtrl', CallCenterFinishedCtrl);

    /** @ngInject */
    function CallCenterFinishedCtrl($scope, $q, Auth, Dlg, UserInfo, Conversation, Table, ArrayHelper, UIHelper) {
        var states = Conversation.getStates();
        var types = Conversation.getTypes();
        var STATE = Conversation.STATE;
        var vm = $scope;
        vm.show = show;
        vm.init = init;
        vm.addEdit = addEdit;

        init();

        function init() {
            UIHelper.loadTab(vm, 'finished');
            var options = {
                service: Conversation,
                params: {
                    op: 'finished', is_finish: 'true'
                },
                optInFront: true,
                optColWidth: Table._2_BTN,
                showSn: true,
                count: 30,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}, width: Table._6_CHAR},
                    {field: "type", title: "类型", width: Table._6_CHAR},
                    {field: "rate", title: '评价', filter: {rate: 'num_range'}},
                    {field: 'finish_at', title: '结束时间'}
                ]
            };

            Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn, loadItem);
            });
        }

        function loadItem(item) {
            item.type = ArrayHelper.getItem(item.type, types)
        }

        function show(m) {
            Dlg.show({
                template: 'pages/call_center/conversationFinishDlg.html',
                ctrl: 'ConversationFinishDlgCtrl',
                data: {
                    id: m.id
                },
                size: 'lg'
            }).then().finally(function () {
                vm.tableReload();
            });
        }

        function addEdit(m) {
            Dlg.addEdit(vm, 'pages/call_center/conversationAddDlg.html', 'ConversationAddDlgCtrl', m);
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CallCenterHandlingCtrl', CallCenterHandlingCtrl);

    /** @ngInject */
    function CallCenterHandlingCtrl($scope, $q, Auth, Dlg, UserInfo, Conversation, Table, ArrayHelper, UIHelper) {
        var states = Conversation.getStates();
        var types = Conversation.getTypes();
        var account = Auth.getAccount();
        var STATE = Conversation.STATE;
        var vm = $scope;
        vm.show = show;
        vm.init = init;
        vm.finish = finish;

        init();

        function init() {
            UIHelper.loadTab(vm, 'handling');
            var options = {
                service: Conversation,
                params: {
                    op: 'handling'
                },
                optInFront: true,
                optColWidth: Table._4_BTN,
                showSn: true,
                count: 30,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}, width: Table._6_CHAR},
                    {field: "type", title: "类型", width: Table._7_CHAR},
                    {field: "unread", title: '未读', width: Table._2_CHAR},
                    {field: 'last_execute', title: '最近消息时间'}
                ]
            };

            Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn, loadItem);
            });
        }

        function loadItem(item) {
            item.type = ArrayHelper.getItem(item.type, types)
        }

        function show(m) {
            Dlg.show({
                template: 'pages/call_center/conversationDlg.html',
                ctrl: 'ConversationDlgCtrl',
                data: {
                    id: m.id
                },
                size: 'lg'
            }).then().finally(function () {
                vm.tableReload();
            });
        }

        function finish(m) {
            var defer = $q.defer();
            Conversation.update({id: m.id}, {op: 'finish'}).$promise.then(function (resp) {
                Dlg.s(resp.msg);
            }, function (e) {
                var resp = e.data;
                if (resp.msg) Dlg.error(resp.msg);
            }).finally(function () {
                defer.resolve();
                vm.tableReload();
            });
            return defer.promise;
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CallCenterUnhandledCtrl', CallCenterUnhandledCtrl);

    /** @ngInject */
    function CallCenterUnhandledCtrl($scope, $q, Auth, Dlg, UserInfo, Conversation, Table, ArrayHelper, UIHelper) {
        var states = Conversation.getStates();
        var types = Conversation.getTypes();
        var account = Auth.getAccount();
        var STATE = Conversation.STATE;
        var vm = $scope;
        vm.claim = claim;
        // vm.show = show;
        vm.init = init;

        init();

        function init() {
            UIHelper.loadTab(vm, 'unhandled');
            var options = {
                service: Conversation,
                params: {
                    op: 'unhandled'
                },
                optInFront: true,
                optColWidth: Table._1_BTN,
                showSn: true,
                count: 30,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}, width: Table._5_CHAR},
                    {field: "type", title: "类型", width: Table._4_CHAR},
                    {field: "description", title: '描述'}
                ]
            };

            Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn, loadItem);
            });
        }

        function loadItem(item) {
            item.state = ArrayHelper.getItem(item.state, states);
            item.type = ArrayHelper.getItem(item.type, types)
        }

        function claim(m) {
            var defer = $q.defer();
            Conversation.update({id: m.id, op: 'claim'}, {state: m.state.id}).$promise.then(function (resp) {
                m.state = resp.state;
                m.type = resp.type;
                loadItem(m);
                Dlg.s(resp.msg);
            }, function (error) {
                var resp = error.data;
                if (resp.msg) Dlg.error(resp.msg);
            }).finally(function () {
                defer.resolve();
            });
            return defer.promise;
        }

    }
})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:80,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
(function () {
    'use strict';

    angular.module('email', []);
    angular.module('c').requires.push('email');
})();

(function () {
    'use strict';

    angular.module('email')
        .controller('EmailCtrl', EmailCtrl)
        .controller('InboxController', InboxController)
        .controller('OutboxController', OutboxController)
        .controller('RecipientsTipsCtrl', RecipientsTipsCtrl)
        .controller('WritEmailCtrl', WritEmailCtrl);

    function EmailCtrl($scope, $stateParams, $timeout, UIHelper, Dlg, Email) {
        UIHelper.loadTabs($scope, $stateParams);

        $timeout(function () {
            Email.query({opt: 5}, function (resp) {
                if (resp.overflow) {
                    Dlg.notify('邮箱快被撑爆了,请清理邮箱内有附件的邮件!');
                }
            });
        }, 300);
    }

    function InboxController($rootScope, $scope, Dlg, C, ArrayHelper, UIHelper, Table, Email, $q) {
        var vm = $scope;
        var checker = null;
        vm.removeChecked = removeChecked;
        vm.show = show;
        vm.remove = remove;
        var readStatusOpts = Table.getNgTableOpts(ArrayHelper.get('readOrUnread'));
        var emailLvs = ArrayHelper.get('email_lvs');
        var emailLvOpts = Table.getNgTableOpts(emailLvs);


        $scope.$on('mail.send', function (event, data) {
            vm.tableReload();
        });

        $scope.$on(C.P + 'mail.withdraw', function (event, data) {
            var mail = data.data.mail;

            var mail = ArrayHelper.getItem(mail.id, vm.tableParams.settings().$scope.$data);
            if (mail) {
                mail.withdraw = '1';
            }
        });

        $scope.$on('mailRead', function (event, data) {
            var mail = ArrayHelper.getItem(data, vm.tableParams.settings().$scope.$data);
            if (mail) {
                mail.is_read = '1';
            }
        });

        $scope.$on('mailDel', function (event, data) {
            vm.tableReload();
        });

        init();

        function init() {
            var options = {
                service: Email,
                params: {opt: 3},
                optColWidth: Table._3_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {
                        title: '状态',
                        filter: {is_read: 'select'},
                        data: readStatusOpts,
                        field: 'is_read'
                    },
                    {title: '发件人', filter: {sender: 'text'}, field: 'sender_id'},
                    {title: '主题', filter: {subject: 'text'}, field: 'subject'},
                    {
                        title: '重要性',
                        sortable: 'level',
                        filter: {level: 'select'},
                        data: emailLvOpts,
                        field: 'level'
                    },
                    {
                        title: '时间',
                        sortable: 'created_at',
                        filter: {created_at: 'date_range'},
                        field: 'created_at'
                    }
                ]
            };

            Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn, function (item) {
                    item.level = ArrayHelper.getItem(item.level, emailLvs);
                })
            });
            checker = Table.loadMultiSelectedFn(vm);
        }

        function removeChecked() {
            var items = checker.getChecked();
            var mailIds = [];
            var count = items.length;
            if (count === 0) {
                checker.clearChecked();
                Dlg.w("请至少选中一个邮件");
                return;
            }
            var defer = $q.defer();
            vm.tableParams.settings().$loading = true;
            angular.forEach(items, function (item) {
                mailIds.push(item.id);
            });

            Email.rm_from_inbox({mails: mailIds}).$promise.then(
                function () {
                    Dlg.s('邮件删除成功!');
                    $rootScope.$broadcast('mailDel');
                },
                function () {
                    Dlg.e('邮件删除失败!');
                }
            );
            defer.resolve();
            checker.clearChecked();
            vm.tableReload();
            return defer.promise;
        }

        function show(m) {
            if (m.withdraw == 1) {
                Dlg.notify('该邮件已经被发送者撤回', '确认');
            } else {
                Dlg.show({
                    template: C.V + 'email/show_dlg.html',
                    ctrl: 'MailShowDlgCtrl',
                    data: {
                        mail: m
                    },
                    size: 'lg'
                }).then(function (resp) {
                    switch (resp.opt) {
                        case 1:
                            UIHelper.tabTo('write', {op: 'mailReply', mail: resp.mail});
                            break;
                        case 2:
                            UIHelper.tabTo('write', {op: 'mailForward', mail: resp.mail});
                            break;
                        case 3:
                            Email.rm_from_inbox({mails: [resp.mail.id]}).$promise.then(
                                function () {
                                    $rootScope.$broadcast('mailDel', resp.mail.id);
                                },
                                function () {
                                    Dlg.error('邮件删除失败!');
                                });
                            break;
                    }
                });
            }
        }

        function remove(m) {
            Dlg.confirm('确定要删除邮件吗？', function (resp) {
                Email.rm_from_inbox({mails: [m.id]}).$promise.then(
                    function () {
                        Dlg.s('邮件删除成功!');
                        $rootScope.$broadcast('mailDel');
                    },
                    function () {
                        Dlg.e('邮件删除失败!');
                    }
                );
            }, '删除');
        }
    }

    /** @ngInject */
    function OutboxController($scope, UIHelper, ArrayHelper, C, Auth, Table, Email, Dlg, $q) {
        var vm = $scope;
        var account = Auth.getAccount();
        var checker = null;

        vm.remove = remove;
        vm.show = show;
        vm.removeChecked = removeChecked;

        $scope.$on(C.P + 'mail.read', function (event, data) {
            var mail = data.data.mail;
            if (account.id === mail.sender_id) {
                var mails = vm.tableParams.settings().$scope.$data;
                for (var i = 0; i < mails.length; i++) {
                    if (mails[i].id === mail.id) {
                        var recipients = mails[i].recipients;
                        for (var j = 0; j < recipients.length; j++) {
                            if (recipients[j].id === mail.reader_id) {
                                recipients[j].is_read = true;
                            }
                        }
                    }
                }
            }
        });

        $scope.$on('mail.send', function (event, data) {
            vm.tableReload();
        });

        var undoOrNotOpts = Table.getNgTableOpts(ArrayHelper.get('undoOrNot'));
        var emailLvs = ArrayHelper.get('email_lvs');
        var emailLvOpts = Table.getNgTableOpts(emailLvs);

        init();


        function init() {
            var options = {
                service: Email,
                params: {opt: 2},
                optColWidth: Table._3_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {
                        title: '状态',
                        filter: {withdraw: 'select'},
                        data: undoOrNotOpts,
                        field: 'withdraw'
                    },
                    {title: '收件人', filter: {recipient: 'text'}, field: 'recipients'},
                    {title: '主题', filter: {subject: 'text'}, field: 'subject'},
                    {
                        title: '重要性',
                        filter: {level: 'select'},
                        data: emailLvOpts,
                        field: 'level'
                    },
                    {
                        title: '时间',
                        filter: {created_at: 'date_range'},
                        field: 'created_at'
                    }
                ]
            };

            Table.load(vm, options, function (resp) {
                vm.users = resp.users;
                angular.forEach(resp.items, function (item) {
                    item.level = ArrayHelper.getItem(item.level, emailLvs);
                })
            });
            checker = Table.loadMultiSelectedFn(vm);
        }

        function removeChecked() {
            var items = checker.getChecked();
            var mailIds = [];
            var count = items.length;
            if (count === 0) {
                checker.clearChecked();
                Dlg.w("请至少选中一个邮件");
                return;
            }
            var defer = $q.defer();
            vm.tableParams.settings().$loading = true;
            angular.forEach(items, function (item) {
                mailIds.push(item.id);
            });

            Email.rm_from_outbox({mails: mailIds}).$promise.then(
                function () {
                    Dlg.s('邮件删除成功!');
                    vm.tableReload();
                },
                function () {
                    Dlg.e('邮件删除失败!');
                }
            );
            defer.resolve();
            checker.clearChecked();
            vm.tableReload();
            return defer.promise;
        }

        function show(m) {
            Dlg.show({
                template: C.V + 'email/show_dlg.html',
                ctrl: 'MailShowDlgCtrl',
                data: {
                    mail: m,
                    is_outbox: true
                },
                size: 'lg'
            }).then(function (params) {
                switch (params.opt) {
                    case 2:     //转发
                        UIHelper.tabTo('write', {op: 'mailForward', mail: params.mail});
                        break;
                    case 3:     //删除
                        Email.rm_from_outbox({mails: [params.mail.id]});
                        vm.tableReload();
                        break;
                    case 4:     //撤回
                        vm.tableReload();
                        break;
                    case 5:     //再次编辑
                        UIHelper.tabTo('write', {op: 'mailEdit', mail: params.mail});
                        break;
                }
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除邮件吗？', function (resp) {
                Email.rm_from_outbox({mails: [m.id]}).$promise.then(
                    function () {
                        Dlg.s('邮件删除成功!');
                        vm.tableReload();
                    },
                    function () {
                        Dlg.e('邮件删除失败!');
                    }
                );
            }, '删除邮件');
        }
    }

    function RecipientsTipsCtrl($scope, $interval) {
        var recipients = $scope.mail.recipients;
        var n = Math.ceil(recipients.length / 20);
        var i = 0;

        $scope.recipients = recipients.slice(i * 20, (i + 1) * 20);

        if (n > 1) {
            $scope.count = n;
            $scope.page = 1;
            var intervalPromise = $interval(function () {
                i++;
                if (i >= n) {
                    i = 0;
                }
                $scope.page = i + 1;
                $scope.recipients = recipients.slice(i * 20, (i + 1) * 20);
                if ($scope.recipients.length < 20) {
                    var k = 20 - $scope.recipients.length;
                    for (var j = 0; j < k; j++) {
                        $scope.recipients.push({name: '?'});
                    }
                }

            }, 3000);

            $scope.$on('$destroy', function () {
                $interval.cancel(intervalPromise);
            });
        }
    }

    /** @ngInject */
    function WritEmailCtrl(UIHelper, $scope, Dlg, C, Auth, ArrayHelper, Sms, Email, FileHelper) {
        var account = Auth.getAccount();
        var vm = $scope;
        vm.levels = ArrayHelper.get('email_lvs');
        vm.reset = reset;
        vm.deleteAttachment = deleteAttachment;
        vm.upload = upload;
        vm.send = send;

        init();


        function init() {
            UIHelper.loadTab($scope, 'write', loadMailAccordingToOp);

            if (UIHelper.hasTabExtra()) {
                loadMailAccordingToOp(UIHelper.getTabExtra());
            } else {
                reset();
            }
        }

        function loadMailAccordingToOp(data) {
            if (!data || !data.mail) return;
            var op = data.op;
            var mail = data.mail;
            mail.with_wx = true;
            switch (op) {
                case 'mailReply':
                    loadMail(mail, true);
                    break;
                case 'mailForward':
                    loadMail(mail, false);
                    break;
                case 'mailEdit':
                    $scope.mail = mail;
                    break;
            }
            return true;
        }


        function deleteAttachment($index, mail) {
            mail.attachments.splice($index, 1);
        }

        function upload(file, mail, e) {
            FileHelper.upload(C.URL.MAIL_UPLOAD, file, mail, e);
        }

        function send(mail) {
            if (!mail.subject) {
                Dlg.w('邮件主题不能为空!');
            } else if (!mail.recipients || mail.recipients.length === 0) {
                Dlg.w('请填写收件人!');
            } else if (!FileHelper.isAttachmentsUploaded(mail)) {
                Dlg.w('请等一小会儿,部分附件还在路上');
            } else {
                var params = {with_wx: mail.with_wx};
                params['subject'] = mail.subject;
                params['level'] = mail.level.id;
                params['body'] = mail.body;
                params['attachments'] = [];
                params['size'] = 0;
                angular.forEach(mail.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                    params['size'] += attachment.size;
                });

                params['recipients'] = [];
                angular.forEach(mail.recipients, function (recipient) {
                    params['recipients'].push(recipient.id);
                });

                Email.save(params).$promise.then(function () {
                    Dlg.s('邮件发送成功!');
                    $scope.reset();
                    UIHelper.tabTo('outbox');

                    if (mail.with_sms) {
                        var pa = {};
                        pa['sign'] = '【西藏成办】';
                        pa['content'] = '请查收邮件《' + params['subject'] + '》';
                        pa['content'] += '(' + account.name + account.phone + ')';
                        pa['recipients'] = params['recipients'];
                        Sms.send(pa, function () {
                            Dlg.s('短信请求成功!');
                        }, function () {
                            Dlg.e('短信请求失败!');
                        });
                    }

                    if (mail.attachments.length > 0) {
                        Email.query({opt: 5}, function (resp) {
                            if (resp.overflow) {
                                Dlg.notify('邮箱快被撑爆了,请前往站内邮箱清理邮件!');
                            }
                        });
                    }
                }, function (msg) {
                    Dlg.e('邮件发送失败了!');
                });
            }
        }

        function reset() {
            $scope.mail = {level: $scope.levels[0], attachments: [], recipients: [], content: '', with_wx: true};
        }

        function loadMail(mail, is_reply) {
            var header = '<br><br><br><p><i>------------------ 原始邮件 ------------------<br>';
            header += '<strong>发件人：</strong>' + mail.sender.name + '<' + mail.sender.username + '>;<br>';
            header += '<strong>发送时间：</strong>' + mail.created_at + ';<br>';
            header += '<strong>收件人：</strong>';
            angular.forEach(mail.recipients, function (recipient) {
                header += recipient.name + '<' + recipient.username + '>;';
            });
            header += '<br>';
            header += '<strong>主题：</strong>' + mail.subject + ';<br></i></p>';

            mail.body = header + mail.body;

            if (is_reply) {  //回复
                mail.subject = "回复：" + mail.subject;
                mail.recipients = [{
                    id: mail.sender.id, name: mail.sender.name,
                    username: mail.sender.username
                }];
                mail.attachments = [];
                mail.level = $scope.levels[0];
            } else { //转发
                mail.subject = "转发：" + mail.subject;
                mail.recipients = [];
            }
            $scope.mail = mail;
        }
    }


})();
angular.module('email').controller('MailShowDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, dialogs, toaster, F, Email, data) {
        $scope.is_outbox = data.is_outbox;

        //$scope.mail = {subject: data.mail.subject, level: data.mail.level};
        var emailLvs = F.get('email_lvs');
        Email.get({id: data.mail.id}).$promise.then(function (resp) {
            if (data.mail.is_read != '1') {
                data.mail.is_read = '1';
                $rootScope.$broadcast('mailRead', data.mail.id);
            }
            var mail = resp.mail;
            mail.level = F.getItem(mail.level, emailLvs);
            angular.forEach(mail.attachments, function (attachment) {
                attachment.ico = F.getIconFromMime(attachment.mime);
                attachment.size = parseInt(attachment.size);
            });

            $scope.mailContent = $sce.trustAsHtml(mail.body);
            $scope.mail = mail;
        }, function () {
            toaster.pop({
                type: 'warning', title: '邮件不存在', body: '该邮件可能已被删除!', onHideCallback: function () {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        });

        /**
         * opt: 1--reply/回复; 2--forward/转发; 3--delete/删除; 4--withdraw/撤回
         *      5--edit/再次编辑
         */

        $scope.delete = function (mail) {
            var params = {opt: 3, mail: mail};
            dialogs.confirm('删除邮件', '确定要删除邮件吗?')
                .result.then(function () {
                $uibModalInstance.close(params);
            });
        };

        $scope.withdraw = function (mail) {
            var params = {opt: 4, mail: mail};
            dialogs.confirm('撤回邮件', '确定要撤回邮件吗?')
                .result.then(function () {
                Email.withdraw({id: mail.id}).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 2:
                                toaster.warning('邮件已被阅读,无法撤回!');
                                break;
                            case 1:
                                toaster.warning('邮件发送已超过15天,无法撤回!');
                                break;
                            case 0:
                                toaster.success('邮件撤回成功!');
                                $uibModalInstance.close(params);
                                break;
                        }
                    },
                    function () {
                        toaster.error('邮件撤回失败!');
                    }
                );
            });
        };

        $scope.forward = function (mail) {
            var params = {opt: 2, mail: mail};
            $uibModalInstance.close(params);
        };

        $scope.reply = function (mail) {
            var params = {opt: 1, mail: mail};
            $uibModalInstance.close(params);
        };

        $scope.edit = function (mail) {
            var params = {opt: 5, mail: mail};
            $uibModalInstance.close(params);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module("c").run(["$templateCache", function($templateCache) {$templateCache.put("templates/cache/breadcrumb.html","<div class=\"col-lg-12 px-0\"><ul class=\"breadcrumb\"><li><a ui-sref=\"app.home\" ng-click=\"$root.collapseVar=0\">首页</a></li><li ng-if=\"parent\"><a href=\"\">{{parent}}</a></li><li ng-if=\"current\" class=\"active\">{{current}}</li></ul></div>");
$templateCache.put("templates/cache/footer.html","<div class=\"col-xs-12 footer\"><div>成都云慈康祥医疗科技有限公司©ygjg.cbxz.gov.cn</div></div>");
$templateCache.put("templates/cache/header.html","<nav class=\"navbar navbar-default navbar-fixed-top mb-0\" role=\"navigation\"><div class=\"navbar-header\"><a class=\"navbar-toggle\" ng-click=\"header.toggleSidebar()\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></a><ul class=\"nav navbar-top-links navbar-right\"><li uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"header.openTaskD\" on-toggle=\"header.toggleTaskD()\"><a id=\"task-dropdown\" uib-dropdown-toggle=\"\"><i class=\"fa fa-tasks fa-fw\"></i> <span class=\"notify-tag bg-red\" ng-show=\"header.hasTask\" ng-class=\"{\'notify-animated\':shakePoint}\">！</span></a><div class=\"dropdown-menu header-dp dp-task\" uib-dropdown-menu=\"\" aria-labelledby=\"task-dropdown\"><i class=\"dropdown-arr\"></i><div class=\"dp-header\"><div class=\"dp-header-title\">待处理事务</div><div class=\"dp-btn-group\"><div class=\"dp-header-btn\" ng-click=\"header.reloadTask()\" promise-btn=\"\"><i class=\"fa fa-refresh fa-fw\"></i></div><div class=\"dp-header-btn\" ng-click=\"header.openTaskD=false\"><i class=\"fa fa-times fa-fw\"></i></div></div></div><div class=\"dp-list\" ng-if=\"header.taskLoading||header.tasks.length>0\" loading-container=\"header.taskLoading\" loading-icon=\"fa-cog fa-2x fa-spin\"><a ng-repeat=\"task in header.tasks track by task.type\" class=\"task-item clearfix\" ng-click=\"header.openTaskD=false;header.toTask(task,$index)\"><i class=\"fa fa-bookmark fa-fw\"></i>{{::task.name}} <span ng-if=\"task.subName\" class=\"text-muted\">[{{::task.subName}}]</span> <span ng-if=\"task.isNew\" class=\"order-tag tag-danger\">新</span> <span class=\"pull-right text-muted small\" style=\"padding-top:3px\">进入处理..</span></a></div><div class=\"dp-list\" ng-else=\"\"><div class=\"no-data\"><div><i class=\"fa fa-smile-o fa-fw\"></i>最近没有待处理事务</div></div></div></div></li><li uib-dropdown=\"\" is-open=\"openMailD\"><a id=\"mail-dropdown\" uib-dropdown-toggle=\"\"><i class=\"fa fa-envelope-o fa-fw\"></i> <span ng-show=\"header.mails.length > 0\" class=\"notify-tag bg-orange\" ng-bind=\"header.mails.length\"></span></a><div class=\"dropdown-menu header-dp dp-mail\" uib-dropdown-menu=\"\" aria-labelledby=\"mail-dropdown\"><i class=\"dropdown-arr\"></i><div class=\"dp-header\"><div class=\"dp-header-title\">未读邮件</div><div class=\"dp-btn-group\"><div class=\"dp-header-btn\" ng-click=\"header.reloadMail()\" promise-btn=\"\"><i class=\"fa fa-refresh fa-fw\"></i></div><div class=\"dp-header-btn\" ui-sref=\"app.message_email\" uib-tooltip=\"进入邮箱\"><i class=\"fa fa-arrow-right fa-fw\"></i></div></div></div><div class=\"dp-list\" ng-if=\"header.mailLoading||header.mails.length>0\" loading-container=\"header.mailLoading\" loading-icon=\"fa-cog fa-2x fa-spin\"><a ng-repeat=\"mail in header.mails track by mail.id\" ng-show=\"header.mails.length>0\" class=\"mail-item\" ng-click=\"header.readMail(mail,$index)\"><div class=\"mail-title\"><i class=\"fa fa-envelope-o fa-fw\"></i>{{mail.subject}}</div><div class=\"text-muted small mail-date\" am-time-ago=\"mail.created_at\"></div></a></div><div class=\"dp-list\" ng-else=\"\"><div class=\"no-data\"><div><i class=\"fa fa-smile-o fa-fw\"></i>最近没有未读邮件</div></div></div></div></li><li uib-dropdown=\"\" is-open=\"openUserD\"><a id=\"user-dropdown\" uib-dropdown-toggle=\"\"><i class=\"fa fa-user fa-fw\"></i></a><ul class=\"dropdown-menu dp-user\" uib-dropdown-menu=\"\" aria-labelledby=\"user-dropdown\"><i class=\"dropdown-arr\"></i><li><a ui-sref=\"app.user_profile\"><i class=\"fa fa-user fa-fw\"></i>用户资料</a></li><li><a ui-sref=\"app.message_contacts\"><i class=\"fa fa-phone-square fa-fw\"></i>通讯录</a></li><li><a ui-sref=\"app.user_help\"><i class=\"fa fa-book fa-fw\"></i>帮助</a></li><li class=\"divider\"></li><li><a ng-click=\"header.logout()\"><i class=\"fa fa-sign-out fa-fw\"></i>注销</a></li></ul></li><img class=\"img-circle\" ng-if=\"header.account.photo\" style=\"margin-left:6px;margin-right:8px;cursor:pointer\" ui-sref=\"app.user_profile\" ng-src=\"{{header.account.photo}}\" width=\"36\" height=\"36\"><li class=\"dropdown hidden-sm hidden-xs\"><a class=\"dropdown-toggle\" style=\"padding-left:2px;padding-right:2px\" ui-sref=\"app.user_profile\"><span ng-bind=\"header.account.name\"></span></a></li></ul></div></nav>");
$templateCache.put("templates/cache/home.html","<div class=\"row\"><breadcrumb></breadcrumb></div><div class=\"row mb-3\"><div class=\"dashboard-card-wrapper\" ng-repeat=\"card in home.cards\"><div class=\"dashboard-card\" ng-class=\"card.bg\"><div class=\"card-stat-item\"><div class=\"stat-title\">{{card.statTitle}}</div><div class=\"stat-num\">{{card.statNum}}</div></div><div class=\"card-icon\"><a ui-sref=\"{{card.linkTo}}\"><i class=\"fa fa-fw\" ng-class=\"card.icon\"></i><div class=\"card-icon-title\">{{card.iconTitle}}</div></a></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"home-blk\" ng-controller=\"BulletinListCtrl\"><div class=\"home-blk-title\"><a href=\"/#/app/message/bulletin\"><i class=\"fa fa-bullhorn fa-fw mr-1\"></i>公告列表</a> <a href=\"/#/app/message/bulletin\" class=\"home-more\">更多>></a></div><div class=\"table-responsive home-blk-table\" style=\"min-height:263px\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\"><tr ng-repeat=\"bulletin in home.bulletins track by bulletin.id\" ng-click=\"read(bulletin)\"><td><span class=\"text-red\" ng-if=\"bulletin.recipient==null\">[new]</span> <span class=\"bulletin-subject-col\" ng-bind=\"bulletin.title\" style=\"vertical-align:top\"></span> <span ng-if=\"bulletin.attachments.length>0\" class=\"fa fa-paperclip\" style=\"vertical-align:middle\"></span> <span style=\"color:red;font-weight:bold\" ng-if=\"bulletin.top_time>bulletin.release_time&&bulletin.top_time>=home.today\">顶</span></td><td width=\"15%\"><span ng-bind=\"bulletin.updated_at|date2:\'yyyy-MM-dd\'\"></span></td><td width=\"10%\"><span ng-bind=\"bulletin.dept.name\"></span></td></tr><tr ng-if=\"home.bulletins.length==0\" height=\"240px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div><div class=\"col-md-6\"><div class=\"home-blk\" ng-controller=\"MeetingListCtrl\"><div class=\"home-blk-title\"><a href=\"/#/app/coop/meeting\"><i class=\"fa fa-users fa-fw mr-1\"></i>会议安排</a> <a href=\"/#/app/coop/meeting\" class=\"home-more\">更多>></a></div><div class=\"table-responsive home-blk-table\" style=\"min-height:263px\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\"><tr ng-repeat=\"meeting in home.meetings track by meeting.id\" ng-click=\"read(meeting)\"><td><span class=\"text-red\" ng-if=\"meeting.recipient==null\">[new]</span> <span class=\"bulletin-subject-col\" ng-bind=\"meeting.name\" style=\"vertical-align:top\"></span> <span ng-if=\"meeting.attachments.length>0\" class=\"fa fa-paperclip\" style=\"vertical-align:middle\"></span></td><td><span ng-bind=\"meeting.start_time|amCalendar\"></span></td><td><span ng-bind=\"meeting.room_id!=null?meeting.room.name:meeting.place\"></span></td></tr><tr ng-if=\"home.meetings.length==0\" height=\"240px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"home-blk\" ng-controller=\"NewsListCtrl\"><div class=\"home-blk-title\"><a href=\"/#/app/message/news\"><i class=\"fa fa-newspaper-o fa-fw mr-1\"></i>新闻列表</a> <a href=\"/#/app/message/news\" class=\"home-more\">更多>></a></div><div class=\"table-responsive home-blk-table\" style=\"min-height:263px\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\"><tr ng-repeat=\"n in home.ns track by n.id\" ng-click=\"read(n)\"><td><span class=\"news-subject-col\" ng-bind=\"n.title\" style=\"vertical-align:top\"></span> <span ng-if=\"n.attachments.length>0\" class=\"fa fa-paperclip\" style=\"vertical-align:middle\"></span> <span style=\"color:red;font-weight:bold\" ng-if=\"n.top_time>n.release_time&&n.top_time>=home.today\">顶</span>&nbsp;</td><td><span ng-bind=\"n.updated_at|date2:\'yyyy-MM-dd\'\"></span></td><td><span ng-bind=\"n.dept.name\"></span></td></tr><tr ng-if=\"home.ns.length==0\" height=\"240px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div><div class=\"col-md-6\"><div class=\"home-blk\" ng-controller=\"FileListCtrl\"><div class=\"home-blk-title\"><a href=\"/#/app/user/file_cabinet\"><i class=\"fa fa-file-o fa-fw mr-1\"></i>文件共享</a> <a href=\"/#/app/user/file_cabinet\" class=\"home-more\">更多>></a></div><div class=\"table-responsive home-blk-table\" style=\"min-height:263px\"><table class=\"table table-nowrap table-hover no-selection table-row-clicked\"><tr ng-repeat=\"file in home.files track by file.id\" attachment-download=\"file\" mod=\"file_cabinet\"><td><span class=\"bulletin-subject-col\" style=\"vertical-align:top\" ng-bind=\"file.name\"></span> <span class=\"text-muted\"><small>{{file.size|bytes}}</small></span> <span ng-show=\"file.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></td><td><span ng-bind=\"file.updated_at|date2:\'yyyy-MM-dd\'\"></span></td><td><span ng-bind=\"file.dept.name\"></span></td></tr><tr ng-if=\"home.files.length==0\" height=\"240px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div>");
$templateCache.put("templates/cache/main.html","<div id=\"wrapper\"><sidebar></sidebar><header></header><div id=\"page-wrapper\" ng-class=\"{\'page-wrapper-offset\':sidebarState===2,\'page-wrapper-offset-sm\':sidebarState===1}\"><div ui-view=\"\"><div class=\"no-data\"><div class=\"font-lg\">你好！不小心让你发现我在这里了<i class=\"fa fa-smile-o text-yellow\"></i>,这里啥也米有～请到<a ui-sref=\"app.home\">首页逛逛</a> 或 出门<a ui-sref=\"login\">左拐</a>!</div></div></div></div><footer></footer><back-top></back-top></div><div id=\"preloader\" ng-if=\"!$finishedLoading\"><div></div></div><div id=\"pswp\" class=\"pswp init-hidden\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\" st=\"\"><div class=\"pswp__bg\"></div><div class=\"pswp__scroll-wrap\"><div class=\"pswp__container\"><div class=\"pswp__item\"></div><div class=\"pswp__item\"></div><div class=\"pswp__item\"></div></div><div class=\"pswp__ui pswp__ui--hidden\"><div class=\"pswp__top-bar\"><div class=\"pswp__counter\"></div><button class=\"pswp__button pswp__button--close\" title=\"关闭 (Esc)\"></button> <button class=\"pswp__button pswp__button--download\" title=\"下载图片\"></button> <button class=\"pswp__button pswp__button--fs\" title=\"全屏\"></button> <button class=\"pswp__button pswp__button--zoom\" title=\"放大/缩小\"></button><div class=\"pswp__preloader\"><div class=\"pswp__preloader__icn\"><div class=\"pswp__preloader__cut\"><div class=\"pswp__preloader__donut\"></div></div></div></div></div><div class=\"pswp__share-modal pswp__share-modal--hidden pswp__single-tap\"><div class=\"pswp__share-tooltip\"></div></div><button class=\"pswp__button pswp__button--arrow--left\" title=\"上一张\"></button> <button class=\"pswp__button pswp__button--arrow--right\" title=\"下一张\"></button><div class=\"pswp__caption\"><div class=\"pswp__caption__center\"></div></div></div></div></div>");
$templateCache.put("templates/cache/sidebar.html","<div class=\"navbar-default sidebar\" role=\"navigation\" ng-show=\"sidebarState>0\" ng-class=\"{\'icon-only\':sidebarState===1}\"><div id=\"sidebar-nav\"><ul class=\"nav in\" slimscroll=\"{height: \'{{sidebar.menuHeight}}px\',touchScrollStep:100, position:\'left\'}\" slimscroll-watch=\"sidebar.menuHeight\"><div class=\"p-1 sidebar-search hidden-xs\" ng-if=\"sidebarState===2\"><i class=\"fa fa-search fw text-muted\"></i> <input type=\"text\" class=\"form-control input-xs\" placeholder=\"请输入菜单检索\" ng-model=\"sidebar.search\" ng-model-options=\"{ debounce: 200 }\"> <button ng-if=\"sidebar.search\" class=\"close\" ng-click=\"sidebar.search=null\">&times;</button></div><li ui-sref-active=\"active\" ng-click=\"sidebar.check(0)\" class=\"home-link\"><a ui-sref=\"app.home\"><i class=\"fa fa-home fa-fw\"></i> 首页</a></li><li ng-repeat=\"item in sidebar.menuItems\" ng-if=\"sidebar.firstLvVisible(item)\" ng-class=\"{active: collapseVar===$index+1}\" ng-mouseover=\"sidebar.mouseOverMenuItem($event)\" ng-mouseleave=\"sidebar.mouseLeaveMenuItem($event)\"><a ng-click=\"sidebar.check($index+1)\"><i ng-class=\"[\'fa\', \'fa-\' + item.icon, \'fa-fw\']\"></i> {{::item.display_name}} <span class=\"fa arrow\"></span></a><div class=\"sub-item-wrapper\" msd-wheel=\"sidebar.mouseWheelSubItem($event)\"><div ng-if=\"sidebarState===1\" class=\"sub-item-title\">{{::item.display_name}}</div><ul class=\"nav nav-second-level\" uib-collapse=\"sidebar.subItemCollapse($index+1)\"><li ng-repeat=\"subItem in item.children\" ui-sref-active=\"active\" ng-click=\"sidebar.clickSubItem($event)\" ng-if=\"sidebar.secondLvVisible(subItem)\"><a ui-sref=\"{{::subItem.state.name}}\">{{::subItem.display_name}}</a></li></ul></div></li></ul></div></div>");}]);